var Vo = Object.defineProperty;
var bo = (e, t, r) => t in e ? Vo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Zt = (e, t, r) => bo(e, typeof t != "symbol" ? t + "" : t, r);
import { jsxs as $e, jsx as _, Fragment as vr } from "react/jsx-runtime";
import { stringifyLoggable as tr, createSpanName as De, SpanComponent as Tt, instrumentService as ln, error as Ie, debug as ee, addSpanEvent as Ce, isApiErrorLike as yo, useUnMounted as ba, TERMINATE_REASON_CODE as di, instrument as Hn, addSpanAttributes as Sn, createSpan as go } from "@imprivata-cloud/common";
import { Button as Br } from "@imprivata-cloud/components";
import * as C from "react";
import { useRef as Un, useMemo as ir, createContext as Bn, useState as ht, useCallback as Xe, useEffect as Ht, Fragment as Zo, useContext as Yn } from "react";
import { useTranslation as ya } from "react-i18next";
import { Q as Vr, F as Yr, d as et, x as Fo, A as ut, E as Xo, y as pr, R as br, m as rr, e as St, z as Wo, B as xo, r as Do, D as fi, G as Co, b as ga, H as qo, J as mi, g as ae, n as pi, S as So, u as _t, v as mt, K as wo, M as Ko } from "./index-B_Mi3W2t.js";
import { jsonToBase64 as wn } from "@imprivata-cloud/dataprivacy";
import { A as wt } from "./api-DwyZ-w1t.js";
import { ResourceType as Io, ContextType as Eo } from "./types.js";
import "antd";
function Ro(e = {}) {
  var i;
  const t = Un({}).current;
  for (const [a, u] of Object.entries(e))
    (i = t[a]) != null && i.current || (t[a] = { current: u });
  const r = ir(
    () => new Proxy({}, {
      get: (a, u) => {
        var o;
        return (o = t[u]) == null ? void 0 : o.current;
      },
      set: (a, u, s) => {
        const o = u;
        return t[o] ? t[o].current = s : t[o] = { current: s }, !0;
      }
    }),
    []
  ), n = ir(() => (a, u) => (t[a] || (t[a] = { current: u }), t[a]), []);
  return { proxy: r, register: n };
}
var Za = "1.0.1";
function Fa(e, t, r) {
  const n = document.createElement("canvas");
  n.width = t, n.height = r;
  const i = {};
  i.desynchronized = !0, i.alpha = !1, i.willReadFrequently = !0;
  const a = n.getContext("2d", i);
  let u = e.width, s = e.height;
  if (u > s ? (s = s * t / u, u = t) : (u = u * r / s, s = r), a.fillStyle = "black", a.fillRect(0, 0, t, r), e instanceof ImageData) {
    const o = document.createElement("canvas");
    o.width = e.width, o.height = e.height;
    const l = {};
    l.desynchronized = !0, l.alpha = !1, l.willReadFrequently = !0, o.getContext("2d", l).putImageData(e, 0, 0), a.drawImage(o, 0, 0, u, s);
  } else a.drawImage(e, 0, 0, u, s);
  return { image: a.getImageData(0, 0, t, r), resizedHeight: s, resizedWidth: u };
}
function Xr(e) {
  const t = e.data.length / e.width / e.height, r = e.width * e.height, n = new Float32Array(r * 3);
  for (let a = 0; a < r; a += 1) {
    const u = a * t;
    n[a] = e.data[u], n[a + r] = e.data[u + 1], n[a + 2 * r] = e.data[u + 2];
  }
  const i = {};
  return i.data = n, i.shape = [3, e.height, e.width], i.width = e.width, i.height = e.height, i.channels = 3, i;
}
function It(e, t, r) {
  const n = Math.max(0, e.origin.x), i = Math.max(0, e.origin.y), a = Math.min(e.origin.x + e.width, t), u = Math.min(e.origin.y + e.height, r), s = {};
  s.x = n, s.y = i;
  const o = {};
  return o.origin = s, o.width = a - n, o.height = u - i, o.score = e.score, o;
}
function Xa(e, t) {
  const r = document.createElement("canvas"), n = [];
  for (const i of t) {
    const a = i.width, u = i.height;
    r.width = a, r.height = u;
    const s = {};
    s.willReadFrequently = !0, s.desynchronized = !0, s.alpha = !1;
    const o = r.getContext("2d", s);
    o.fillStyle = "black", o.fillRect(0, 0, a, u);
    const l = It(i, e.width, e.height), A = l.width, d = l.height, m = l.origin.x - i.origin.x, f = l.origin.y - i.origin.y;
    o.drawImage(e, l.origin.x, l.origin.y, A, d, m, f, A, d), n.push(o.getImageData(0, 0, a, u));
  }
  return n;
}
function Wa(e, t) {
  const { origin: r, width: n, height: i } = e;
  let a = r.x, u = r.y, s = r.x + n, o = r.y + i;
  const l = (s - a) * t / 2, A = (o - u) * t / 2, d = a - l, m = u - A, f = s + l, p = o + A, c = {};
  c.x = d, c.y = m;
  const h = {};
  return h.origin = c, h.width = f - d, h.height = p - m, h.score = e.score, h;
}
function xa(e, t) {
  const { origin: r, width: n, height: i } = e;
  let a = r.x, u = r.y, s = r.x + n, o = r.y + i;
  const l = i / n;
  if (l === t) return e;
  if (l > t) {
    const m = (i / t - n) / 2;
    a -= m, s += m;
  } else {
    const m = (t * n - i) / 2;
    u -= m, o += m;
  }
  const A = {};
  A.x = a, A.y = u;
  const d = {};
  return d.origin = A, d.width = s - a, d.height = o - u, d.score = e.score, d;
}
function zo(e, t, r) {
  const n = Math.min(t, r);
  let i = 0, a = 0;
  r > t ? i = (t - n) / 2 : a = (r - n) / 2;
  const u = {};
  u.x = i, u.y = a;
  const s = {};
  return s.origin = u, s.width = n, s.height = n, s.score = e.score, s;
}
function Da(e, t, r, n) {
  const i = { dx: Math.round(e.origin.x - t.origin.x), dy: Math.round(e.origin.y - t.origin.y), dWidth: Math.round(e.width - t.width), dHeight: Math.round(e.height - t.height) }, a = {};
  a.x = t.origin.x - i.dx, a.y = t.origin.y - i.dy;
  const u = {};
  u.origin = a, u.width = t.width - i.dWidth, u.height = t.height - i.dHeight, u.score = e.score;
  const s = u;
  return s.origin.x < 0 || s.origin.y < 0 || s.origin.x + s.width > r || s.origin.y + s.height > n ? zo(t, r, n) : s;
}
class ct extends Error {
  constructor(t) {
    super(t), this.name = "SDKError";
  }
}
async function To(e, t, r, n, i) {
  const a = {};
  let u = performance.now(), s;
  if (t instanceof ImageBitmap) s = t;
  else try {
    s = await createImageBitmap(t);
  } catch {
  }
  if (!s || s.width === 0 || s.height === 0) throw new ct("Invalid image data from input source.");
  const o = No(s, e.inputWidth, e.inputHeight, r);
  a.preProcess = performance.now() - u, u = performance.now();
  const l = await Go(e, o);
  a.infer = performance.now() - u, u = performance.now();
  const A = Po(o, l, n, i);
  A.sort((m, f) => hi(f.boundingBox, o) - hi(m.boundingBox, o)), A.forEach((m, f) => {
    m.isBboxOverlapping = Mo(m, f, A, o);
  }), a.postProcess = performance.now() - u, A.forEach((m) => {
    m.timings.detection = a;
  });
  const d = {};
  return d.mostProminentFaceIndex = A.length > 0 ? 0 : -1, d.faces = A, d.image = o.input, d;
}
function hi(e, t) {
  const r = It(e, t.input.width, t.input.height);
  return r.width * r.height;
}
function No(e, t, r, n) {
  const i = Fa(e, t, r), a = Xr(i.image), u = {};
  return u.input = e, u.resizedHeight = i.resizedHeight, u.resizedWidth = i.resizedWidth, u.tensor = a, u.sourceType = n, u;
}
async function Go(e, t) {
  const r = await import("onnxruntime-web"), n = new r.Tensor("float32", t.tensor.data, [1, ...t.tensor.shape]);
  return await e.run({ [e.inputNames[0]]: n });
}
function Po(e, t, r, n) {
  const i = [], a = [], u = t.selected_indices.data.length / 3;
  for (let f = 0; f < u; f++) {
    const p = 3 * (f + 1), c = Number(t.selected_indices.data[p - 1]), h = t.bboxes.data.slice(c * 4, c * 4 + 4);
    i.push(h), a.push(t.scores.data[c]);
  }
  const s = e.tensor.width / e.resizedWidth, o = e.tensor.height / e.resizedHeight, l = i.map((f, p) => {
    const c = {};
    c.x = f[0] * s * e.input.width, c.y = f[1] * o * e.input.height;
    const h = c, v = f[2] * s * e.input.width - h.x, Z = f[3] * o * e.input.height - h.y, b = {};
    return b.origin = h, b.width = v, b.height = Z, b.score = a[p], b;
  }), A = l.map((f) => Ho(Uo(It(f, e.input.width, e.input.height)), 0.3)), d = Xa(e.input, A);
  return l.map((f, p) => ({ boundingBox: f, preparedBoundingBox: A[p], preparedImage: Fa(d[p], r, n).image, sourceImage: e.input, imageSourceType: e.sourceType, timings: {} }));
}
function Lo(e, t) {
  const r = e.origin.x, n = e.origin.y, i = e.origin.x + e.width, a = e.origin.y + e.height, u = t.origin.x, s = t.origin.y, o = t.origin.x + t.width, l = t.origin.y + t.height;
  return !(i < u || r > o || a < s || n > l);
}
function Mo(e, t, r, n) {
  let i = It(e.boundingBox, n.input.width, n.input.height), a = xa(i, 1);
  a = Wa(a, 1), i = It(a, n.input.width, n.input.height), a = Da(a, i, n.input.width, n.input.height);
  let u = !1;
  return r.forEach((s, o) => {
    o === t || u || (u = Lo(a, s.boundingBox));
  }), u;
}
function Ho(e, t) {
  const r = e.width * t, n = e.height * t, i = e.width + r, a = e.height + n, u = e.origin.x - r / 2, s = e.origin.y - n / 2, o = {};
  o.x = u, o.y = s;
  const l = {};
  return l.origin = o, l.width = i, l.height = a, l.score = e.score, l;
}
function Uo(e) {
  if (e.height > e.width) {
    const t = (e.height - e.width) / 2, r = {};
    r.x = e.origin.x, r.y = e.origin.y + t;
    const n = {};
    return n.origin = r, n.width = e.width, n.height = e.height - t * 2, n.score = e.score, n;
  } else if (e.width > e.height) {
    const t = (e.width - e.height) / 2, r = {};
    r.x = e.origin.x, r.y = e.origin.y + t;
    const n = {};
    return n.origin = r, n.width = e.width - t * 2, n.height = e.height, n.score = e.score, n;
  }
  return e;
}
async function Bo(e, t) {
  let r = performance.now();
  const n = Xr(t.preparedImage), i = {};
  i.preProcess = performance.now() - r, r = performance.now();
  const a = await import("onnxruntime-web"), u = new a.Tensor("float32", n.data, [1, ...n.shape]), s = await e.run({ [e.inputNames[0]]: u });
  i.infer = performance.now() - r, r = performance.now(), t.quality = s.qualities.data[0], t.acceptability = s.acceptabilities.data[0], i.postProcess = performance.now() - r, t.timings.quality = i;
}
async function Yo(e, t) {
  let r = performance.now();
  const n = {}, i = Xr(t.preparedImage);
  n.preProcess = performance.now() - r, r = performance.now();
  const a = await import("onnxruntime-web"), u = new a.Tensor("float32", new Float32Array(i.data), [1, ...i.shape]), s = await e.run({ [e.inputNames[0]]: u });
  n.infer = performance.now() - r, r = performance.now(), t.landmarks = Oo(s.landmarks.data, t.preparedBoundingBox), n.postProcess = performance.now() - r, t.timings.landmarks = n;
}
function Oo(e, t) {
  const r = (i) => i * t.width + t.origin.x, n = (i) => i * t.height + t.origin.y;
  return { leftEye: { x: r(e[0]), y: n(e[1]) }, rightEye: { x: r(e[2]), y: n(e[3]) }, nose: { x: r(e[4]), y: n(e[5]) }, leftMouth: { x: r(e[6]), y: n(e[7]) }, rightMouth: { x: r(e[8]), y: n(e[9]) } };
}
const Jo = () => {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    const e = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return e === null ? -1 : parseInt(e[1], 10);
  }
  return -1;
};
import("onnxruntime-web").then((e) => {
  e.env.wasm.numThreads = Jo() === 17 ? 1 : 0;
});
const Wr = "models/v1.0.0/", Tr = {};
Tr.url = Wr + "detection-mobile.onnx", Tr.inputWidth = 229, Tr.inputHeight = 129;
const jo = Tr, Nr = {};
Nr.url = Wr + "landmarks.onnx", Nr.inputWidth = 112, Nr.inputHeight = 112;
const ko = Nr, Gr = {};
Gr.url = Wr + "quality.onnx", Gr.inputWidth = 112, Gr.inputHeight = 112;
const Qo = Gr, Pr = {};
Pr.url = Wr + "mask.onnx", Pr.inputWidth = 112, Pr.inputHeight = 112;
const _o = Pr, Lr = {};
Lr.url = Wr + "sharpness.onnx", Lr.inputWidth = 160, Lr.inputHeight = 160;
const $o = Lr;
async function hr(e, t) {
  const r = await import("onnxruntime-web");
  try {
    const n = {};
    n.executionProviders = t;
    const i = await r.InferenceSession.create(e.url, n);
    return i.inputWidth = e.inputWidth, i.inputHeight = e.inputHeight, i;
  } catch (n) {
    throw new ct("Failed to load model at " + e.url + ": " + n);
  }
}
const An = class An {
  constructor(t, r, n) {
    Zt(this, "detectionEngine");
    Zt(this, "landmarksEngine");
    Zt(this, "qualityEngine");
    this.detectionEngine = t, this.landmarksEngine = r, this.qualityEngine = n;
  }
  static async create() {
    const t = await hr(jo, ["wasm"]), r = await hr(ko, ["wasm"]), n = await hr(Qo, ["wasm"]);
    return new An(t, r, n);
  }
  async getFaces({ source: t, options: r }) {
    const n = await To(this.detectionEngine, t, (r == null ? void 0 : r.imageSourceType) ?? "UNKNOWN", this.landmarksEngine.inputWidth, this.landmarksEngine.inputHeight);
    return r != null && r.qualities && await this.getQualities(n.faces), r != null && r.landmarks && await this.getLandmarks(n.faces), n;
  }
  async getQualities(t) {
    const r = t.filter((n) => n.quality === void 0);
    for (const n of r)
      await Bo(this.qualityEngine, n);
  }
  async getLandmarks(t) {
    const r = t.filter((n) => n.landmarks === void 0);
    for (const n of r)
      await Yo(this.landmarksEngine, n);
  }
};
Zt(An, "version", Za);
let Kn = An;
function Or() {
  return Or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Or.apply(null, arguments);
}
var Ca = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  relTol: 1e-12,
  // minimum absolute difference between two compared values,
  // used by all comparison functions
  absTol: 1e-15,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', 'bigint', or 'Fraction'
  number: "number",
  // type of fallback used for config { number: 'bigint' } when a value cannot be represented
  // in the configured numeric type. Choose 'number' (default) or 'BigNumber'.
  numberFallback: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
function qa(e, t) {
  if (Jr(e, t))
    return e[t];
  throw typeof e[t] == "function" && es(e, t) ? new Error('Cannot access method "' + t + '" as a property') : new Error('No access to property "' + t + '"');
}
function Sa(e, t, r) {
  if (Jr(e, t))
    return e[t] = r, r;
  throw new Error('No access to property "' + t + '"');
}
function Jr(e, t) {
  return !ts(e) && !Array.isArray(e) ? !1 : gr(rs, t) ? !0 : !(t in Object.prototype || t in Function.prototype);
}
function es(e, t) {
  return e == null || typeof e[t] != "function" || gr(e, t) && Object.getPrototypeOf && t in Object.getPrototypeOf(e) ? !1 : gr(ns, t) ? !0 : !(t in Object.prototype || t in Function.prototype);
}
function ts(e) {
  return typeof e == "object" && e && e.constructor === Object;
}
var rs = {
  length: !0,
  name: !0
}, ns = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
class is {
  constructor(t) {
    this.wrappedObject = t, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((t) => this.has(t)).values();
  }
  get(t) {
    return qa(this.wrappedObject, t);
  }
  set(t, r) {
    return Sa(this.wrappedObject, t, r), this;
  }
  has(t) {
    return Jr(this.wrappedObject, t) && t in this.wrappedObject;
  }
  entries() {
    return as(this.keys(), (t) => [t, this.get(t)]);
  }
  forEach(t) {
    for (var r of this.keys())
      t(this.get(r), r, this);
  }
  delete(t) {
    Jr(this.wrappedObject, t) && delete this.wrappedObject[t];
  }
  clear() {
    for (var t of this.keys())
      this.delete(t);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}
function as(e, t) {
  return {
    next: () => {
      var r = e.next();
      return r.done ? r : {
        value: t(r.value),
        done: !1
      };
    }
  };
}
function Ze(e) {
  return typeof e == "number";
}
function We(e) {
  return !e || typeof e != "object" || typeof e.constructor != "function" ? !1 : e.isBigNumber === !0 && typeof e.constructor.prototype == "object" && e.constructor.prototype.isBigNumber === !0 || typeof e.constructor.isDecimal == "function" && e.constructor.isDecimal(e) === !0;
}
function us(e) {
  return typeof e == "bigint";
}
function wa(e) {
  return e && typeof e == "object" && Object.getPrototypeOf(e).isComplex === !0 || !1;
}
function Ka(e) {
  return e && typeof e == "object" && Object.getPrototypeOf(e).isFraction === !0 || !1;
}
function Ia(e) {
  return e && e.constructor.prototype.isUnit === !0 || !1;
}
function ot(e) {
  return typeof e == "string";
}
var ge = Array.isArray;
function Ve(e) {
  return e && e.constructor.prototype.isMatrix === !0 || !1;
}
function yr(e) {
  return Array.isArray(e) || Ve(e);
}
function os(e) {
  return e && e.isDenseMatrix && e.constructor.prototype.isMatrix === !0 || !1;
}
function ss(e) {
  return e && e.isSparseMatrix && e.constructor.prototype.isMatrix === !0 || !1;
}
function Ea(e) {
  return e && e.constructor.prototype.isRange === !0 || !1;
}
function cn(e) {
  return e && e.constructor.prototype.isIndex === !0 || !1;
}
function As(e) {
  return typeof e == "boolean";
}
function ls(e) {
  return e && e.constructor.prototype.isResultSet === !0 || !1;
}
function cs(e) {
  return e && e.constructor.prototype.isHelp === !0 || !1;
}
function ds(e) {
  return typeof e == "function";
}
function fs(e) {
  return e instanceof Date;
}
function ms(e) {
  return e instanceof RegExp;
}
function On(e) {
  return !!(e && typeof e == "object" && e.constructor === Object && !wa(e) && !Ka(e));
}
function ps(e) {
  return e ? e instanceof Map || e instanceof is || typeof e.set == "function" && typeof e.get == "function" && typeof e.keys == "function" && typeof e.has == "function" : !1;
}
function hs(e) {
  return e === null;
}
function vs(e) {
  return e === void 0;
}
function Vs(e) {
  return e && e.isAccessorNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function bs(e) {
  return e && e.isArrayNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function ys(e) {
  return e && e.isAssignmentNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function gs(e) {
  return e && e.isBlockNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Zs(e) {
  return e && e.isConditionalNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Fs(e) {
  return e && e.isConstantNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Xs(e) {
  return e && e.isFunctionAssignmentNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Ws(e) {
  return e && e.isFunctionNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function xs(e) {
  return e && e.isIndexNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Ds(e) {
  return e && e.isNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Cs(e) {
  return e && e.isObjectNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function qs(e) {
  return e && e.isOperatorNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Ss(e) {
  return e && e.isParenthesisNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function ws(e) {
  return e && e.isRangeNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Ks(e) {
  return e && e.isRelationalNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Is(e) {
  return e && e.isSymbolNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Es(e) {
  return e && e.constructor.prototype.isChain === !0 || !1;
}
function st(e) {
  var t = typeof e;
  return t === "object" ? e === null ? "null" : We(e) ? "BigNumber" : e.constructor && e.constructor.name ? e.constructor.name : "Object" : t;
}
function Ae(e) {
  var t = typeof e;
  if (t === "number" || t === "bigint" || t === "string" || t === "boolean" || e === null || e === void 0)
    return e;
  if (typeof e.clone == "function")
    return e.clone();
  if (Array.isArray(e))
    return e.map(function(r) {
      return Ae(r);
    });
  if (e instanceof Date) return new Date(e.valueOf());
  if (We(e)) return e;
  if (On(e))
    return Rs(e, Ae);
  if (t === "function")
    return e;
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(e, ")"));
}
function Rs(e, t) {
  var r = {};
  for (var n in e)
    gr(e, n) && (r[n] = t(e[n]));
  return r;
}
function Ra(e, t) {
  for (var r in t)
    gr(t, r) && (e[r] = t[r]);
  return e;
}
function Et(e, t) {
  var r, n, i;
  if (Array.isArray(e)) {
    if (!Array.isArray(t) || e.length !== t.length)
      return !1;
    for (n = 0, i = e.length; n < i; n++)
      if (!Et(e[n], t[n]))
        return !1;
    return !0;
  } else {
    if (typeof e == "function")
      return e === t;
    if (e instanceof Object) {
      if (Array.isArray(t) || !(t instanceof Object))
        return !1;
      for (r in e)
        if (!(r in t) || !Et(e[r], t[r]))
          return !1;
      for (r in t)
        if (!(r in e))
          return !1;
      return !0;
    } else
      return e === t;
  }
}
function gr(e, t) {
  return e && Object.hasOwnProperty.call(e, t);
}
function zs(e, t) {
  for (var r = {}, n = 0; n < t.length; n++) {
    var i = t[n], a = e[i];
    a !== void 0 && (r[i] = a);
  }
  return r;
}
var Ts = ["Matrix", "Array"], Ns = ["number", "BigNumber", "Fraction"], Oe = function(t) {
  if (t)
    throw new Error(`The global config is readonly. 
Please create a mathjs instance if you want to change the default configuration. 
Example:

  import { create, all } from 'mathjs';
  const mathjs = create(all);
  mathjs.config({ number: 'BigNumber' });
`);
  return Object.freeze(Ca);
};
Or(Oe, Ca, {
  MATRIX_OPTIONS: Ts,
  NUMBER_OPTIONS: Ns
});
function vi() {
  return !0;
}
function nt() {
  return !1;
}
function Ot() {
}
const Vi = "Argument is not a typed-function.";
function za() {
  function e(g) {
    return typeof g == "object" && g !== null && g.constructor === Object;
  }
  const t = [{
    name: "number",
    test: function(g) {
      return typeof g == "number";
    }
  }, {
    name: "string",
    test: function(g) {
      return typeof g == "string";
    }
  }, {
    name: "boolean",
    test: function(g) {
      return typeof g == "boolean";
    }
  }, {
    name: "Function",
    test: function(g) {
      return typeof g == "function";
    }
  }, {
    name: "Array",
    test: Array.isArray
  }, {
    name: "Date",
    test: function(g) {
      return g instanceof Date;
    }
  }, {
    name: "RegExp",
    test: function(g) {
      return g instanceof RegExp;
    }
  }, {
    name: "Object",
    test: e
  }, {
    name: "null",
    test: function(g) {
      return g === null;
    }
  }, {
    name: "undefined",
    test: function(g) {
      return g === void 0;
    }
  }], r = {
    name: "any",
    test: vi,
    isAny: !0
  };
  let n, i, a = 0, u = {
    createCount: 0
  };
  function s(g) {
    const D = n.get(g);
    if (D)
      return D;
    let S = 'Unknown type "' + g + '"';
    const R = g.toLowerCase();
    let P;
    for (P of i)
      if (P.toLowerCase() === R) {
        S += '. Did you mean "' + P + '" ?';
        break;
      }
    throw new TypeError(S);
  }
  function o(g) {
    let D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "any";
    const S = D ? s(D).index : i.length, R = [];
    for (let T = 0; T < g.length; ++T) {
      if (!g[T] || typeof g[T].name != "string" || typeof g[T].test != "function")
        throw new TypeError("Object with properties {name: string, test: function} expected");
      const B = g[T].name;
      if (n.has(B))
        throw new TypeError('Duplicate type name "' + B + '"');
      R.push(B), n.set(B, {
        name: B,
        test: g[T].test,
        isAny: g[T].isAny,
        index: S + T,
        conversionsTo: []
        // Newly added type can't have any conversions to it
      });
    }
    const P = i.slice(S);
    i = i.slice(0, S).concat(R).concat(P);
    for (let T = S + R.length; T < i.length; ++T)
      n.get(i[T]).index = T;
  }
  function l() {
    n = /* @__PURE__ */ new Map(), i = [], a = 0, o([r], !1);
  }
  l(), o(t);
  function A() {
    let g;
    for (g of i)
      n.get(g).conversionsTo = [];
    a = 0;
  }
  function d(g) {
    const D = i.filter((S) => {
      const R = n.get(S);
      return !R.isAny && R.test(g);
    });
    return D.length ? D : ["any"];
  }
  function m(g) {
    return g && typeof g == "function" && "_typedFunctionData" in g;
  }
  function f(g, D, S) {
    if (!m(g))
      throw new TypeError(Vi);
    const R = S && S.exact, P = Array.isArray(D) ? D.join(",") : D, T = F(P), B = h(T);
    if (!R || B in g.signatures) {
      const fe = g._typedFunctionData.signatureMap.get(B);
      if (fe)
        return fe;
    }
    const H = T.length;
    let Y;
    if (R) {
      Y = [];
      let fe;
      for (fe in g.signatures)
        Y.push(g._typedFunctionData.signatureMap.get(fe));
    } else
      Y = g._typedFunctionData.signatures;
    for (let fe = 0; fe < H; ++fe) {
      const ye = T[fe], Re = [];
      let Je;
      for (Je of Y) {
        const Ye = X(Je.params, fe);
        if (!(!Ye || ye.restParam && !Ye.restParam)) {
          if (!Ye.hasAny) {
            const At = b(Ye);
            if (ye.types.some((lt) => !At.has(lt.name)))
              continue;
          }
          Re.push(Je);
        }
      }
      if (Y = Re, Y.length === 0) break;
    }
    let M;
    for (M of Y)
      if (M.params.length <= H)
        return M;
    throw new TypeError("Signature not found (signature: " + (g.name || "unnamed") + "(" + h(T, ", ") + "))");
  }
  function p(g, D, S) {
    return f(g, D, S).implementation;
  }
  function c(g, D) {
    const S = s(D);
    if (S.test(g))
      return g;
    const R = S.conversionsTo;
    if (R.length === 0)
      throw new Error("There are no conversions to " + D + " defined.");
    for (let P = 0; P < R.length; P++)
      if (s(R[P].from).test(g))
        return R[P].convert(g);
    throw new Error("Cannot convert " + g + " to " + D);
  }
  function h(g) {
    let D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return g.map((S) => S.name).join(D);
  }
  function v(g) {
    const D = g.indexOf("...") === 0, R = (D ? g.length > 3 ? g.slice(3) : "any" : g).split("|").map((H) => s(H.trim()));
    let P = !1, T = D ? "..." : "";
    return {
      types: R.map(function(H) {
        return P = H.isAny || P, T += H.name + "|", {
          name: H.name,
          typeIndex: H.index,
          test: H.test,
          isAny: H.isAny,
          conversion: null,
          conversionIndex: -1
        };
      }),
      name: T.slice(0, -1),
      // remove trailing '|' from above
      hasAny: P,
      hasConversion: !1,
      restParam: D
    };
  }
  function Z(g) {
    const D = g.types.map((B) => B.name), S = U(D);
    let R = g.hasAny, P = g.name;
    const T = S.map(function(B) {
      const H = s(B.from);
      return R = H.isAny || R, P += "|" + B.from, {
        name: B.from,
        typeIndex: H.index,
        test: H.test,
        isAny: H.isAny,
        conversion: B,
        conversionIndex: B.index
      };
    });
    return {
      types: g.types.concat(T),
      name: P,
      hasAny: R,
      hasConversion: T.length > 0,
      restParam: g.restParam
    };
  }
  function b(g) {
    return g.typeSet || (g.typeSet = /* @__PURE__ */ new Set(), g.types.forEach((D) => g.typeSet.add(D.name))), g.typeSet;
  }
  function F(g) {
    const D = [];
    if (typeof g != "string")
      throw new TypeError("Signatures must be strings");
    const S = g.trim();
    if (S === "")
      return D;
    const R = S.split(",");
    for (let P = 0; P < R.length; ++P) {
      const T = v(R[P].trim());
      if (T.restParam && P !== R.length - 1)
        throw new SyntaxError('Unexpected rest parameter "' + R[P] + '": only allowed for the last parameter');
      if (T.types.length === 0)
        return null;
      D.push(T);
    }
    return D;
  }
  function y(g) {
    const D = me(g);
    return D ? D.restParam : !1;
  }
  function V(g) {
    if (!g || g.types.length === 0)
      return vi;
    if (g.types.length === 1)
      return s(g.types[0].name).test;
    if (g.types.length === 2) {
      const D = s(g.types[0].name).test, S = s(g.types[1].name).test;
      return function(P) {
        return D(P) || S(P);
      };
    } else {
      const D = g.types.map(function(S) {
        return s(S.name).test;
      });
      return function(R) {
        for (let P = 0; P < D.length; P++)
          if (D[P](R))
            return !0;
        return !1;
      };
    }
  }
  function W(g) {
    let D, S, R;
    if (y(g)) {
      D = Be(g).map(V);
      const P = D.length, T = V(me(g)), B = function(H) {
        for (let Y = P; Y < H.length; Y++)
          if (!T(H[Y]))
            return !1;
        return !0;
      };
      return function(Y) {
        for (let M = 0; M < D.length; M++)
          if (!D[M](Y[M]))
            return !1;
        return B(Y) && Y.length >= P + 1;
      };
    } else
      return g.length === 0 ? function(T) {
        return T.length === 0;
      } : g.length === 1 ? (S = V(g[0]), function(T) {
        return S(T[0]) && T.length === 1;
      }) : g.length === 2 ? (S = V(g[0]), R = V(g[1]), function(T) {
        return S(T[0]) && R(T[1]) && T.length === 2;
      }) : (D = g.map(V), function(T) {
        for (let B = 0; B < D.length; B++)
          if (!D[B](T[B]))
            return !1;
        return T.length === D.length;
      });
  }
  function X(g, D) {
    return D < g.length ? g[D] : y(g) ? me(g) : null;
  }
  function x(g, D) {
    const S = X(g, D);
    return S ? b(S) : /* @__PURE__ */ new Set();
  }
  function q(g) {
    return g.conversion === null || g.conversion === void 0;
  }
  function I(g, D) {
    const S = /* @__PURE__ */ new Set();
    return g.forEach((R) => {
      const P = x(R.params, D);
      let T;
      for (T of P)
        S.add(T);
    }), S.has("any") ? ["any"] : Array.from(S);
  }
  function E(g, D, S) {
    let R, P;
    const T = g || "unnamed";
    let B = S, H;
    for (H = 0; H < D.length; H++) {
      const ye = [];
      if (B.forEach((Re) => {
        const Je = X(Re.params, H), Ye = V(Je);
        (H < Re.params.length || y(Re.params)) && Ye(D[H]) && ye.push(Re);
      }), ye.length === 0) {
        if (P = I(B, H), P.length > 0) {
          const Re = d(D[H]);
          return R = new TypeError("Unexpected type of argument in function " + T + " (expected: " + P.join(" or ") + ", actual: " + Re.join(" | ") + ", index: " + H + ")"), R.data = {
            category: "wrongType",
            fn: T,
            index: H,
            actual: Re,
            expected: P
          }, R;
        }
      } else
        B = ye;
    }
    const Y = B.map(function(ye) {
      return y(ye.params) ? 1 / 0 : ye.params.length;
    });
    if (D.length < Math.min.apply(null, Y))
      return P = I(B, H), R = new TypeError("Too few arguments in function " + T + " (expected: " + P.join(" or ") + ", index: " + D.length + ")"), R.data = {
        category: "tooFewArgs",
        fn: T,
        index: D.length,
        expected: P
      }, R;
    const M = Math.max.apply(null, Y);
    if (D.length > M)
      return R = new TypeError("Too many arguments in function " + T + " (expected: " + M + ", actual: " + D.length + ")"), R.data = {
        category: "tooManyArgs",
        fn: T,
        index: D.length,
        expectedLength: M
      }, R;
    const fe = [];
    for (let ye = 0; ye < D.length; ++ye)
      fe.push(d(D[ye]).join("|"));
    return R = new TypeError('Arguments of type "' + fe.join(", ") + '" do not match any of the defined signatures of function ' + T + "."), R.data = {
      category: "mismatch",
      actual: fe
    }, R;
  }
  function L(g) {
    let D = i.length + 1;
    for (let S = 0; S < g.types.length; S++)
      q(g.types[S]) && (D = Math.min(D, g.types[S].typeIndex));
    return D;
  }
  function z(g) {
    let D = a + 1;
    for (let S = 0; S < g.types.length; S++)
      q(g.types[S]) || (D = Math.min(D, g.types[S].conversionIndex));
    return D;
  }
  function G(g, D) {
    if (g.hasAny) {
      if (!D.hasAny)
        return 1;
    } else if (D.hasAny)
      return -1;
    if (g.restParam) {
      if (!D.restParam)
        return 1;
    } else if (D.restParam)
      return -1;
    if (g.hasConversion) {
      if (!D.hasConversion)
        return 1;
    } else if (D.hasConversion)
      return -1;
    const S = L(g) - L(D);
    if (S < 0)
      return -1;
    if (S > 0)
      return 1;
    const R = z(g) - z(D);
    return R < 0 ? -1 : R > 0 ? 1 : 0;
  }
  function w(g, D) {
    const S = g.params, R = D.params, P = me(S), T = me(R), B = y(S), H = y(R);
    if (B && P.hasAny) {
      if (!H || !T.hasAny)
        return 1;
    } else if (H && T.hasAny)
      return -1;
    let Y = 0, M = 0, fe;
    for (fe of S)
      fe.hasAny && ++Y, fe.hasConversion && ++M;
    let ye = 0, Re = 0;
    for (fe of R)
      fe.hasAny && ++ye, fe.hasConversion && ++Re;
    if (Y !== ye)
      return Y - ye;
    if (B && P.hasConversion) {
      if (!H || !T.hasConversion)
        return 1;
    } else if (H && T.hasConversion)
      return -1;
    if (M !== Re)
      return M - Re;
    if (B) {
      if (!H)
        return 1;
    } else if (H)
      return -1;
    const Je = (S.length - R.length) * (B ? -1 : 1);
    if (Je !== 0)
      return Je;
    const Ye = [];
    let At = 0;
    for (let Yt = 0; Yt < S.length; ++Yt) {
      const wr = G(S[Yt], R[Yt]);
      Ye.push(wr), At += wr;
    }
    if (At !== 0)
      return At;
    let lt;
    for (lt of Ye)
      if (lt !== 0)
        return lt;
    return 0;
  }
  function U(g) {
    if (g.length === 0)
      return [];
    const D = g.map(s);
    g.length > 1 && D.sort((P, T) => P.index - T.index);
    let S = D[0].conversionsTo;
    if (g.length === 1)
      return S;
    S = S.concat([]);
    const R = new Set(g);
    for (let P = 1; P < D.length; ++P) {
      let T;
      for (T of D[P].conversionsTo)
        R.has(T.from) || (S.push(T), R.add(T.from));
    }
    return S;
  }
  function O(g, D) {
    let S = D;
    if (g.some((P) => P.hasConversion)) {
      const P = y(g), T = g.map(j);
      S = function() {
        const H = [], Y = P ? arguments.length - 1 : arguments.length;
        for (let M = 0; M < Y; M++)
          H[M] = T[M](arguments[M]);
        return P && (H[Y] = arguments[Y].map(T[Y])), D.apply(this, H);
      };
    }
    let R = S;
    if (y(g)) {
      const P = g.length - 1;
      R = function() {
        return S.apply(this, de(arguments, 0, P).concat([de(arguments, P)]));
      };
    }
    return R;
  }
  function j(g) {
    let D, S, R, P;
    const T = [], B = [];
    switch (g.types.forEach(function(H) {
      H.conversion && (T.push(s(H.conversion.from).test), B.push(H.conversion.convert));
    }), B.length) {
      case 0:
        return function(Y) {
          return Y;
        };
      case 1:
        return D = T[0], R = B[0], function(Y) {
          return D(Y) ? R(Y) : Y;
        };
      case 2:
        return D = T[0], S = T[1], R = B[0], P = B[1], function(Y) {
          return D(Y) ? R(Y) : S(Y) ? P(Y) : Y;
        };
      default:
        return function(Y) {
          for (let M = 0; M < B.length; M++)
            if (T[M](Y))
              return B[M](Y);
          return Y;
        };
    }
  }
  function te(g) {
    function D(S, R, P) {
      if (R < S.length) {
        const T = S[R];
        let B = [];
        if (T.restParam) {
          const H = T.types.filter(q);
          H.length < T.types.length && B.push({
            types: H,
            name: "..." + H.map((Y) => Y.name).join("|"),
            hasAny: H.some((Y) => Y.isAny),
            hasConversion: !1,
            restParam: !0
          }), B.push(T);
        } else
          B = T.types.map(function(H) {
            return {
              types: [H],
              name: H.name,
              hasAny: H.isAny,
              hasConversion: H.conversion,
              restParam: !1
            };
          });
        return Pe(B, function(H) {
          return D(S, R + 1, P.concat([H]));
        });
      } else
        return [P];
    }
    return D(g, 0, []);
  }
  function oe(g, D) {
    const S = Math.max(g.length, D.length);
    for (let H = 0; H < S; H++) {
      const Y = x(g, H), M = x(D, H);
      let fe = !1, ye;
      for (ye of M)
        if (Y.has(ye)) {
          fe = !0;
          break;
        }
      if (!fe)
        return !1;
    }
    const R = g.length, P = D.length, T = y(g), B = y(D);
    return T ? B ? R === P : P >= R : B ? R >= P : R === P;
  }
  function ue(g) {
    return g.map((D) => gt(D) ? rt(D.referToSelf.callback) : yt(D) ? Te(D.referTo.references, D.referTo.callback) : D);
  }
  function se(g, D, S) {
    const R = [];
    let P;
    for (P of g) {
      let T = S[P];
      if (typeof T != "number")
        throw new TypeError('No definition for referenced signature "' + P + '"');
      if (T = D[T], typeof T != "function")
        return !1;
      R.push(T);
    }
    return R;
  }
  function qe(g, D, S) {
    const R = ue(g), P = new Array(R.length).fill(!1);
    let T = !0;
    for (; T; ) {
      T = !1;
      let B = !0;
      for (let H = 0; H < R.length; ++H) {
        if (P[H]) continue;
        const Y = R[H];
        if (gt(Y))
          R[H] = Y.referToSelf.callback(S), R[H].referToSelf = Y.referToSelf, P[H] = !0, B = !1;
        else if (yt(Y)) {
          const M = se(Y.referTo.references, R, D);
          M ? (R[H] = Y.referTo.callback.apply(this, M), R[H].referTo = Y.referTo, P[H] = !0, B = !1) : T = !0;
        }
      }
      if (B && T)
        throw new SyntaxError("Circular reference detected in resolving typed.referTo");
    }
    return R;
  }
  function Ee(g) {
    const D = /\bthis(\(|\.signatures\b)/;
    Object.keys(g).forEach((S) => {
      const R = g[S];
      if (D.test(R.toString()))
        throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
    });
  }
  function Se(g, D) {
    if (u.createCount++, Object.keys(D).length === 0)
      throw new SyntaxError("No signatures provided");
    u.warnAgainstDeprecatedThis && Ee(D);
    const S = [], R = [], P = {}, T = [];
    let B;
    for (B in D) {
      if (!Object.prototype.hasOwnProperty.call(D, B))
        continue;
      const le = F(B);
      if (!le) continue;
      S.forEach(function(fr) {
        if (oe(fr, le))
          throw new TypeError('Conflicting signatures "' + h(fr) + '" and "' + h(le) + '".');
      }), S.push(le);
      const je = R.length;
      R.push(D[B]);
      const ho = le.map(Z);
      let Kr;
      for (Kr of te(ho)) {
        const fr = h(Kr);
        T.push({
          params: Kr,
          name: fr,
          fn: je
        }), Kr.every((vo) => !vo.hasConversion) && (P[fr] = je);
      }
    }
    T.sort(w);
    const H = qe(R, P, dr);
    let Y;
    for (Y in P)
      Object.prototype.hasOwnProperty.call(P, Y) && (P[Y] = H[P[Y]]);
    const M = [], fe = /* @__PURE__ */ new Map();
    for (Y of T)
      fe.has(Y.name) || (Y.fn = H[Y.fn], M.push(Y), fe.set(Y.name, Y));
    const ye = M[0] && M[0].params.length <= 2 && !y(M[0].params), Re = M[1] && M[1].params.length <= 2 && !y(M[1].params), Je = M[2] && M[2].params.length <= 2 && !y(M[2].params), Ye = M[3] && M[3].params.length <= 2 && !y(M[3].params), At = M[4] && M[4].params.length <= 2 && !y(M[4].params), lt = M[5] && M[5].params.length <= 2 && !y(M[5].params), Yt = ye && Re && Je && Ye && At && lt;
    for (let le = 0; le < M.length; ++le)
      M[le].test = W(M[le].params);
    const wr = ye ? V(M[0].params[0]) : nt, Lu = Re ? V(M[1].params[0]) : nt, Mu = Je ? V(M[2].params[0]) : nt, Hu = Ye ? V(M[3].params[0]) : nt, Uu = At ? V(M[4].params[0]) : nt, Bu = lt ? V(M[5].params[0]) : nt, Yu = ye ? V(M[0].params[1]) : nt, Ou = Re ? V(M[1].params[1]) : nt, Ju = Je ? V(M[2].params[1]) : nt, ju = Ye ? V(M[3].params[1]) : nt, ku = At ? V(M[4].params[1]) : nt, Qu = lt ? V(M[5].params[1]) : nt;
    for (let le = 0; le < M.length; ++le)
      M[le].implementation = O(M[le].params, M[le].fn);
    const _u = ye ? M[0].implementation : Ot, $u = Re ? M[1].implementation : Ot, eo = Je ? M[2].implementation : Ot, to = Ye ? M[3].implementation : Ot, ro = At ? M[4].implementation : Ot, no = lt ? M[5].implementation : Ot, io = ye ? M[0].params.length : -1, ao = Re ? M[1].params.length : -1, uo = Je ? M[2].params.length : -1, oo = Ye ? M[3].params.length : -1, so = At ? M[4].params.length : -1, Ao = lt ? M[5].params.length : -1, lo = Yt ? 6 : 0, co = M.length, fo = M.map((le) => le.test), mo = M.map((le) => le.implementation), po = function() {
      for (let je = lo; je < co; je++)
        if (fo[je](arguments))
          return mo[je].apply(this, arguments);
      return u.onMismatch(g, arguments, M);
    };
    function dr(le, je) {
      return arguments.length === io && wr(le) && Yu(je) ? _u.apply(this, arguments) : arguments.length === ao && Lu(le) && Ou(je) ? $u.apply(this, arguments) : arguments.length === uo && Mu(le) && Ju(je) ? eo.apply(this, arguments) : arguments.length === oo && Hu(le) && ju(je) ? to.apply(this, arguments) : arguments.length === so && Uu(le) && ku(je) ? ro.apply(this, arguments) : arguments.length === Ao && Bu(le) && Qu(je) ? no.apply(this, arguments) : po.apply(this, arguments);
    }
    try {
      Object.defineProperty(dr, "name", {
        value: g
      });
    } catch {
    }
    return dr.signatures = P, dr._typedFunctionData = {
      signatures: M,
      signatureMap: fe
    }, dr;
  }
  function Fe(g, D, S) {
    throw E(g, D, S);
  }
  function Be(g) {
    return de(g, 0, g.length - 1);
  }
  function me(g) {
    return g[g.length - 1];
  }
  function de(g, D, S) {
    return Array.prototype.slice.call(g, D, S);
  }
  function tt(g, D) {
    for (let S = 0; S < g.length; S++)
      if (D(g[S]))
        return g[S];
  }
  function Pe(g, D) {
    return Array.prototype.concat.apply([], g.map(D));
  }
  function pe() {
    const g = Be(arguments).map((S) => h(F(S))), D = me(arguments);
    if (typeof D != "function")
      throw new TypeError("Callback function expected as last argument");
    return Te(g, D);
  }
  function Te(g, D) {
    return {
      referTo: {
        references: g,
        callback: D
      }
    };
  }
  function rt(g) {
    if (typeof g != "function")
      throw new TypeError("Callback function expected as first argument");
    return {
      referToSelf: {
        callback: g
      }
    };
  }
  function yt(g) {
    return g && typeof g.referTo == "object" && Array.isArray(g.referTo.references) && typeof g.referTo.callback == "function";
  }
  function gt(g) {
    return g && typeof g.referToSelf == "object" && typeof g.referToSelf.callback == "function";
  }
  function Ut(g, D) {
    if (!g)
      return D;
    if (D && D !== g) {
      const S = new Error("Function names do not match (expected: " + g + ", actual: " + D + ")");
      throw S.data = {
        actual: D,
        expected: g
      }, S;
    }
    return g;
  }
  function Bt(g) {
    let D;
    for (const S in g)
      Object.prototype.hasOwnProperty.call(g, S) && (m(g[S]) || typeof g[S].signature == "string") && (D = Ut(D, g[S].name));
    return D;
  }
  function Zn(g, D) {
    let S;
    for (S in D)
      if (Object.prototype.hasOwnProperty.call(D, S)) {
        if (S in g && D[S] !== g[S]) {
          const R = new Error('Signature "' + S + '" is defined twice');
          throw R.data = {
            signature: S,
            sourceFunction: D[S],
            destFunction: g[S]
          }, R;
        }
        g[S] = D[S];
      }
  }
  const Pu = u;
  u = function(g) {
    const D = typeof g == "string", S = D ? 1 : 0;
    let R = D ? g : "";
    const P = {};
    for (let T = S; T < arguments.length; ++T) {
      const B = arguments[T];
      let H = {}, Y;
      if (typeof B == "function" ? (Y = B.name, typeof B.signature == "string" ? H[B.signature] = B : m(B) && (H = B.signatures)) : e(B) && (H = B, D || (Y = Bt(B))), Object.keys(H).length === 0) {
        const M = new TypeError("Argument to 'typed' at index " + T + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
        throw M.data = {
          index: T,
          argument: B
        }, M;
      }
      D || (R = Ut(R, Y)), Zn(P, H);
    }
    return Se(R || "", P);
  }, u.create = za, u.createCount = Pu.createCount, u.onMismatch = Fe, u.throwMismatchError = Fe, u.createError = E, u.clear = l, u.clearConversions = A, u.addTypes = o, u._findType = s, u.referTo = pe, u.referToSelf = rt, u.convert = c, u.findSignature = f, u.find = p, u.isTypedFunction = m, u.warnAgainstDeprecatedThis = !0, u.addType = function(g, D) {
    let S = "any";
    D !== !1 && n.has("Object") && (S = "Object"), u.addTypes([g], S);
  };
  function ci(g) {
    if (!g || typeof g.from != "string" || typeof g.to != "string" || typeof g.convert != "function")
      throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
    if (g.to === g.from)
      throw new SyntaxError('Illegal to define conversion from "' + g.from + '" to itself.');
  }
  return u.addConversion = function(g) {
    let D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      override: !1
    };
    ci(g);
    const S = s(g.to), R = S.conversionsTo.find((P) => P.from === g.from);
    if (R)
      if (D && D.override)
        u.removeConversion({
          from: R.from,
          to: g.to,
          convert: R.convert
        });
      else
        throw new Error('There is already a conversion from "' + g.from + '" to "' + S.name + '"');
    S.conversionsTo.push({
      from: g.from,
      convert: g.convert,
      index: a++
    });
  }, u.addConversions = function(g, D) {
    g.forEach((S) => u.addConversion(S, D));
  }, u.removeConversion = function(g) {
    ci(g);
    const D = s(g.to), S = tt(D.conversionsTo, (P) => P.from === g.from);
    if (!S)
      throw new Error("Attempt to remove nonexistent conversion from " + g.from + " to " + g.to);
    if (S.convert !== g.convert)
      throw new Error("Conversion to remove does not match existing conversion");
    const R = D.conversionsTo.indexOf(S);
    D.conversionsTo.splice(R, 1);
  }, u.resolve = function(g, D) {
    if (!m(g))
      throw new TypeError(Vi);
    const S = g._typedFunctionData.signatures;
    for (let R = 0; R < S.length; ++R)
      if (S[R].test(D))
        return S[R];
    return null;
  }, u;
}
const jr = za();
function J(e, t, r, n) {
  function i(a) {
    var u = zs(a, t.map(Ls));
    return Gs(e, t, a), r(u);
  }
  return i.isFactory = !0, i.fn = e, i.dependencies = t.slice().sort(), n && (i.meta = n), i;
}
function Gs(e, t, r) {
  var n = t.filter((a) => !Ps(a)).every((a) => r[a] !== void 0);
  if (!n) {
    var i = t.filter((a) => r[a] === void 0);
    throw new Error('Cannot create function "'.concat(e, '", ') + "some dependencies are missing: ".concat(i.map((a) => '"'.concat(a, '"')).join(", "), "."));
  }
}
function Ps(e) {
  return e && e[0] === "?";
}
function Ls(e) {
  return e && e[0] === "?" ? e.slice(1) : e;
}
function Ke(e) {
  return typeof e == "boolean" ? !0 : isFinite(e) ? e === Math.round(e) : !1;
}
function Ms(e) {
  return /^-?\d+$/.test(e);
}
function Ta(e, t) {
  return t.number === "bigint" && !Ms(e) ? t.numberFallback : t.number;
}
function Fn(e, t, r) {
  var n = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, i = n[t], a = "";
  if (r) {
    if (r < 1)
      throw new Error("size must be in greater than 0");
    if (!Ke(r))
      throw new Error("size must be an integer");
    if (e > 2 ** (r - 1) - 1 || e < -(2 ** (r - 1)))
      throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
    if (!Ke(e))
      throw new Error("Value must be an integer");
    e < 0 && (e = e + 2 ** r), a = "i".concat(r);
  }
  var u = "";
  return e < 0 && (e = -e, u = "-"), "".concat(u).concat(i).concat(e.toString(t)).concat(a);
}
function In(e, t) {
  if (typeof t == "function")
    return t(e);
  if (e === 1 / 0)
    return "Infinity";
  if (e === -1 / 0)
    return "-Infinity";
  if (isNaN(e))
    return "NaN";
  var {
    notation: r,
    precision: n,
    wordSize: i
  } = Na(t);
  switch (r) {
    case "fixed":
      return Us(e, n);
    case "exponential":
      return Ga(e, n);
    case "engineering":
      return Hs(e, n);
    case "bin":
      return Fn(e, 2, i);
    case "oct":
      return Fn(e, 8, i);
    case "hex":
      return Fn(e, 16, i);
    case "auto":
      return Bs(e, n, t).replace(/((\.\d*?)(0+))($|e)/, function() {
        var a = arguments[2], u = arguments[4];
        return a !== "." ? a + u : u;
      });
    default:
      throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function Na(e) {
  var t = "auto", r, n;
  if (e !== void 0)
    if (Ze(e))
      r = e;
    else if (We(e))
      r = e.toNumber();
    else if (On(e))
      e.precision !== void 0 && (r = bi(e.precision, () => {
        throw new Error('Option "precision" must be a number or BigNumber');
      })), e.wordSize !== void 0 && (n = bi(e.wordSize, () => {
        throw new Error('Option "wordSize" must be a number or BigNumber');
      })), e.notation && (t = e.notation);
    else
      throw new Error("Unsupported type of options, number, BigNumber, or object expected");
  return {
    notation: t,
    precision: r,
    wordSize: n
  };
}
function dn(e) {
  var t = String(e).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!t)
    throw new SyntaxError("Invalid number " + e);
  var r = t[1], n = t[2], i = parseFloat(t[4] || "0"), a = n.indexOf(".");
  i += a !== -1 ? a - 1 : n.length - 1;
  var u = n.replace(".", "").replace(/^0*/, function(s) {
    return i -= s.length, "";
  }).replace(/0*$/, "").split("").map(function(s) {
    return parseInt(s);
  });
  return u.length === 0 && (u.push(0), i++), {
    sign: r,
    coefficients: u,
    exponent: i
  };
}
function Hs(e, t) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var r = dn(e), n = fn(r, t), i = n.exponent, a = n.coefficients, u = i % 3 === 0 ? i : i < 0 ? i - 3 - i % 3 : i - i % 3;
  if (Ze(t))
    for (; t > a.length || i - u + 1 > a.length; )
      a.push(0);
  else
    for (var s = Math.abs(i - u) - (a.length - 1), o = 0; o < s; o++)
      a.push(0);
  for (var l = Math.abs(i - u), A = 1; l > 0; )
    A++, l--;
  var d = a.slice(A).join(""), m = Ze(t) && d.length || d.match(/[1-9]/) ? "." + d : "", f = a.slice(0, A).join("") + m + "e" + (i >= 0 ? "+" : "") + u.toString();
  return n.sign + f;
}
function Us(e, t) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var r = dn(e), n = typeof t == "number" ? fn(r, r.exponent + 1 + t) : r, i = n.coefficients, a = n.exponent + 1, u = a + (t || 0);
  return i.length < u && (i = i.concat(nr(u - i.length))), a < 0 && (i = nr(-a + 1).concat(i), a = 1), a < i.length && i.splice(a, 0, a === 0 ? "0." : "."), n.sign + i.join("");
}
function Ga(e, t) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var r = dn(e), n = t ? fn(r, t) : r, i = n.coefficients, a = n.exponent;
  i.length < t && (i = i.concat(nr(t - i.length)));
  var u = i.shift();
  return n.sign + u + (i.length > 0 ? "." + i.join("") : "") + "e" + (a >= 0 ? "+" : "") + a;
}
function Bs(e, t, r) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var n = yi(r == null ? void 0 : r.lowerExp, -3), i = yi(r == null ? void 0 : r.upperExp, 5), a = dn(e), u = t ? fn(a, t) : a;
  if (u.exponent < n || u.exponent >= i)
    return Ga(e, t);
  var s = u.coefficients, o = u.exponent;
  s.length < t && (s = s.concat(nr(t - s.length))), s = s.concat(nr(o - s.length + 1 + (s.length < t ? t - s.length : 0))), s = nr(-o).concat(s);
  var l = o > 0 ? o : 0;
  return l < s.length - 1 && s.splice(l + 1, 0, "."), u.sign + s.join("");
}
function fn(e, t) {
  for (var r = {
    sign: e.sign,
    coefficients: e.coefficients,
    exponent: e.exponent
  }, n = r.coefficients; t <= 0; )
    n.unshift(0), r.exponent++, t++;
  if (n.length > t) {
    var i = n.splice(t, n.length - t);
    if (i[0] >= 5) {
      var a = t - 1;
      for (n[a]++; n[a] === 10; )
        n.pop(), a === 0 && (n.unshift(0), r.exponent++, a++), a--, n[a]++;
    }
  }
  return r;
}
function nr(e) {
  for (var t = [], r = 0; r < e; r++)
    t.push(0);
  return t;
}
function Ys(e) {
  return e.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function Ct(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (n < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return isNaN(e) || isNaN(t) ? !1 : !isFinite(e) || !isFinite(t) ? e === t : e === t ? !0 : Math.abs(e - t) <= Math.max(r * Math.max(Math.abs(e), Math.abs(t)), n);
}
function bi(e, t) {
  if (Ze(e))
    return e;
  if (We(e))
    return e.toNumber();
  t();
}
function yi(e, t) {
  return Ze(e) ? e : We(e) ? e.toNumber() : t;
}
var Pa = function() {
  return Pa = jr.create, jr;
}, Os = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], Js = /* @__PURE__ */ J("typed", Os, function(t) {
  var {
    BigNumber: r,
    Complex: n,
    DenseMatrix: i,
    Fraction: a
  } = t, u = Pa();
  return u.clear(), u.addTypes([
    {
      name: "number",
      test: Ze
    },
    {
      name: "Complex",
      test: wa
    },
    {
      name: "BigNumber",
      test: We
    },
    {
      name: "bigint",
      test: us
    },
    {
      name: "Fraction",
      test: Ka
    },
    {
      name: "Unit",
      test: Ia
    },
    // The following type matches a valid variable name, i.e., an alphanumeric
    // string starting with an alphabetic character. It is used (at least)
    // in the definition of the derivative() function, as the argument telling
    // what to differentiate over must (currently) be a variable.
    // TODO: deprecate the identifier type (it's not used anymore, see https://github.com/josdejong/mathjs/issues/3253)
    {
      name: "identifier",
      test: (s) => ot && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(s)
    },
    {
      name: "string",
      test: ot
    },
    {
      name: "Chain",
      test: Es
    },
    {
      name: "Array",
      test: ge
    },
    {
      name: "Matrix",
      test: Ve
    },
    {
      name: "DenseMatrix",
      test: os
    },
    {
      name: "SparseMatrix",
      test: ss
    },
    {
      name: "Range",
      test: Ea
    },
    {
      name: "Index",
      test: cn
    },
    {
      name: "boolean",
      test: As
    },
    {
      name: "ResultSet",
      test: ls
    },
    {
      name: "Help",
      test: cs
    },
    {
      name: "function",
      test: ds
    },
    {
      name: "Date",
      test: fs
    },
    {
      name: "RegExp",
      test: ms
    },
    {
      name: "null",
      test: hs
    },
    {
      name: "undefined",
      test: vs
    },
    {
      name: "AccessorNode",
      test: Vs
    },
    {
      name: "ArrayNode",
      test: bs
    },
    {
      name: "AssignmentNode",
      test: ys
    },
    {
      name: "BlockNode",
      test: gs
    },
    {
      name: "ConditionalNode",
      test: Zs
    },
    {
      name: "ConstantNode",
      test: Fs
    },
    {
      name: "FunctionNode",
      test: Ws
    },
    {
      name: "FunctionAssignmentNode",
      test: Xs
    },
    {
      name: "IndexNode",
      test: xs
    },
    {
      name: "Node",
      test: Ds
    },
    {
      name: "ObjectNode",
      test: Cs
    },
    {
      name: "OperatorNode",
      test: qs
    },
    {
      name: "ParenthesisNode",
      test: Ss
    },
    {
      name: "RangeNode",
      test: ws
    },
    {
      name: "RelationalNode",
      test: Ks
    },
    {
      name: "SymbolNode",
      test: Is
    },
    {
      name: "Map",
      test: ps
    },
    {
      name: "Object",
      test: On
    }
    // order 'Object' last, it matches on other classes too
  ]), u.addConversions([{
    from: "number",
    to: "BigNumber",
    convert: function(o) {
      if (r || Ir(o), Ys(o) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + o + "). Use function bignumber(x) to convert to BigNumber.");
      return new r(o);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(o) {
      return n || Er(o), new n(o, 0);
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(o) {
      return n || Er(o), new n(o.toNumber(), 0);
    }
  }, {
    from: "bigint",
    to: "number",
    convert: function(o) {
      if (o > Number.MAX_SAFE_INTEGER)
        throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + o + ")");
      return Number(o);
    }
  }, {
    from: "bigint",
    to: "BigNumber",
    convert: function(o) {
      return r || Ir(o), new r(o.toString());
    }
  }, {
    from: "bigint",
    to: "Fraction",
    convert: function(o) {
      return a || Rr(o), new a(o.toString());
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(o) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(o) {
      return n || Er(o), new n(o.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(o) {
      a || Rr(o);
      var l = new a(o);
      if (l.valueOf() !== o)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + o + "). Use function fraction(x) to convert to Fraction.");
      return l;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(o) {
      var l = Number(o);
      if (isNaN(l))
        throw new Error('Cannot convert "' + o + '" to a number');
      return l;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(o) {
      r || Ir(o);
      try {
        return new r(o);
      } catch {
        throw new Error('Cannot convert "' + o + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "bigint",
    convert: function(o) {
      try {
        return BigInt(o);
      } catch {
        throw new Error('Cannot convert "' + o + '" to BigInt');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(o) {
      a || Rr(o);
      try {
        return new a(o);
      } catch {
        throw new Error('Cannot convert "' + o + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(o) {
      n || Er(o);
      try {
        return new n(o);
      } catch {
        throw new Error('Cannot convert "' + o + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(o) {
      return +o;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(o) {
      return r || Ir(o), new r(+o);
    }
  }, {
    from: "boolean",
    to: "bigint",
    convert: function(o) {
      return BigInt(+o);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(o) {
      return a || Rr(o), new a(+o);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(o) {
      return String(o);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(o) {
      return i || js(), new i(o);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(o) {
      return o.valueOf();
    }
  }]), u.onMismatch = (s, o, l) => {
    var A = u.createError(s, o, l);
    if (["wrongType", "mismatch"].includes(A.data.category) && o.length === 1 && yr(o[0]) && // check if the function can be unary:
    l.some((m) => !m.params.includes(","))) {
      var d = new TypeError("Function '".concat(s, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(s, ")'."));
      throw d.data = A.data, d;
    }
    throw A;
  }, u.onMismatch = (s, o, l) => {
    var A = u.createError(s, o, l);
    if (["wrongType", "mismatch"].includes(A.data.category) && o.length === 1 && yr(o[0]) && // check if the function can be unary:
    l.some((m) => !m.params.includes(","))) {
      var d = new TypeError("Function '".concat(s, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(s, ")'."));
      throw d.data = A.data, d;
    }
    throw A;
  }, u;
});
function Ir(e) {
  throw new Error("Cannot convert value ".concat(e, " into a BigNumber: no class 'BigNumber' provided"));
}
function Er(e) {
  throw new Error("Cannot convert value ".concat(e, " into a Complex number: no class 'Complex' provided"));
}
function js() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function Rr(e) {
  throw new Error("Cannot convert value ".concat(e, " into a Fraction, no class 'Fraction' provided."));
}
/*!
 *  decimal.js v10.5.0
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var $t = 9e15, Nt = 1e9, En = "0123456789abcdef", kr = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Qr = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Rn = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -$t,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: $t,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, La, Dt, re = !0, mn = "[DecimalError] ", Rt = mn + "Invalid argument: ", Ma = mn + "Precision limit exceeded", Ha = mn + "crypto unavailable", Ua = "[object Decimal]", Ue = Math.floor, ze = Math.pow, ks = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, Qs = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, _s = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Ba = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ft = 1e7, $ = 7, $s = 9007199254740991, eA = kr.length - 1, zn = Qr.length - 1, N = { toStringTag: Ua };
N.absoluteValue = N.abs = function() {
  var e = new this.constructor(this);
  return e.s < 0 && (e.s = 1), Q(e);
};
N.ceil = function() {
  return Q(new this.constructor(this), this.e + 1, 2);
};
N.clampedTo = N.clamp = function(e, t) {
  var r, n = this, i = n.constructor;
  if (e = new i(e), t = new i(t), !e.s || !t.s) return new i(NaN);
  if (e.gt(t)) throw Error(Rt + t);
  return r = n.cmp(e), r < 0 ? e : n.cmp(t) > 0 ? t : new i(n);
};
N.comparedTo = N.cmp = function(e) {
  var t, r, n, i, a = this, u = a.d, s = (e = new a.constructor(e)).d, o = a.s, l = e.s;
  if (!u || !s)
    return !o || !l ? NaN : o !== l ? o : u === s ? 0 : !u ^ o < 0 ? 1 : -1;
  if (!u[0] || !s[0]) return u[0] ? o : s[0] ? -l : 0;
  if (o !== l) return o;
  if (a.e !== e.e) return a.e > e.e ^ o < 0 ? 1 : -1;
  for (n = u.length, i = s.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (u[t] !== s[t]) return u[t] > s[t] ^ o < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ o < 0 ? 1 : -1;
};
N.cosine = N.cos = function() {
  var e, t, r = this, n = r.constructor;
  return r.d ? r.d[0] ? (e = n.precision, t = n.rounding, n.precision = e + Math.max(r.e, r.sd()) + $, n.rounding = 1, r = tA(n, ka(n, r)), n.precision = e, n.rounding = t, Q(Dt == 2 || Dt == 3 ? r.neg() : r, e, t, !0)) : new n(1) : new n(NaN);
};
N.cubeRoot = N.cbrt = function() {
  var e, t, r, n, i, a, u, s, o, l, A = this, d = A.constructor;
  if (!A.isFinite() || A.isZero()) return new d(A);
  for (re = !1, a = A.s * ze(A.s * A, 1 / 3), !a || Math.abs(a) == 1 / 0 ? (r = Le(A.d), e = A.e, (a = (e - r.length + 1) % 3) && (r += a == 1 || a == -2 ? "0" : "00"), a = ze(r, 1 / 3), e = Ue((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), a == 1 / 0 ? r = "5e" + e : (r = a.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + e), n = new d(r), n.s = A.s) : n = new d(a.toString()), u = (e = d.precision) + 3; ; )
    if (s = n, o = s.times(s).times(s), l = o.plus(A), n = be(l.plus(A).times(s), l.plus(o), u + 2, 1), Le(s.d).slice(0, u) === (r = Le(n.d)).slice(0, u))
      if (r = r.slice(u - 3, u + 1), r == "9999" || !i && r == "4999") {
        if (!i && (Q(s, e + 1, 0), s.times(s).times(s).eq(A))) {
          n = s;
          break;
        }
        u += 4, i = 1;
      } else {
        (!+r || !+r.slice(1) && r.charAt(0) == "5") && (Q(n, e + 1, 1), t = !n.times(n).times(n).eq(A));
        break;
      }
  return re = !0, Q(n, e, d.rounding, t);
};
N.decimalPlaces = N.dp = function() {
  var e, t = this.d, r = NaN;
  if (t) {
    if (e = t.length - 1, r = (e - Ue(this.e / $)) * $, e = t[e], e) for (; e % 10 == 0; e /= 10) r--;
    r < 0 && (r = 0);
  }
  return r;
};
N.dividedBy = N.div = function(e) {
  return be(this, new this.constructor(e));
};
N.dividedToIntegerBy = N.divToInt = function(e) {
  var t = this, r = t.constructor;
  return Q(be(t, new r(e), 0, 1, 1), r.precision, r.rounding);
};
N.equals = N.eq = function(e) {
  return this.cmp(e) === 0;
};
N.floor = function() {
  return Q(new this.constructor(this), this.e + 1, 3);
};
N.greaterThan = N.gt = function(e) {
  return this.cmp(e) > 0;
};
N.greaterThanOrEqualTo = N.gte = function(e) {
  var t = this.cmp(e);
  return t == 1 || t === 0;
};
N.hyperbolicCosine = N.cosh = function() {
  var e, t, r, n, i, a = this, u = a.constructor, s = new u(1);
  if (!a.isFinite()) return new u(a.s ? 1 / 0 : NaN);
  if (a.isZero()) return s;
  r = u.precision, n = u.rounding, u.precision = r + Math.max(a.e, a.sd()) + 4, u.rounding = 1, i = a.d.length, i < 32 ? (e = Math.ceil(i / 3), t = (1 / hn(4, e)).toString()) : (e = 16, t = "2.3283064365386962890625e-10"), a = ar(u, 1, a.times(t), new u(1), !0);
  for (var o, l = e, A = new u(8); l--; )
    o = a.times(a), a = s.minus(o.times(A.minus(o.times(A))));
  return Q(a, u.precision = r, u.rounding = n, !0);
};
N.hyperbolicSine = N.sinh = function() {
  var e, t, r, n, i = this, a = i.constructor;
  if (!i.isFinite() || i.isZero()) return new a(i);
  if (t = a.precision, r = a.rounding, a.precision = t + Math.max(i.e, i.sd()) + 4, a.rounding = 1, n = i.d.length, n < 3)
    i = ar(a, 2, i, i, !0);
  else {
    e = 1.4 * Math.sqrt(n), e = e > 16 ? 16 : e | 0, i = i.times(1 / hn(5, e)), i = ar(a, 2, i, i, !0);
    for (var u, s = new a(5), o = new a(16), l = new a(20); e--; )
      u = i.times(i), i = i.times(s.plus(u.times(o.times(u).plus(l))));
  }
  return a.precision = t, a.rounding = r, Q(i, t, r, !0);
};
N.hyperbolicTangent = N.tanh = function() {
  var e, t, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + 7, n.rounding = 1, be(r.sinh(), r.cosh(), n.precision = e, n.rounding = t)) : new n(r.s);
};
N.inverseCosine = N.acos = function() {
  var e = this, t = e.constructor, r = e.abs().cmp(1), n = t.precision, i = t.rounding;
  return r !== -1 ? r === 0 ? e.isNeg() ? pt(t, n, i) : new t(0) : new t(NaN) : e.isZero() ? pt(t, n + 4, i).times(0.5) : (t.precision = n + 6, t.rounding = 1, e = new t(1).minus(e).div(e.plus(1)).sqrt().atan(), t.precision = n, t.rounding = i, e.times(2));
};
N.inverseHyperbolicCosine = N.acosh = function() {
  var e, t, r = this, n = r.constructor;
  return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (e = n.precision, t = n.rounding, n.precision = e + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, re = !1, r = r.times(r).minus(1).sqrt().plus(r), re = !0, n.precision = e, n.rounding = t, r.ln()) : new n(r);
};
N.inverseHyperbolicSine = N.asinh = function() {
  var e, t, r = this, n = r.constructor;
  return !r.isFinite() || r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, re = !1, r = r.times(r).plus(1).sqrt().plus(r), re = !0, n.precision = e, n.rounding = t, r.ln());
};
N.inverseHyperbolicTangent = N.atanh = function() {
  var e, t, r, n, i = this, a = i.constructor;
  return i.isFinite() ? i.e >= 0 ? new a(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (e = a.precision, t = a.rounding, n = i.sd(), Math.max(n, e) < 2 * -i.e - 1 ? Q(new a(i), e, t, !0) : (a.precision = r = n - i.e, i = be(i.plus(1), new a(1).minus(i), r + e, 1), a.precision = e + 4, a.rounding = 1, i = i.ln(), a.precision = e, a.rounding = t, i.times(0.5))) : new a(NaN);
};
N.inverseSine = N.asin = function() {
  var e, t, r, n, i = this, a = i.constructor;
  return i.isZero() ? new a(i) : (t = i.abs().cmp(1), r = a.precision, n = a.rounding, t !== -1 ? t === 0 ? (e = pt(a, r + 4, n).times(0.5), e.s = i.s, e) : new a(NaN) : (a.precision = r + 6, a.rounding = 1, i = i.div(new a(1).minus(i.times(i)).sqrt().plus(1)).atan(), a.precision = r, a.rounding = n, i.times(2)));
};
N.inverseTangent = N.atan = function() {
  var e, t, r, n, i, a, u, s, o, l = this, A = l.constructor, d = A.precision, m = A.rounding;
  if (l.isFinite()) {
    if (l.isZero())
      return new A(l);
    if (l.abs().eq(1) && d + 4 <= zn)
      return u = pt(A, d + 4, m).times(0.25), u.s = l.s, u;
  } else {
    if (!l.s) return new A(NaN);
    if (d + 4 <= zn)
      return u = pt(A, d + 4, m).times(0.5), u.s = l.s, u;
  }
  for (A.precision = s = d + 10, A.rounding = 1, r = Math.min(28, s / $ + 2 | 0), e = r; e; --e) l = l.div(l.times(l).plus(1).sqrt().plus(1));
  for (re = !1, t = Math.ceil(s / $), n = 1, o = l.times(l), u = new A(l), i = l; e !== -1; )
    if (i = i.times(o), a = u.minus(i.div(n += 2)), i = i.times(o), u = a.plus(i.div(n += 2)), u.d[t] !== void 0) for (e = t; u.d[e] === a.d[e] && e--; ) ;
  return r && (u = u.times(2 << r - 1)), re = !0, Q(u, A.precision = d, A.rounding = m, !0);
};
N.isFinite = function() {
  return !!this.d;
};
N.isInteger = N.isInt = function() {
  return !!this.d && Ue(this.e / $) > this.d.length - 2;
};
N.isNaN = function() {
  return !this.s;
};
N.isNegative = N.isNeg = function() {
  return this.s < 0;
};
N.isPositive = N.isPos = function() {
  return this.s > 0;
};
N.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
N.lessThan = N.lt = function(e) {
  return this.cmp(e) < 0;
};
N.lessThanOrEqualTo = N.lte = function(e) {
  return this.cmp(e) < 1;
};
N.logarithm = N.log = function(e) {
  var t, r, n, i, a, u, s, o, l = this, A = l.constructor, d = A.precision, m = A.rounding, f = 5;
  if (e == null)
    e = new A(10), t = !0;
  else {
    if (e = new A(e), r = e.d, e.s < 0 || !r || !r[0] || e.eq(1)) return new A(NaN);
    t = e.eq(10);
  }
  if (r = l.d, l.s < 0 || !r || !r[0] || l.eq(1))
    return new A(r && !r[0] ? -1 / 0 : l.s != 1 ? NaN : r ? 0 : 1 / 0);
  if (t)
    if (r.length > 1)
      a = !0;
    else {
      for (i = r[0]; i % 10 === 0; ) i /= 10;
      a = i !== 1;
    }
  if (re = !1, s = d + f, u = Kt(l, s), n = t ? _r(A, s + 10) : Kt(e, s), o = be(u, n, s, 1), Zr(o.d, i = d, m))
    do
      if (s += 10, u = Kt(l, s), n = t ? _r(A, s + 10) : Kt(e, s), o = be(u, n, s, 1), !a) {
        +Le(o.d).slice(i + 1, i + 15) + 1 == 1e14 && (o = Q(o, d + 1, 0));
        break;
      }
    while (Zr(o.d, i += 10, m));
  return re = !0, Q(o, d, m);
};
N.minus = N.sub = function(e) {
  var t, r, n, i, a, u, s, o, l, A, d, m, f = this, p = f.constructor;
  if (e = new p(e), !f.d || !e.d)
    return !f.s || !e.s ? e = new p(NaN) : f.d ? e.s = -e.s : e = new p(e.d || f.s !== e.s ? f : NaN), e;
  if (f.s != e.s)
    return e.s = -e.s, f.plus(e);
  if (l = f.d, m = e.d, s = p.precision, o = p.rounding, !l[0] || !m[0]) {
    if (m[0]) e.s = -e.s;
    else if (l[0]) e = new p(f);
    else return new p(o === 3 ? -0 : 0);
    return re ? Q(e, s, o) : e;
  }
  if (r = Ue(e.e / $), A = Ue(f.e / $), l = l.slice(), a = A - r, a) {
    for (d = a < 0, d ? (t = l, a = -a, u = m.length) : (t = m, r = A, u = l.length), n = Math.max(Math.ceil(s / $), u) + 2, a > n && (a = n, t.length = 1), t.reverse(), n = a; n--; ) t.push(0);
    t.reverse();
  } else {
    for (n = l.length, u = m.length, d = n < u, d && (u = n), n = 0; n < u; n++)
      if (l[n] != m[n]) {
        d = l[n] < m[n];
        break;
      }
    a = 0;
  }
  for (d && (t = l, l = m, m = t, e.s = -e.s), u = l.length, n = m.length - u; n > 0; --n) l[u++] = 0;
  for (n = m.length; n > a; ) {
    if (l[--n] < m[n]) {
      for (i = n; i && l[--i] === 0; ) l[i] = ft - 1;
      --l[i], l[n] += ft;
    }
    l[n] -= m[n];
  }
  for (; l[--u] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (e.d = l, e.e = pn(l, r), re ? Q(e, s, o) : e) : new p(o === 3 ? -0 : 0);
};
N.modulo = N.mod = function(e) {
  var t, r = this, n = r.constructor;
  return e = new n(e), !r.d || !e.s || e.d && !e.d[0] ? new n(NaN) : !e.d || r.d && !r.d[0] ? Q(new n(r), n.precision, n.rounding) : (re = !1, n.modulo == 9 ? (t = be(r, e.abs(), 0, 3, 1), t.s *= e.s) : t = be(r, e, 0, n.modulo, 1), t = t.times(e), re = !0, r.minus(t));
};
N.naturalExponential = N.exp = function() {
  return Tn(this);
};
N.naturalLogarithm = N.ln = function() {
  return Kt(this);
};
N.negated = N.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, Q(e);
};
N.plus = N.add = function(e) {
  var t, r, n, i, a, u, s, o, l, A, d = this, m = d.constructor;
  if (e = new m(e), !d.d || !e.d)
    return !d.s || !e.s ? e = new m(NaN) : d.d || (e = new m(e.d || d.s === e.s ? d : NaN)), e;
  if (d.s != e.s)
    return e.s = -e.s, d.minus(e);
  if (l = d.d, A = e.d, s = m.precision, o = m.rounding, !l[0] || !A[0])
    return A[0] || (e = new m(d)), re ? Q(e, s, o) : e;
  if (a = Ue(d.e / $), n = Ue(e.e / $), l = l.slice(), i = a - n, i) {
    for (i < 0 ? (r = l, i = -i, u = A.length) : (r = A, n = a, u = l.length), a = Math.ceil(s / $), u = a > u ? a + 1 : u + 1, i > u && (i = u, r.length = 1), r.reverse(); i--; ) r.push(0);
    r.reverse();
  }
  for (u = l.length, i = A.length, u - i < 0 && (i = u, r = A, A = l, l = r), t = 0; i; )
    t = (l[--i] = l[i] + A[i] + t) / ft | 0, l[i] %= ft;
  for (t && (l.unshift(t), ++n), u = l.length; l[--u] == 0; ) l.pop();
  return e.d = l, e.e = pn(l, n), re ? Q(e, s, o) : e;
};
N.precision = N.sd = function(e) {
  var t, r = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Rt + e);
  return r.d ? (t = Ya(r.d), e && r.e + 1 > t && (t = r.e + 1)) : t = NaN, t;
};
N.round = function() {
  var e = this, t = e.constructor;
  return Q(new t(e), e.e + 1, t.rounding);
};
N.sine = N.sin = function() {
  var e, t, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + Math.max(r.e, r.sd()) + $, n.rounding = 1, r = nA(n, ka(n, r)), n.precision = e, n.rounding = t, Q(Dt > 2 ? r.neg() : r, e, t, !0)) : new n(NaN);
};
N.squareRoot = N.sqrt = function() {
  var e, t, r, n, i, a, u = this, s = u.d, o = u.e, l = u.s, A = u.constructor;
  if (l !== 1 || !s || !s[0])
    return new A(!l || l < 0 && (!s || s[0]) ? NaN : s ? u : 1 / 0);
  for (re = !1, l = Math.sqrt(+u), l == 0 || l == 1 / 0 ? (t = Le(s), (t.length + o) % 2 == 0 && (t += "0"), l = Math.sqrt(t), o = Ue((o + 1) / 2) - (o < 0 || o % 2), l == 1 / 0 ? t = "5e" + o : (t = l.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + o), n = new A(t)) : n = new A(l.toString()), r = (o = A.precision) + 3; ; )
    if (a = n, n = a.plus(be(u, a, r + 2, 1)).times(0.5), Le(a.d).slice(0, r) === (t = Le(n.d)).slice(0, r))
      if (t = t.slice(r - 3, r + 1), t == "9999" || !i && t == "4999") {
        if (!i && (Q(a, o + 1, 0), a.times(a).eq(u))) {
          n = a;
          break;
        }
        r += 4, i = 1;
      } else {
        (!+t || !+t.slice(1) && t.charAt(0) == "5") && (Q(n, o + 1, 1), e = !n.times(n).eq(u));
        break;
      }
  return re = !0, Q(n, o, A.rounding, e);
};
N.tangent = N.tan = function() {
  var e, t, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e = n.precision, t = n.rounding, n.precision = e + 10, n.rounding = 1, r = r.sin(), r.s = 1, r = be(r, new n(1).minus(r.times(r)).sqrt(), e + 10, 0), n.precision = e, n.rounding = t, Q(Dt == 2 || Dt == 4 ? r.neg() : r, e, t, !0)) : new n(NaN);
};
N.times = N.mul = function(e) {
  var t, r, n, i, a, u, s, o, l, A = this, d = A.constructor, m = A.d, f = (e = new d(e)).d;
  if (e.s *= A.s, !m || !m[0] || !f || !f[0])
    return new d(!e.s || m && !m[0] && !f || f && !f[0] && !m ? NaN : !m || !f ? e.s / 0 : e.s * 0);
  for (r = Ue(A.e / $) + Ue(e.e / $), o = m.length, l = f.length, o < l && (a = m, m = f, f = a, u = o, o = l, l = u), a = [], u = o + l, n = u; n--; ) a.push(0);
  for (n = l; --n >= 0; ) {
    for (t = 0, i = o + n; i > n; )
      s = a[i] + f[n] * m[i - n - 1] + t, a[i--] = s % ft | 0, t = s / ft | 0;
    a[i] = (a[i] + t) % ft | 0;
  }
  for (; !a[--u]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = pn(a, r), re ? Q(e, d.precision, d.rounding) : e;
};
N.toBinary = function(e, t) {
  return Jn(this, 2, e, t);
};
N.toDecimalPlaces = N.toDP = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Qe(e, 0, Nt), t === void 0 ? t = n.rounding : Qe(t, 0, 8), Q(r, e + r.e + 1, t));
};
N.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = vt(n, !0) : (Qe(e, 0, Nt), t === void 0 ? t = i.rounding : Qe(t, 0, 8), n = Q(new i(n), e + 1, t), r = vt(n, !0, e + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
};
N.toFixed = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? r = vt(i) : (Qe(e, 0, Nt), t === void 0 ? t = a.rounding : Qe(t, 0, 8), n = Q(new a(i), e + i.e + 1, t), r = vt(n, !1, e + n.e + 1)), i.isNeg() && !i.isZero() ? "-" + r : r;
};
N.toFraction = function(e) {
  var t, r, n, i, a, u, s, o, l, A, d, m, f = this, p = f.d, c = f.constructor;
  if (!p) return new c(f);
  if (l = r = new c(1), n = o = new c(0), t = new c(n), a = t.e = Ya(p) - f.e - 1, u = a % $, t.d[0] = ze(10, u < 0 ? $ + u : u), e == null)
    e = a > 0 ? t : l;
  else {
    if (s = new c(e), !s.isInt() || s.lt(l)) throw Error(Rt + s);
    e = s.gt(t) ? a > 0 ? t : l : s;
  }
  for (re = !1, s = new c(Le(p)), A = c.precision, c.precision = a = p.length * $ * 2; d = be(s, t, 0, 1, 1), i = r.plus(d.times(n)), i.cmp(e) != 1; )
    r = n, n = i, i = l, l = o.plus(d.times(i)), o = i, i = t, t = s.minus(d.times(i)), s = i;
  return i = be(e.minus(r), n, 0, 1, 1), o = o.plus(i.times(l)), r = r.plus(i.times(n)), o.s = l.s = f.s, m = be(l, n, a, 1).minus(f).abs().cmp(be(o, r, a, 1).minus(f).abs()) < 1 ? [l, n] : [o, r], c.precision = A, re = !0, m;
};
N.toHexadecimal = N.toHex = function(e, t) {
  return Jn(this, 16, e, t);
};
N.toNearest = function(e, t) {
  var r = this, n = r.constructor;
  if (r = new n(r), e == null) {
    if (!r.d) return r;
    e = new n(1), t = n.rounding;
  } else {
    if (e = new n(e), t === void 0 ? t = n.rounding : Qe(t, 0, 8), !r.d) return e.s ? r : e;
    if (!e.d)
      return e.s && (e.s = r.s), e;
  }
  return e.d[0] ? (re = !1, r = be(r, e, 0, t, 1).times(e), re = !0, Q(r)) : (e.s = r.s, r = e), r;
};
N.toNumber = function() {
  return +this;
};
N.toOctal = function(e, t) {
  return Jn(this, 8, e, t);
};
N.toPower = N.pow = function(e) {
  var t, r, n, i, a, u, s = this, o = s.constructor, l = +(e = new o(e));
  if (!s.d || !e.d || !s.d[0] || !e.d[0]) return new o(ze(+s, l));
  if (s = new o(s), s.eq(1)) return s;
  if (n = o.precision, a = o.rounding, e.eq(1)) return Q(s, n, a);
  if (t = Ue(e.e / $), t >= e.d.length - 1 && (r = l < 0 ? -l : l) <= $s)
    return i = Oa(o, s, r, n), e.s < 0 ? new o(1).div(i) : Q(i, n, a);
  if (u = s.s, u < 0) {
    if (t < e.d.length - 1) return new o(NaN);
    if (e.d[t] & 1 || (u = 1), s.e == 0 && s.d[0] == 1 && s.d.length == 1)
      return s.s = u, s;
  }
  return r = ze(+s, l), t = r == 0 || !isFinite(r) ? Ue(l * (Math.log("0." + Le(s.d)) / Math.LN10 + s.e + 1)) : new o(r + "").e, t > o.maxE + 1 || t < o.minE - 1 ? new o(t > 0 ? u / 0 : 0) : (re = !1, o.rounding = s.s = 1, r = Math.min(12, (t + "").length), i = Tn(e.times(Kt(s, n + r)), n), i.d && (i = Q(i, n + 5, 1), Zr(i.d, n, a) && (t = n + 10, i = Q(Tn(e.times(Kt(s, t + r)), t), t + 5, 1), +Le(i.d).slice(n + 1, n + 15) + 1 == 1e14 && (i = Q(i, n + 1, 0)))), i.s = u, re = !0, o.rounding = a, Q(i, n, a));
};
N.toPrecision = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = vt(n, n.e <= i.toExpNeg || n.e >= i.toExpPos) : (Qe(e, 1, Nt), t === void 0 ? t = i.rounding : Qe(t, 0, 8), n = Q(new i(n), e, t), r = vt(n, e <= n.e || n.e <= i.toExpNeg, e)), n.isNeg() && !n.isZero() ? "-" + r : r;
};
N.toSignificantDigits = N.toSD = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Qe(e, 1, Nt), t === void 0 ? t = n.rounding : Qe(t, 0, 8)), Q(new n(r), e, t);
};
N.toString = function() {
  var e = this, t = e.constructor, r = vt(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
  return e.isNeg() && !e.isZero() ? "-" + r : r;
};
N.truncated = N.trunc = function() {
  return Q(new this.constructor(this), this.e + 1, 1);
};
N.valueOf = N.toJSON = function() {
  var e = this, t = e.constructor, r = vt(e, e.e <= t.toExpNeg || e.e >= t.toExpPos);
  return e.isNeg() ? "-" + r : r;
};
function Le(e) {
  var t, r, n, i = e.length - 1, a = "", u = e[0];
  if (i > 0) {
    for (a += u, t = 1; t < i; t++)
      n = e[t] + "", r = $ - n.length, r && (a += qt(r)), a += n;
    u = e[t], n = u + "", r = $ - n.length, r && (a += qt(r));
  } else if (u === 0)
    return "0";
  for (; u % 10 === 0; ) u /= 10;
  return a + u;
}
function Qe(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Rt + e);
}
function Zr(e, t, r, n) {
  var i, a, u, s;
  for (a = e[0]; a >= 10; a /= 10) --t;
  return --t < 0 ? (t += $, i = 0) : (i = Math.ceil((t + 1) / $), t %= $), a = ze(10, $ - t), s = e[i] % a | 0, n == null ? t < 3 ? (t == 0 ? s = s / 100 | 0 : t == 1 && (s = s / 10 | 0), u = r < 4 && s == 99999 || r > 3 && s == 49999 || s == 5e4 || s == 0) : u = (r < 4 && s + 1 == a || r > 3 && s + 1 == a / 2) && (e[i + 1] / a / 100 | 0) == ze(10, t - 2) - 1 || (s == a / 2 || s == 0) && (e[i + 1] / a / 100 | 0) == 0 : t < 4 ? (t == 0 ? s = s / 1e3 | 0 : t == 1 ? s = s / 100 | 0 : t == 2 && (s = s / 10 | 0), u = (n || r < 4) && s == 9999 || !n && r > 3 && s == 4999) : u = ((n || r < 4) && s + 1 == a || !n && r > 3 && s + 1 == a / 2) && (e[i + 1] / a / 1e3 | 0) == ze(10, t - 3) - 1, u;
}
function Mr(e, t, r) {
  for (var n, i = [0], a, u = 0, s = e.length; u < s; ) {
    for (a = i.length; a--; ) i[a] *= t;
    for (i[0] += En.indexOf(e.charAt(u++)), n = 0; n < i.length; n++)
      i[n] > r - 1 && (i[n + 1] === void 0 && (i[n + 1] = 0), i[n + 1] += i[n] / r | 0, i[n] %= r);
  }
  return i.reverse();
}
function tA(e, t) {
  var r, n, i;
  if (t.isZero()) return t;
  n = t.d.length, n < 32 ? (r = Math.ceil(n / 3), i = (1 / hn(4, r)).toString()) : (r = 16, i = "2.3283064365386962890625e-10"), e.precision += r, t = ar(e, 1, t.times(i), new e(1));
  for (var a = r; a--; ) {
    var u = t.times(t);
    t = u.times(u).minus(u).times(8).plus(1);
  }
  return e.precision -= r, t;
}
var be = /* @__PURE__ */ function() {
  function e(n, i, a) {
    var u, s = 0, o = n.length;
    for (n = n.slice(); o--; )
      u = n[o] * i + s, n[o] = u % a | 0, s = u / a | 0;
    return s && n.unshift(s), n;
  }
  function t(n, i, a, u) {
    var s, o;
    if (a != u)
      o = a > u ? 1 : -1;
    else
      for (s = o = 0; s < a; s++)
        if (n[s] != i[s]) {
          o = n[s] > i[s] ? 1 : -1;
          break;
        }
    return o;
  }
  function r(n, i, a, u) {
    for (var s = 0; a--; )
      n[a] -= s, s = n[a] < i[a] ? 1 : 0, n[a] = s * u + n[a] - i[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, a, u, s, o) {
    var l, A, d, m, f, p, c, h, v, Z, b, F, y, V, W, X, x, q, I, E, L = n.constructor, z = n.s == i.s ? 1 : -1, G = n.d, w = i.d;
    if (!G || !G[0] || !w || !w[0])
      return new L(
        // Return NaN if either NaN, or both Infinity or 0.
        !n.s || !i.s || (G ? w && G[0] == w[0] : !w) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          G && G[0] == 0 || !w ? z * 0 : z / 0
        )
      );
    for (o ? (f = 1, A = n.e - i.e) : (o = ft, f = $, A = Ue(n.e / f) - Ue(i.e / f)), I = w.length, x = G.length, v = new L(z), Z = v.d = [], d = 0; w[d] == (G[d] || 0); d++) ;
    if (w[d] > (G[d] || 0) && A--, a == null ? (V = a = L.precision, u = L.rounding) : s ? V = a + (n.e - i.e) + 1 : V = a, V < 0)
      Z.push(1), p = !0;
    else {
      if (V = V / f + 2 | 0, d = 0, I == 1) {
        for (m = 0, w = w[0], V++; (d < x || m) && V--; d++)
          W = m * o + (G[d] || 0), Z[d] = W / w | 0, m = W % w | 0;
        p = m || d < x;
      } else {
        for (m = o / (w[0] + 1) | 0, m > 1 && (w = e(w, m, o), G = e(G, m, o), I = w.length, x = G.length), X = I, b = G.slice(0, I), F = b.length; F < I; ) b[F++] = 0;
        E = w.slice(), E.unshift(0), q = w[0], w[1] >= o / 2 && ++q;
        do
          m = 0, l = t(w, b, I, F), l < 0 ? (y = b[0], I != F && (y = y * o + (b[1] || 0)), m = y / q | 0, m > 1 ? (m >= o && (m = o - 1), c = e(w, m, o), h = c.length, F = b.length, l = t(c, b, h, F), l == 1 && (m--, r(c, I < h ? E : w, h, o))) : (m == 0 && (l = m = 1), c = w.slice()), h = c.length, h < F && c.unshift(0), r(b, c, F, o), l == -1 && (F = b.length, l = t(w, b, I, F), l < 1 && (m++, r(b, I < F ? E : w, F, o))), F = b.length) : l === 0 && (m++, b = [0]), Z[d++] = m, l && b[0] ? b[F++] = G[X] || 0 : (b = [G[X]], F = 1);
        while ((X++ < x || b[0] !== void 0) && V--);
        p = b[0] !== void 0;
      }
      Z[0] || Z.shift();
    }
    if (f == 1)
      v.e = A, La = p;
    else {
      for (d = 1, m = Z[0]; m >= 10; m /= 10) d++;
      v.e = d + A * f - 1, Q(v, s ? a + v.e + 1 : a, u, p);
    }
    return v;
  };
}();
function Q(e, t, r, n) {
  var i, a, u, s, o, l, A, d, m, f = e.constructor;
  e: if (t != null) {
    if (d = e.d, !d) return e;
    for (i = 1, s = d[0]; s >= 10; s /= 10) i++;
    if (a = t - i, a < 0)
      a += $, u = t, A = d[m = 0], o = A / ze(10, i - u - 1) % 10 | 0;
    else if (m = Math.ceil((a + 1) / $), s = d.length, m >= s)
      if (n) {
        for (; s++ <= m; ) d.push(0);
        A = o = 0, i = 1, a %= $, u = a - $ + 1;
      } else
        break e;
    else {
      for (A = s = d[m], i = 1; s >= 10; s /= 10) i++;
      a %= $, u = a - $ + i, o = u < 0 ? 0 : A / ze(10, i - u - 1) % 10 | 0;
    }
    if (n = n || t < 0 || d[m + 1] !== void 0 || (u < 0 ? A : A % ze(10, i - u - 1)), l = r < 4 ? (o || n) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : o > 5 || o == 5 && (r == 4 || n || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (a > 0 ? u > 0 ? A / ze(10, i - u) : 0 : d[m - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7)), t < 1 || !d[0])
      return d.length = 0, l ? (t -= e.e + 1, d[0] = ze(10, ($ - t % $) % $), e.e = -t || 0) : d[0] = e.e = 0, e;
    if (a == 0 ? (d.length = m, s = 1, m--) : (d.length = m + 1, s = ze(10, $ - a), d[m] = u > 0 ? (A / ze(10, i - u) % ze(10, u) | 0) * s : 0), l)
      for (; ; )
        if (m == 0) {
          for (a = 1, u = d[0]; u >= 10; u /= 10) a++;
          for (u = d[0] += s, s = 1; u >= 10; u /= 10) s++;
          a != s && (e.e++, d[0] == ft && (d[0] = 1));
          break;
        } else {
          if (d[m] += s, d[m] != ft) break;
          d[m--] = 0, s = 1;
        }
    for (a = d.length; d[--a] === 0; ) d.pop();
  }
  return re && (e.e > f.maxE ? (e.d = null, e.e = NaN) : e.e < f.minE && (e.e = 0, e.d = [0])), e;
}
function vt(e, t, r) {
  if (!e.isFinite()) return ja(e);
  var n, i = e.e, a = Le(e.d), u = a.length;
  return t ? (r && (n = r - u) > 0 ? a = a.charAt(0) + "." + a.slice(1) + qt(n) : u > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (e.e < 0 ? "e" : "e+") + e.e) : i < 0 ? (a = "0." + qt(-i - 1) + a, r && (n = r - u) > 0 && (a += qt(n))) : i >= u ? (a += qt(i + 1 - u), r && (n = r - i - 1) > 0 && (a = a + "." + qt(n))) : ((n = i + 1) < u && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - u) > 0 && (i + 1 === u && (a += "."), a += qt(n))), a;
}
function pn(e, t) {
  var r = e[0];
  for (t *= $; r >= 10; r /= 10) t++;
  return t;
}
function _r(e, t, r) {
  if (t > eA)
    throw re = !0, r && (e.precision = r), Error(Ma);
  return Q(new e(kr), t, 1, !0);
}
function pt(e, t, r) {
  if (t > zn) throw Error(Ma);
  return Q(new e(Qr), t, r, !0);
}
function Ya(e) {
  var t = e.length - 1, r = t * $ + 1;
  if (t = e[t], t) {
    for (; t % 10 == 0; t /= 10) r--;
    for (t = e[0]; t >= 10; t /= 10) r++;
  }
  return r;
}
function qt(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Oa(e, t, r, n) {
  var i, a = new e(1), u = Math.ceil(n / $ + 4);
  for (re = !1; ; ) {
    if (r % 2 && (a = a.times(t), Zi(a.d, u) && (i = !0)), r = Ue(r / 2), r === 0) {
      r = a.d.length - 1, i && a.d[r] === 0 && ++a.d[r];
      break;
    }
    t = t.times(t), Zi(t.d, u);
  }
  return re = !0, a;
}
function gi(e) {
  return e.d[e.d.length - 1] & 1;
}
function Ja(e, t, r) {
  for (var n, i, a = new e(t[0]), u = 0; ++u < t.length; ) {
    if (i = new e(t[u]), !i.s) {
      a = i;
      break;
    }
    n = a.cmp(i), (n === r || n === 0 && a.s === r) && (a = i);
  }
  return a;
}
function Tn(e, t) {
  var r, n, i, a, u, s, o, l = 0, A = 0, d = 0, m = e.constructor, f = m.rounding, p = m.precision;
  if (!e.d || !e.d[0] || e.e > 17)
    return new m(e.d ? e.d[0] ? e.s < 0 ? 0 : 1 / 0 : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
  for (t == null ? (re = !1, o = p) : o = t, s = new m(0.03125); e.e > -2; )
    e = e.times(s), d += 5;
  for (n = Math.log(ze(2, d)) / Math.LN10 * 2 + 5 | 0, o += n, r = a = u = new m(1), m.precision = o; ; ) {
    if (a = Q(a.times(e), o, 1), r = r.times(++A), s = u.plus(be(a, r, o, 1)), Le(s.d).slice(0, o) === Le(u.d).slice(0, o)) {
      for (i = d; i--; ) u = Q(u.times(u), o, 1);
      if (t == null)
        if (l < 3 && Zr(u.d, o - n, f, l))
          m.precision = o += 10, r = a = s = new m(1), A = 0, l++;
        else
          return Q(u, m.precision = p, f, re = !0);
      else
        return m.precision = p, u;
    }
    u = s;
  }
}
function Kt(e, t) {
  var r, n, i, a, u, s, o, l, A, d, m, f = 1, p = 10, c = e, h = c.d, v = c.constructor, Z = v.rounding, b = v.precision;
  if (c.s < 0 || !h || !h[0] || !c.e && h[0] == 1 && h.length == 1)
    return new v(h && !h[0] ? -1 / 0 : c.s != 1 ? NaN : h ? 0 : c);
  if (t == null ? (re = !1, A = b) : A = t, v.precision = A += p, r = Le(h), n = r.charAt(0), Math.abs(a = c.e) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      c = c.times(e), r = Le(c.d), n = r.charAt(0), f++;
    a = c.e, n > 1 ? (c = new v("0." + r), a++) : c = new v(n + "." + r.slice(1));
  } else
    return l = _r(v, A + 2, b).times(a + ""), c = Kt(new v(n + "." + r.slice(1)), A - p).plus(l), v.precision = b, t == null ? Q(c, b, Z, re = !0) : c;
  for (d = c, o = u = c = be(c.minus(1), c.plus(1), A, 1), m = Q(c.times(c), A, 1), i = 3; ; ) {
    if (u = Q(u.times(m), A, 1), l = o.plus(be(u, new v(i), A, 1)), Le(l.d).slice(0, A) === Le(o.d).slice(0, A))
      if (o = o.times(2), a !== 0 && (o = o.plus(_r(v, A + 2, b).times(a + ""))), o = be(o, new v(f), A, 1), t == null)
        if (Zr(o.d, A - p, Z, s))
          v.precision = A += p, l = u = c = be(d.minus(1), d.plus(1), A, 1), m = Q(c.times(c), A, 1), i = s = 1;
        else
          return Q(o, v.precision = b, Z, re = !0);
      else
        return v.precision = b, o;
    o = l, i += 2;
  }
}
function ja(e) {
  return String(e.s * e.s / 0);
}
function Hr(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; n++) ;
  for (i = t.length; t.charCodeAt(i - 1) === 48; --i) ;
  if (t = t.slice(n, i), t) {
    if (i -= n, e.e = r = r - n - 1, e.d = [], n = (r + 1) % $, r < 0 && (n += $), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= $; n < i; ) e.d.push(+t.slice(n, n += $));
      t = t.slice(n), n = $ - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    e.d.push(+t), re && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
  } else
    e.e = 0, e.d = [0];
  return e;
}
function rA(e, t) {
  var r, n, i, a, u, s, o, l, A;
  if (t.indexOf("_") > -1) {
    if (t = t.replace(/(\d)_(?=\d)/g, "$1"), Ba.test(t)) return Hr(e, t);
  } else if (t === "Infinity" || t === "NaN")
    return +t || (e.s = NaN), e.e = NaN, e.d = null, e;
  if (Qs.test(t))
    r = 16, t = t.toLowerCase();
  else if (ks.test(t))
    r = 2;
  else if (_s.test(t))
    r = 8;
  else
    throw Error(Rt + t);
  for (a = t.search(/p/i), a > 0 ? (o = +t.slice(a + 1), t = t.substring(2, a)) : t = t.slice(2), a = t.indexOf("."), u = a >= 0, n = e.constructor, u && (t = t.replace(".", ""), s = t.length, a = s - a, i = Oa(n, new n(r), a, a * 2)), l = Mr(t, r, ft), A = l.length - 1, a = A; l[a] === 0; --a) l.pop();
  return a < 0 ? new n(e.s * 0) : (e.e = pn(l, A), e.d = l, re = !1, u && (e = be(e, i, s * 4)), o && (e = e.times(Math.abs(o) < 54 ? ze(2, o) : ur.pow(2, o))), re = !0, e);
}
function nA(e, t) {
  var r, n = t.d.length;
  if (n < 3)
    return t.isZero() ? t : ar(e, 2, t, t);
  r = 1.4 * Math.sqrt(n), r = r > 16 ? 16 : r | 0, t = t.times(1 / hn(5, r)), t = ar(e, 2, t, t);
  for (var i, a = new e(5), u = new e(16), s = new e(20); r--; )
    i = t.times(t), t = t.times(a.plus(i.times(u.times(i).minus(s))));
  return t;
}
function ar(e, t, r, n, i) {
  var a, u, s, o, l = e.precision, A = Math.ceil(l / $);
  for (re = !1, o = r.times(r), s = new e(n); ; ) {
    if (u = be(s.times(o), new e(t++ * t++), l, 1), s = i ? n.plus(u) : n.minus(u), n = be(u.times(o), new e(t++ * t++), l, 1), u = s.plus(n), u.d[A] !== void 0) {
      for (a = A; u.d[a] === s.d[a] && a--; ) ;
      if (a == -1) break;
    }
    a = s, s = n, n = u, u = a;
  }
  return re = !0, u.d.length = A + 1, u;
}
function hn(e, t) {
  for (var r = e; --t; ) r *= e;
  return r;
}
function ka(e, t) {
  var r, n = t.s < 0, i = pt(e, e.precision, 1), a = i.times(0.5);
  if (t = t.abs(), t.lte(a))
    return Dt = n ? 4 : 1, t;
  if (r = t.divToInt(i), r.isZero())
    Dt = n ? 3 : 2;
  else {
    if (t = t.minus(r.times(i)), t.lte(a))
      return Dt = gi(r) ? n ? 2 : 3 : n ? 4 : 1, t;
    Dt = gi(r) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return t.minus(i).abs();
}
function Jn(e, t, r, n) {
  var i, a, u, s, o, l, A, d, m, f = e.constructor, p = r !== void 0;
  if (p ? (Qe(r, 1, Nt), n === void 0 ? n = f.rounding : Qe(n, 0, 8)) : (r = f.precision, n = f.rounding), !e.isFinite())
    A = ja(e);
  else {
    for (A = vt(e), u = A.indexOf("."), p ? (i = 2, t == 16 ? r = r * 4 - 3 : t == 8 && (r = r * 3 - 2)) : i = t, u >= 0 && (A = A.replace(".", ""), m = new f(1), m.e = A.length - u, m.d = Mr(vt(m), 10, i), m.e = m.d.length), d = Mr(A, 10, i), a = o = d.length; d[--o] == 0; ) d.pop();
    if (!d[0])
      A = p ? "0p+0" : "0";
    else {
      if (u < 0 ? a-- : (e = new f(e), e.d = d, e.e = a, e = be(e, m, r, n, 0, i), d = e.d, a = e.e, l = La), u = d[r], s = i / 2, l = l || d[r + 1] !== void 0, l = n < 4 ? (u !== void 0 || l) && (n === 0 || n === (e.s < 0 ? 3 : 2)) : u > s || u === s && (n === 4 || l || n === 6 && d[r - 1] & 1 || n === (e.s < 0 ? 8 : 7)), d.length = r, l)
        for (; ++d[--r] > i - 1; )
          d[r] = 0, r || (++a, d.unshift(1));
      for (o = d.length; !d[o - 1]; --o) ;
      for (u = 0, A = ""; u < o; u++) A += En.charAt(d[u]);
      if (p) {
        if (o > 1)
          if (t == 16 || t == 8) {
            for (u = t == 16 ? 4 : 3, --o; o % u; o++) A += "0";
            for (d = Mr(A, i, t), o = d.length; !d[o - 1]; --o) ;
            for (u = 1, A = "1."; u < o; u++) A += En.charAt(d[u]);
          } else
            A = A.charAt(0) + "." + A.slice(1);
        A = A + (a < 0 ? "p" : "p+") + a;
      } else if (a < 0) {
        for (; ++a; ) A = "0" + A;
        A = "0." + A;
      } else if (++a > o) for (a -= o; a--; ) A += "0";
      else a < o && (A = A.slice(0, a) + "." + A.slice(a));
    }
    A = (t == 16 ? "0x" : t == 2 ? "0b" : t == 8 ? "0o" : "") + A;
  }
  return e.s < 0 ? "-" + A : A;
}
function Zi(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function iA(e) {
  return new this(e).abs();
}
function aA(e) {
  return new this(e).acos();
}
function uA(e) {
  return new this(e).acosh();
}
function oA(e, t) {
  return new this(e).plus(t);
}
function sA(e) {
  return new this(e).asin();
}
function AA(e) {
  return new this(e).asinh();
}
function lA(e) {
  return new this(e).atan();
}
function cA(e) {
  return new this(e).atanh();
}
function dA(e, t) {
  e = new this(e), t = new this(t);
  var r, n = this.precision, i = this.rounding, a = n + 4;
  return !e.s || !t.s ? r = new this(NaN) : !e.d && !t.d ? (r = pt(this, a, 1).times(t.s > 0 ? 0.25 : 0.75), r.s = e.s) : !t.d || e.isZero() ? (r = t.s < 0 ? pt(this, n, i) : new this(0), r.s = e.s) : !e.d || t.isZero() ? (r = pt(this, a, 1).times(0.5), r.s = e.s) : t.s < 0 ? (this.precision = a, this.rounding = 1, r = this.atan(be(e, t, a, 1)), t = pt(this, a, 1), this.precision = n, this.rounding = i, r = e.s < 0 ? r.minus(t) : r.plus(t)) : r = this.atan(be(e, t, a, 1)), r;
}
function fA(e) {
  return new this(e).cbrt();
}
function mA(e) {
  return Q(e = new this(e), e.e + 1, 2);
}
function pA(e, t, r) {
  return new this(e).clamp(t, r);
}
function hA(e) {
  if (!e || typeof e != "object") throw Error(mn + "Object expected");
  var t, r, n, i = e.defaults === !0, a = [
    "precision",
    1,
    Nt,
    "rounding",
    0,
    8,
    "toExpNeg",
    -$t,
    0,
    "toExpPos",
    0,
    $t,
    "maxE",
    0,
    $t,
    "minE",
    -$t,
    0,
    "modulo",
    0,
    9
  ];
  for (t = 0; t < a.length; t += 3)
    if (r = a[t], i && (this[r] = Rn[r]), (n = e[r]) !== void 0)
      if (Ue(n) === n && n >= a[t + 1] && n <= a[t + 2]) this[r] = n;
      else throw Error(Rt + r + ": " + n);
  if (r = "crypto", i && (this[r] = Rn[r]), (n = e[r]) !== void 0)
    if (n === !0 || n === !1 || n === 0 || n === 1)
      if (n)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[r] = !0;
        else
          throw Error(Ha);
      else
        this[r] = !1;
    else
      throw Error(Rt + r + ": " + n);
  return this;
}
function vA(e) {
  return new this(e).cos();
}
function VA(e) {
  return new this(e).cosh();
}
function Qa(e) {
  var t, r, n;
  function i(a) {
    var u, s, o, l = this;
    if (!(l instanceof i)) return new i(a);
    if (l.constructor = i, Fi(a)) {
      l.s = a.s, re ? !a.d || a.e > i.maxE ? (l.e = NaN, l.d = null) : a.e < i.minE ? (l.e = 0, l.d = [0]) : (l.e = a.e, l.d = a.d.slice()) : (l.e = a.e, l.d = a.d ? a.d.slice() : a.d);
      return;
    }
    if (o = typeof a, o === "number") {
      if (a === 0) {
        l.s = 1 / a < 0 ? -1 : 1, l.e = 0, l.d = [0];
        return;
      }
      if (a < 0 ? (a = -a, l.s = -1) : l.s = 1, a === ~~a && a < 1e7) {
        for (u = 0, s = a; s >= 10; s /= 10) u++;
        re ? u > i.maxE ? (l.e = NaN, l.d = null) : u < i.minE ? (l.e = 0, l.d = [0]) : (l.e = u, l.d = [a]) : (l.e = u, l.d = [a]);
        return;
      }
      if (a * 0 !== 0) {
        a || (l.s = NaN), l.e = NaN, l.d = null;
        return;
      }
      return Hr(l, a.toString());
    }
    if (o === "string")
      return (s = a.charCodeAt(0)) === 45 ? (a = a.slice(1), l.s = -1) : (s === 43 && (a = a.slice(1)), l.s = 1), Ba.test(a) ? Hr(l, a) : rA(l, a);
    if (o === "bigint")
      return a < 0 ? (a = -a, l.s = -1) : l.s = 1, Hr(l, a.toString());
    throw Error(Rt + a);
  }
  if (i.prototype = N, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.EUCLID = 9, i.config = i.set = hA, i.clone = Qa, i.isDecimal = Fi, i.abs = iA, i.acos = aA, i.acosh = uA, i.add = oA, i.asin = sA, i.asinh = AA, i.atan = lA, i.atanh = cA, i.atan2 = dA, i.cbrt = fA, i.ceil = mA, i.clamp = pA, i.cos = vA, i.cosh = VA, i.div = bA, i.exp = yA, i.floor = gA, i.hypot = ZA, i.ln = FA, i.log = XA, i.log10 = xA, i.log2 = WA, i.max = DA, i.min = CA, i.mod = qA, i.mul = SA, i.pow = wA, i.random = KA, i.round = IA, i.sign = EA, i.sin = RA, i.sinh = zA, i.sqrt = TA, i.sub = NA, i.sum = GA, i.tan = PA, i.tanh = LA, i.trunc = MA, e === void 0 && (e = {}), e && e.defaults !== !0)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function bA(e, t) {
  return new this(e).div(t);
}
function yA(e) {
  return new this(e).exp();
}
function gA(e) {
  return Q(e = new this(e), e.e + 1, 3);
}
function ZA() {
  var e, t, r = new this(0);
  for (re = !1, e = 0; e < arguments.length; )
    if (t = new this(arguments[e++]), t.d)
      r.d && (r = r.plus(t.times(t)));
    else {
      if (t.s)
        return re = !0, new this(1 / 0);
      r = t;
    }
  return re = !0, r.sqrt();
}
function Fi(e) {
  return e instanceof ur || e && e.toStringTag === Ua || !1;
}
function FA(e) {
  return new this(e).ln();
}
function XA(e, t) {
  return new this(e).log(t);
}
function WA(e) {
  return new this(e).log(2);
}
function xA(e) {
  return new this(e).log(10);
}
function DA() {
  return Ja(this, arguments, -1);
}
function CA() {
  return Ja(this, arguments, 1);
}
function qA(e, t) {
  return new this(e).mod(t);
}
function SA(e, t) {
  return new this(e).mul(t);
}
function wA(e, t) {
  return new this(e).pow(t);
}
function KA(e) {
  var t, r, n, i, a = 0, u = new this(1), s = [];
  if (e === void 0 ? e = this.precision : Qe(e, 1, Nt), n = Math.ceil(e / $), this.crypto)
    if (crypto.getRandomValues)
      for (t = crypto.getRandomValues(new Uint32Array(n)); a < n; )
        i = t[a], i >= 429e7 ? t[a] = crypto.getRandomValues(new Uint32Array(1))[0] : s[a++] = i % 1e7;
    else if (crypto.randomBytes) {
      for (t = crypto.randomBytes(n *= 4); a < n; )
        i = t[a] + (t[a + 1] << 8) + (t[a + 2] << 16) + ((t[a + 3] & 127) << 24), i >= 214e7 ? crypto.randomBytes(4).copy(t, a) : (s.push(i % 1e7), a += 4);
      a = n / 4;
    } else
      throw Error(Ha);
  else for (; a < n; ) s[a++] = Math.random() * 1e7 | 0;
  for (n = s[--a], e %= $, n && e && (i = ze(10, $ - e), s[a] = (n / i | 0) * i); s[a] === 0; a--) s.pop();
  if (a < 0)
    r = 0, s = [0];
  else {
    for (r = -1; s[0] === 0; r -= $) s.shift();
    for (n = 1, i = s[0]; i >= 10; i /= 10) n++;
    n < $ && (r -= $ - n);
  }
  return u.e = r, u.d = s, u;
}
function IA(e) {
  return Q(e = new this(e), e.e + 1, this.rounding);
}
function EA(e) {
  return e = new this(e), e.d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
}
function RA(e) {
  return new this(e).sin();
}
function zA(e) {
  return new this(e).sinh();
}
function TA(e) {
  return new this(e).sqrt();
}
function NA(e, t) {
  return new this(e).sub(t);
}
function GA() {
  var e = 0, t = arguments, r = new this(t[e]);
  for (re = !1; r.s && ++e < t.length; ) r = r.plus(t[e]);
  return re = !0, Q(r, this.precision, this.rounding);
}
function PA(e) {
  return new this(e).tan();
}
function LA(e) {
  return new this(e).tanh();
}
function MA(e) {
  return Q(e = new this(e), e.e + 1, 1);
}
N[Symbol.for("nodejs.util.inspect.custom")] = N.toString;
N[Symbol.toStringTag] = "Decimal";
var ur = N.constructor = Qa(Rn);
kr = new ur(kr);
Qr = new ur(Qr);
var HA = "BigNumber", UA = ["?on", "config"], BA = /* @__PURE__ */ J(HA, UA, (e) => {
  var {
    on: t,
    config: r
  } = e, n = ur.clone({
    precision: r.precision,
    modulo: ur.EUCLID
  });
  return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, n.fromJSON = function(i) {
    return new n(i.value);
  }, t && t("config", function(i, a) {
    i.precision !== a.precision && n.config({
      precision: i.precision
    });
  }), n;
}, {
  isClass: !0
});
const Me = Math.cosh || function(e) {
  return Math.abs(e) < 1e-9 ? 1 - e : (Math.exp(e) + Math.exp(-e)) * 0.5;
}, it = Math.sinh || function(e) {
  return Math.abs(e) < 1e-9 ? e : (Math.exp(e) - Math.exp(-e)) * 0.5;
}, YA = function(e) {
  const t = Math.PI / 4;
  if (-t > e || e > t)
    return Math.cos(e) - 1;
  const r = e * e;
  return r * (r * (r * (r * (r * (r * (r * (r / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
}, Xn = function(e, t) {
  return e = Math.abs(e), t = Math.abs(t), e < t && ([e, t] = [t, e]), e < 1e8 ? Math.sqrt(e * e + t * t) : (t /= e, e * Math.sqrt(1 + t * t));
}, Jt = function() {
  throw SyntaxError("Invalid Param");
};
function Wn(e, t) {
  const r = Math.abs(e), n = Math.abs(t);
  return e === 0 ? Math.log(n) : t === 0 ? Math.log(r) : r < 3e3 && n < 3e3 ? Math.log(e * e + t * t) * 0.5 : (e = e * 0.5, t = t * 0.5, 0.5 * Math.log(e * e + t * t) + Math.LN2);
}
const OA = { re: 0, im: 0 }, Mt = function(e, t) {
  const r = OA;
  if (e == null)
    r.re = r.im = 0;
  else if (t !== void 0)
    r.re = e, r.im = t;
  else
    switch (typeof e) {
      case "object":
        if ("im" in e && "re" in e)
          r.re = e.re, r.im = e.im;
        else if ("abs" in e && "arg" in e) {
          if (!isFinite(e.abs) && isFinite(e.arg))
            return K.INFINITY;
          r.re = e.abs * Math.cos(e.arg), r.im = e.abs * Math.sin(e.arg);
        } else if ("r" in e && "phi" in e) {
          if (!isFinite(e.r) && isFinite(e.phi))
            return K.INFINITY;
          r.re = e.r * Math.cos(e.phi), r.im = e.r * Math.sin(e.phi);
        } else e.length === 2 ? (r.re = e[0], r.im = e[1]) : Jt();
        break;
      case "string":
        r.im = /* void */
        r.re = 0;
        const n = e.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
        let i = 1, a = 0;
        n === null && Jt();
        for (let u = 0; u < n.length; u++) {
          const s = n[u];
          s === " " || s === "	" || s === `
` || (s === "+" ? i++ : s === "-" ? a++ : s === "i" || s === "I" ? (i + a === 0 && Jt(), n[u + 1] !== " " && !isNaN(n[u + 1]) ? (r.im += parseFloat((a % 2 ? "-" : "") + n[u + 1]), u++) : r.im += parseFloat((a % 2 ? "-" : "") + "1"), i = a = 0) : ((i + a === 0 || isNaN(s)) && Jt(), n[u + 1] === "i" || n[u + 1] === "I" ? (r.im += parseFloat((a % 2 ? "-" : "") + s), u++) : r.re += parseFloat((a % 2 ? "-" : "") + s), i = a = 0));
        }
        i + a > 0 && Jt();
        break;
      case "number":
        r.im = 0, r.re = e;
        break;
      default:
        Jt();
    }
  return isNaN(r.re) || isNaN(r.im), r;
};
function K(e, t) {
  if (!(this instanceof K))
    return new K(e, t);
  const r = Mt(e, t);
  this.re = r.re, this.im = r.im;
}
K.prototype = {
  re: 0,
  im: 0,
  /**
   * Calculates the sign of a complex number, which is a normalized complex
   *
   * @returns {Complex}
   */
  sign: function() {
    const e = Xn(this.re, this.im);
    return new K(
      this.re / e,
      this.im / e
    );
  },
  /**
   * Adds two complex numbers
   *
   * @returns {Complex}
   */
  add: function(e, t) {
    const r = Mt(e, t), n = this.isInfinite(), i = !(isFinite(r.re) && isFinite(r.im));
    return n || i ? n && i ? K.NAN : K.INFINITY : new K(
      this.re + r.re,
      this.im + r.im
    );
  },
  /**
   * Subtracts two complex numbers
   *
   * @returns {Complex}
   */
  sub: function(e, t) {
    const r = Mt(e, t), n = this.isInfinite(), i = !(isFinite(r.re) && isFinite(r.im));
    return n || i ? n && i ? K.NAN : K.INFINITY : new K(
      this.re - r.re,
      this.im - r.im
    );
  },
  /**
   * Multiplies two complex numbers
   *
   * @returns {Complex}
   */
  mul: function(e, t) {
    const r = Mt(e, t), n = this.isInfinite(), i = !(isFinite(r.re) && isFinite(r.im)), a = this.re === 0 && this.im === 0, u = r.re === 0 && r.im === 0;
    return n && u || i && a ? K.NAN : n || i ? K.INFINITY : r.im === 0 && this.im === 0 ? new K(this.re * r.re, 0) : new K(
      this.re * r.re - this.im * r.im,
      this.re * r.im + this.im * r.re
    );
  },
  /**
   * Divides two complex numbers
   *
   * @returns {Complex}
   */
  div: function(e, t) {
    const r = Mt(e, t), n = this.isInfinite(), i = !(isFinite(r.re) && isFinite(r.im)), a = this.re === 0 && this.im === 0, u = r.re === 0 && r.im === 0;
    if (a && u || n && i)
      return K.NAN;
    if (u || n)
      return K.INFINITY;
    if (a || i)
      return K.ZERO;
    if (r.im === 0)
      return new K(this.re / r.re, this.im / r.re);
    if (Math.abs(r.re) < Math.abs(r.im)) {
      const s = r.re / r.im, o = r.re * s + r.im;
      return new K(
        (this.re * s + this.im) / o,
        (this.im * s - this.re) / o
      );
    } else {
      const s = r.im / r.re, o = r.im * s + r.re;
      return new K(
        (this.re + this.im * s) / o,
        (this.im - this.re * s) / o
      );
    }
  },
  /**
   * Calculate the power of two complex numbers
   *
   * @returns {Complex}
   */
  pow: function(e, t) {
    const r = Mt(e, t), n = this.re === 0 && this.im === 0;
    if (r.re === 0 && r.im === 0)
      return K.ONE;
    if (r.im === 0) {
      if (this.im === 0 && this.re > 0)
        return new K(Math.pow(this.re, r.re), 0);
      if (this.re === 0)
        switch ((r.re % 4 + 4) % 4) {
          case 0:
            return new K(Math.pow(this.im, r.re), 0);
          case 1:
            return new K(0, Math.pow(this.im, r.re));
          case 2:
            return new K(-Math.pow(this.im, r.re), 0);
          case 3:
            return new K(0, -Math.pow(this.im, r.re));
        }
    }
    if (n && r.re > 0)
      return K.ZERO;
    const a = Math.atan2(this.im, this.re), u = Wn(this.re, this.im);
    let s = Math.exp(r.re * u - r.im * a), o = r.im * u + r.re * a;
    return new K(
      s * Math.cos(o),
      s * Math.sin(o)
    );
  },
  /**
   * Calculate the complex square root
   *
   * @returns {Complex}
   */
  sqrt: function() {
    const e = this.re, t = this.im;
    if (t === 0)
      return e >= 0 ? new K(Math.sqrt(e), 0) : new K(0, Math.sqrt(-e));
    const r = Xn(e, t);
    let n = Math.sqrt(0.5 * (r + Math.abs(e))), i = Math.abs(t) / (2 * n);
    return e >= 0 ? new K(n, t < 0 ? -i : i) : new K(i, t < 0 ? -n : n);
  },
  /**
   * Calculate the complex exponent
   *
   * @returns {Complex}
   */
  exp: function() {
    const e = Math.exp(this.re);
    return this.im === 0 ? new K(e, 0) : new K(
      e * Math.cos(this.im),
      e * Math.sin(this.im)
    );
  },
  /**
   * Calculate the complex exponent and subtracts one.
   *
   * This may be more accurate than `Complex(x).exp().sub(1)` if
   * `x` is small.
   *
   * @returns {Complex}
   */
  expm1: function() {
    const e = this.re, t = this.im;
    return new K(
      Math.expm1(e) * Math.cos(t) + YA(t),
      Math.exp(e) * Math.sin(t)
    );
  },
  /**
   * Calculate the natural log
   *
   * @returns {Complex}
   */
  log: function() {
    const e = this.re, t = this.im;
    return t === 0 && e > 0 ? new K(Math.log(e), 0) : new K(
      Wn(e, t),
      Math.atan2(t, e)
    );
  },
  /**
   * Calculate the magnitude of the complex number
   *
   * @returns {number}
   */
  abs: function() {
    return Xn(this.re, this.im);
  },
  /**
   * Calculate the angle of the complex number
   *
   * @returns {number}
   */
  arg: function() {
    return Math.atan2(this.im, this.re);
  },
  /**
   * Calculate the sine of the complex number
   *
   * @returns {Complex}
   */
  sin: function() {
    const e = this.re, t = this.im;
    return new K(
      Math.sin(e) * Me(t),
      Math.cos(e) * it(t)
    );
  },
  /**
   * Calculate the cosine
   *
   * @returns {Complex}
   */
  cos: function() {
    const e = this.re, t = this.im;
    return new K(
      Math.cos(e) * Me(t),
      -Math.sin(e) * it(t)
    );
  },
  /**
   * Calculate the tangent
   *
   * @returns {Complex}
   */
  tan: function() {
    const e = 2 * this.re, t = 2 * this.im, r = Math.cos(e) + Me(t);
    return new K(
      Math.sin(e) / r,
      it(t) / r
    );
  },
  /**
   * Calculate the cotangent
   *
   * @returns {Complex}
   */
  cot: function() {
    const e = 2 * this.re, t = 2 * this.im, r = Math.cos(e) - Me(t);
    return new K(
      -Math.sin(e) / r,
      it(t) / r
    );
  },
  /**
   * Calculate the secant
   *
   * @returns {Complex}
   */
  sec: function() {
    const e = this.re, t = this.im, r = 0.5 * Me(2 * t) + 0.5 * Math.cos(2 * e);
    return new K(
      Math.cos(e) * Me(t) / r,
      Math.sin(e) * it(t) / r
    );
  },
  /**
   * Calculate the cosecans
   *
   * @returns {Complex}
   */
  csc: function() {
    const e = this.re, t = this.im, r = 0.5 * Me(2 * t) - 0.5 * Math.cos(2 * e);
    return new K(
      Math.sin(e) * Me(t) / r,
      -Math.cos(e) * it(t) / r
    );
  },
  /**
   * Calculate the complex arcus sinus
   *
   * @returns {Complex}
   */
  asin: function() {
    const e = this.re, t = this.im, r = new K(
      t * t - e * e + 1,
      -2 * e * t
    ).sqrt(), n = new K(
      r.re - t,
      r.im + e
    ).log();
    return new K(n.im, -n.re);
  },
  /**
   * Calculate the complex arcus cosinus
   *
   * @returns {Complex}
   */
  acos: function() {
    const e = this.re, t = this.im, r = new K(
      t * t - e * e + 1,
      -2 * e * t
    ).sqrt(), n = new K(
      r.re - t,
      r.im + e
    ).log();
    return new K(Math.PI / 2 - n.im, n.re);
  },
  /**
   * Calculate the complex arcus tangent
   *
   * @returns {Complex}
   */
  atan: function() {
    const e = this.re, t = this.im;
    if (e === 0) {
      if (t === 1)
        return new K(0, 1 / 0);
      if (t === -1)
        return new K(0, -1 / 0);
    }
    const r = e * e + (1 - t) * (1 - t), n = new K(
      (1 - t * t - e * e) / r,
      -2 * e / r
    ).log();
    return new K(-0.5 * n.im, 0.5 * n.re);
  },
  /**
   * Calculate the complex arcus cotangent
   *
   * @returns {Complex}
   */
  acot: function() {
    const e = this.re, t = this.im;
    if (t === 0)
      return new K(Math.atan2(1, e), 0);
    const r = e * e + t * t;
    return r !== 0 ? new K(
      e / r,
      -t / r
    ).atan() : new K(
      e !== 0 ? e / 0 : 0,
      t !== 0 ? -t / 0 : 0
    ).atan();
  },
  /**
   * Calculate the complex arcus secant
   *
   * @returns {Complex}
   */
  asec: function() {
    const e = this.re, t = this.im;
    if (e === 0 && t === 0)
      return new K(0, 1 / 0);
    const r = e * e + t * t;
    return r !== 0 ? new K(
      e / r,
      -t / r
    ).acos() : new K(
      e !== 0 ? e / 0 : 0,
      t !== 0 ? -t / 0 : 0
    ).acos();
  },
  /**
   * Calculate the complex arcus cosecans
   *
   * @returns {Complex}
   */
  acsc: function() {
    const e = this.re, t = this.im;
    if (e === 0 && t === 0)
      return new K(Math.PI / 2, 1 / 0);
    const r = e * e + t * t;
    return r !== 0 ? new K(
      e / r,
      -t / r
    ).asin() : new K(
      e !== 0 ? e / 0 : 0,
      t !== 0 ? -t / 0 : 0
    ).asin();
  },
  /**
   * Calculate the complex sinh
   *
   * @returns {Complex}
   */
  sinh: function() {
    const e = this.re, t = this.im;
    return new K(
      it(e) * Math.cos(t),
      Me(e) * Math.sin(t)
    );
  },
  /**
   * Calculate the complex cosh
   *
   * @returns {Complex}
   */
  cosh: function() {
    const e = this.re, t = this.im;
    return new K(
      Me(e) * Math.cos(t),
      it(e) * Math.sin(t)
    );
  },
  /**
   * Calculate the complex tanh
   *
   * @returns {Complex}
   */
  tanh: function() {
    const e = 2 * this.re, t = 2 * this.im, r = Me(e) + Math.cos(t);
    return new K(
      it(e) / r,
      Math.sin(t) / r
    );
  },
  /**
   * Calculate the complex coth
   *
   * @returns {Complex}
   */
  coth: function() {
    const e = 2 * this.re, t = 2 * this.im, r = Me(e) - Math.cos(t);
    return new K(
      it(e) / r,
      -Math.sin(t) / r
    );
  },
  /**
   * Calculate the complex coth
   *
   * @returns {Complex}
   */
  csch: function() {
    const e = this.re, t = this.im, r = Math.cos(2 * t) - Me(2 * e);
    return new K(
      -2 * it(e) * Math.cos(t) / r,
      2 * Me(e) * Math.sin(t) / r
    );
  },
  /**
   * Calculate the complex sech
   *
   * @returns {Complex}
   */
  sech: function() {
    const e = this.re, t = this.im, r = Math.cos(2 * t) + Me(2 * e);
    return new K(
      2 * Me(e) * Math.cos(t) / r,
      -2 * it(e) * Math.sin(t) / r
    );
  },
  /**
   * Calculate the complex asinh
   *
   * @returns {Complex}
   */
  asinh: function() {
    let e = this.im;
    this.im = -this.re, this.re = e;
    const t = this.asin();
    return this.re = -this.im, this.im = e, e = t.re, t.re = -t.im, t.im = e, t;
  },
  /**
   * Calculate the complex acosh
   *
   * @returns {Complex}
   */
  acosh: function() {
    const e = this.acos();
    if (e.im <= 0) {
      const t = e.re;
      e.re = -e.im, e.im = t;
    } else {
      const t = e.im;
      e.im = -e.re, e.re = t;
    }
    return e;
  },
  /**
   * Calculate the complex atanh
   *
   * @returns {Complex}
   */
  atanh: function() {
    const e = this.re, t = this.im, r = e > 1 && t === 0, n = 1 - e, i = 1 + e, a = n * n + t * t, u = a !== 0 ? new K(
      (i * n - t * t) / a,
      (t * n + i * t) / a
    ) : new K(
      e !== -1 ? e / 0 : 0,
      t !== 0 ? t / 0 : 0
    ), s = u.re;
    return u.re = Wn(u.re, u.im) / 2, u.im = Math.atan2(u.im, s) / 2, r && (u.im = -u.im), u;
  },
  /**
   * Calculate the complex acoth
   *
   * @returns {Complex}
   */
  acoth: function() {
    const e = this.re, t = this.im;
    if (e === 0 && t === 0)
      return new K(0, Math.PI / 2);
    const r = e * e + t * t;
    return r !== 0 ? new K(
      e / r,
      -t / r
    ).atanh() : new K(
      e !== 0 ? e / 0 : 0,
      t !== 0 ? -t / 0 : 0
    ).atanh();
  },
  /**
   * Calculate the complex acsch
   *
   * @returns {Complex}
   */
  acsch: function() {
    const e = this.re, t = this.im;
    if (t === 0)
      return new K(
        e !== 0 ? Math.log(e + Math.sqrt(e * e + 1)) : 1 / 0,
        0
      );
    const r = e * e + t * t;
    return r !== 0 ? new K(
      e / r,
      -t / r
    ).asinh() : new K(
      e !== 0 ? e / 0 : 0,
      t !== 0 ? -t / 0 : 0
    ).asinh();
  },
  /**
   * Calculate the complex asech
   *
   * @returns {Complex}
   */
  asech: function() {
    const e = this.re, t = this.im;
    if (this.isZero())
      return K.INFINITY;
    const r = e * e + t * t;
    return r !== 0 ? new K(
      e / r,
      -t / r
    ).acosh() : new K(
      e !== 0 ? e / 0 : 0,
      t !== 0 ? -t / 0 : 0
    ).acosh();
  },
  /**
   * Calculate the complex inverse 1/z
   *
   * @returns {Complex}
   */
  inverse: function() {
    if (this.isZero())
      return K.INFINITY;
    if (this.isInfinite())
      return K.ZERO;
    const e = this.re, t = this.im, r = e * e + t * t;
    return new K(e / r, -t / r);
  },
  /**
   * Returns the complex conjugate
   *
   * @returns {Complex}
   */
  conjugate: function() {
    return new K(this.re, -this.im);
  },
  /**
   * Gets the negated complex number
   *
   * @returns {Complex}
   */
  neg: function() {
    return new K(-this.re, -this.im);
  },
  /**
   * Ceils the actual complex number
   *
   * @returns {Complex}
   */
  ceil: function(e) {
    return e = Math.pow(10, e || 0), new K(
      Math.ceil(this.re * e) / e,
      Math.ceil(this.im * e) / e
    );
  },
  /**
   * Floors the actual complex number
   *
   * @returns {Complex}
   */
  floor: function(e) {
    return e = Math.pow(10, e || 0), new K(
      Math.floor(this.re * e) / e,
      Math.floor(this.im * e) / e
    );
  },
  /**
   * Ceils the actual complex number
   *
   * @returns {Complex}
   */
  round: function(e) {
    return e = Math.pow(10, e || 0), new K(
      Math.round(this.re * e) / e,
      Math.round(this.im * e) / e
    );
  },
  /**
   * Compares two complex numbers
   *
   * **Note:** new Complex(Infinity).equals(Infinity) === false
   *
   * @returns {boolean}
   */
  equals: function(e, t) {
    const r = Mt(e, t);
    return Math.abs(r.re - this.re) <= K.EPSILON && Math.abs(r.im - this.im) <= K.EPSILON;
  },
  /**
   * Clones the actual object
   *
   * @returns {Complex}
   */
  clone: function() {
    return new K(this.re, this.im);
  },
  /**
   * Gets a string of the actual complex number
   *
   * @returns {string}
   */
  toString: function() {
    let e = this.re, t = this.im, r = "";
    return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e) < K.EPSILON && (e = 0), Math.abs(t) < K.EPSILON && (t = 0), t === 0 ? r + e : (e !== 0 ? (r += e, r += " ", t < 0 ? (t = -t, r += "-") : r += "+", r += " ") : t < 0 && (t = -t, r += "-"), t !== 1 && (r += t), r + "i"));
  },
  /**
   * Returns the actual number as a vector
   *
   * @returns {Array}
   */
  toVector: function() {
    return [this.re, this.im];
  },
  /**
   * Returns the actual real value of the current object
   *
   * @returns {number|null}
   */
  valueOf: function() {
    return this.im === 0 ? this.re : null;
  },
  /**
   * Determines whether a complex number is not on the Riemann sphere.
   *
   * @returns {boolean}
   */
  isNaN: function() {
    return isNaN(this.re) || isNaN(this.im);
  },
  /**
   * Determines whether or not a complex number is at the zero pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isZero: function() {
    return this.im === 0 && this.re === 0;
  },
  /**
   * Determines whether a complex number is not at the infinity pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isFinite: function() {
    return isFinite(this.re) && isFinite(this.im);
  },
  /**
   * Determines whether or not a complex number is at the infinity pole of the
   * Riemann sphere.
   *
   * @returns {boolean}
   */
  isInfinite: function() {
    return !this.isFinite();
  }
};
K.ZERO = new K(0, 0);
K.ONE = new K(1, 0);
K.I = new K(0, 1);
K.PI = new K(Math.PI, 0);
K.E = new K(Math.E, 0);
K.INFINITY = new K(1 / 0, 1 / 0);
K.NAN = new K(NaN, NaN);
K.EPSILON = 1e-15;
var JA = "Complex", jA = [], kA = /* @__PURE__ */ J(JA, jA, () => (Object.defineProperty(K, "name", {
  value: "Complex"
}), K.prototype.constructor = K, K.prototype.type = "Complex", K.prototype.isComplex = !0, K.prototype.toJSON = function() {
  return {
    mathjs: "Complex",
    re: this.re,
    im: this.im
  };
}, K.prototype.toPolar = function() {
  return {
    r: this.abs(),
    phi: this.arg()
  };
}, K.prototype.format = function(e) {
  var t = "", r = this.im, n = this.re, i = In(this.re, e), a = In(this.im, e), u = Ze(e) ? e : e ? e.precision : null;
  if (u !== null) {
    var s = Math.pow(10, -u);
    Math.abs(n / r) < s && (n = 0), Math.abs(r / n) < s && (r = 0);
  }
  return r === 0 ? t = i : n === 0 ? r === 1 ? t = "i" : r === -1 ? t = "-i" : t = a + "i" : r < 0 ? r === -1 ? t = i + " - i" : t = i + " - " + a.substring(1) + "i" : r === 1 ? t = i + " + i" : t = i + " + " + a + "i", t;
}, K.fromPolar = function(e) {
  switch (arguments.length) {
    case 1: {
      var t = arguments[0];
      if (typeof t == "object")
        return K(t);
      throw new TypeError("Input has to be an object with r and phi keys.");
    }
    case 2: {
      var r = arguments[0], n = arguments[1];
      if (Ze(r)) {
        if (Ia(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), Ze(n))
          return new K({
            r,
            phi: n
          });
        throw new TypeError("Phi is not a number nor an angle unit.");
      } else
        throw new TypeError("Radius r is not a number.");
    }
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, K.prototype.valueOf = K.prototype.toString, K.fromJSON = function(e) {
  return new K(e);
}, K.compare = function(e, t) {
  return e.re > t.re ? 1 : e.re < t.re ? -1 : e.im > t.im ? 1 : e.im < t.im ? -1 : 0;
}, K), {
  isClass: !0
});
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
var QA = 2e3, k = {
  s: 1,
  n: 0,
  d: 1
};
function Ft(e, t) {
  if (isNaN(e = parseInt(e, 10)))
    throw Ur();
  return e * t;
}
function xe(e, t) {
  if (t === 0)
    throw jn();
  var r = Object.create(He.prototype);
  r.s = e < 0 ? -1 : 1, e = e < 0 ? -e : e;
  var n = er(e, t);
  return r.n = e / n, r.d = t / n, r;
}
function Xi(e) {
  for (var t = {}, r = e, n = 2, i = 4; i <= r; ) {
    for (; r % n === 0; )
      r /= n, t[n] = (t[n] || 0) + 1;
    i += 1 + 2 * n++;
  }
  return r !== e ? r > 1 && (t[r] = (t[r] || 0) + 1) : t[e] = (t[e] || 0) + 1, t;
}
var _e = function(e, t) {
  var r = 0, n = 1, i = 1, a = 0, u = 0, s = 0, o = 1, l = 1, A = 0, d = 1, m = 1, f = 1, p = 1e7, c;
  if (e != null) if (t !== void 0) {
    if (r = e, n = t, i = r * n, r % 1 !== 0 || n % 1 !== 0)
      throw tl();
  } else
    switch (typeof e) {
      case "object": {
        if ("d" in e && "n" in e)
          r = e.n, n = e.d, "s" in e && (r *= e.s);
        else if (0 in e)
          r = e[0], 1 in e && (n = e[1]);
        else
          throw Ur();
        i = r * n;
        break;
      }
      case "number": {
        if (e < 0 && (i = e, e = -e), e % 1 === 0)
          r = e;
        else if (e > 0) {
          for (e >= 1 && (l = Math.pow(10, Math.floor(1 + Math.log(e) / Math.LN10)), e /= l); d <= p && f <= p; )
            if (c = (A + m) / (d + f), e === c) {
              d + f <= p ? (r = A + m, n = d + f) : f > d ? (r = m, n = f) : (r = A, n = d);
              break;
            } else
              e > c ? (A += m, d += f) : (m += A, f += d), d > p ? (r = m, n = f) : (r = A, n = d);
          r *= l;
        } else (isNaN(e) || isNaN(t)) && (n = r = NaN);
        break;
      }
      case "string": {
        if (d = e.match(/\d+|./g), d === null)
          throw Ur();
        if (d[A] === "-" ? (i = -1, A++) : d[A] === "+" && A++, d.length === A + 1 ? u = Ft(d[A++], i) : d[A + 1] === "." || d[A] === "." ? (d[A] !== "." && (a = Ft(d[A++], i)), A++, (A + 1 === d.length || d[A + 1] === "(" && d[A + 3] === ")" || d[A + 1] === "'" && d[A + 3] === "'") && (u = Ft(d[A], i), o = Math.pow(10, d[A].length), A++), (d[A] === "(" && d[A + 2] === ")" || d[A] === "'" && d[A + 2] === "'") && (s = Ft(d[A + 1], i), l = Math.pow(10, d[A + 1].length) - 1, A += 3)) : d[A + 1] === "/" || d[A + 1] === ":" ? (u = Ft(d[A], i), o = Ft(d[A + 2], 1), A += 3) : d[A + 3] === "/" && d[A + 1] === " " && (a = Ft(d[A], i), u = Ft(d[A + 2], i), o = Ft(d[A + 4], 1), A += 5), d.length <= A) {
          n = o * l, i = /* void */
          r = s + n * a + l * u;
          break;
        }
      }
      default:
        throw Ur();
    }
  if (n === 0)
    throw jn();
  k.s = i < 0 ? -1 : 1, k.n = Math.abs(r), k.d = Math.abs(n);
};
function _A(e, t, r) {
  for (var n = 1; t > 0; e = e * e % r, t >>= 1)
    t & 1 && (n = n * e % r);
  return n;
}
function $A(e, t) {
  for (; t % 2 === 0; t /= 2)
    ;
  for (; t % 5 === 0; t /= 5)
    ;
  if (t === 1)
    return 0;
  for (var r = 10 % t, n = 1; r !== 1; n++)
    if (r = r * 10 % t, n > QA)
      return 0;
  return n;
}
function el(e, t, r) {
  for (var n = 1, i = _A(10, r, t), a = 0; a < 300; a++) {
    if (n === i)
      return a;
    n = n * 10 % t, i = i * 10 % t;
  }
  return 0;
}
function er(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  for (; ; ) {
    if (e %= t, !e)
      return t;
    if (t %= e, !t)
      return e;
  }
}
function He(e, t) {
  if (_e(e, t), this instanceof He)
    e = er(k.d, k.n), this.s = k.s, this.n = k.n / e, this.d = k.d / e;
  else
    return xe(k.s * k.n, k.d);
}
var jn = function() {
  return new Error("Division by Zero");
}, Ur = function() {
  return new Error("Invalid argument");
}, tl = function() {
  return new Error("Parameters must be integer");
};
He.prototype = {
  s: 1,
  n: 0,
  d: 1,
  /**
   * Calculates the absolute value
   *
   * Ex: new Fraction(-4).abs() => 4
   **/
  abs: function() {
    return xe(this.n, this.d);
  },
  /**
   * Inverts the sign of the current fraction
   *
   * Ex: new Fraction(-4).neg() => 4
   **/
  neg: function() {
    return xe(-this.s * this.n, this.d);
  },
  /**
   * Adds two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
   **/
  add: function(e, t) {
    return _e(e, t), xe(
      this.s * this.n * k.d + k.s * this.d * k.n,
      this.d * k.d
    );
  },
  /**
   * Subtracts two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
   **/
  sub: function(e, t) {
    return _e(e, t), xe(
      this.s * this.n * k.d - k.s * this.d * k.n,
      this.d * k.d
    );
  },
  /**
   * Multiplies two rational numbers
   *
   * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
   **/
  mul: function(e, t) {
    return _e(e, t), xe(
      this.s * k.s * this.n * k.n,
      this.d * k.d
    );
  },
  /**
   * Divides two rational numbers
   *
   * Ex: new Fraction("-17.(345)").inverse().div(3)
   **/
  div: function(e, t) {
    return _e(e, t), xe(
      this.s * k.s * this.n * k.d,
      this.d * k.n
    );
  },
  /**
   * Clones the actual object
   *
   * Ex: new Fraction("-17.(345)").clone()
   **/
  clone: function() {
    return xe(this.s * this.n, this.d);
  },
  /**
   * Calculates the modulo of two rational numbers - a more precise fmod
   *
   * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
   **/
  mod: function(e, t) {
    if (isNaN(this.n) || isNaN(this.d))
      return new He(NaN);
    if (e === void 0)
      return xe(this.s * this.n % this.d, 1);
    if (_e(e, t), k.n === 0 && this.d === 0)
      throw jn();
    return xe(
      this.s * (k.d * this.n) % (k.n * this.d),
      k.d * this.d
    );
  },
  /**
   * Calculates the fractional gcd of two rational numbers
   *
   * Ex: new Fraction(5,8).gcd(3,7) => 1/56
   */
  gcd: function(e, t) {
    return _e(e, t), xe(er(k.n, this.n) * er(k.d, this.d), k.d * this.d);
  },
  /**
   * Calculates the fractional lcm of two rational numbers
   *
   * Ex: new Fraction(5,8).lcm(3,7) => 15
   */
  lcm: function(e, t) {
    return _e(e, t), k.n === 0 && this.n === 0 ? xe(0, 1) : xe(k.n * this.n, er(k.n, this.n) * er(k.d, this.d));
  },
  /**
   * Calculates the ceil of a rational number
   *
   * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
   **/
  ceil: function(e) {
    return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new He(NaN) : xe(Math.ceil(e * this.s * this.n / this.d), e);
  },
  /**
   * Calculates the floor of a rational number
   *
   * Ex: new Fraction('4.(3)').floor() => (4 / 1)
   **/
  floor: function(e) {
    return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new He(NaN) : xe(Math.floor(e * this.s * this.n / this.d), e);
  },
  /**
   * Rounds a rational number
   *
   * Ex: new Fraction('4.(3)').round() => (4 / 1)
   **/
  round: function(e) {
    return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new He(NaN) : xe(Math.round(e * this.s * this.n / this.d), e);
  },
  /**
   * Rounds a rational number to a multiple of another rational number
   *
   * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
   **/
  roundTo: function(e, t) {
    return _e(e, t), xe(this.s * Math.round(this.n * k.d / (this.d * k.n)) * k.n, k.d);
  },
  /**
   * Gets the inverse of the fraction, means numerator and denominator are exchanged
   *
   * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
   **/
  inverse: function() {
    return xe(this.s * this.d, this.n);
  },
  /**
   * Calculates the fraction to some rational exponent, if possible
   *
   * Ex: new Fraction(-1,2).pow(-3) => -8
   */
  pow: function(e, t) {
    if (_e(e, t), k.d === 1)
      return k.s < 0 ? xe(Math.pow(this.s * this.d, k.n), Math.pow(this.n, k.n)) : xe(Math.pow(this.s * this.n, k.n), Math.pow(this.d, k.n));
    if (this.s < 0) return null;
    var r = Xi(this.n), n = Xi(this.d), i = 1, a = 1;
    for (var u in r)
      if (u !== "1") {
        if (u === "0") {
          i = 0;
          break;
        }
        if (r[u] *= k.n, r[u] % k.d === 0)
          r[u] /= k.d;
        else return null;
        i *= Math.pow(u, r[u]);
      }
    for (var u in n)
      if (u !== "1") {
        if (n[u] *= k.n, n[u] % k.d === 0)
          n[u] /= k.d;
        else return null;
        a *= Math.pow(u, n[u]);
      }
    return k.s < 0 ? xe(a, i) : xe(i, a);
  },
  /**
   * Check if two rational numbers are the same
   *
   * Ex: new Fraction(19.6).equals([98, 5]);
   **/
  equals: function(e, t) {
    return _e(e, t), this.s * this.n * k.d === k.s * k.n * this.d;
  },
  /**
   * Check if two rational numbers are the same
   *
   * Ex: new Fraction(19.6).equals([98, 5]);
   **/
  compare: function(e, t) {
    _e(e, t);
    var r = this.s * this.n * k.d - k.s * k.n * this.d;
    return (0 < r) - (r < 0);
  },
  simplify: function(e) {
    if (isNaN(this.n) || isNaN(this.d))
      return this;
    e = e || 1e-3;
    for (var t = this.abs(), r = t.toContinued(), n = 1; n < r.length; n++) {
      for (var i = xe(r[n - 1], 1), a = n - 2; a >= 0; a--)
        i = i.inverse().add(r[a]);
      if (Math.abs(i.sub(t).valueOf()) < e)
        return i.mul(this.s);
    }
    return this;
  },
  /**
   * Check if two rational numbers are divisible
   *
   * Ex: new Fraction(19.6).divisible(1.5);
   */
  divisible: function(e, t) {
    return _e(e, t), !(!(k.n * this.d) || this.n * k.d % (k.n * this.d));
  },
  /**
   * Returns a decimal representation of the fraction
   *
   * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
   **/
  valueOf: function() {
    return this.s * this.n / this.d;
  },
  /**
   * Returns a string-fraction representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
   **/
  toFraction: function(e) {
    var t, r = "", n = this.n, i = this.d;
    return this.s < 0 && (r += "-"), i === 1 ? r += n : (e && (t = Math.floor(n / i)) > 0 && (r += t, r += " ", n %= i), r += n, r += "/", r += i), r;
  },
  /**
   * Returns a latex representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
   **/
  toLatex: function(e) {
    var t, r = "", n = this.n, i = this.d;
    return this.s < 0 && (r += "-"), i === 1 ? r += n : (e && (t = Math.floor(n / i)) > 0 && (r += t, n %= i), r += "\\frac{", r += n, r += "}{", r += i, r += "}"), r;
  },
  /**
   * Returns an array of continued fraction elements
   *
   * Ex: new Fraction("7/8").toContinued() => [0,1,7]
   */
  toContinued: function() {
    var e, t = this.n, r = this.d, n = [];
    if (isNaN(t) || isNaN(r))
      return n;
    do
      n.push(Math.floor(t / r)), e = t % r, t = r, r = e;
    while (t !== 1);
    return n;
  },
  /**
   * Creates a string representation of a fraction with all digits
   *
   * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
   **/
  toString: function(e) {
    var t = this.n, r = this.d;
    if (isNaN(t) || isNaN(r))
      return "NaN";
    e = e || 15;
    var n = $A(t, r), i = el(t, r, n), a = this.s < 0 ? "-" : "";
    if (a += t / r | 0, t %= r, t *= 10, t && (a += "."), n) {
      for (var u = i; u--; )
        a += t / r | 0, t %= r, t *= 10;
      a += "(";
      for (var u = n; u--; )
        a += t / r | 0, t %= r, t *= 10;
      a += ")";
    } else
      for (var u = e; t && u--; )
        a += t / r | 0, t %= r, t *= 10;
    return a;
  }
};
var rl = "Fraction", nl = [], il = /* @__PURE__ */ J(rl, nl, () => (Object.defineProperty(He, "name", {
  value: "Fraction"
}), He.prototype.constructor = He, He.prototype.type = "Fraction", He.prototype.isFraction = !0, He.prototype.toJSON = function() {
  return {
    mathjs: "Fraction",
    n: this.s * this.n,
    d: this.d
  };
}, He.fromJSON = function(e) {
  return new He(e);
}, He), {
  isClass: !0
}), al = "Matrix", ul = [], ol = /* @__PURE__ */ J(al, ul, () => {
  function e() {
    if (!(this instanceof e))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return e.prototype.type = "Matrix", e.prototype.isMatrix = !0, e.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, e.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, e.prototype.create = function(t, r) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, e.prototype.subset = function(t, r, n) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, e.prototype.get = function(t) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, e.prototype.set = function(t, r, n) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, e.prototype.resize = function(t, r) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, e.prototype.reshape = function(t, r) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, e.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, e.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, e.prototype.map = function(t, r) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, e.prototype.forEach = function(t) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, e.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, e.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, e.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, e.prototype.format = function(t) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, e.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, e;
}, {
  isClass: !0
});
function xn(e, t, r) {
  var n = e.constructor, i = new n(2), a = "";
  if (r) {
    if (r < 1)
      throw new Error("size must be in greater than 0");
    if (!Ke(r))
      throw new Error("size must be an integer");
    if (e.greaterThan(i.pow(r - 1).sub(1)) || e.lessThan(i.pow(r - 1).mul(-1)))
      throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
    if (!e.isInteger())
      throw new Error("Value must be an integer");
    e.lessThan(0) && (e = e.add(i.pow(r))), a = "i".concat(r);
  }
  switch (t) {
    case 2:
      return "".concat(e.toBinary()).concat(a);
    case 8:
      return "".concat(e.toOctal()).concat(a);
    case 16:
      return "".concat(e.toHexadecimal()).concat(a);
    default:
      throw new Error("Base ".concat(t, " not supported "));
  }
}
function sl(e, t) {
  if (typeof t == "function")
    return t(e);
  if (!e.isFinite())
    return e.isNaN() ? "NaN" : e.gt(0) ? "Infinity" : "-Infinity";
  var {
    notation: r,
    precision: n,
    wordSize: i
  } = Na(t);
  switch (r) {
    case "fixed":
      return ll(e, n);
    case "exponential":
      return Wi(e, n);
    case "engineering":
      return Al(e, n);
    case "bin":
      return xn(e, 2, i);
    case "oct":
      return xn(e, 8, i);
    case "hex":
      return xn(e, 16, i);
    case "auto": {
      var a = xi(t == null ? void 0 : t.lowerExp, -3), u = xi(t == null ? void 0 : t.upperExp, 5);
      if (e.isZero()) return "0";
      var s, o = e.toSignificantDigits(n), l = o.e;
      return l >= a && l < u ? s = o.toFixed() : s = Wi(e, n), s.replace(/((\.\d*?)(0+))($|e)/, function() {
        var A = arguments[2], d = arguments[4];
        return A !== "." ? A + d : d;
      });
    }
    default:
      throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function Al(e, t) {
  var r = e.e, n = r % 3 === 0 ? r : r < 0 ? r - 3 - r % 3 : r - r % 3, i = e.mul(Math.pow(10, -n)), a = i.toPrecision(t);
  if (a.includes("e")) {
    var u = e.constructor;
    a = new u(a).toFixed();
  }
  return a + "e" + (r >= 0 ? "+" : "") + n.toString();
}
function Wi(e, t) {
  return t !== void 0 ? e.toExponential(t - 1) : e.toExponential();
}
function ll(e, t) {
  return e.toFixed(t);
}
function xi(e, t) {
  return Ze(e) ? e : We(e) ? e.toNumber() : t;
}
function we(e, t) {
  var r = cl(e, t);
  return t && typeof t == "object" && "truncate" in t && r.length > t.truncate ? r.substring(0, t.truncate - 3) + "..." : r;
}
function cl(e, t) {
  if (typeof e == "number")
    return In(e, t);
  if (We(e))
    return sl(e, t);
  if (dl(e))
    return !t || t.fraction !== "decimal" ? e.s * e.n + "/" + e.d : e.toString();
  if (Array.isArray(e))
    return _a(e, t);
  if (ot(e))
    return Di(e);
  if (typeof e == "function")
    return e.syntax ? String(e.syntax) : "function";
  if (e && typeof e == "object") {
    if (typeof e.format == "function")
      return e.format(t);
    if (e && e.toString(t) !== {}.toString())
      return e.toString(t);
    var r = Object.keys(e).map((n) => Di(n) + ": " + we(e[n], t));
    return "{" + r.join(", ") + "}";
  }
  return String(e);
}
function Di(e) {
  for (var t = String(e), r = "", n = 0; n < t.length; ) {
    var i = t.charAt(n);
    r += i in Ci ? Ci[i] : i, n++;
  }
  return '"' + r + '"';
}
var Ci = {
  '"': '\\"',
  "\\": "\\\\",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
};
function _a(e, t) {
  if (Array.isArray(e)) {
    for (var r = "[", n = e.length, i = 0; i < n; i++)
      i !== 0 && (r += ", "), r += _a(e[i], t);
    return r += "]", r;
  } else
    return we(e, t);
}
function dl(e) {
  return e && typeof e == "object" && typeof e.s == "number" && typeof e.n == "number" && typeof e.d == "number" || !1;
}
function ie(e, t, r) {
  if (!(this instanceof ie))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = e, this.expected = t, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + " " + (this.relation || "!=") + " " + (Array.isArray(t) ? "[" + t.join(", ") + "]" : t) + ")", this.stack = new Error().stack;
}
ie.prototype = new RangeError();
ie.prototype.constructor = RangeError;
ie.prototype.name = "DimensionError";
ie.prototype.isDimensionError = !0;
function Gt(e, t, r) {
  if (!(this instanceof Gt))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = e, arguments.length < 3 ? (this.min = 0, this.max = t) : (this.min = t, this.max = r), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
Gt.prototype = new RangeError();
Gt.prototype.constructor = RangeError;
Gt.prototype.name = "IndexError";
Gt.prototype.isIndexError = !0;
function Ge(e) {
  for (var t = []; Array.isArray(e); )
    t.push(e.length), e = e[0];
  return t;
}
function $a(e, t, r) {
  var n, i = e.length;
  if (i !== t[r])
    throw new ie(i, t[r]);
  if (r < t.length - 1) {
    var a = r + 1;
    for (n = 0; n < i; n++) {
      var u = e[n];
      if (!Array.isArray(u))
        throw new ie(t.length - 1, t.length, "<");
      $a(e[n], t, a);
    }
  } else
    for (n = 0; n < i; n++)
      if (Array.isArray(e[n]))
        throw new ie(t.length + 1, t.length, ">");
}
function qi(e, t) {
  var r = t.length === 0;
  if (r) {
    if (Array.isArray(e))
      throw new ie(e.length, 0);
  } else
    $a(e, t, 0);
}
function $r(e, t) {
  var r = e.isMatrix ? e._size : Ge(e), n = t._sourceSize;
  n.forEach((i, a) => {
    if (i !== null && i !== r[a])
      throw new ie(i, r[a]);
  });
}
function he(e, t) {
  if (e !== void 0) {
    if (!Ze(e) || !Ke(e))
      throw new TypeError("Index must be an integer (value: " + e + ")");
    if (e < 0 || typeof t == "number" && e >= t)
      throw new Gt(e, t);
  }
}
function or(e) {
  for (var t = 0; t < e._dimensions.length; ++t) {
    var r = e._dimensions[t];
    if (r._data && ge(r._data)) {
      if (r._size[0] === 0)
        return !0;
    } else if (r.isRange) {
      if (r.start === r.end)
        return !0;
    } else if (ot(r) && r.length === 0)
      return !0;
  }
  return !1;
}
function en(e, t, r) {
  if (!Array.isArray(t))
    throw new TypeError("Array expected");
  if (t.length === 0)
    throw new Error("Resizing to scalar is not supported");
  t.forEach(function(i) {
    if (!Ze(i) || !Ke(i) || i < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + we(t) + ")");
  }), (Ze(e) || We(e)) && (e = [e]);
  var n = r !== void 0 ? r : 0;
  return Nn(e, t, 0, n), e;
}
function Nn(e, t, r, n) {
  var i, a, u = e.length, s = t[r], o = Math.min(u, s);
  if (e.length = s, r < t.length - 1) {
    var l = r + 1;
    for (i = 0; i < o; i++)
      a = e[i], Array.isArray(a) || (a = [a], e[i] = a), Nn(a, t, l, n);
    for (i = o; i < s; i++)
      a = [], e[i] = a, Nn(a, t, l, n);
  } else {
    for (i = 0; i < o; i++)
      for (; Array.isArray(e[i]); )
        e[i] = e[i][0];
    for (i = o; i < s; i++)
      e[i] = n;
  }
}
function kn(e, t) {
  var r = Gn(e), n = r.length;
  if (!Array.isArray(e) || !Array.isArray(t))
    throw new TypeError("Array expected");
  if (t.length === 0)
    throw new ie(0, n, "!=");
  t = Qn(t, n);
  var i = eu(t);
  if (n !== i)
    throw new ie(i, n, "!=");
  try {
    return fl(r, t);
  } catch (a) {
    throw a instanceof ie ? new ie(i, n, "!=") : a;
  }
}
function Qn(e, t) {
  var r = eu(e), n = e.slice(), i = -1, a = e.indexOf(i), u = e.indexOf(i, a + 1) >= 0;
  if (u)
    throw new Error("More than one wildcard in sizes");
  var s = a >= 0, o = t % r === 0;
  if (s)
    if (o)
      n[a] = -t / r;
    else
      throw new Error("Could not replace wildcard, since " + t + " is no multiple of " + -r);
  return n;
}
function eu(e) {
  return e.reduce((t, r) => t * r, 1);
}
function fl(e, t) {
  for (var r = e, n, i = t.length - 1; i > 0; i--) {
    var a = t[i];
    n = [];
    for (var u = r.length / a, s = 0; s < u; s++)
      n.push(r.slice(s * a, (s + 1) * a));
    r = n;
  }
  return r;
}
function tu(e, t, r, n) {
  var i = n || Ge(e);
  if (r)
    for (var a = 0; a < r; a++)
      e = [e], i.unshift(1);
  for (e = ru(e, t, 0); i.length < t; )
    i.push(1);
  return e;
}
function ru(e, t, r) {
  var n, i;
  if (Array.isArray(e)) {
    var a = r + 1;
    for (n = 0, i = e.length; n < i; n++)
      e[n] = ru(e[n], t, a);
  } else
    for (var u = r; u < t; u++)
      e = [e];
  return e;
}
function Gn(e) {
  if (!Array.isArray(e))
    return e;
  var t = [];
  return e.forEach(function r(n) {
    Array.isArray(n) ? n.forEach(r) : t.push(n);
  }), t;
}
function vn(e, t) {
  for (var r, n = 0, i = 0; i < e.length; i++) {
    var a = e[i], u = Array.isArray(a);
    if (i === 0 && u && (n = a.length), u && a.length !== n)
      return;
    var s = u ? vn(a, t) : t(a);
    if (r === void 0)
      r = s;
    else if (r !== s)
      return "mixed";
  }
  return r;
}
function nu(e, t, r, n) {
  if (n < r) {
    if (e.length !== t.length)
      throw new ie(e.length, t.length);
    for (var i = [], a = 0; a < e.length; a++)
      i[a] = nu(e[a], t[a], r, n + 1);
    return i;
  } else
    return e.concat(t);
}
function iu() {
  var e = Array.prototype.slice.call(arguments, 0, -1), t = Array.prototype.slice.call(arguments, -1);
  if (e.length === 1)
    return e[0];
  if (e.length > 1)
    return e.slice(1).reduce(function(r, n) {
      return nu(r, n, t, 0);
    }, e[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function au() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  for (var n = t.map((m) => m.length), i = Math.max(...n), a = new Array(i).fill(null), u = 0; u < t.length; u++)
    for (var s = t[u], o = n[u], l = 0; l < o; l++) {
      var A = i - o + l;
      s[l] > a[A] && (a[A] = s[l]);
    }
  for (var d = 0; d < t.length; d++)
    uu(t[d], a);
  return a;
}
function uu(e, t) {
  for (var r = t.length, n = e.length, i = 0; i < n; i++) {
    var a = r - n + i;
    if (e[i] < t[a] && e[i] > 1 || e[i] > t[a])
      throw new Error("shape missmatch: missmatch is found in arg with shape (".concat(e, ") not possible to broadcast dimension ").concat(n, " with size ").concat(e[i], " to size ").concat(t[a]));
  }
}
function Pn(e, t) {
  var r = Ge(e);
  if (Et(r, t))
    return e;
  uu(r, t);
  var n = au(r, t), i = n.length, a = [...Array(i - r.length).fill(1), ...r], u = pl(e);
  r.length < i && (u = kn(u, a), r = Ge(u));
  for (var s = 0; s < i; s++)
    r[s] < n[s] && (u = ml(u, n[s], s), r = Ge(u));
  return u;
}
function ml(e, t, r) {
  return iu(...Array(t).fill(e), r);
}
function ou(e, t) {
  if (!Array.isArray(e))
    throw new Error("Array expected");
  var r = Ge(e);
  if (t.length !== r.length)
    throw new ie(t.length, r.length);
  for (var n = 0; n < t.length; n++)
    he(t[n], r[n]);
  return t.reduce((i, a) => i[a], e);
}
function pl(e) {
  return Or([], e);
}
function tn(e, t, r) {
  if (jr.isTypedFunction(e)) {
    var n = (t.isMatrix ? t.size() : Ge(t)).map(() => 0), i = t.isMatrix ? t.get(n) : ou(t, n), a = Object.keys(e.signatures).length === 1, u = hl(e, i, n, t), s = a ? Object.values(e.signatures)[0] : e;
    return u >= 1 && u <= 3 ? function() {
      for (var o = arguments.length, l = new Array(o), A = 0; A < o; A++)
        l[A] = arguments[A];
      return Si(s, l.slice(0, u), r, e.name);
    } : function() {
      for (var o = arguments.length, l = new Array(o), A = 0; A < o; A++)
        l[A] = arguments[A];
      return Si(s, l, r, e.name);
    };
  }
  return e;
}
function hl(e, t, r, n) {
  for (var i = [t, r, n], a = 3; a > 0; a--) {
    var u = i.slice(0, a);
    if (jr.resolve(e, u) !== null)
      return a;
  }
}
function Si(e, t, r, n) {
  try {
    return e(...t);
  } catch (i) {
    vl(i, t, r, n);
  }
}
function vl(e, t, r, n) {
  var i;
  if (e instanceof TypeError && ((i = e.data) === null || i === void 0 ? void 0 : i.category) === "wrongType") {
    var a = [];
    throw a.push("value: ".concat(st(t[0]))), t.length >= 2 && a.push("index: ".concat(st(t[1]))), t.length >= 3 && a.push("array: ".concat(st(t[2]))), new TypeError("Function ".concat(r, " cannot apply callback arguments ") + "".concat(n, "(").concat(a.join(", "), ") at index ").concat(JSON.stringify(t[1])));
  } else
    throw new TypeError("Function ".concat(r, " cannot apply callback arguments ") + "to function ".concat(n, ": ").concat(e.message));
}
var Vl = "DenseMatrix", bl = ["Matrix"], yl = /* @__PURE__ */ J(Vl, bl, (e) => {
  var {
    Matrix: t
  } = e;
  function r(A, d) {
    if (!(this instanceof r))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (d && !ot(d))
      throw new Error("Invalid datatype: " + d);
    if (Ve(A))
      A.type === "DenseMatrix" ? (this._data = Ae(A._data), this._size = Ae(A._size), this._datatype = d || A._datatype) : (this._data = A.toArray(), this._size = A.size(), this._datatype = d || A._datatype);
    else if (A && ge(A.data) && ge(A.size))
      this._data = A.data, this._size = A.size, qi(this._data, this._size), this._datatype = d || A.datatype;
    else if (ge(A))
      this._data = l(A), this._size = Ge(this._data), qi(this._data, this._size), this._datatype = d;
    else {
      if (A)
        throw new TypeError("Unsupported type of data (" + st(A) + ")");
      this._data = [], this._size = [0], this._datatype = d;
    }
  }
  r.prototype = new t(), r.prototype.createDenseMatrix = function(A, d) {
    return new r(A, d);
  }, Object.defineProperty(r, "name", {
    value: "DenseMatrix"
  }), r.prototype.constructor = r, r.prototype.type = "DenseMatrix", r.prototype.isDenseMatrix = !0, r.prototype.getDataType = function() {
    return vn(this._data, st);
  }, r.prototype.storage = function() {
    return "dense";
  }, r.prototype.datatype = function() {
    return this._datatype;
  }, r.prototype.create = function(A, d) {
    return new r(A, d);
  }, r.prototype.subset = function(A, d, m) {
    switch (arguments.length) {
      case 1:
        return n(this, A);
      case 2:
      case 3:
        return a(this, A, d, m);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, r.prototype.get = function(A) {
    return ou(this._data, A);
  }, r.prototype.set = function(A, d, m) {
    if (!ge(A))
      throw new TypeError("Array expected");
    if (A.length < this._size.length)
      throw new ie(A.length, this._size.length, "<");
    var f, p, c, h = A.map(function(Z) {
      return Z + 1;
    });
    o(this, h, m);
    var v = this._data;
    for (f = 0, p = A.length - 1; f < p; f++)
      c = A[f], he(c, v.length), v = v[c];
    return c = A[A.length - 1], he(c, v.length), v[c] = d, this;
  };
  function n(A, d) {
    if (!cn(d))
      throw new TypeError("Invalid index");
    var m = d.isScalar();
    if (m)
      return A.get(d.min());
    var f = d.size();
    if (f.length !== A._size.length)
      throw new ie(f.length, A._size.length);
    for (var p = d.min(), c = d.max(), h = 0, v = A._size.length; h < v; h++)
      he(p[h], A._size[h]), he(c[h], A._size[h]);
    return new r(i(A._data, d, f.length, 0), A._datatype);
  }
  function i(A, d, m, f) {
    var p = f === m - 1, c = d.dimension(f);
    return p ? c.map(function(h) {
      return he(h, A.length), A[h];
    }).valueOf() : c.map(function(h) {
      he(h, A.length);
      var v = A[h];
      return i(v, d, m, f + 1);
    }).valueOf();
  }
  function a(A, d, m, f) {
    if (!d || d.isIndex !== !0)
      throw new TypeError("Invalid index");
    var p = d.size(), c = d.isScalar(), h;
    if (Ve(m) ? (h = m.size(), m = m.valueOf()) : h = Ge(m), c) {
      if (h.length !== 0)
        throw new TypeError("Scalar expected");
      A.set(d.min(), m, f);
    } else {
      if (!Et(h, p))
        try {
          h.length === 0 ? m = Pn([m], p) : m = Pn(m, p), h = Ge(m);
        } catch {
        }
      if (p.length < A._size.length)
        throw new ie(p.length, A._size.length, "<");
      if (h.length < p.length) {
        for (var v = 0, Z = 0; p[v] === 1 && h[v] === 1; )
          v++;
        for (; p[v] === 1; )
          Z++, v++;
        m = tu(m, p.length, Z, h);
      }
      if (!Et(p, h))
        throw new ie(p, h, ">");
      var b = d.max().map(function(V) {
        return V + 1;
      });
      o(A, b, f);
      var F = p.length, y = 0;
      u(A._data, d, m, F, y);
    }
    return A;
  }
  function u(A, d, m, f, p) {
    var c = p === f - 1, h = d.dimension(p);
    c ? h.forEach(function(v, Z) {
      he(v), A[v] = m[Z[0]];
    }) : h.forEach(function(v, Z) {
      he(v), u(A[v], d, m[Z[0]], f, p + 1);
    });
  }
  r.prototype.resize = function(A, d, m) {
    if (!yr(A))
      throw new TypeError("Array or Matrix expected");
    var f = A.valueOf().map((c) => Array.isArray(c) && c.length === 1 ? c[0] : c), p = m ? this.clone() : this;
    return s(p, f, d);
  };
  function s(A, d, m) {
    if (d.length === 0) {
      for (var f = A._data; ge(f); )
        f = f[0];
      return f;
    }
    return A._size = d.slice(0), A._data = en(A._data, A._size, m), A;
  }
  r.prototype.reshape = function(A, d) {
    var m = d ? this.clone() : this;
    m._data = kn(m._data, A);
    var f = m._size.reduce((p, c) => p * c);
    return m._size = Qn(A, f), m;
  };
  function o(A, d, m) {
    for (var f = A._size.slice(0), p = !1; f.length < d.length; )
      f.push(0), p = !0;
    for (var c = 0, h = d.length; c < h; c++)
      d[c] > f[c] && (f[c] = d[c], p = !0);
    p && s(A, f, m);
  }
  r.prototype.clone = function() {
    var A = new r({
      data: Ae(this._data),
      size: Ae(this._size),
      datatype: this._datatype
    });
    return A;
  }, r.prototype.size = function() {
    return this._size.slice(0);
  }, r.prototype._forEach = function(A) {
    var d = this, m = d.size();
    if (m.length === 1) {
      for (var f = 0; f < m[0]; f++)
        A(d._data, f, [f]);
      return;
    }
    var p = Array(m.length).fill(0), c = Array(m.length - 1), h = c.length - 1;
    c[0] = d._data[0];
    for (var v = 0; v < h; v++)
      c[v + 1] = c[v][0];
    for (p[h] = -1; ; ) {
      var Z = void 0;
      for (Z = h; Z >= 0; Z--) {
        if (p[Z]++, p[Z] === m[Z]) {
          p[Z] = 0;
          continue;
        }
        c[Z] = Z === 0 ? d._data[p[Z]] : c[Z - 1][p[Z]];
        for (var b = Z; b < h; b++)
          c[b + 1] = c[b][0];
        for (var F = 0; F < m[c.length]; F++)
          p[c.length] = F, A(c[h], F, p.slice(0));
        break;
      }
      if (Z === -1)
        break;
    }
  }, r.prototype.map = function(A) {
    var d = this, m = new r(d), f = tn(A, d._data, "map");
    return m._forEach(function(p, c, h) {
      p[c] = f(p[c], h, d);
    }), m;
  }, r.prototype.forEach = function(A) {
    var d = this, m = tn(A, d._data, "map");
    d._forEach(function(f, p, c) {
      m(f[p], c, d);
    });
  }, r.prototype[Symbol.iterator] = function* () {
    var A = function* (m, f) {
      if (ge(m))
        for (var p = 0; p < m.length; p++)
          yield* A(m[p], f.concat(p));
      else
        yield {
          value: m,
          index: f
        };
    };
    yield* A(this._data, []);
  }, r.prototype.rows = function() {
    var A = [], d = this.size();
    if (d.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    var m = this._data;
    for (var f of m)
      A.push(new r([f], this._datatype));
    return A;
  }, r.prototype.columns = function() {
    var A = this, d = [], m = this.size();
    if (m.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var f = this._data, p = function(v) {
      var Z = f.map((b) => [b[v]]);
      d.push(new r(Z, A._datatype));
    }, c = 0; c < m[1]; c++)
      p(c);
    return d;
  }, r.prototype.toArray = function() {
    return Ae(this._data);
  }, r.prototype.valueOf = function() {
    return this._data;
  }, r.prototype.format = function(A) {
    return we(this._data, A);
  }, r.prototype.toString = function() {
    return we(this._data);
  }, r.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, r.prototype.diagonal = function(A) {
    if (A) {
      if (We(A) && (A = A.toNumber()), !Ze(A) || !Ke(A))
        throw new TypeError("The parameter k must be an integer number");
    } else
      A = 0;
    for (var d = A > 0 ? A : 0, m = A < 0 ? -A : 0, f = this._size[0], p = this._size[1], c = Math.min(f - m, p - d), h = [], v = 0; v < c; v++)
      h[v] = this._data[v + m][v + d];
    return new r({
      data: h,
      size: [c],
      datatype: this._datatype
    });
  }, r.diagonal = function(A, d, m, f) {
    if (!ge(A))
      throw new TypeError("Array expected, size parameter");
    if (A.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (A = A.map(function(W) {
      if (We(W) && (W = W.toNumber()), !Ze(W) || !Ke(W) || W < 1)
        throw new Error("Size values must be positive integers");
      return W;
    }), m) {
      if (We(m) && (m = m.toNumber()), !Ze(m) || !Ke(m))
        throw new TypeError("The parameter k must be an integer number");
    } else
      m = 0;
    var p = m > 0 ? m : 0, c = m < 0 ? -m : 0, h = A[0], v = A[1], Z = Math.min(h - c, v - p), b;
    if (ge(d)) {
      if (d.length !== Z)
        throw new Error("Invalid value array length");
      b = function(X) {
        return d[X];
      };
    } else if (Ve(d)) {
      var F = d.size();
      if (F.length !== 1 || F[0] !== Z)
        throw new Error("Invalid matrix length");
      b = function(X) {
        return d.get([X]);
      };
    } else
      b = function() {
        return d;
      };
    f || (f = We(b(0)) ? b(0).mul(0) : 0);
    var y = [];
    if (A.length > 0) {
      y = en(y, A, f);
      for (var V = 0; V < Z; V++)
        y[V + c][V + p] = b(V);
    }
    return new r({
      data: y,
      size: [h, v]
    });
  }, r.fromJSON = function(A) {
    return new r(A);
  }, r.prototype.swapRows = function(A, d) {
    if (!Ze(A) || !Ke(A) || !Ze(d) || !Ke(d))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return he(A, this._size[0]), he(d, this._size[0]), r._swapRows(A, d, this._data), this;
  }, r._swapRows = function(A, d, m) {
    var f = m[A];
    m[A] = m[d], m[d] = f;
  };
  function l(A) {
    return Ve(A) ? l(A.valueOf()) : ge(A) ? A.map(l) : A;
  }
  return r;
}, {
  isClass: !0
});
function gl(e) {
  var t = e.length, r = e[0].length, n, i, a = [];
  for (i = 0; i < r; i++) {
    var u = [];
    for (n = 0; n < t; n++)
      u.push(e[n][i]);
    a.push(u);
  }
  return a;
}
function _n(e) {
  for (var t = 0; t < e.length; t++)
    if (yr(e[t]))
      return !0;
  return !1;
}
function Vn(e, t) {
  Ve(e) && (e = e.valueOf());
  for (var r = 0, n = e.length; r < n; r++) {
    var i = e[r];
    Array.isArray(i) ? Vn(i, t) : t(i);
  }
}
function Vt(e, t, r) {
  return e && typeof e.map == "function" ? e.map(function(n) {
    return Vt(n, t);
  }) : t(e);
}
function $n(e, t, r) {
  var n = Array.isArray(e) ? Ge(e) : e.size();
  if (t < 0 || t >= n.length)
    throw new Gt(t, n.length);
  return Ve(e) ? e.create(rn(e.valueOf(), t, r), e.datatype()) : rn(e, t, r);
}
function rn(e, t, r) {
  var n, i, a, u;
  if (t <= 0)
    if (Array.isArray(e[0])) {
      for (u = gl(e), i = [], n = 0; n < u.length; n++)
        i[n] = rn(u[n], t - 1, r);
      return i;
    } else {
      for (a = e[0], n = 1; n < e.length; n++)
        a = r(a, e[n]);
      return a;
    }
  else {
    for (i = [], n = 0; n < e.length; n++)
      i[n] = rn(e[n], t - 1, r);
    return i;
  }
}
var wi = "isInteger", Zl = ["typed"], Fl = /* @__PURE__ */ J(wi, Zl, (e) => {
  var {
    typed: t
  } = e;
  return t(wi, {
    number: Ke,
    // TODO: what to do with isInteger(add(0.1, 0.2))  ?
    BigNumber: function(n) {
      return n.isInt();
    },
    bigint: function(n) {
      return !0;
    },
    Fraction: function(n) {
      return n.d === 1 && isFinite(n.n);
    },
    "Array | Matrix": t.referToSelf((r) => (n) => Vt(n, r))
  });
}), ei = "number", ti = "number, number";
function su(e) {
  return Math.abs(e);
}
su.signature = ei;
function Au(e, t) {
  return e + t;
}
Au.signature = ti;
function lu(e, t) {
  return e - t;
}
lu.signature = ti;
function cu(e, t) {
  return e * t;
}
cu.signature = ti;
function du(e) {
  return -e;
}
du.signature = ei;
function fu(e) {
  return e * e;
}
fu.signature = ei;
var Xl = "number";
function mu(e) {
  return e > 0;
}
mu.signature = Xl;
function Ar(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (n < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return e.isNaN() || t.isNaN() ? !1 : !e.isFinite() || !t.isFinite() ? e.eq(t) : e.eq(t) ? !0 : e.minus(t).abs().lte(e.constructor.max(e.constructor.max(e.abs(), t.abs()).mul(r), n));
}
var Ki = "isPositive", Wl = ["typed", "config"], xl = /* @__PURE__ */ J(Ki, Wl, (e) => {
  var {
    typed: t,
    config: r
  } = e;
  return t(Ki, {
    number: (n) => Ct(n, 0, r.relTol, r.absTol) ? !1 : mu(n),
    BigNumber: (n) => Ar(n, new n.constructor(0), r.relTol, r.absTol) ? !1 : !n.isNeg() && !n.isZero() && !n.isNaN(),
    bigint: (n) => n > 0n,
    Fraction: (n) => n.s > 0 && n.n > 0,
    Unit: t.referToSelf((n) => (i) => t.find(n, i.valueType())(i.value)),
    "Array | Matrix": t.referToSelf((n) => (i) => Vt(i, n))
  });
}), Ii = "isZero", Dl = ["typed", "equalScalar"], Cl = /* @__PURE__ */ J(Ii, Dl, (e) => {
  var {
    typed: t,
    equalScalar: r
  } = e;
  return t(Ii, {
    "number | BigNumber | Complex | Fraction": (n) => r(n, 0),
    bigint: (n) => n === 0n,
    Unit: t.referToSelf((n) => (i) => t.find(n, i.valueType())(i.value)),
    "Array | Matrix": t.referToSelf((n) => (i) => Vt(i, n))
  });
});
function ql(e, t, r, n) {
  return Ct(e.re, t.re, r, n) && Ct(e.im, t.im, r, n);
}
var xr = /* @__PURE__ */ J("compareUnits", ["typed"], (e) => {
  var {
    typed: t
  } = e;
  return {
    "Unit, Unit": t.referToSelf((r) => (n, i) => {
      if (!n.equalBase(i))
        throw new Error("Cannot compare units with different base");
      return t.find(r, [n.valueType(), i.valueType()])(n.value, i.value);
    })
  };
}), nn = "equalScalar", Sl = ["typed", "config"], wl = /* @__PURE__ */ J(nn, Sl, (e) => {
  var {
    typed: t,
    config: r
  } = e, n = xr({
    typed: t
  });
  return t(nn, {
    "boolean, boolean": function(a, u) {
      return a === u;
    },
    "number, number": function(a, u) {
      return Ct(a, u, r.relTol, r.absTol);
    },
    "BigNumber, BigNumber": function(a, u) {
      return a.eq(u) || Ar(a, u, r.relTol, r.absTol);
    },
    "bigint, bigint": function(a, u) {
      return a === u;
    },
    "Fraction, Fraction": function(a, u) {
      return a.equals(u);
    },
    "Complex, Complex": function(a, u) {
      return ql(a, u, r.relTol, r.absTol);
    }
  }, n);
});
J(nn, ["typed", "config"], (e) => {
  var {
    typed: t,
    config: r
  } = e;
  return t(nn, {
    "number, number": function(i, a) {
      return Ct(i, a, r.relTol, r.absTol);
    }
  });
});
var Kl = "SparseMatrix", Il = ["typed", "equalScalar", "Matrix"], El = /* @__PURE__ */ J(Kl, Il, (e) => {
  var {
    typed: t,
    equalScalar: r,
    Matrix: n
  } = e;
  function i(c, h) {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (h && !ot(h))
      throw new Error("Invalid datatype: " + h);
    if (Ve(c))
      a(this, c, h);
    else if (c && ge(c.index) && ge(c.ptr) && ge(c.size))
      this._values = c.values, this._index = c.index, this._ptr = c.ptr, this._size = c.size, this._datatype = h || c.datatype;
    else if (ge(c))
      u(this, c, h);
    else {
      if (c)
        throw new TypeError("Unsupported type of data (" + st(c) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = h;
    }
  }
  function a(c, h, v) {
    h.type === "SparseMatrix" ? (c._values = h._values ? Ae(h._values) : void 0, c._index = Ae(h._index), c._ptr = Ae(h._ptr), c._size = Ae(h._size), c._datatype = v || h._datatype) : u(c, h.valueOf(), v || h._datatype);
  }
  function u(c, h, v) {
    c._values = [], c._index = [], c._ptr = [], c._datatype = v;
    var Z = h.length, b = 0, F = r, y = 0;
    if (ot(v) && (F = t.find(r, [v, v]) || r, y = t.convert(0, v)), Z > 0) {
      var V = 0;
      do {
        c._ptr.push(c._index.length);
        for (var W = 0; W < Z; W++) {
          var X = h[W];
          if (ge(X)) {
            if (V === 0 && b < X.length && (b = X.length), V < X.length) {
              var x = X[V];
              F(x, y) || (c._values.push(x), c._index.push(W));
            }
          } else
            V === 0 && b < 1 && (b = 1), F(X, y) || (c._values.push(X), c._index.push(W));
        }
        V++;
      } while (V < b);
    }
    c._ptr.push(c._index.length), c._size = [Z, b];
  }
  i.prototype = new n(), i.prototype.createSparseMatrix = function(c, h) {
    return new i(c, h);
  }, Object.defineProperty(i, "name", {
    value: "SparseMatrix"
  }), i.prototype.constructor = i, i.prototype.type = "SparseMatrix", i.prototype.isSparseMatrix = !0, i.prototype.getDataType = function() {
    return vn(this._values, st);
  }, i.prototype.storage = function() {
    return "sparse";
  }, i.prototype.datatype = function() {
    return this._datatype;
  }, i.prototype.create = function(c, h) {
    return new i(c, h);
  }, i.prototype.density = function() {
    var c = this._size[0], h = this._size[1];
    return c !== 0 && h !== 0 ? this._index.length / (c * h) : 0;
  }, i.prototype.subset = function(c, h, v) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return s(this, c);
      case 2:
      case 3:
        return o(this, c, h, v);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function s(c, h) {
    if (!cn(h))
      throw new TypeError("Invalid index");
    var v = h.isScalar();
    if (v)
      return c.get(h.min());
    var Z = h.size();
    if (Z.length !== c._size.length)
      throw new ie(Z.length, c._size.length);
    var b, F, y, V, W = h.min(), X = h.max();
    for (b = 0, F = c._size.length; b < F; b++)
      he(W[b], c._size[b]), he(X[b], c._size[b]);
    var x = c._values, q = c._index, I = c._ptr, E = h.dimension(0), L = h.dimension(1), z = [], G = [];
    E.forEach(function(j, te) {
      G[j] = te[0], z[j] = !0;
    });
    var w = x ? [] : void 0, U = [], O = [];
    return L.forEach(function(j) {
      for (O.push(U.length), y = I[j], V = I[j + 1]; y < V; y++)
        b = q[y], z[b] === !0 && (U.push(G[b]), w && w.push(x[y]));
    }), O.push(U.length), new i({
      values: w,
      index: U,
      ptr: O,
      size: Z,
      datatype: c._datatype
    });
  }
  function o(c, h, v, Z) {
    if (!h || h.isIndex !== !0)
      throw new TypeError("Invalid index");
    var b = h.size(), F = h.isScalar(), y;
    if (Ve(v) ? (y = v.size(), v = v.toArray()) : y = Ge(v), F) {
      if (y.length !== 0)
        throw new TypeError("Scalar expected");
      c.set(h.min(), v, Z);
    } else {
      if (b.length !== 1 && b.length !== 2)
        throw new ie(b.length, c._size.length, "<");
      if (y.length < b.length) {
        for (var V = 0, W = 0; b[V] === 1 && y[V] === 1; )
          V++;
        for (; b[V] === 1; )
          W++, V++;
        v = tu(v, b.length, W, y);
      }
      if (!Et(b, y))
        throw new ie(b, y, ">");
      if (b.length === 1) {
        var X = h.dimension(0);
        X.forEach(function(I, E) {
          he(I), c.set([I, 0], v[E[0]], Z);
        });
      } else {
        var x = h.dimension(0), q = h.dimension(1);
        x.forEach(function(I, E) {
          he(I), q.forEach(function(L, z) {
            he(L), c.set([I, L], v[E[0]][z[0]], Z);
          });
        });
      }
    }
    return c;
  }
  i.prototype.get = function(c) {
    if (!ge(c))
      throw new TypeError("Array expected");
    if (c.length !== this._size.length)
      throw new ie(c.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var h = c[0], v = c[1];
    he(h, this._size[0]), he(v, this._size[1]);
    var Z = l(h, this._ptr[v], this._ptr[v + 1], this._index);
    return Z < this._ptr[v + 1] && this._index[Z] === h ? this._values[Z] : 0;
  }, i.prototype.set = function(c, h, v) {
    if (!ge(c))
      throw new TypeError("Array expected");
    if (c.length !== this._size.length)
      throw new ie(c.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var Z = c[0], b = c[1], F = this._size[0], y = this._size[1], V = r, W = 0;
    ot(this._datatype) && (V = t.find(r, [this._datatype, this._datatype]) || r, W = t.convert(0, this._datatype)), (Z > F - 1 || b > y - 1) && (m(this, Math.max(Z + 1, F), Math.max(b + 1, y), v), F = this._size[0], y = this._size[1]), he(Z, F), he(b, y);
    var X = l(Z, this._ptr[b], this._ptr[b + 1], this._index);
    return X < this._ptr[b + 1] && this._index[X] === Z ? V(h, W) ? A(X, b, this._values, this._index, this._ptr) : this._values[X] = h : V(h, W) || d(X, Z, b, h, this._values, this._index, this._ptr), this;
  };
  function l(c, h, v, Z) {
    if (v - h === 0)
      return v;
    for (var b = h; b < v; b++)
      if (Z[b] === c)
        return b;
    return h;
  }
  function A(c, h, v, Z, b) {
    v.splice(c, 1), Z.splice(c, 1);
    for (var F = h + 1; F < b.length; F++)
      b[F]--;
  }
  function d(c, h, v, Z, b, F, y) {
    b.splice(c, 0, Z), F.splice(c, 0, h);
    for (var V = v + 1; V < y.length; V++)
      y[V]++;
  }
  i.prototype.resize = function(c, h, v) {
    if (!yr(c))
      throw new TypeError("Array or Matrix expected");
    var Z = c.valueOf().map((F) => Array.isArray(F) && F.length === 1 ? F[0] : F);
    if (Z.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    Z.forEach(function(F) {
      if (!Ze(F) || !Ke(F) || F < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + we(Z) + ")");
    });
    var b = v ? this.clone() : this;
    return m(b, Z[0], Z[1], h);
  };
  function m(c, h, v, Z) {
    var b = Z || 0, F = r, y = 0;
    ot(c._datatype) && (F = t.find(r, [c._datatype, c._datatype]) || r, y = t.convert(0, c._datatype), b = t.convert(b, c._datatype));
    var V = !F(b, y), W = c._size[0], X = c._size[1], x, q, I;
    if (v > X) {
      for (q = X; q < v; q++)
        if (c._ptr[q] = c._values.length, V)
          for (x = 0; x < W; x++)
            c._values.push(b), c._index.push(x);
      c._ptr[v] = c._values.length;
    } else v < X && (c._ptr.splice(v + 1, X - v), c._values.splice(c._ptr[v], c._values.length), c._index.splice(c._ptr[v], c._index.length));
    if (X = v, h > W) {
      if (V) {
        var E = 0;
        for (q = 0; q < X; q++) {
          c._ptr[q] = c._ptr[q] + E, I = c._ptr[q + 1] + E;
          var L = 0;
          for (x = W; x < h; x++, L++)
            c._values.splice(I + L, 0, b), c._index.splice(I + L, 0, x), E++;
        }
        c._ptr[X] = c._values.length;
      }
    } else if (h < W) {
      var z = 0;
      for (q = 0; q < X; q++) {
        c._ptr[q] = c._ptr[q] - z;
        var G = c._ptr[q], w = c._ptr[q + 1] - z;
        for (I = G; I < w; I++)
          x = c._index[I], x > h - 1 && (c._values.splice(I, 1), c._index.splice(I, 1), z++);
      }
      c._ptr[q] = c._values.length;
    }
    return c._size[0] = h, c._size[1] = v, c;
  }
  i.prototype.reshape = function(c, h) {
    if (!ge(c))
      throw new TypeError("Array expected");
    if (c.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    c.forEach(function(j) {
      if (!Ze(j) || !Ke(j) || j <= -2 || j === 0)
        throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + we(c) + ")");
    });
    var v = this._size[0] * this._size[1];
    c = Qn(c, v);
    var Z = c[0] * c[1];
    if (v !== Z)
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var b = h ? this.clone() : this;
    if (this._size[0] === c[0] && this._size[1] === c[1])
      return b;
    for (var F = [], y = 0; y < b._ptr.length; y++)
      for (var V = 0; V < b._ptr[y + 1] - b._ptr[y]; V++)
        F.push(y);
    for (var W = b._values.slice(), X = b._index.slice(), x = 0; x < b._index.length; x++) {
      var q = X[x], I = F[x], E = q * b._size[1] + I;
      F[x] = E % c[1], X[x] = Math.floor(E / c[1]);
    }
    b._values.length = 0, b._index.length = 0, b._ptr.length = c[1] + 1, b._size = c.slice();
    for (var L = 0; L < b._ptr.length; L++)
      b._ptr[L] = 0;
    for (var z = 0; z < W.length; z++) {
      var G = X[z], w = F[z], U = W[z], O = l(G, b._ptr[w], b._ptr[w + 1], b._index);
      d(O, G, w, U, b._values, b._index, b._ptr);
    }
    return b;
  }, i.prototype.clone = function() {
    var c = new i({
      values: this._values ? Ae(this._values) : void 0,
      index: Ae(this._index),
      ptr: Ae(this._ptr),
      size: Ae(this._size),
      datatype: this._datatype
    });
    return c;
  }, i.prototype.size = function() {
    return this._size.slice(0);
  }, i.prototype.map = function(c, h) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var v = this, Z = this._size[0], b = this._size[1], F = tn(c, v, "map"), y = function(W, X, x) {
      return F(W, [X, x], v);
    };
    return f(this, 0, Z - 1, 0, b - 1, y, h);
  };
  function f(c, h, v, Z, b, F, y) {
    var V = [], W = [], X = [], x = r, q = 0;
    ot(c._datatype) && (x = t.find(r, [c._datatype, c._datatype]) || r, q = t.convert(0, c._datatype));
    for (var I = function(se, qe, Ee) {
      var Se = F(se, qe, Ee);
      x(Se, q) || (V.push(Se), W.push(qe));
    }, E = Z; E <= b; E++) {
      X.push(V.length);
      var L = c._ptr[E], z = c._ptr[E + 1];
      if (y)
        for (var G = L; G < z; G++) {
          var w = c._index[G];
          w >= h && w <= v && I(c._values[G], w - h, E - Z);
        }
      else {
        for (var U = {}, O = L; O < z; O++) {
          var j = c._index[O];
          U[j] = c._values[O];
        }
        for (var te = h; te <= v; te++) {
          var oe = te in U ? U[te] : 0;
          I(oe, te - h, E - Z);
        }
      }
    }
    return X.push(V.length), new i({
      values: V,
      index: W,
      ptr: X,
      size: [v - h + 1, b - Z + 1]
    });
  }
  i.prototype.forEach = function(c, h) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var v = this, Z = this._size[0], b = this._size[1], F = tn(c, v, "forEach"), y = 0; y < b; y++) {
      var V = this._ptr[y], W = this._ptr[y + 1];
      if (h)
        for (var X = V; X < W; X++) {
          var x = this._index[X];
          F(this._values[X], [x, y], v);
        }
      else {
        for (var q = {}, I = V; I < W; I++) {
          var E = this._index[I];
          q[E] = this._values[I];
        }
        for (var L = 0; L < Z; L++) {
          var z = L in q ? q[L] : 0;
          F(z, [L, y], v);
        }
      }
    }
  }, i.prototype[Symbol.iterator] = function* () {
    if (!this._values)
      throw new Error("Cannot iterate a Pattern only matrix");
    for (var c = this._size[1], h = 0; h < c; h++)
      for (var v = this._ptr[h], Z = this._ptr[h + 1], b = v; b < Z; b++) {
        var F = this._index[b];
        yield {
          value: this._values[b],
          index: [F, h]
        };
      }
  }, i.prototype.toArray = function() {
    return p(this._values, this._index, this._ptr, this._size, !0);
  }, i.prototype.valueOf = function() {
    return p(this._values, this._index, this._ptr, this._size, !1);
  };
  function p(c, h, v, Z, b) {
    var F = Z[0], y = Z[1], V = [], W, X;
    for (W = 0; W < F; W++)
      for (V[W] = [], X = 0; X < y; X++)
        V[W][X] = 0;
    for (X = 0; X < y; X++)
      for (var x = v[X], q = v[X + 1], I = x; I < q; I++)
        W = h[I], V[W][X] = c ? b ? Ae(c[I]) : c[I] : 1;
    return V;
  }
  return i.prototype.format = function(c) {
    for (var h = this._size[0], v = this._size[1], Z = this.density(), b = "Sparse Matrix [" + we(h, c) + " x " + we(v, c) + "] density: " + we(Z, c) + `
`, F = 0; F < v; F++)
      for (var y = this._ptr[F], V = this._ptr[F + 1], W = y; W < V; W++) {
        var X = this._index[W];
        b += `
    (` + we(X, c) + ", " + we(F, c) + ") ==> " + (this._values ? we(this._values[W], c) : "X");
      }
    return b;
  }, i.prototype.toString = function() {
    return we(this.toArray());
  }, i.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, i.prototype.diagonal = function(c) {
    if (c) {
      if (We(c) && (c = c.toNumber()), !Ze(c) || !Ke(c))
        throw new TypeError("The parameter k must be an integer number");
    } else
      c = 0;
    var h = c > 0 ? c : 0, v = c < 0 ? -c : 0, Z = this._size[0], b = this._size[1], F = Math.min(Z - v, b - h), y = [], V = [], W = [];
    W[0] = 0;
    for (var X = h; X < b && y.length < F; X++)
      for (var x = this._ptr[X], q = this._ptr[X + 1], I = x; I < q; I++) {
        var E = this._index[I];
        if (E === X - h + v) {
          y.push(this._values[I]), V[y.length - 1] = E - v;
          break;
        }
      }
    return W.push(y.length), new i({
      values: y,
      index: V,
      ptr: W,
      size: [F, 1]
    });
  }, i.fromJSON = function(c) {
    return new i(c);
  }, i.diagonal = function(c, h, v, Z, b) {
    if (!ge(c))
      throw new TypeError("Array expected, size parameter");
    if (c.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (c = c.map(function(j) {
      if (We(j) && (j = j.toNumber()), !Ze(j) || !Ke(j) || j < 1)
        throw new Error("Size values must be positive integers");
      return j;
    }), v) {
      if (We(v) && (v = v.toNumber()), !Ze(v) || !Ke(v))
        throw new TypeError("The parameter k must be an integer number");
    } else
      v = 0;
    var F = r, y = 0;
    ot(b) && (F = t.find(r, [b, b]) || r, y = t.convert(0, b));
    var V = v > 0 ? v : 0, W = v < 0 ? -v : 0, X = c[0], x = c[1], q = Math.min(X - W, x - V), I;
    if (ge(h)) {
      if (h.length !== q)
        throw new Error("Invalid value array length");
      I = function(te) {
        return h[te];
      };
    } else if (Ve(h)) {
      var E = h.size();
      if (E.length !== 1 || E[0] !== q)
        throw new Error("Invalid matrix length");
      I = function(te) {
        return h.get([te]);
      };
    } else
      I = function() {
        return h;
      };
    for (var L = [], z = [], G = [], w = 0; w < x; w++) {
      G.push(L.length);
      var U = w - V;
      if (U >= 0 && U < q) {
        var O = I(U);
        F(O, y) || (z.push(U + W), L.push(O));
      }
    }
    return G.push(L.length), new i({
      values: L,
      index: z,
      ptr: G,
      size: [X, x]
    });
  }, i.prototype.swapRows = function(c, h) {
    if (!Ze(c) || !Ke(c) || !Ze(h) || !Ke(h))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return he(c, this._size[0]), he(h, this._size[0]), i._swapRows(c, h, this._size[1], this._values, this._index, this._ptr), this;
  }, i._forEachRow = function(c, h, v, Z, b) {
    for (var F = Z[c], y = Z[c + 1], V = F; V < y; V++)
      b(v[V], h[V]);
  }, i._swapRows = function(c, h, v, Z, b, F) {
    for (var y = 0; y < v; y++) {
      var V = F[y], W = F[y + 1], X = l(c, V, W, b), x = l(h, V, W, b);
      if (X < W && x < W && b[X] === c && b[x] === h) {
        if (Z) {
          var q = Z[X];
          Z[X] = Z[x], Z[x] = q;
        }
        continue;
      }
      if (X < W && b[X] === c && (x >= W || b[x] !== h)) {
        var I = Z ? Z[X] : void 0;
        b.splice(x, 0, h), Z && Z.splice(x, 0, I), b.splice(x <= X ? X + 1 : X, 1), Z && Z.splice(x <= X ? X + 1 : X, 1);
        continue;
      }
      if (x < W && b[x] === h && (X >= W || b[X] !== c)) {
        var E = Z ? Z[x] : void 0;
        b.splice(X, 0, c), Z && Z.splice(X, 0, E), b.splice(X <= x ? x + 1 : x, 1), Z && Z.splice(X <= x ? x + 1 : x, 1);
      }
    }
  }, i;
}, {
  isClass: !0
}), Rl = "number", zl = ["typed"];
function Tl(e) {
  var t = e.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  if (t) {
    var r = {
      "0b": 2,
      "0o": 8,
      "0x": 16
    }[t[1]], n = t[2], i = t[3];
    return {
      input: e,
      radix: r,
      integerPart: n,
      fractionalPart: i
    };
  } else
    return null;
}
function Nl(e) {
  for (var t = parseInt(e.integerPart, e.radix), r = 0, n = 0; n < e.fractionalPart.length; n++) {
    var i = parseInt(e.fractionalPart[n], e.radix);
    r += i / Math.pow(e.radix, n + 1);
  }
  var a = t + r;
  if (isNaN(a))
    throw new SyntaxError('String "' + e.input + '" is not a valid number');
  return a;
}
var Gl = /* @__PURE__ */ J(Rl, zl, (e) => {
  var {
    typed: t
  } = e, r = t("number", {
    "": function() {
      return 0;
    },
    number: function(i) {
      return i;
    },
    string: function(i) {
      if (i === "NaN") return NaN;
      var a = Tl(i);
      if (a)
        return Nl(a);
      var u = 0, s = i.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      s && (u = Number(s[2]), i = s[1]);
      var o = Number(i);
      if (isNaN(o))
        throw new SyntaxError('String "' + i + '" is not a valid number');
      if (s) {
        if (o > 2 ** u - 1)
          throw new SyntaxError('String "'.concat(i, '" is out of range'));
        o >= 2 ** (u - 1) && (o = o - 2 ** u);
      }
      return o;
    },
    BigNumber: function(i) {
      return i.toNumber();
    },
    bigint: function(i) {
      return Number(i);
    },
    Fraction: function(i) {
      return i.valueOf();
    },
    Unit: t.referToSelf((n) => (i) => {
      var a = i.clone();
      return a.value = n(i.value), a;
    }),
    null: function(i) {
      return 0;
    },
    "Unit, string | Unit": function(i, a) {
      return i.toNumber(a);
    },
    "Array | Matrix": t.referToSelf((n) => (i) => Vt(i, n))
  });
  return r.fromJSON = function(n) {
    return parseFloat(n.value);
  }, r;
}), Pl = "bignumber", Ll = ["typed", "BigNumber"], Ml = /* @__PURE__ */ J(Pl, Ll, (e) => {
  var {
    typed: t,
    BigNumber: r
  } = e;
  return t("bignumber", {
    "": function() {
      return new r(0);
    },
    number: function(i) {
      return new r(i + "");
    },
    string: function(i) {
      var a = i.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      if (a) {
        var u = a[2], s = r(a[1]), o = new r(2).pow(Number(u));
        if (s.gt(o.sub(1)))
          throw new SyntaxError('String "'.concat(i, '" is out of range'));
        var l = new r(2).pow(Number(u) - 1);
        return s.gte(l) ? s.sub(o) : s;
      }
      return new r(i);
    },
    BigNumber: function(i) {
      return i;
    },
    bigint: function(i) {
      return new r(i.toString());
    },
    Unit: t.referToSelf((n) => (i) => {
      var a = i.clone();
      return a.value = n(i.value), a;
    }),
    Fraction: function(i) {
      return new r(i.n).div(i.d).times(i.s);
    },
    null: function(i) {
      return new r(0);
    },
    "Array | Matrix": t.referToSelf((n) => (i) => Vt(i, n))
  });
}), Hl = "fraction", Ul = ["typed", "Fraction"], Bl = /* @__PURE__ */ J(Hl, Ul, (e) => {
  var {
    typed: t,
    Fraction: r
  } = e;
  return t("fraction", {
    number: function(i) {
      if (!isFinite(i) || isNaN(i))
        throw new Error(i + " cannot be represented as a fraction");
      return new r(i);
    },
    string: function(i) {
      return new r(i);
    },
    "number, number": function(i, a) {
      return new r(i, a);
    },
    null: function(i) {
      return new r(0);
    },
    BigNumber: function(i) {
      return new r(i.toString());
    },
    bigint: function(i) {
      return new r(i.toString());
    },
    Fraction: function(i) {
      return i;
    },
    Unit: t.referToSelf((n) => (i) => {
      var a = i.clone();
      return a.value = n(i.value), a;
    }),
    Object: function(i) {
      return new r(i);
    },
    "Array | Matrix": t.referToSelf((n) => (i) => Vt(i, n))
  });
}), Ei = "matrix", Yl = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], Ol = /* @__PURE__ */ J(Ei, Yl, (e) => {
  var {
    typed: t,
    Matrix: r,
    DenseMatrix: n,
    SparseMatrix: i
  } = e;
  return t(Ei, {
    "": function() {
      return a([]);
    },
    string: function(s) {
      return a([], s);
    },
    "string, string": function(s, o) {
      return a([], s, o);
    },
    Array: function(s) {
      return a(s);
    },
    Matrix: function(s) {
      return a(s, s.storage());
    },
    "Array | Matrix, string": a,
    "Array | Matrix, string, string": a
  });
  function a(u, s, o) {
    if (s === "dense" || s === "default" || s === void 0)
      return new n(u, o);
    if (s === "sparse")
      return new i(u, o);
    throw new TypeError("Unknown matrix type " + JSON.stringify(s) + ".");
  }
}), Ri = "unaryMinus", Jl = ["typed"], jl = /* @__PURE__ */ J(Ri, Jl, (e) => {
  var {
    typed: t
  } = e;
  return t(Ri, {
    number: du,
    "Complex | BigNumber | Fraction": (r) => r.neg(),
    bigint: (r) => -r,
    Unit: t.referToSelf((r) => (n) => {
      var i = n.clone();
      return i.value = t.find(r, i.valueType())(n.value), i;
    }),
    // deep map collection, skip zeros since unaryMinus(0) = 0
    "Array | Matrix": t.referToSelf((r) => (n) => Vt(n, r))
    // TODO: add support for string
  });
}), zi = "abs", kl = ["typed"], Ql = /* @__PURE__ */ J(zi, kl, (e) => {
  var {
    typed: t
  } = e;
  return t(zi, {
    number: su,
    "Complex | BigNumber | Fraction | Unit": (r) => r.abs(),
    bigint: (r) => r < 0n ? -r : r,
    // deep map collection, skip zeros since abs(0) = 0
    "Array | Matrix": t.referToSelf((r) => (n) => Vt(n, r))
  });
}), Ti = "addScalar", _l = ["typed"], $l = /* @__PURE__ */ J(Ti, _l, (e) => {
  var {
    typed: t
  } = e;
  return t(Ti, {
    "number, number": Au,
    "Complex, Complex": function(n, i) {
      return n.add(i);
    },
    "BigNumber, BigNumber": function(n, i) {
      return n.plus(i);
    },
    "bigint, bigint": function(n, i) {
      return n + i;
    },
    "Fraction, Fraction": function(n, i) {
      return n.add(i);
    },
    "Unit, Unit": t.referToSelf((r) => (n, i) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (i.value === null || i.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(i)) throw new Error("Units do not match");
      var a = n.clone();
      return a.value = t.find(r, [a.valueType(), i.valueType()])(a.value, i.value), a.fixPrefix = !1, a;
    })
  });
}), Ni = "subtractScalar", ec = ["typed"], tc = /* @__PURE__ */ J(Ni, ec, (e) => {
  var {
    typed: t
  } = e;
  return t(Ni, {
    "number, number": lu,
    "Complex, Complex": function(n, i) {
      return n.sub(i);
    },
    "BigNumber, BigNumber": function(n, i) {
      return n.minus(i);
    },
    "bigint, bigint": function(n, i) {
      return n - i;
    },
    "Fraction, Fraction": function(n, i) {
      return n.sub(i);
    },
    "Unit, Unit": t.referToSelf((r) => (n, i) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (i.value === null || i.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(i)) throw new Error("Units do not match");
      var a = n.clone();
      return a.value = t.find(r, [a.valueType(), i.valueType()])(a.value, i.value), a.fixPrefix = !1, a;
    })
  });
}), rc = "matAlgo11xS0s", nc = ["typed", "equalScalar"], pu = /* @__PURE__ */ J(rc, nc, (e) => {
  var {
    typed: t,
    equalScalar: r
  } = e;
  return function(i, a, u, s) {
    var o = i._values, l = i._index, A = i._ptr, d = i._size, m = i._datatype;
    if (!o)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f = d[0], p = d[1], c, h = r, v = 0, Z = u;
    typeof m == "string" && (c = m, h = t.find(r, [c, c]), v = t.convert(0, c), a = t.convert(a, c), Z = t.find(u, [c, c]));
    for (var b = [], F = [], y = [], V = 0; V < p; V++) {
      y[V] = F.length;
      for (var W = A[V], X = A[V + 1], x = W; x < X; x++) {
        var q = l[x], I = s ? Z(a, o[x]) : Z(o[x], a);
        h(I, v) || (F.push(q), b.push(I));
      }
    }
    return y[p] = F.length, i.createSparseMatrix({
      values: b,
      index: F,
      ptr: y,
      size: [f, p],
      datatype: c
    });
  };
}), ic = "matAlgo12xSfs", ac = ["typed", "DenseMatrix"], Dr = /* @__PURE__ */ J(ic, ac, (e) => {
  var {
    typed: t,
    DenseMatrix: r
  } = e;
  return function(i, a, u, s) {
    var o = i._values, l = i._index, A = i._ptr, d = i._size, m = i._datatype;
    if (!o)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f = d[0], p = d[1], c, h = u;
    typeof m == "string" && (c = m, a = t.convert(a, c), h = t.find(u, [c, c]));
    for (var v = [], Z = [], b = [], F = 0; F < p; F++) {
      for (var y = F + 1, V = A[F], W = A[F + 1], X = V; X < W; X++) {
        var x = l[X];
        Z[x] = o[X], b[x] = y;
      }
      for (var q = 0; q < f; q++)
        F === 0 && (v[q] = []), b[q] === y ? v[q][F] = s ? h(a, Z[q]) : h(Z[q], a) : v[q][F] = s ? h(a, 0) : h(0, a);
    }
    return new r({
      data: v,
      size: [f, p],
      datatype: c
    });
  };
}), uc = "matAlgo14xDs", oc = ["typed"], ri = /* @__PURE__ */ J(uc, oc, (e) => {
  var {
    typed: t
  } = e;
  return function(i, a, u, s) {
    var o = i._data, l = i._size, A = i._datatype, d, m = u;
    typeof A == "string" && (d = A, a = t.convert(a, d), m = t.find(u, [d, d]));
    var f = l.length > 0 ? r(m, 0, l, l[0], o, a, s) : [];
    return i.createDenseMatrix({
      data: f,
      size: Ae(l),
      datatype: d
    });
  };
  function r(n, i, a, u, s, o, l) {
    var A = [];
    if (i === a.length - 1)
      for (var d = 0; d < u; d++)
        A[d] = l ? n(o, s[d]) : n(s[d], o);
    else
      for (var m = 0; m < u; m++)
        A[m] = r(n, i + 1, a, a[i + 1], s[m], o, l);
    return A;
  }
}), sc = "matAlgo03xDSf", Ac = ["typed"], Cr = /* @__PURE__ */ J(sc, Ac, (e) => {
  var {
    typed: t
  } = e;
  return function(n, i, a, u) {
    var s = n._data, o = n._size, l = n._datatype || n.getDataType(), A = i._values, d = i._index, m = i._ptr, f = i._size, p = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (o.length !== f.length)
      throw new ie(o.length, f.length);
    if (o[0] !== f[0] || o[1] !== f[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + f + ")");
    if (!A)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var c = o[0], h = o[1], v, Z = 0, b = a;
    typeof l == "string" && l === p && l !== "mixed" && (v = l, Z = t.convert(0, v), b = t.find(a, [v, v]));
    for (var F = [], y = 0; y < c; y++)
      F[y] = [];
    for (var V = [], W = [], X = 0; X < h; X++) {
      for (var x = X + 1, q = m[X], I = m[X + 1], E = q; E < I; E++) {
        var L = d[E];
        V[L] = u ? b(A[E], s[L][X]) : b(s[L][X], A[E]), W[L] = x;
      }
      for (var z = 0; z < c; z++)
        W[z] === x ? F[z][X] = V[z] : F[z][X] = u ? b(Z, s[z][X]) : b(s[z][X], Z);
    }
    return n.createDenseMatrix({
      data: F,
      size: [c, h],
      datatype: l === n._datatype && p === i._datatype ? v : void 0
    });
  };
}), lc = "matAlgo05xSfSf", cc = ["typed", "equalScalar"], dc = /* @__PURE__ */ J(lc, cc, (e) => {
  var {
    typed: t,
    equalScalar: r
  } = e;
  return function(i, a, u) {
    var s = i._values, o = i._index, l = i._ptr, A = i._size, d = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), m = a._values, f = a._index, p = a._ptr, c = a._size, h = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (A.length !== c.length)
      throw new ie(A.length, c.length);
    if (A[0] !== c[0] || A[1] !== c[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + A + ") must match Matrix B (" + c + ")");
    var v = A[0], Z = A[1], b, F = r, y = 0, V = u;
    typeof d == "string" && d === h && d !== "mixed" && (b = d, F = t.find(r, [b, b]), y = t.convert(0, b), V = t.find(u, [b, b]));
    var W = s && m ? [] : void 0, X = [], x = [], q = W ? [] : void 0, I = W ? [] : void 0, E = [], L = [], z, G, w, U;
    for (G = 0; G < Z; G++) {
      x[G] = X.length;
      var O = G + 1;
      for (w = l[G], U = l[G + 1]; w < U; w++)
        z = o[w], X.push(z), E[z] = O, q && (q[z] = s[w]);
      for (w = p[G], U = p[G + 1]; w < U; w++)
        z = f[w], E[z] !== O && X.push(z), L[z] = O, I && (I[z] = m[w]);
      if (W)
        for (w = x[G]; w < X.length; ) {
          z = X[w];
          var j = E[z], te = L[z];
          if (j === O || te === O) {
            var oe = j === O ? q[z] : y, ue = te === O ? I[z] : y, se = V(oe, ue);
            F(se, y) ? X.splice(w, 1) : (W.push(se), w++);
          }
        }
    }
    return x[Z] = X.length, i.createSparseMatrix({
      values: W,
      index: X,
      ptr: x,
      size: [v, Z],
      datatype: d === i._datatype && h === a._datatype ? b : void 0
    });
  };
}), fc = "matAlgo13xDD", mc = ["typed"], pc = /* @__PURE__ */ J(fc, mc, (e) => {
  var {
    typed: t
  } = e;
  return function(i, a, u) {
    var s = i._data, o = i._size, l = i._datatype, A = a._data, d = a._size, m = a._datatype, f = [];
    if (o.length !== d.length)
      throw new ie(o.length, d.length);
    for (var p = 0; p < o.length; p++) {
      if (o[p] !== d[p])
        throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + d + ")");
      f[p] = o[p];
    }
    var c, h = u;
    typeof l == "string" && l === m && (c = l, h = t.find(u, [c, c]));
    var v = f.length > 0 ? r(h, 0, f, f[0], s, A) : [];
    return i.createDenseMatrix({
      data: v,
      size: f,
      datatype: c
    });
  };
  function r(n, i, a, u, s, o) {
    var l = [];
    if (i === a.length - 1)
      for (var A = 0; A < u; A++)
        l[A] = n(s[A], o[A]);
    else
      for (var d = 0; d < u; d++)
        l[d] = r(n, i + 1, a, a[i + 1], s[d], o[d]);
    return l;
  }
});
function Ne(e, t) {
  if (Et(e.size(), t.size()))
    return [e, t];
  var r = au(e.size(), t.size());
  return [e, t].map((n) => hc(n, r));
}
function hc(e, t) {
  return Et(e.size(), t) ? e : e.create(Pn(e.valueOf(), t), e.datatype());
}
var vc = "matrixAlgorithmSuite", Vc = ["typed", "matrix"], lr = /* @__PURE__ */ J(vc, Vc, (e) => {
  var {
    typed: t,
    matrix: r
  } = e, n = pc({
    typed: t
  }), i = ri({
    typed: t
  });
  return function(u) {
    var s = u.elop, o = u.SD || u.DS, l;
    s ? (l = {
      "DenseMatrix, DenseMatrix": (f, p) => n(...Ne(f, p), s),
      "Array, Array": (f, p) => n(...Ne(r(f), r(p)), s).valueOf(),
      "Array, DenseMatrix": (f, p) => n(...Ne(r(f), p), s),
      "DenseMatrix, Array": (f, p) => n(...Ne(f, r(p)), s)
    }, u.SS && (l["SparseMatrix, SparseMatrix"] = (f, p) => u.SS(...Ne(f, p), s, !1)), u.DS && (l["DenseMatrix, SparseMatrix"] = (f, p) => u.DS(...Ne(f, p), s, !1), l["Array, SparseMatrix"] = (f, p) => u.DS(...Ne(r(f), p), s, !1)), o && (l["SparseMatrix, DenseMatrix"] = (f, p) => o(...Ne(p, f), s, !0), l["SparseMatrix, Array"] = (f, p) => o(...Ne(r(p), f), s, !0))) : (l = {
      "DenseMatrix, DenseMatrix": t.referToSelf((f) => (p, c) => n(...Ne(p, c), f)),
      "Array, Array": t.referToSelf((f) => (p, c) => n(...Ne(r(p), r(c)), f).valueOf()),
      "Array, DenseMatrix": t.referToSelf((f) => (p, c) => n(...Ne(r(p), c), f)),
      "DenseMatrix, Array": t.referToSelf((f) => (p, c) => n(...Ne(p, r(c)), f))
    }, u.SS && (l["SparseMatrix, SparseMatrix"] = t.referToSelf((f) => (p, c) => u.SS(...Ne(p, c), f, !1))), u.DS && (l["DenseMatrix, SparseMatrix"] = t.referToSelf((f) => (p, c) => u.DS(...Ne(p, c), f, !1)), l["Array, SparseMatrix"] = t.referToSelf((f) => (p, c) => u.DS(...Ne(r(p), c), f, !1))), o && (l["SparseMatrix, DenseMatrix"] = t.referToSelf((f) => (p, c) => o(...Ne(c, p), f, !0)), l["SparseMatrix, Array"] = t.referToSelf((f) => (p, c) => o(...Ne(r(c), p), f, !0))));
    var A = u.scalar || "any", d = u.Ds || u.Ss;
    d && (s ? (l["DenseMatrix," + A] = (f, p) => i(f, p, s, !1), l[A + ", DenseMatrix"] = (f, p) => i(p, f, s, !0), l["Array," + A] = (f, p) => i(r(f), p, s, !1).valueOf(), l[A + ", Array"] = (f, p) => i(r(p), f, s, !0).valueOf()) : (l["DenseMatrix," + A] = t.referToSelf((f) => (p, c) => i(p, c, f, !1)), l[A + ", DenseMatrix"] = t.referToSelf((f) => (p, c) => i(c, p, f, !0)), l["Array," + A] = t.referToSelf((f) => (p, c) => i(r(p), c, f, !1).valueOf()), l[A + ", Array"] = t.referToSelf((f) => (p, c) => i(r(c), p, f, !0).valueOf())));
    var m = u.sS !== void 0 ? u.sS : u.Ss;
    return s ? (u.Ss && (l["SparseMatrix," + A] = (f, p) => u.Ss(f, p, s, !1)), m && (l[A + ", SparseMatrix"] = (f, p) => m(p, f, s, !0))) : (u.Ss && (l["SparseMatrix," + A] = t.referToSelf((f) => (p, c) => u.Ss(p, c, f, !1))), m && (l[A + ", SparseMatrix"] = t.referToSelf((f) => (p, c) => m(c, p, f, !0)))), s && s.signatures && Ra(l, s.signatures), l;
  };
}), bc = "matAlgo01xDSid", yc = ["typed"], hu = /* @__PURE__ */ J(bc, yc, (e) => {
  var {
    typed: t
  } = e;
  return function(n, i, a, u) {
    var s = n._data, o = n._size, l = n._datatype || n.getDataType(), A = i._values, d = i._index, m = i._ptr, f = i._size, p = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (o.length !== f.length)
      throw new ie(o.length, f.length);
    if (o[0] !== f[0] || o[1] !== f[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + f + ")");
    if (!A)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var c = o[0], h = o[1], v = typeof l == "string" && l !== "mixed" && l === p ? l : void 0, Z = v ? t.find(a, [v, v]) : a, b, F, y = [];
    for (b = 0; b < c; b++)
      y[b] = [];
    var V = [], W = [];
    for (F = 0; F < h; F++) {
      for (var X = F + 1, x = m[F], q = m[F + 1], I = x; I < q; I++)
        b = d[I], V[b] = u ? Z(A[I], s[b][F]) : Z(s[b][F], A[I]), W[b] = X;
      for (b = 0; b < c; b++)
        W[b] === X ? y[b][F] = V[b] : y[b][F] = s[b][F];
    }
    return n.createDenseMatrix({
      data: y,
      size: [c, h],
      datatype: l === n._datatype && p === i._datatype ? v : void 0
    });
  };
}), gc = "matAlgo04xSidSid", Zc = ["typed", "equalScalar"], Fc = /* @__PURE__ */ J(gc, Zc, (e) => {
  var {
    typed: t,
    equalScalar: r
  } = e;
  return function(i, a, u) {
    var s = i._values, o = i._index, l = i._ptr, A = i._size, d = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), m = a._values, f = a._index, p = a._ptr, c = a._size, h = a._datatype || a._data === void 0 ? a._datatype : a.getDataType();
    if (A.length !== c.length)
      throw new ie(A.length, c.length);
    if (A[0] !== c[0] || A[1] !== c[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + A + ") must match Matrix B (" + c + ")");
    var v = A[0], Z = A[1], b, F = r, y = 0, V = u;
    typeof d == "string" && d === h && d !== "mixed" && (b = d, F = t.find(r, [b, b]), y = t.convert(0, b), V = t.find(u, [b, b]));
    var W = s && m ? [] : void 0, X = [], x = [], q = s && m ? [] : void 0, I = s && m ? [] : void 0, E = [], L = [], z, G, w, U, O;
    for (G = 0; G < Z; G++) {
      x[G] = X.length;
      var j = G + 1;
      for (U = l[G], O = l[G + 1], w = U; w < O; w++)
        z = o[w], X.push(z), E[z] = j, q && (q[z] = s[w]);
      for (U = p[G], O = p[G + 1], w = U; w < O; w++)
        if (z = f[w], E[z] === j) {
          if (q) {
            var te = V(q[z], m[w]);
            F(te, y) ? E[z] = null : q[z] = te;
          }
        } else
          X.push(z), L[z] = j, I && (I[z] = m[w]);
      if (q && I)
        for (w = x[G]; w < X.length; )
          z = X[w], E[z] === j ? (W[w] = q[z], w++) : L[z] === j ? (W[w] = I[z], w++) : X.splice(w, 1);
    }
    return x[Z] = X.length, i.createSparseMatrix({
      values: W,
      index: X,
      ptr: x,
      size: [v, Z],
      datatype: d === i._datatype && h === a._datatype ? b : void 0
    });
  };
}), Xc = "matAlgo10xSids", Wc = ["typed", "DenseMatrix"], vu = /* @__PURE__ */ J(Xc, Wc, (e) => {
  var {
    typed: t,
    DenseMatrix: r
  } = e;
  return function(i, a, u, s) {
    var o = i._values, l = i._index, A = i._ptr, d = i._size, m = i._datatype;
    if (!o)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f = d[0], p = d[1], c, h = u;
    typeof m == "string" && (c = m, a = t.convert(a, c), h = t.find(u, [c, c]));
    for (var v = [], Z = [], b = [], F = 0; F < p; F++) {
      for (var y = F + 1, V = A[F], W = A[F + 1], X = V; X < W; X++) {
        var x = l[X];
        Z[x] = o[X], b[x] = y;
      }
      for (var q = 0; q < f; q++)
        F === 0 && (v[q] = []), b[q] === y ? v[q][F] = s ? h(a, Z[q]) : h(Z[q], a) : v[q][F] = a;
    }
    return new r({
      data: v,
      size: [f, p],
      datatype: c
    });
  };
}), xc = "multiplyScalar", Dc = ["typed"], Cc = /* @__PURE__ */ J(xc, Dc, (e) => {
  var {
    typed: t
  } = e;
  return t("multiplyScalar", {
    "number, number": cu,
    "Complex, Complex": function(n, i) {
      return n.mul(i);
    },
    "BigNumber, BigNumber": function(n, i) {
      return n.times(i);
    },
    "bigint, bigint": function(n, i) {
      return n * i;
    },
    "Fraction, Fraction": function(n, i) {
      return n.mul(i);
    },
    "number | Fraction | BigNumber | Complex, Unit": (r, n) => n.multiply(r),
    "Unit, number | Fraction | BigNumber | Complex | Unit": (r, n) => r.multiply(n)
  });
}), Gi = "multiply", qc = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], Sc = /* @__PURE__ */ J(Gi, qc, (e) => {
  var {
    typed: t,
    matrix: r,
    addScalar: n,
    multiplyScalar: i,
    equalScalar: a,
    dot: u
  } = e, s = pu({
    typed: t,
    equalScalar: a
  }), o = ri({
    typed: t
  });
  function l(y, V) {
    switch (y.length) {
      case 1:
        switch (V.length) {
          case 1:
            if (y[0] !== V[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (y[0] !== V[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + y[0] + ") must match Matrix rows (" + V[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + V.length + " dimensions)");
        }
        break;
      case 2:
        switch (V.length) {
          case 1:
            if (y[1] !== V[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + y[1] + ") must match Vector length (" + V[0] + ")");
            break;
          case 2:
            if (y[1] !== V[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + y[1] + ") must match Matrix B rows (" + V[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + V.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + y.length + " dimensions)");
    }
  }
  function A(y, V, W) {
    if (W === 0)
      throw new Error("Cannot multiply two empty vectors");
    return u(y, V);
  }
  function d(y, V) {
    if (V.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return m(y, V);
  }
  function m(y, V) {
    var W = y._data, X = y._size, x = y._datatype || y.getDataType(), q = V._data, I = V._size, E = V._datatype || V.getDataType(), L = X[0], z = I[1], G, w = n, U = i;
    x && E && x === E && typeof x == "string" && x !== "mixed" && (G = x, w = t.find(n, [G, G]), U = t.find(i, [G, G]));
    for (var O = [], j = 0; j < z; j++) {
      for (var te = U(W[0], q[0][j]), oe = 1; oe < L; oe++)
        te = w(te, U(W[oe], q[oe][j]));
      O[j] = te;
    }
    return y.createDenseMatrix({
      data: O,
      size: [z],
      datatype: x === y._datatype && E === V._datatype ? G : void 0
    });
  }
  var f = t("_multiplyMatrixVector", {
    "DenseMatrix, any": c,
    "SparseMatrix, any": Z
  }), p = t("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": h,
    "DenseMatrix, SparseMatrix": v,
    "SparseMatrix, DenseMatrix": b,
    "SparseMatrix, SparseMatrix": F
  });
  function c(y, V) {
    var W = y._data, X = y._size, x = y._datatype || y.getDataType(), q = V._data, I = V._datatype || V.getDataType(), E = X[0], L = X[1], z, G = n, w = i;
    x && I && x === I && typeof x == "string" && x !== "mixed" && (z = x, G = t.find(n, [z, z]), w = t.find(i, [z, z]));
    for (var U = [], O = 0; O < E; O++) {
      for (var j = W[O], te = w(j[0], q[0]), oe = 1; oe < L; oe++)
        te = G(te, w(j[oe], q[oe]));
      U[O] = te;
    }
    return y.createDenseMatrix({
      data: U,
      size: [E],
      datatype: x === y._datatype && I === V._datatype ? z : void 0
    });
  }
  function h(y, V) {
    var W = y._data, X = y._size, x = y._datatype || y.getDataType(), q = V._data, I = V._size, E = V._datatype || V.getDataType(), L = X[0], z = X[1], G = I[1], w, U = n, O = i;
    x && E && x === E && typeof x == "string" && x !== "mixed" && x !== "mixed" && (w = x, U = t.find(n, [w, w]), O = t.find(i, [w, w]));
    for (var j = [], te = 0; te < L; te++) {
      var oe = W[te];
      j[te] = [];
      for (var ue = 0; ue < G; ue++) {
        for (var se = O(oe[0], q[0][ue]), qe = 1; qe < z; qe++)
          se = U(se, O(oe[qe], q[qe][ue]));
        j[te][ue] = se;
      }
    }
    return y.createDenseMatrix({
      data: j,
      size: [L, G],
      datatype: x === y._datatype && E === V._datatype ? w : void 0
    });
  }
  function v(y, V) {
    var W = y._data, X = y._size, x = y._datatype || y.getDataType(), q = V._values, I = V._index, E = V._ptr, L = V._size, z = V._datatype || V._data === void 0 ? V._datatype : V.getDataType();
    if (!q)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var G = X[0], w = L[1], U, O = n, j = i, te = a, oe = 0;
    x && z && x === z && typeof x == "string" && x !== "mixed" && (U = x, O = t.find(n, [U, U]), j = t.find(i, [U, U]), te = t.find(a, [U, U]), oe = t.convert(0, U));
    for (var ue = [], se = [], qe = [], Ee = V.createSparseMatrix({
      values: ue,
      index: se,
      ptr: qe,
      size: [G, w],
      datatype: x === y._datatype && z === V._datatype ? U : void 0
    }), Se = 0; Se < w; Se++) {
      qe[Se] = se.length;
      var Fe = E[Se], Be = E[Se + 1];
      if (Be > Fe)
        for (var me = 0, de = 0; de < G; de++) {
          for (var tt = de + 1, Pe = void 0, pe = Fe; pe < Be; pe++) {
            var Te = I[pe];
            me !== tt ? (Pe = j(W[de][Te], q[pe]), me = tt) : Pe = O(Pe, j(W[de][Te], q[pe]));
          }
          me === tt && !te(Pe, oe) && (se.push(de), ue.push(Pe));
        }
    }
    return qe[w] = se.length, Ee;
  }
  function Z(y, V) {
    var W = y._values, X = y._index, x = y._ptr, q = y._datatype || y._data === void 0 ? y._datatype : y.getDataType();
    if (!W)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var I = V._data, E = V._datatype || V.getDataType(), L = y._size[0], z = V._size[0], G = [], w = [], U = [], O, j = n, te = i, oe = a, ue = 0;
    q && E && q === E && typeof q == "string" && q !== "mixed" && (O = q, j = t.find(n, [O, O]), te = t.find(i, [O, O]), oe = t.find(a, [O, O]), ue = t.convert(0, O));
    var se = [], qe = [];
    U[0] = 0;
    for (var Ee = 0; Ee < z; Ee++) {
      var Se = I[Ee];
      if (!oe(Se, ue))
        for (var Fe = x[Ee], Be = x[Ee + 1], me = Fe; me < Be; me++) {
          var de = X[me];
          qe[de] ? se[de] = j(se[de], te(Se, W[me])) : (qe[de] = !0, w.push(de), se[de] = te(Se, W[me]));
        }
    }
    for (var tt = w.length, Pe = 0; Pe < tt; Pe++) {
      var pe = w[Pe];
      G[Pe] = se[pe];
    }
    return U[1] = w.length, y.createSparseMatrix({
      values: G,
      index: w,
      ptr: U,
      size: [L, 1],
      datatype: q === y._datatype && E === V._datatype ? O : void 0
    });
  }
  function b(y, V) {
    var W = y._values, X = y._index, x = y._ptr, q = y._datatype || y._data === void 0 ? y._datatype : y.getDataType();
    if (!W)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var I = V._data, E = V._datatype || V.getDataType(), L = y._size[0], z = V._size[0], G = V._size[1], w, U = n, O = i, j = a, te = 0;
    q && E && q === E && typeof q == "string" && q !== "mixed" && (w = q, U = t.find(n, [w, w]), O = t.find(i, [w, w]), j = t.find(a, [w, w]), te = t.convert(0, w));
    for (var oe = [], ue = [], se = [], qe = y.createSparseMatrix({
      values: oe,
      index: ue,
      ptr: se,
      size: [L, G],
      datatype: q === y._datatype && E === V._datatype ? w : void 0
    }), Ee = [], Se = [], Fe = 0; Fe < G; Fe++) {
      se[Fe] = ue.length;
      for (var Be = Fe + 1, me = 0; me < z; me++) {
        var de = I[me][Fe];
        if (!j(de, te))
          for (var tt = x[me], Pe = x[me + 1], pe = tt; pe < Pe; pe++) {
            var Te = X[pe];
            Se[Te] !== Be ? (Se[Te] = Be, ue.push(Te), Ee[Te] = O(de, W[pe])) : Ee[Te] = U(Ee[Te], O(de, W[pe]));
          }
      }
      for (var rt = se[Fe], yt = ue.length, gt = rt; gt < yt; gt++) {
        var Ut = ue[gt];
        oe[gt] = Ee[Ut];
      }
    }
    return se[G] = ue.length, qe;
  }
  function F(y, V) {
    var W = y._values, X = y._index, x = y._ptr, q = y._datatype || y._data === void 0 ? y._datatype : y.getDataType(), I = V._values, E = V._index, L = V._ptr, z = V._datatype || V._data === void 0 ? V._datatype : V.getDataType(), G = y._size[0], w = V._size[1], U = W && I, O, j = n, te = i;
    q && z && q === z && typeof q == "string" && q !== "mixed" && (O = q, j = t.find(n, [O, O]), te = t.find(i, [O, O]));
    for (var oe = U ? [] : void 0, ue = [], se = [], qe = y.createSparseMatrix({
      values: oe,
      index: ue,
      ptr: se,
      size: [G, w],
      datatype: q === y._datatype && z === V._datatype ? O : void 0
    }), Ee = U ? [] : void 0, Se = [], Fe, Be, me, de, tt, Pe, pe, Te, rt = 0; rt < w; rt++) {
      se[rt] = ue.length;
      var yt = rt + 1;
      for (tt = L[rt], Pe = L[rt + 1], de = tt; de < Pe; de++)
        if (Te = E[de], U)
          for (Be = x[Te], me = x[Te + 1], Fe = Be; Fe < me; Fe++)
            pe = X[Fe], Se[pe] !== yt ? (Se[pe] = yt, ue.push(pe), Ee[pe] = te(I[de], W[Fe])) : Ee[pe] = j(Ee[pe], te(I[de], W[Fe]));
        else
          for (Be = x[Te], me = x[Te + 1], Fe = Be; Fe < me; Fe++)
            pe = X[Fe], Se[pe] !== yt && (Se[pe] = yt, ue.push(pe));
      if (U)
        for (var gt = se[rt], Ut = ue.length, Bt = gt; Bt < Ut; Bt++) {
          var Zn = ue[Bt];
          oe[Bt] = Ee[Zn];
        }
    }
    return se[w] = ue.length, qe;
  }
  return t(Gi, i, {
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": t.referTo("Matrix, Matrix", (y) => (V, W) => {
      l(Ge(V), Ge(W));
      var X = y(r(V), r(W));
      return Ve(X) ? X.valueOf() : X;
    }),
    "Matrix, Matrix": function(V, W) {
      var X = V.size(), x = W.size();
      return l(X, x), X.length === 1 ? x.length === 1 ? A(V, W, X[0]) : d(V, W) : x.length === 1 ? f(V, W) : p(V, W);
    },
    "Matrix, Array": t.referTo("Matrix,Matrix", (y) => (V, W) => y(V, r(W))),
    "Array, Matrix": t.referToSelf((y) => (V, W) => y(r(V, W.storage()), W)),
    "SparseMatrix, any": function(V, W) {
      return s(V, W, i, !1);
    },
    "DenseMatrix, any": function(V, W) {
      return o(V, W, i, !1);
    },
    "any, SparseMatrix": function(V, W) {
      return s(W, V, i, !0);
    },
    "any, DenseMatrix": function(V, W) {
      return o(W, V, i, !0);
    },
    "Array, any": function(V, W) {
      return o(r(V), W, i, !1).valueOf();
    },
    "any, Array": function(V, W) {
      return o(r(W), V, i, !0).valueOf();
    },
    "any, any": i,
    "any, any, ...any": t.referToSelf((y) => (V, W, X) => {
      for (var x = y(V, W), q = 0; q < X.length; q++)
        x = y(x, X[q]);
      return x;
    })
  });
}), wc = "sqrt", Kc = ["config", "typed", "Complex"], Ic = /* @__PURE__ */ J(wc, Kc, (e) => {
  var {
    config: t,
    typed: r,
    Complex: n
  } = e;
  return r("sqrt", {
    number: i,
    Complex: function(u) {
      return u.sqrt();
    },
    BigNumber: function(u) {
      return !u.isNegative() || t.predictable ? u.sqrt() : i(u.toNumber());
    },
    Unit: function(u) {
      return u.pow(0.5);
    }
  });
  function i(a) {
    return isNaN(a) ? NaN : a >= 0 || t.predictable ? Math.sqrt(a) : new n(a, 0).sqrt();
  }
}), Pi = "square", Ec = ["typed"], Rc = /* @__PURE__ */ J(Pi, Ec, (e) => {
  var {
    typed: t
  } = e;
  return t(Pi, {
    number: fu,
    Complex: function(n) {
      return n.mul(n);
    },
    BigNumber: function(n) {
      return n.times(n);
    },
    bigint: function(n) {
      return n * n;
    },
    Fraction: function(n) {
      return n.mul(n);
    },
    Unit: function(n) {
      return n.pow(2);
    }
  });
}), Li = "subtract", zc = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], Tc = /* @__PURE__ */ J(Li, zc, (e) => {
  var {
    typed: t,
    matrix: r,
    equalScalar: n,
    subtractScalar: i,
    unaryMinus: a,
    DenseMatrix: u,
    concat: s
  } = e, o = hu({
    typed: t
  }), l = Cr({
    typed: t
  }), A = dc({
    typed: t,
    equalScalar: n
  }), d = vu({
    typed: t,
    DenseMatrix: u
  }), m = Dr({
    typed: t,
    DenseMatrix: u
  }), f = lr({
    typed: t,
    matrix: r,
    concat: s
  });
  return t(Li, {
    "any, any": i
  }, f({
    elop: i,
    SS: A,
    DS: o,
    SD: l,
    Ss: m,
    sS: d
  }));
}), Nc = "matAlgo07xSSf", Gc = ["typed", "DenseMatrix"], bn = /* @__PURE__ */ J(Nc, Gc, (e) => {
  var {
    typed: t,
    DenseMatrix: r
  } = e;
  return function(a, u, s) {
    var o = a._size, l = a._datatype || a._data === void 0 ? a._datatype : a.getDataType(), A = u._size, d = u._datatype || u._data === void 0 ? u._datatype : u.getDataType();
    if (o.length !== A.length)
      throw new ie(o.length, A.length);
    if (o[0] !== A[0] || o[1] !== A[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + A + ")");
    var m = o[0], f = o[1], p, c = 0, h = s;
    typeof l == "string" && l === d && l !== "mixed" && (p = l, c = t.convert(0, p), h = t.find(s, [p, p]));
    var v, Z, b = [];
    for (v = 0; v < m; v++)
      b[v] = [];
    var F = [], y = [], V = [], W = [];
    for (Z = 0; Z < f; Z++) {
      var X = Z + 1;
      for (n(a, Z, V, F, X), n(u, Z, W, y, X), v = 0; v < m; v++) {
        var x = V[v] === X ? F[v] : c, q = W[v] === X ? y[v] : c;
        b[v][Z] = h(x, q);
      }
    }
    return new r({
      data: b,
      size: [m, f],
      datatype: l === a._datatype && d === u._datatype ? p : void 0
    });
  };
  function n(i, a, u, s, o) {
    for (var l = i._values, A = i._index, d = i._ptr, m = d[a], f = d[a + 1]; m < f; m++) {
      var p = A[m];
      u[p] = o, s[p] = l[m];
    }
  }
}), Mi = "conj", Pc = ["typed"], Lc = /* @__PURE__ */ J(Mi, Pc, (e) => {
  var {
    typed: t
  } = e;
  return t(Mi, {
    "number | BigNumber | Fraction": (r) => r,
    Complex: (r) => r.conjugate(),
    "Array | Matrix": t.referToSelf((r) => (n) => Vt(n, r))
  });
}), Hi = "concat", Mc = ["typed", "matrix", "isInteger"], Hc = /* @__PURE__ */ J(Hi, Mc, (e) => {
  var {
    typed: t,
    matrix: r,
    isInteger: n
  } = e;
  return t(Hi, {
    // TODO: change signature to '...Array | Matrix, dim?' when supported
    "...Array | Matrix | number | BigNumber": function(a) {
      var u, s = a.length, o = -1, l, A = !1, d = [];
      for (u = 0; u < s; u++) {
        var m = a[u];
        if (Ve(m) && (A = !0), Ze(m) || We(m)) {
          if (u !== s - 1)
            throw new Error("Dimension must be specified as last argument");
          if (l = o, o = m.valueOf(), !n(o))
            throw new TypeError("Integer number expected for dimension");
          if (o < 0 || u > 0 && o > l)
            throw new Gt(o, l + 1);
        } else {
          var f = Ae(m).valueOf(), p = Ge(f);
          if (d[u] = f, l = o, o = p.length - 1, u > 0 && o !== l)
            throw new ie(l + 1, o + 1);
        }
      }
      if (d.length === 0)
        throw new SyntaxError("At least one matrix expected");
      for (var c = d.shift(); d.length; )
        c = iu(c, d.shift(), o);
      return A ? r(c) : c;
    },
    "...string": function(a) {
      return a.join("");
    }
  });
}), Ui = "column", Uc = ["typed", "Index", "matrix", "range"], Bc = /* @__PURE__ */ J(Ui, Uc, (e) => {
  var {
    typed: t,
    Index: r,
    matrix: n,
    range: i
  } = e;
  return t(Ui, {
    "Matrix, number": a,
    "Array, number": function(s, o) {
      return a(n(Ae(s)), o).valueOf();
    }
  });
  function a(u, s) {
    if (u.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    he(s, u.size()[1]);
    var o = i(0, u.size()[0]), l = new r(o, s), A = u.subset(l);
    return Ve(A) ? A : n([[A]]);
  }
}), Bi = "flatten", Yc = ["typed"], Oc = /* @__PURE__ */ J(Bi, Yc, (e) => {
  var {
    typed: t
  } = e;
  return t(Bi, {
    Array: function(n) {
      return Gn(n);
    },
    Matrix: function(n) {
      return n.create(Gn(n.toArray()), n.datatype());
    }
  });
}), Yi = "getMatrixDataType", Jc = ["typed"], jc = /* @__PURE__ */ J(Yi, Jc, (e) => {
  var {
    typed: t
  } = e;
  return t(Yi, {
    Array: function(n) {
      return vn(n, st);
    },
    Matrix: function(n) {
      return n.getDataType();
    }
  });
}), Oi = "identity", kc = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], Qc = /* @__PURE__ */ J(Oi, kc, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    BigNumber: i,
    DenseMatrix: a,
    SparseMatrix: u
  } = e;
  return t(Oi, {
    "": function() {
      return r.matrix === "Matrix" ? n([]) : [];
    },
    string: function(A) {
      return n(A);
    },
    "number | BigNumber": function(A) {
      return o(A, A, r.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(A, d) {
      return o(A, A, d);
    },
    "number | BigNumber, number | BigNumber": function(A, d) {
      return o(A, d, r.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(A, d, m) {
      return o(A, d, m);
    },
    Array: function(A) {
      return s(A);
    },
    "Array, string": function(A, d) {
      return s(A, d);
    },
    Matrix: function(A) {
      return s(A.valueOf(), A.storage());
    },
    "Matrix, string": function(A, d) {
      return s(A.valueOf(), d);
    }
  });
  function s(l, A) {
    switch (l.length) {
      case 0:
        return A ? n(A) : [];
      case 1:
        return o(l[0], l[0], A);
      case 2:
        return o(l[0], l[1], A);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function o(l, A, d) {
    var m = We(l) || We(A) ? i : null;
    if (We(l) && (l = l.toNumber()), We(A) && (A = A.toNumber()), !Ke(l) || l < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!Ke(A) || A < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var f = m ? new i(1) : 1, p = m ? new m(0) : 0, c = [l, A];
    if (d) {
      if (d === "sparse")
        return u.diagonal(c, f, 0, p);
      if (d === "dense")
        return a.diagonal(c, f, 0, p);
      throw new TypeError('Unknown matrix type "'.concat(d, '"'));
    }
    for (var h = en([], c, p), v = l < A ? l : A, Z = 0; Z < v; Z++)
      h[Z][Z] = f;
    return h;
  }
});
function Vu() {
  throw new Error('No "bignumber" implementation available');
}
function _c() {
  throw new Error('No "fraction" implementation available');
}
function bu() {
  throw new Error('No "matrix" implementation available');
}
var Ji = "range", $c = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq", "add", "isPositive"], e0 = /* @__PURE__ */ J(Ji, $c, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    bignumber: i,
    smaller: a,
    smallerEq: u,
    larger: s,
    largerEq: o,
    add: l,
    isPositive: A
  } = e;
  return t(Ji, {
    // TODO: simplify signatures when typed-function supports default values and optional arguments
    // TODO: a number or boolean should not be converted to string here
    string: m,
    "string, boolean": m,
    "number, number": function(h, v) {
      return d(f(h, v, 1, !1));
    },
    "number, number, number": function(h, v, Z) {
      return d(f(h, v, Z, !1));
    },
    "number, number, boolean": function(h, v, Z) {
      return d(f(h, v, 1, Z));
    },
    "number, number, number, boolean": function(h, v, Z, b) {
      return d(f(h, v, Z, b));
    },
    "BigNumber, BigNumber": function(h, v) {
      var Z = h.constructor;
      return d(f(h, v, new Z(1), !1));
    },
    "BigNumber, BigNumber, BigNumber": function(h, v, Z) {
      return d(f(h, v, Z, !1));
    },
    "BigNumber, BigNumber, boolean": function(h, v, Z) {
      var b = h.constructor;
      return d(f(h, v, new b(1), Z));
    },
    "BigNumber, BigNumber, BigNumber, boolean": function(h, v, Z, b) {
      return d(f(h, v, Z, b));
    },
    "Unit, Unit, Unit": function(h, v, Z) {
      return d(f(h, v, Z, !1));
    },
    "Unit, Unit, Unit, boolean": function(h, v, Z, b) {
      return d(f(h, v, Z, b));
    }
  });
  function d(c) {
    return r.matrix === "Matrix" ? n ? n(c) : bu() : c;
  }
  function m(c, h) {
    var v = p(c);
    if (!v)
      throw new SyntaxError('String "' + c + '" is no valid range');
    return r.number === "BigNumber" ? (i === void 0 && Vu(), d(f(i(v.start), i(v.end), i(v.step)))) : d(f(v.start, v.end, v.step, h));
  }
  function f(c, h, v, Z) {
    for (var b = [], F = A(v) ? Z ? u : a : Z ? o : s, y = c; F(y, h); )
      b.push(y), y = l(y, v);
    return b;
  }
  function p(c) {
    var h = c.split(":"), v = h.map(function(b) {
      return Number(b);
    }), Z = v.some(function(b) {
      return isNaN(b);
    });
    if (Z)
      return null;
    switch (v.length) {
      case 2:
        return {
          start: v[0],
          end: v[1],
          step: 1
        };
      case 3:
        return {
          start: v[0],
          end: v[2],
          step: v[1]
        };
      default:
        return null;
    }
  }
}), ji = "reshape", t0 = ["typed", "isInteger", "matrix"], r0 = /* @__PURE__ */ J(ji, t0, (e) => {
  var {
    typed: t,
    isInteger: r
  } = e;
  return t(ji, {
    "Matrix, Array": function(i, a) {
      return i.reshape(a, !0);
    },
    "Array, Array": function(i, a) {
      return a.forEach(function(u) {
        if (!r(u))
          throw new TypeError("Invalid size for dimension: " + u);
      }), kn(i, a);
    }
  });
}), ki = "size", n0 = ["typed", "config", "?matrix"], i0 = /* @__PURE__ */ J(ki, n0, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n
  } = e;
  return t(ki, {
    Matrix: function(a) {
      return a.create(a.size(), "number");
    },
    Array: Ge,
    string: function(a) {
      return r.matrix === "Array" ? [a.length] : n([a.length], "dense", "number");
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(a) {
      return r.matrix === "Array" ? [] : n ? n([], "dense", "number") : bu();
    }
  });
}), Qi = "subset", a0 = ["typed", "matrix", "zeros", "add"], u0 = /* @__PURE__ */ J(Qi, a0, (e) => {
  var {
    typed: t,
    matrix: r,
    zeros: n,
    add: i
  } = e;
  return t(Qi, {
    // get subset
    "Matrix, Index": function(s, o) {
      return or(o) ? r() : ($r(s, o), s.subset(o));
    },
    "Array, Index": t.referTo("Matrix, Index", function(u) {
      return function(s, o) {
        var l = u(r(s), o);
        return o.isScalar() ? l : l.valueOf();
      };
    }),
    "Object, Index": s0,
    "string, Index": o0,
    // set subset
    "Matrix, Index, any, any": function(s, o, l, A) {
      return or(o) ? s : ($r(s, o), s.clone().subset(o, a(l, o), A));
    },
    "Array, Index, any, any": t.referTo("Matrix, Index, any, any", function(u) {
      return function(s, o, l, A) {
        var d = u(r(s), o, l, A);
        return d.isMatrix ? d.valueOf() : d;
      };
    }),
    "Array, Index, any": t.referTo("Matrix, Index, any, any", function(u) {
      return function(s, o, l) {
        return u(r(s), o, l, void 0).valueOf();
      };
    }),
    "Matrix, Index, any": t.referTo("Matrix, Index, any, any", function(u) {
      return function(s, o, l) {
        return u(s, o, l, void 0);
      };
    }),
    "string, Index, string": _i,
    "string, Index, string, string": _i,
    "Object, Index, any": A0
  });
  function a(u, s) {
    if (typeof u == "string")
      throw new Error("can't boradcast a string");
    if (s._isScalar)
      return u;
    var o = s.size();
    if (o.every((l) => l > 0))
      try {
        return i(u, n(o));
      } catch {
        return u;
      }
    else
      return u;
  }
});
function o0(e, t) {
  if (!cn(t))
    throw new TypeError("Index expected");
  if (or(t))
    return "";
  if ($r(Array.from(e), t), t.size().length !== 1)
    throw new ie(t.size().length, 1);
  var r = e.length;
  he(t.min()[0], r), he(t.max()[0], r);
  var n = t.dimension(0), i = "";
  return n.forEach(function(a) {
    i += e.charAt(a);
  }), i;
}
function _i(e, t, r, n) {
  if (!t || t.isIndex !== !0)
    throw new TypeError("Index expected");
  if (or(t))
    return e;
  if ($r(Array.from(e), t), t.size().length !== 1)
    throw new ie(t.size().length, 1);
  if (n !== void 0) {
    if (typeof n != "string" || n.length !== 1)
      throw new TypeError("Single character expected as defaultValue");
  } else
    n = " ";
  var i = t.dimension(0), a = i.size()[0];
  if (a !== r.length)
    throw new ie(i.size()[0], r.length);
  var u = e.length;
  he(t.min()[0]), he(t.max()[0]);
  for (var s = [], o = 0; o < u; o++)
    s[o] = e.charAt(o);
  if (i.forEach(function(d, m) {
    s[d] = r.charAt(m[0]);
  }), s.length > u)
    for (var l = u - 1, A = s.length; l < A; l++)
      s[l] || (s[l] = n);
  return s.join("");
}
function s0(e, t) {
  if (!or(t)) {
    if (t.size().length !== 1)
      throw new ie(t.size(), 1);
    var r = t.dimension(0);
    if (typeof r != "string")
      throw new TypeError("String expected as index to retrieve an object property");
    return qa(e, r);
  }
}
function A0(e, t, r) {
  if (or(t))
    return e;
  if (t.size().length !== 1)
    throw new ie(t.size(), 1);
  var n = t.dimension(0);
  if (typeof n != "string")
    throw new TypeError("String expected as index to retrieve an object property");
  var i = Ae(e);
  return Sa(i, n, r), i;
}
var $i = "transpose", l0 = ["typed", "matrix"], c0 = /* @__PURE__ */ J($i, l0, (e) => {
  var {
    typed: t,
    matrix: r
  } = e;
  return t($i, {
    Array: (u) => n(r(u)).valueOf(),
    Matrix: n,
    any: Ae
    // scalars
  });
  function n(u) {
    var s = u.size(), o;
    switch (s.length) {
      case 1:
        o = u.clone();
        break;
      case 2:
        {
          var l = s[0], A = s[1];
          if (A === 0)
            throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + we(s) + ")");
          switch (u.storage()) {
            case "dense":
              o = i(u, l, A);
              break;
            case "sparse":
              o = a(u, l, A);
              break;
          }
        }
        break;
      default:
        throw new RangeError("Matrix must be a vector or two dimensional (size: " + we(s) + ")");
    }
    return o;
  }
  function i(u, s, o) {
    for (var l = u._data, A = [], d, m = 0; m < o; m++) {
      d = A[m] = [];
      for (var f = 0; f < s; f++)
        d[f] = Ae(l[f][m]);
    }
    return u.createDenseMatrix({
      data: A,
      size: [o, s],
      datatype: u._datatype
    });
  }
  function a(u, s, o) {
    for (var l = u._values, A = u._index, d = u._ptr, m = l ? [] : void 0, f = [], p = [], c = [], h = 0; h < s; h++)
      c[h] = 0;
    var v, Z, b;
    for (v = 0, Z = A.length; v < Z; v++)
      c[A[v]]++;
    for (var F = 0, y = 0; y < s; y++)
      p.push(F), F += c[y], c[y] = p[y];
    for (p.push(F), b = 0; b < o; b++)
      for (var V = d[b], W = d[b + 1], X = V; X < W; X++) {
        var x = c[A[X]]++;
        f[x] = b, l && (m[x] = Ae(l[X]));
      }
    return u.createSparseMatrix({
      values: m,
      index: f,
      ptr: p,
      size: [o, s],
      datatype: u._datatype
    });
  }
}), ea = "zeros", d0 = ["typed", "config", "matrix", "BigNumber"], f0 = /* @__PURE__ */ J(ea, d0, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    BigNumber: i
  } = e;
  return t(ea, {
    "": function() {
      return r.matrix === "Array" ? a([]) : a([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(l) {
      var A = l[l.length - 1];
      if (typeof A == "string") {
        var d = l.pop();
        return a(l, d);
      } else return r.matrix === "Array" ? a(l) : a(l, "default");
    },
    Array: a,
    Matrix: function(l) {
      var A = l.storage();
      return a(l.valueOf(), A);
    },
    "Array | Matrix, string": function(l, A) {
      return a(l.valueOf(), A);
    }
  });
  function a(o, l) {
    var A = u(o), d = A ? new i(0) : 0;
    if (s(o), l) {
      var m = n(l);
      return o.length > 0 ? m.resize(o, d) : m;
    } else {
      var f = [];
      return o.length > 0 ? en(f, o, d) : f;
    }
  }
  function u(o) {
    var l = !1;
    return o.forEach(function(A, d, m) {
      We(A) && (l = !0, m[d] = A.toNumber());
    }), l;
  }
  function s(o) {
    o.forEach(function(l) {
      if (typeof l != "number" || !Ke(l) || l < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
});
function sr(e, t, r) {
  var n;
  return String(e).includes("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + st(r) + ", value: " + JSON.stringify(r) + ")" : " (type: " + e.data.actual + ")", new TypeError("Cannot calculate " + t + ", unexpected type of argument" + n)) : String(e).includes("complex numbers") ? (n = arguments.length > 2 ? " (type: " + st(r) + ", value: " + JSON.stringify(r) + ")" : "", new TypeError("Cannot calculate " + t + ", no ordering relation is defined for complex numbers" + n)) : e;
}
var m0 = "numeric", p0 = ["number", "?bignumber", "?fraction"], h0 = /* @__PURE__ */ J(m0, p0, (e) => {
  var {
    number: t,
    bignumber: r,
    fraction: n
  } = e, i = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, a = {
    number: (u) => t(u),
    BigNumber: r ? (u) => r(u) : Vu,
    bigint: (u) => BigInt(u),
    Fraction: n ? (u) => n(u) : _c
  };
  return function(s) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "number", l = arguments.length > 2 ? arguments[2] : void 0;
    if (l !== void 0)
      throw new SyntaxError("numeric() takes one or two arguments");
    var A = st(s);
    if (!(A in i))
      throw new TypeError("Cannot convert " + s + ' of type "' + A + '"; valid input types are ' + Object.keys(i).join(", "));
    if (!(o in a))
      throw new TypeError("Cannot convert " + s + ' to type "' + o + '"; valid output types are ' + Object.keys(a).join(", "));
    return o === A ? s : a[o](s);
  };
}), ta = "divideScalar", v0 = ["typed", "numeric"], V0 = /* @__PURE__ */ J(ta, v0, (e) => {
  var {
    typed: t,
    numeric: r
  } = e;
  return t(ta, {
    "number, number": function(i, a) {
      return i / a;
    },
    "Complex, Complex": function(i, a) {
      return i.div(a);
    },
    "BigNumber, BigNumber": function(i, a) {
      return i.div(a);
    },
    "bigint, bigint": function(i, a) {
      return i / a;
    },
    "Fraction, Fraction": function(i, a) {
      return i.div(a);
    },
    "Unit, number | Complex | Fraction | BigNumber | Unit": (n, i) => n.divide(i),
    "number | Fraction | Complex | BigNumber, Unit": (n, i) => i.divideInto(n)
  });
}), an = "smaller", b0 = ["typed", "config", "matrix", "DenseMatrix", "concat"], y0 = /* @__PURE__ */ J(an, b0, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    DenseMatrix: i,
    concat: a
  } = e, u = Cr({
    typed: t
  }), s = bn({
    typed: t,
    DenseMatrix: i
  }), o = Dr({
    typed: t,
    DenseMatrix: i
  }), l = lr({
    typed: t,
    matrix: n,
    concat: a
  }), A = xr({
    typed: t
  });
  return t(an, g0({
    typed: t,
    config: r
  }), {
    "boolean, boolean": (d, m) => d < m,
    "BigNumber, BigNumber": function(m, f) {
      return m.lt(f) && !Ar(m, f, r.relTol, r.absTol);
    },
    "bigint, bigint": (d, m) => d < m,
    "Fraction, Fraction": (d, m) => d.compare(m) === -1,
    "Complex, Complex": function(m, f) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, A, l({
    SS: s,
    DS: u,
    Ss: o
  }));
}), g0 = /* @__PURE__ */ J(an, ["typed", "config"], (e) => {
  var {
    typed: t,
    config: r
  } = e;
  return t(an, {
    "number, number": function(i, a) {
      return i < a && !Ct(i, a, r.relTol, r.absTol);
    }
  });
}), un = "smallerEq", Z0 = ["typed", "config", "matrix", "DenseMatrix", "concat"], F0 = /* @__PURE__ */ J(un, Z0, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    DenseMatrix: i,
    concat: a
  } = e, u = Cr({
    typed: t
  }), s = bn({
    typed: t,
    DenseMatrix: i
  }), o = Dr({
    typed: t,
    DenseMatrix: i
  }), l = lr({
    typed: t,
    matrix: n,
    concat: a
  }), A = xr({
    typed: t
  });
  return t(un, X0({
    typed: t,
    config: r
  }), {
    "boolean, boolean": (d, m) => d <= m,
    "BigNumber, BigNumber": function(m, f) {
      return m.lte(f) || Ar(m, f, r.relTol, r.absTol);
    },
    "bigint, bigint": (d, m) => d <= m,
    "Fraction, Fraction": (d, m) => d.compare(m) !== 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, A, l({
    SS: s,
    DS: u,
    Ss: o
  }));
}), X0 = /* @__PURE__ */ J(un, ["typed", "config"], (e) => {
  var {
    typed: t,
    config: r
  } = e;
  return t(un, {
    "number, number": function(i, a) {
      return i <= a || Ct(i, a, r.relTol, r.absTol);
    }
  });
}), on = "larger", W0 = ["typed", "config", "matrix", "DenseMatrix", "concat"], x0 = /* @__PURE__ */ J(on, W0, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    DenseMatrix: i,
    concat: a
  } = e, u = Cr({
    typed: t
  }), s = bn({
    typed: t,
    DenseMatrix: i
  }), o = Dr({
    typed: t,
    DenseMatrix: i
  }), l = lr({
    typed: t,
    matrix: n,
    concat: a
  }), A = xr({
    typed: t
  });
  return t(on, D0({
    typed: t,
    config: r
  }), {
    "boolean, boolean": (d, m) => d > m,
    "BigNumber, BigNumber": function(m, f) {
      return m.gt(f) && !Ar(m, f, r.relTol, r.absTol);
    },
    "bigint, bigint": (d, m) => d > m,
    "Fraction, Fraction": (d, m) => d.compare(m) === 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, A, l({
    SS: s,
    DS: u,
    Ss: o
  }));
}), D0 = /* @__PURE__ */ J(on, ["typed", "config"], (e) => {
  var {
    typed: t,
    config: r
  } = e;
  return t(on, {
    "number, number": function(i, a) {
      return i > a && !Ct(i, a, r.relTol, r.absTol);
    }
  });
}), sn = "largerEq", C0 = ["typed", "config", "matrix", "DenseMatrix", "concat"], q0 = /* @__PURE__ */ J(sn, C0, (e) => {
  var {
    typed: t,
    config: r,
    matrix: n,
    DenseMatrix: i,
    concat: a
  } = e, u = Cr({
    typed: t
  }), s = bn({
    typed: t,
    DenseMatrix: i
  }), o = Dr({
    typed: t,
    DenseMatrix: i
  }), l = lr({
    typed: t,
    matrix: n,
    concat: a
  }), A = xr({
    typed: t
  });
  return t(sn, S0({
    typed: t,
    config: r
  }), {
    "boolean, boolean": (d, m) => d >= m,
    "BigNumber, BigNumber": function(m, f) {
      return m.gte(f) || Ar(m, f, r.relTol, r.absTol);
    },
    "bigint, bigint": function(m, f) {
      return m >= f;
    },
    "Fraction, Fraction": (d, m) => d.compare(m) !== -1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, A, l({
    SS: s,
    DS: u,
    Ss: o
  }));
}), S0 = /* @__PURE__ */ J(sn, ["typed", "config"], (e) => {
  var {
    typed: t,
    config: r
  } = e;
  return t(sn, {
    "number, number": function(i, a) {
      return i >= a || Ct(i, a, r.relTol, r.absTol);
    }
  });
}), ra = "max", w0 = ["typed", "config", "numeric", "larger"], K0 = /* @__PURE__ */ J(ra, w0, (e) => {
  var {
    typed: t,
    config: r,
    numeric: n,
    larger: i
  } = e;
  return t(ra, {
    // max([a, b, c, d, ...])
    "Array | Matrix": u,
    // max([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(o, l) {
      return $n(o, l.valueOf(), a);
    },
    // max(a, b, c, d, ...)
    "...": function(o) {
      if (_n(o))
        throw new TypeError("Scalar values expected in function max");
      return u(o);
    }
  });
  function a(s, o) {
    try {
      return i(s, o) ? s : o;
    } catch (l) {
      throw sr(l, "max", o);
    }
  }
  function u(s) {
    var o;
    if (Vn(s, function(l) {
      try {
        isNaN(l) && typeof l == "number" ? o = NaN : (o === void 0 || i(l, o)) && (o = l);
      } catch (A) {
        throw sr(A, "max", l);
      }
    }), o === void 0)
      throw new Error("Cannot calculate max of an empty array");
    return typeof o == "string" && (o = n(o, Ta(o, r))), o;
  }
}), I0 = "ImmutableDenseMatrix", E0 = ["smaller", "DenseMatrix"], R0 = /* @__PURE__ */ J(I0, E0, (e) => {
  var {
    smaller: t,
    DenseMatrix: r
  } = e;
  function n(i, a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (a && !ot(a))
      throw new Error("Invalid datatype: " + a);
    if (Ve(i) || ge(i)) {
      var u = new r(i, a);
      this._data = u._data, this._size = u._size, this._datatype = u._datatype, this._min = null, this._max = null;
    } else if (i && ge(i.data) && ge(i.size))
      this._data = i.data, this._size = i.size, this._datatype = i.datatype, this._min = typeof i.min < "u" ? i.min : null, this._max = typeof i.max < "u" ? i.max : null;
    else {
      if (i)
        throw new TypeError("Unsupported type of data (" + st(i) + ")");
      this._data = [], this._size = [0], this._datatype = a, this._min = null, this._max = null;
    }
  }
  return n.prototype = new r(), n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = !0, n.prototype.subset = function(i) {
    switch (arguments.length) {
      case 1: {
        var a = r.prototype.subset.call(this, i);
        return Ve(a) ? new n({
          data: a._data,
          size: a._size,
          datatype: a._datatype
        }) : a;
      }
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, n.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, n.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, n.prototype.clone = function() {
    return new n({
      data: Ae(this._data),
      size: Ae(this._size),
      datatype: this._datatype
    });
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ImmutableDenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, n.fromJSON = function(i) {
    return new n(i);
  }, n.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, n.prototype.min = function() {
    if (this._min === null) {
      var i = null;
      this.forEach(function(a) {
        (i === null || t(a, i)) && (i = a);
      }), this._min = i !== null ? i : void 0;
    }
    return this._min;
  }, n.prototype.max = function() {
    if (this._max === null) {
      var i = null;
      this.forEach(function(a) {
        (i === null || t(i, a)) && (i = a);
      }), this._max = i !== null ? i : void 0;
    }
    return this._max;
  }, n;
}, {
  isClass: !0
}), z0 = "Index", T0 = ["ImmutableDenseMatrix", "getMatrixDataType"], N0 = /* @__PURE__ */ J(z0, T0, (e) => {
  var {
    ImmutableDenseMatrix: t,
    getMatrixDataType: r
  } = e;
  function n(a) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
    for (var u = 0, s = arguments.length; u < s; u++) {
      var o = arguments[u], l = ge(o), A = Ve(o), d = null;
      if (Ea(o))
        this._dimensions.push(o), this._isScalar = !1;
      else if (l || A) {
        var m = void 0;
        r(o) === "boolean" ? (l && (m = i(na(o).valueOf())), A && (m = i(na(o._data).valueOf())), d = o.valueOf().length) : m = i(o.valueOf()), this._dimensions.push(m);
        var f = m.size();
        (f.length !== 1 || f[0] !== 1 || d !== null) && (this._isScalar = !1);
      } else if (typeof o == "number")
        this._dimensions.push(i([o]));
      else if (typeof o == "string")
        this._dimensions.push(o);
      else
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
      this._sourceSize.push(d);
    }
  }
  n.prototype.type = "Index", n.prototype.isIndex = !0;
  function i(a) {
    for (var u = 0, s = a.length; u < s; u++)
      if (typeof a[u] != "number" || !Ke(a[u]))
        throw new TypeError("Index parameters must be positive integer numbers");
    return new t(a);
  }
  return n.prototype.clone = function() {
    var a = new n();
    return a._dimensions = Ae(this._dimensions), a._isScalar = this._isScalar, a._sourceSize = this._sourceSize, a;
  }, n.create = function(a) {
    var u = new n();
    return n.apply(u, a), u;
  }, n.prototype.size = function() {
    for (var a = [], u = 0, s = this._dimensions.length; u < s; u++) {
      var o = this._dimensions[u];
      a[u] = typeof o == "string" ? 1 : o.size()[0];
    }
    return a;
  }, n.prototype.max = function() {
    for (var a = [], u = 0, s = this._dimensions.length; u < s; u++) {
      var o = this._dimensions[u];
      a[u] = typeof o == "string" ? o : o.max();
    }
    return a;
  }, n.prototype.min = function() {
    for (var a = [], u = 0, s = this._dimensions.length; u < s; u++) {
      var o = this._dimensions[u];
      a[u] = typeof o == "string" ? o : o.min();
    }
    return a;
  }, n.prototype.forEach = function(a) {
    for (var u = 0, s = this._dimensions.length; u < s; u++)
      a(this._dimensions[u], u, this);
  }, n.prototype.dimension = function(a) {
    return typeof a != "number" ? null : this._dimensions[a] || null;
  }, n.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && typeof this._dimensions[0] == "string";
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var a = [], u = 0, s = this._dimensions.length; u < s; u++) {
      var o = this._dimensions[u];
      a.push(typeof o == "string" ? o : o.toArray());
    }
    return a;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var a = [], u = 0, s = this._dimensions.length; u < s; u++) {
      var o = this._dimensions[u];
      typeof o == "string" ? a.push(JSON.stringify(o)) : a.push(o.toString());
    }
    return "[" + a.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "Index",
      dimensions: this._dimensions
    };
  }, n.fromJSON = function(a) {
    return n.create(a.dimensions);
  }, n;
}, {
  isClass: !0
});
function na(e) {
  var t = [];
  return e.forEach((r, n) => {
    r && t.push(n);
  }), t;
}
var ia = "add", G0 = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], P0 = /* @__PURE__ */ J(ia, G0, (e) => {
  var {
    typed: t,
    matrix: r,
    addScalar: n,
    equalScalar: i,
    DenseMatrix: a,
    SparseMatrix: u,
    concat: s
  } = e, o = hu({
    typed: t
  }), l = Fc({
    typed: t,
    equalScalar: i
  }), A = vu({
    typed: t,
    DenseMatrix: a
  }), d = lr({
    typed: t,
    matrix: r,
    concat: s
  });
  return t(ia, {
    "any, any": n,
    "any, any, ...any": t.referToSelf((m) => (f, p, c) => {
      for (var h = m(f, p), v = 0; v < c.length; v++)
        h = m(h, c[v]);
      return h;
    })
  }, d({
    elop: n,
    DS: o,
    SS: l,
    Ss: A
  }));
}), aa = "dot", L0 = ["typed", "addScalar", "multiplyScalar", "conj", "size"], M0 = /* @__PURE__ */ J(aa, L0, (e) => {
  var {
    typed: t,
    addScalar: r,
    multiplyScalar: n,
    conj: i,
    size: a
  } = e;
  return t(aa, {
    "Array | DenseMatrix, Array | DenseMatrix": s,
    "SparseMatrix, SparseMatrix": o
  });
  function u(A, d) {
    var m = l(A), f = l(d), p, c;
    if (m.length === 1)
      p = m[0];
    else if (m.length === 2 && m[1] === 1)
      p = m[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + m.join(", ") + ")");
    if (f.length === 1)
      c = f[0];
    else if (f.length === 2 && f[1] === 1)
      c = f[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + f.join(", ") + ")");
    if (p !== c) throw new RangeError("Vectors must have equal length (" + p + " != " + c + ")");
    if (p === 0) throw new RangeError("Cannot calculate the dot product of empty vectors");
    return p;
  }
  function s(A, d) {
    var m = u(A, d), f = Ve(A) ? A._data : A, p = Ve(A) ? A._datatype || A.getDataType() : void 0, c = Ve(d) ? d._data : d, h = Ve(d) ? d._datatype || d.getDataType() : void 0, v = l(A).length === 2, Z = l(d).length === 2, b = r, F = n;
    if (p && h && p === h && typeof p == "string" && p !== "mixed") {
      var y = p;
      b = t.find(r, [y, y]), F = t.find(n, [y, y]);
    }
    if (!v && !Z) {
      for (var V = F(i(f[0]), c[0]), W = 1; W < m; W++)
        V = b(V, F(i(f[W]), c[W]));
      return V;
    }
    if (!v && Z) {
      for (var X = F(i(f[0]), c[0][0]), x = 1; x < m; x++)
        X = b(X, F(i(f[x]), c[x][0]));
      return X;
    }
    if (v && !Z) {
      for (var q = F(i(f[0][0]), c[0]), I = 1; I < m; I++)
        q = b(q, F(i(f[I][0]), c[I]));
      return q;
    }
    if (v && Z) {
      for (var E = F(i(f[0][0]), c[0][0]), L = 1; L < m; L++)
        E = b(E, F(i(f[L][0]), c[L][0]));
      return E;
    }
  }
  function o(A, d) {
    u(A, d);
    for (var m = A._index, f = A._values, p = d._index, c = d._values, h = 0, v = r, Z = n, b = 0, F = 0; b < m.length && F < p.length; ) {
      var y = m[b], V = p[F];
      if (y < V) {
        b++;
        continue;
      }
      if (y > V) {
        F++;
        continue;
      }
      y === V && (h = v(h, Z(f[b], c[F])), b++, F++);
    }
    return h;
  }
  function l(A) {
    return Ve(A) ? A.size() : a(A);
  }
}), ua = "index", H0 = ["typed", "Index"], U0 = /* @__PURE__ */ J(ua, H0, (e) => {
  var {
    typed: t,
    Index: r
  } = e;
  return t(ua, {
    "...number | string | BigNumber | Range | Array | Matrix": function(i) {
      var a = i.map(function(s) {
        return We(s) ? s.toNumber() : ge(s) || Ve(s) ? s.map(function(o) {
          return We(o) ? o.toNumber() : o;
        }) : s;
      }), u = new r();
      return r.apply(u, a), u;
    }
  });
}), oa = "det", B0 = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], Y0 = /* @__PURE__ */ J(oa, B0, (e) => {
  var {
    typed: t,
    matrix: r,
    subtractScalar: n,
    multiply: i,
    divideScalar: a,
    isZero: u,
    unaryMinus: s
  } = e;
  return t(oa, {
    any: function(A) {
      return Ae(A);
    },
    "Array | Matrix": function(A) {
      var d;
      switch (Ve(A) ? d = A.size() : Array.isArray(A) ? (A = r(A), d = A.size()) : d = [], d.length) {
        case 0:
          return Ae(A);
        case 1:
          if (d[0] === 1)
            return Ae(A.valueOf()[0]);
          if (d[0] === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + we(d) + ")");
        case 2: {
          var m = d[0], f = d[1];
          if (m === f)
            return o(A.clone().valueOf(), m);
          if (f === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + we(d) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + we(d) + ")");
      }
    }
  });
  function o(l, A, d) {
    if (A === 1)
      return Ae(l[0][0]);
    if (A === 2)
      return n(i(l[0][0], l[1][1]), i(l[1][0], l[0][1]));
    for (var m = !1, f = new Array(A).fill(0).map((W, X) => X), p = 0; p < A; p++) {
      var c = f[p];
      if (u(l[c][p])) {
        var h = void 0;
        for (h = p + 1; h < A; h++)
          if (!u(l[f[h]][p])) {
            c = f[h], f[h] = f[p], f[p] = c, m = !m;
            break;
          }
        if (h === A) return l[c][p];
      }
      for (var v = l[c][p], Z = p === 0 ? 1 : l[f[p - 1]][p - 1], b = p + 1; b < A; b++)
        for (var F = f[b], y = p + 1; y < A; y++)
          l[F][y] = a(n(i(l[F][y], v), i(l[F][p], l[c][y])), Z);
    }
    var V = l[f[A - 1]][A - 1];
    return m ? s(V) : V;
  }
}), sa = "inv", O0 = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], J0 = /* @__PURE__ */ J(sa, O0, (e) => {
  var {
    typed: t,
    matrix: r,
    divideScalar: n,
    addScalar: i,
    multiply: a,
    unaryMinus: u,
    det: s,
    identity: o,
    abs: l
  } = e;
  return t(sa, {
    "Array | Matrix": function(m) {
      var f = Ve(m) ? m.size() : Ge(m);
      switch (f.length) {
        case 1:
          if (f[0] === 1)
            return Ve(m) ? r([n(1, m.valueOf()[0])]) : [n(1, m[0])];
          throw new RangeError("Matrix must be square (size: " + we(f) + ")");
        case 2: {
          var p = f[0], c = f[1];
          if (p === c)
            return Ve(m) ? r(A(m.valueOf(), p, c), m.storage()) : A(m, p, c);
          throw new RangeError("Matrix must be square (size: " + we(f) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + we(f) + ")");
      }
    },
    any: function(m) {
      return n(1, m);
    }
  });
  function A(d, m, f) {
    var p, c, h, v, Z;
    if (m === 1) {
      if (v = d[0][0], v === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(1, v)]];
    } else if (m === 2) {
      var b = s(d);
      if (b === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(d[1][1], b), n(u(d[0][1]), b)], [n(u(d[1][0]), b), n(d[0][0], b)]];
    } else {
      var F = d.concat();
      for (p = 0; p < m; p++)
        F[p] = F[p].concat();
      for (var y = o(m).valueOf(), V = 0; V < f; V++) {
        var W = l(F[V][V]), X = V;
        for (p = V + 1; p < m; )
          l(F[p][V]) > W && (W = l(F[p][V]), X = p), p++;
        if (W === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        p = X, p !== V && (Z = F[V], F[V] = F[p], F[p] = Z, Z = y[V], y[V] = y[p], y[p] = Z);
        var x = F[V], q = y[V];
        for (p = 0; p < m; p++) {
          var I = F[p], E = y[p];
          if (p !== V) {
            if (I[V] !== 0) {
              for (h = n(u(I[V]), x[V]), c = V; c < f; c++)
                I[c] = i(I[c], a(h, x[c]));
              for (c = 0; c < f; c++)
                E[c] = i(E[c], a(h, q[c]));
            }
          } else {
            for (h = x[V], c = V; c < f; c++)
              I[c] = n(I[c], h);
            for (c = 0; c < f; c++)
              E[c] = n(E[c], h);
          }
        }
      }
      return y;
    }
  }
}), j0 = "divide", k0 = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], Q0 = /* @__PURE__ */ J(j0, k0, (e) => {
  var {
    typed: t,
    matrix: r,
    multiply: n,
    equalScalar: i,
    divideScalar: a,
    inv: u
  } = e, s = pu({
    typed: t,
    equalScalar: i
  }), o = ri({
    typed: t
  });
  return t("divide", Ra({
    // we extend the signatures of divideScalar with signatures dealing with matrices
    "Array | Matrix, Array | Matrix": function(A, d) {
      return n(A, u(d));
    },
    "DenseMatrix, any": function(A, d) {
      return o(A, d, a, !1);
    },
    "SparseMatrix, any": function(A, d) {
      return s(A, d, a, !1);
    },
    "Array, any": function(A, d) {
      return o(r(A), d, a, !1).valueOf();
    },
    "any, Array | Matrix": function(A, d) {
      return n(A, u(d));
    }
  }, a.signatures));
}), Aa = "sum", _0 = ["typed", "config", "add", "numeric"], $0 = /* @__PURE__ */ J(Aa, _0, (e) => {
  var {
    typed: t,
    config: r,
    add: n,
    numeric: i
  } = e;
  return t(Aa, {
    // sum([a, b, c, d, ...])
    "Array | Matrix": a,
    // sum([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": u,
    // sum(a, b, c, d, ...)
    "...": function(o) {
      if (_n(o))
        throw new TypeError("Scalar values expected in function sum");
      return a(o);
    }
  });
  function a(s) {
    var o;
    return Vn(s, function(l) {
      try {
        o = o === void 0 ? l : n(o, l);
      } catch (A) {
        throw sr(A, "sum", l);
      }
    }), o === void 0 && (o = i(0, r.number)), typeof o == "string" && (o = i(o, Ta(o, r))), o;
  }
  function u(s, o) {
    try {
      var l = $n(s, o, n);
      return l;
    } catch (A) {
      throw sr(A, "sum");
    }
  }
}), la = "mean", ed = ["typed", "add", "divide"], td = /* @__PURE__ */ J(la, ed, (e) => {
  var {
    typed: t,
    add: r,
    divide: n
  } = e;
  return t(la, {
    // mean([a, b, c, d, ...])
    "Array | Matrix": a,
    // mean([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": i,
    // mean(a, b, c, d, ...)
    "...": function(s) {
      if (_n(s))
        throw new TypeError("Scalar values expected in function mean");
      return a(s);
    }
  });
  function i(u, s) {
    try {
      var o = $n(u, s, r), l = Array.isArray(u) ? Ge(u) : u.size();
      return n(o, l[s]);
    } catch (A) {
      throw sr(A, "mean");
    }
  }
  function a(u) {
    var s, o = 0;
    if (Vn(u, function(l) {
      try {
        s = s === void 0 ? l : r(s, l), o++;
      } catch (A) {
        throw sr(A, "mean", l);
      }
    }), o === 0)
      throw new Error("Cannot calculate the mean of an empty array");
    return n(s, o);
  }
}), yn = /* @__PURE__ */ BA({
  config: Oe
}), yu = /* @__PURE__ */ kA({}), gu = /* @__PURE__ */ il({}), ni = /* @__PURE__ */ ol({}), bt = /* @__PURE__ */ yl({
  Matrix: ni
}), ne = /* @__PURE__ */ Js({
  BigNumber: yn,
  Complex: yu,
  DenseMatrix: bt,
  Fraction: gu
}), rd = /* @__PURE__ */ Ql({
  typed: ne
}), gn = /* @__PURE__ */ $l({
  typed: ne
}), nd = /* @__PURE__ */ Lc({
  typed: ne
}), cr = /* @__PURE__ */ wl({
  config: Oe,
  typed: ne
}), ca = /* @__PURE__ */ Oc({
  typed: ne
}), id = /* @__PURE__ */ jc({
  typed: ne
}), Zu = /* @__PURE__ */ Fl({
  typed: ne
}), ad = /* @__PURE__ */ xl({
  config: Oe,
  typed: ne
}), ud = /* @__PURE__ */ Cl({
  equalScalar: cr,
  typed: ne
}), Fu = /* @__PURE__ */ Cc({
  typed: ne
}), od = /* @__PURE__ */ Gl({
  typed: ne
}), ii = /* @__PURE__ */ El({
  Matrix: ni,
  equalScalar: cr,
  typed: ne
}), sd = /* @__PURE__ */ Rc({
  typed: ne
}), Xu = /* @__PURE__ */ tc({
  typed: ne
}), Wu = /* @__PURE__ */ Ml({
  BigNumber: yn,
  typed: ne
}), da = /* @__PURE__ */ Ic({
  Complex: yu,
  config: Oe,
  typed: ne
}), ai = /* @__PURE__ */ jl({
  typed: ne
}), Ad = /* @__PURE__ */ Bl({
  Fraction: gu,
  typed: ne
}), ve = /* @__PURE__ */ Ol({
  DenseMatrix: bt,
  Matrix: ni,
  SparseMatrix: ii,
  typed: ne
}), ui = /* @__PURE__ */ h0({
  bignumber: Wu,
  fraction: Ad,
  number: od
}), ld = /* @__PURE__ */ r0({
  isInteger: Zu,
  matrix: ve,
  typed: ne
}), cd = /* @__PURE__ */ i0({
  matrix: ve,
  config: Oe,
  typed: ne
}), Xt = /* @__PURE__ */ c0({
  matrix: ve,
  typed: ne
}), dd = /* @__PURE__ */ f0({
  BigNumber: yn,
  config: Oe,
  matrix: ve,
  typed: ne
}), zt = /* @__PURE__ */ Hc({
  isInteger: Zu,
  matrix: ve,
  typed: ne
}), oi = /* @__PURE__ */ V0({
  numeric: ui,
  typed: ne
}), fd = /* @__PURE__ */ Qc({
  BigNumber: yn,
  DenseMatrix: bt,
  SparseMatrix: ii,
  config: Oe,
  matrix: ve,
  typed: ne
}), md = /* @__PURE__ */ q0({
  DenseMatrix: bt,
  concat: zt,
  config: Oe,
  matrix: ve,
  typed: ne
}), xu = /* @__PURE__ */ y0({
  DenseMatrix: bt,
  concat: zt,
  config: Oe,
  matrix: ve,
  typed: ne
}), jt = /* @__PURE__ */ Tc({
  DenseMatrix: bt,
  concat: zt,
  equalScalar: cr,
  matrix: ve,
  subtractScalar: Xu,
  typed: ne,
  unaryMinus: ai
}), qr = /* @__PURE__ */ P0({
  DenseMatrix: bt,
  SparseMatrix: ii,
  addScalar: gn,
  concat: zt,
  equalScalar: cr,
  matrix: ve,
  typed: ne
}), pd = /* @__PURE__ */ M0({
  addScalar: gn,
  conj: nd,
  multiplyScalar: Fu,
  size: cd,
  typed: ne
}), hd = /* @__PURE__ */ R0({
  DenseMatrix: bt,
  smaller: xu
}), Du = /* @__PURE__ */ N0({
  ImmutableDenseMatrix: hd,
  getMatrixDataType: id
}), Cu = /* @__PURE__ */ x0({
  DenseMatrix: bt,
  concat: zt,
  config: Oe,
  matrix: ve,
  typed: ne
}), dt = /* @__PURE__ */ Sc({
  addScalar: gn,
  dot: pd,
  equalScalar: cr,
  matrix: ve,
  multiplyScalar: Fu,
  typed: ne
}), vd = /* @__PURE__ */ u0({
  add: qr,
  matrix: ve,
  typed: ne,
  zeros: dd
}), Dn = /* @__PURE__ */ $0({
  add: qr,
  config: Oe,
  numeric: ui,
  typed: ne
}), Vd = /* @__PURE__ */ Y0({
  divideScalar: oi,
  isZero: ud,
  matrix: ve,
  multiply: dt,
  subtractScalar: Xu,
  typed: ne,
  unaryMinus: ai
}), bd = /* @__PURE__ */ U0({
  Index: Du,
  typed: ne
}), yd = /* @__PURE__ */ K0({
  config: Oe,
  larger: Cu,
  numeric: ui,
  typed: ne
}), gd = /* @__PURE__ */ F0({
  DenseMatrix: bt,
  concat: zt,
  config: Oe,
  matrix: ve,
  typed: ne
}), Zd = /* @__PURE__ */ e0({
  bignumber: Wu,
  matrix: ve,
  add: qr,
  config: Oe,
  isPositive: ad,
  larger: Cu,
  largerEq: md,
  smaller: xu,
  smallerEq: gd,
  typed: ne
}), Fd = /* @__PURE__ */ Bc({
  Index: Du,
  matrix: ve,
  range: Zd,
  typed: ne
}), Xd = /* @__PURE__ */ J0({
  abs: rd,
  addScalar: gn,
  det: Vd,
  divideScalar: oi,
  identity: fd,
  matrix: ve,
  multiply: dt,
  typed: ne,
  unaryMinus: ai
}), mr = /* @__PURE__ */ Q0({
  divideScalar: oi,
  equalScalar: cr,
  inv: Xd,
  matrix: ve,
  multiply: dt,
  typed: ne
}), zr = /* @__PURE__ */ td({
  add: qr,
  divide: mr,
  typed: ne
}), Wd = function(t, r, n, i, a) {
  if (r = r !== void 0 ? r : !0, n = n !== void 0 ? n : !0, i = i || Math.pow(2, -52), a = 1e-64 / i, !t)
    throw new TypeError("Matrix a is not defined");
  var u = t[0].length, s = t.length;
  if (s < u)
    throw new TypeError("Invalid matrix: m < n");
  var o, l, A, d, m, f, p, c, h, v, Z, b, F;
  c = 0, Z = 0;
  var y = [], V = [], W = [], X = r === "f" ? s : u;
  for (o = 0; o < s; o++)
    V[o] = new Array(X).fill(0);
  for (o = 0; o < u; o++)
    W[o] = new Array(u).fill(0);
  var x = new Array(u).fill(0);
  for (o = 0; o < s; o++)
    for (l = 0; l < u; l++)
      V[o][l] = t[o][l];
  for (o = 0; o < u; o++) {
    for (y[o] = c, v = 0, d = o + 1, l = o; l < s; l++)
      v += Math.pow(V[l][o], 2);
    if (v < a)
      c = 0;
    else
      for (p = V[o][o], c = p < 0 ? Math.sqrt(v) : -Math.sqrt(v), h = p * c - v, V[o][o] = p - c, l = d; l < u; l++) {
        for (v = 0, A = o; A < s; A++)
          v += V[A][o] * V[A][l];
        for (p = v / h, A = o; A < s; A++)
          V[A][l] = V[A][l] + p * V[A][o];
      }
    for (x[o] = c, v = 0, l = d; l < u; l++)
      v += Math.pow(V[o][l], 2);
    if (v < a)
      c = 0;
    else {
      for (p = V[o][o + 1], c = p < 0 ? Math.sqrt(v) : -Math.sqrt(v), h = p * c - v, V[o][o + 1] = p - c, l = d; l < u; l++)
        y[l] = V[o][l] / h;
      for (l = d; l < s; l++) {
        for (v = 0, A = d; A < u; A++)
          v += V[l][A] * V[o][A];
        for (A = d; A < u; A++)
          V[l][A] = V[l][A] + v * y[A];
      }
    }
    b = Math.abs(x[o]) + Math.abs(y[o]), b > Z && (Z = b);
  }
  if (n)
    for (o = u - 1; o >= 0; o--) {
      if (c !== 0) {
        for (h = V[o][o + 1] * c, l = d; l < u; l++)
          W[l][o] = V[o][l] / h;
        for (l = d; l < u; l++) {
          for (v = 0, A = d; A < u; A++)
            v += V[o][A] * W[A][l];
          for (A = d; A < u; A++)
            W[A][l] = W[A][l] + v * W[A][o];
        }
      }
      for (l = d; l < u; l++)
        W[o][l] = 0, W[l][o] = 0;
      W[o][o] = 1, c = y[o], d = o;
    }
  if (r) {
    if (r === "f")
      for (o = u; o < s; o++) {
        for (l = u; l < s; l++)
          V[o][l] = 0;
        V[o][o] = 1;
      }
    for (o = u - 1; o >= 0; o--) {
      for (d = o + 1, c = x[o], l = d; l < X; l++)
        V[o][l] = 0;
      if (c !== 0) {
        for (h = V[o][o] * c, l = d; l < X; l++) {
          for (v = 0, A = d; A < s; A++)
            v += V[A][o] * V[A][l];
          for (p = v / h, A = o; A < s; A++)
            V[A][l] = V[A][l] + p * V[A][o];
        }
        for (l = o; l < s; l++)
          V[l][o] = V[l][o] / c;
      } else
        for (l = o; l < s; l++)
          V[l][o] = 0;
      V[o][o] = V[o][o] + 1;
    }
  }
  i = i * Z;
  var q;
  for (A = u - 1; A >= 0; A--)
    for (var I = 0; I < 50; I++) {
      for (q = !1, d = A; d >= 0; d--) {
        if (Math.abs(y[d]) <= i) {
          q = !0;
          break;
        }
        if (Math.abs(x[d - 1]) <= i)
          break;
      }
      if (!q) {
        for (f = 0, v = 1, m = d - 1, o = d; o < A + 1 && (p = v * y[o], y[o] = f * y[o], !(Math.abs(p) <= i)); o++)
          if (c = x[o], x[o] = Math.sqrt(p * p + c * c), h = x[o], f = c / h, v = -p / h, r)
            for (l = 0; l < s; l++)
              b = V[l][m], F = V[l][o], V[l][m] = b * f + F * v, V[l][o] = -b * v + F * f;
      }
      if (F = x[A], d === A) {
        if (F < 0 && (x[A] = -F, n))
          for (l = 0; l < u; l++)
            W[l][A] = -W[l][A];
        break;
      }
      for (Z = x[d], b = x[A - 1], c = y[A - 1], h = y[A], p = ((b - F) * (b + F) + (c - h) * (c + h)) / (2 * h * b), c = Math.sqrt(p * p + 1), p = ((Z - F) * (Z + F) + h * (b / (p < 0 ? p - c : p + c) - h)) / Z, f = 1, v = 1, o = d + 1; o < A + 1; o++) {
        if (c = y[o], b = x[o], h = v * c, c = f * c, F = Math.sqrt(p * p + h * h), y[o - 1] = F, f = p / F, v = h / F, p = Z * f + c * v, c = -Z * v + c * f, h = b * v, b = b * f, n)
          for (l = 0; l < u; l++)
            Z = W[l][o - 1], F = W[l][o], W[l][o - 1] = Z * f + F * v, W[l][o] = -Z * v + F * f;
        if (F = Math.sqrt(p * p + h * h), x[o - 1] = F, f = p / F, v = h / F, p = f * c + v * b, Z = -v * c + f * b, r)
          for (l = 0; l < s; l++)
            b = V[l][o - 1], F = V[l][o], V[l][o - 1] = b * f + F * v, V[l][o] = -b * v + F * f;
      }
      y[d] = 0, y[A] = p, x[A] = Z;
    }
  for (o = 0; o < u; o++)
    x[o] < i && (x[o] = 0);
  return {
    u: V,
    q: x,
    v: W
  };
};
const ke = {};
ke.maxFaceMaskProbability = 0.55, ke.minFaceAcceptability = 0.2, ke.minFaceQuality = 0.6, ke.minFaceFrontality = 75, ke.minFaceSize = 190, ke.imageBoundaryWidthPct = 0.75, ke.imageBoundaryHeightPct = 0.75, ke.minFaceHeightPct = 0.25, ke.maxFaceSizePct = 0.7, ke.imageIlluminationControl = 60, ke.minFaceSharpness = 0.45, ke.maxFaceRollAngle = 40, ke.failFast = !0;
const qu = ke, Qt = {};
Qt.minFaceAcceptability = 0.2, Qt.minFaceQuality = 0.55, Qt.imageIlluminationControl = 60, Qt.minFaceSize = 70, Qt.failFast = !0;
const xd = Qt, Wt = {};
Wt.maxFaceMaskProbability = 0.55, Wt.minFaceAcceptability = 0.2, Wt.minFaceQuality = 0.55, Wt.minFaceFrontality = 65, Wt.imageIlluminationControl = 60, Wt.minFaceSharpness = 0.45, Wt.minFaceSize = 120, Wt.failFast = !0;
const Dd = Wt, Cd = 50;
function qd(e) {
  switch (e) {
    case "AGE":
      return Dd;
    case "DEEPFAKE":
      return xd;
    default:
      return qu;
  }
}
function Sd(e, t, r, n) {
  if (t.origin.x < 0 || t.origin.y < 0 || t.origin.x + t.width > e.width || t.origin.y + t.height > e.height)
    throw console.log(t, e.width, e.height), new Error("Bounding box is out of bounds");
  const i = document.createElement("canvas");
  i.width = r, i.height = n;
  const a = {};
  a.desynchronized = !0, a.alpha = !1, a.willReadFrequently = !0;
  const u = i.getContext("2d", a);
  return u.drawImage(e, t.origin.x, t.origin.y, t.width, t.height, 0, 0, r, n), u.getImageData(0, 0, r, n);
}
async function wd(e, t) {
  let r = performance.now();
  const n = It(t.boundingBox, t.sourceImage.width, t.sourceImage.height), i = xa(n, 1), a = It(i, t.sourceImage.width, t.sourceImage.height), u = Da(i, a, t.sourceImage.width, t.sourceImage.height), s = Sd(t.sourceImage, u, e.inputWidth, e.inputHeight), o = Xr(s), l = {};
  l.preProcess = performance.now() - r, r = performance.now();
  const A = await import("onnxruntime-web"), d = new A.Tensor("float32", o.data, [1, ...o.shape]), m = await e.run({ [e.inputNames[0]]: d });
  l.infer = performance.now() - r, r = performance.now(), t.sharpness = Math.max(0, Math.min(1, m.sharpness.data[0])), l.postProcess = performance.now() - r, t.timings.sharpness = l;
}
async function Kd(e, t) {
  let r = performance.now();
  const n = Xr(t.preparedImage), i = {};
  i.preProcess = performance.now() - r, r = performance.now();
  const a = await import("onnxruntime-web"), u = new a.Tensor("float32", n.data, [1, ...n.shape]), s = await e.run({ [e.inputNames[0]]: u });
  i.infer = performance.now() - r, r = performance.now(), t.maskProbability = s.mask_probs.data[0], i.postProcess = performance.now() - r, t.timings.mask = i;
}
const ce = class ce {
  constructor(t, r) {
    Zt(this, "sharpnessEngine");
    Zt(this, "maskEngine");
    this.sharpnessEngine = t, this.maskEngine = r;
  }
  static async create() {
    const t = await hr($o, ["wasm"]), r = await hr(_o, ["wasm"]);
    return new ce(t, r);
  }
  static checkFacePosition(t, r, n, i) {
    if (n.imageBoundaryWidthPct === void 0 && n.imageBoundaryHeightPct === void 0) return;
    const a = t.width, u = t.height;
    if (a === 0 || u === 0) throw new ct("Failed to compute face-position check due to invalid source image data.");
    const s = r.boundingBox.origin.x, o = r.boundingBox.origin.y, l = r.boundingBox.origin.x + r.boundingBox.width, A = r.boundingBox.origin.y + r.boundingBox.height, d = n.imageBoundaryWidthPct ? (1 - n.imageBoundaryWidthPct) / 2 * a : 0, m = n.imageBoundaryWidthPct ? d + n.imageBoundaryWidthPct * a : a, f = n.imageBoundaryHeightPct ? (1 - n.imageBoundaryHeightPct) / 2 * u : 0, p = n.imageBoundaryHeightPct ? f + n.imageBoundaryHeightPct * u : u;
    if (s < d) {
      if (i.feedback.push("FACE_POS_LEFT"), i.isValid = !1, n.failFast) return;
    } else if (l > m && (i.feedback.push("FACE_POS_RIGHT"), i.isValid = !1, n.failFast))
      return;
    if (o < f) {
      if (i.feedback.push("FACE_POS_HIGH"), i.isValid = !1, n.failFast) return;
    } else if (A > p && (i.feedback.push("FACE_POS_LOW"), i.isValid = !1, n.failFast))
      return;
  }
  static checkFaceSize(t, r, n, i) {
    if (n.minFaceSize === void 0 && n.minFaceHeightPct === void 0 && n.maxFaceSizePct === void 0) return;
    const a = t.width, u = t.height;
    if (a === 0 || u === 0) throw new ct("Failed to compute face-size check due to invalid source image data.");
    const s = r.boundingBox.height, o = r.boundingBox.width, l = s / u, A = o / a;
    if (i.faceWidth = o, i.faceHeight = s, i.faceWidthPct = A, i.faceHeightPct = l, n.minFaceSize !== void 0 && (o < n.minFaceSize || s < n.minFaceSize) && (i.feedback.push("FACE_RES_LOW"), i.isValid = !1, n.failFast))
      return;
    const d = Math.max(A, l);
    if (n.minFaceHeightPct !== void 0 && d < n.minFaceHeightPct) {
      if (i.feedback.push("FACE_SIZE_SMALL"), i.isValid = !1, n.failFast) return;
    } else if (n.maxFaceSizePct !== void 0 && d > n.maxFaceSizePct && (i.feedback.push("FACE_SIZE_LARGE"), i.isValid = !1, n.failFast))
      return;
  }
  static clampValidnessSettings(t) {
    function r(n, i, a) {
      return Math.min(Math.max(n, i), a);
    }
    t.maxFaceRollAngle !== void 0 && (t.maxFaceRollAngle = r(t.maxFaceRollAngle, 0, 180)), t.minFaceSharpness !== void 0 && (t.minFaceSharpness = r(t.minFaceSharpness, 0, 1)), t.minFaceQuality !== void 0 && (t.minFaceQuality = r(t.minFaceQuality, 0, 1)), t.minFaceAcceptability !== void 0 && (t.minFaceAcceptability = r(t.minFaceAcceptability, 0, 1)), t.minFaceFrontality !== void 0 && (t.minFaceFrontality = r(t.minFaceFrontality, 0, 100)), t.maxFaceMaskProbability !== void 0 && (t.maxFaceMaskProbability = r(t.maxFaceMaskProbability, 0, 1)), t.imageIlluminationControl !== void 0 && (t.imageIlluminationControl = r(t.imageIlluminationControl, 0, 100)), t.imageBoundaryWidthPct !== void 0 && (t.imageBoundaryWidthPct = r(t.imageBoundaryWidthPct, 0, 1)), t.imageBoundaryHeightPct !== void 0 && (t.imageBoundaryHeightPct = r(t.imageBoundaryHeightPct, 0, 1)), t.maxFaceSizePct !== void 0 && (t.maxFaceSizePct = r(t.maxFaceSizePct, 0, 1)), t.minFaceHeightPct !== void 0 && (t.minFaceHeightPct = r(t.minFaceHeightPct, 0, 1));
  }
  async checkValidness({ faces: t, settings: r }) {
    const n = [];
    if (t.length === 0) return n;
    const i = typeof r == "string" ? qd(r) : r;
    if (!i || Object.keys(i).length === 0) throw new ct("Invalid validness settings provided.");
    for (const a of t) {
      if (!a || Object.keys(a).length === 0) throw new ct("Invalid input face object found.");
      n.push(await ce.runChecks(a, i, this.sharpnessEngine, this.maskEngine));
    }
    return n;
  }
  static async runChecks(t, r, n, i) {
    const a = {};
    a.quality = t.quality ?? -1, a.acceptability = t.acceptability ?? -1, a.feedback = [], a.isValid = !0;
    const u = a;
    return ce.clampValidnessSettings(r), ce.checkFaceRollAngle(t, r, u), r.failFast && !u.isValid || (ce.checkTooManyFaces(t, r, u), r.failFast && !u.isValid) || (ce.checkIllumination(t, r, u), r.failFast && !u.isValid) || (ce.checkFaceSize(t.sourceImage, t, r, u), r.failFast && !u.isValid) || (ce.checkFacePosition(t.sourceImage, t, r, u), r.failFast && !u.isValid) || (ce.checkFaceFrontality(t, r, u), r.failFast && !u.isValid) || (await ce.checkFaceMask(t, r, i, u), r.failFast && !u.isValid) || (await ce.checkFaceSharpness(t, r, n, u), r.failFast && !u.isValid) || (ce.checkFaceAcceptability(t, r, u), r.failFast && !u.isValid) || (ce.checkFaceQuality(t, r, u), r.failFast && !u.isValid), u;
  }
  static getLandmarksDstTemplate() {
    const t = ve([[38.2946, 51.6963], [73.5318, 51.5014], [56.0252, 71.7366], [41.5493, 92.3655], [70.7299, 92.2041]]), r = zr(t, 0);
    let n = jt(t, r);
    const i = ca(n), a = jt(i, zr(i)), u = da(mr(Dn(dt(a, a)), i.size()[0]));
    n = mr(n, u);
    const s = {};
    return s.dst = t, s.dstZeroMean = n, s.dstStdDev = u, s.dstCenter = r, s;
  }
  static computeTransform(t) {
    const r = zr(t, 0);
    t = jt(t, r);
    const n = ca(t), i = jt(n, zr(n));
    let a = da(mr(Dn(dt(i, i)), n.size()[0]));
    a = a === 0 ? 1 : a, t = mr(t, a);
    const { dstStdDev: u, dstZeroMean: s, dstCenter: o } = ce.CACHED_LANDMARKS_DST_TEMPLATE, l = Wd(dt(Xt(t), s).valueOf()), A = Xt(ve(l.u)).swapRows(0, 1), d = Xt(ve(l.v)).swapRows(0, 1), m = Xt(dt(ve(A), Xt(ve(d)))), f = dt(u / a, m), p = jt(Xt(o), dt(f, Xt(r))).valueOf();
    return zt(f, ld(ve([p]), [2, 1]));
  }
  static transformPoints(t, r) {
    const n = vd(r, bd([0, 1], [0, 1])), i = Fd(r, 2), a = zt(i, i, i, i, i), u = qr(dt(n, Xt(t)), a);
    return Xt(u);
  }
  static checkFaceRollAngle(t, r, n) {
    if (r.maxFaceRollAngle === void 0) return;
    if (t.landmarks === void 0) throw new ct("Cannot compute face-roll-angle check due to invalid face landmarks.");
    const i = t.landmarks, a = ve([[i.leftEye.x, i.leftEye.y], [i.rightEye.x, i.rightEye.y], [i.nose.x, i.nose.y], [i.leftMouth.x, i.leftMouth.y], [i.rightMouth.x, i.rightMouth.y]]), u = ce.computeTransform(a);
    let s = Math.atan2(-u.get([0, 1]), u.get([0, 0]));
    s = s * (180 / Math.PI), n.faceRollAngle = s, Math.abs(s) > r.maxFaceRollAngle && (n.feedback.push("FACE_ROLL_ANGLE_EXCEEDED"), n.isValid = !1, r.failFast);
  }
  static checkTooManyFaces(t, r, n) {
    if (t.isBboxOverlapping && (n.feedback.push("TOO_MANY_FACES"), n.isValid = !1, r.failFast))
      return n;
  }
  static checkFaceFrontality(t, r, n) {
    if (r.minFaceFrontality === void 0) return;
    if (!t.landmarks) throw new ct("Cannot compute face-frontality check due to invalid face landmarks");
    const i = t.landmarks, a = ve([[i.leftEye.x, i.leftEye.y], [i.rightEye.x, i.rightEye.y], [i.nose.x, i.nose.y], [i.leftMouth.x, i.leftMouth.y], [i.rightMouth.x, i.rightMouth.y]]), u = ce.computeTransform(a), s = ce.transformPoints(a, u), o = 0.1, l = Dn(jt(s, ce.CACHED_LANDMARKS_DST_TEMPLATE.dst).map(sd)), A = dt(l, o).valueOf(), d = yd(100 - A, 0);
    n.frontality = d, d < r.minFaceFrontality && (n.feedback.push("FACE_FRONTALITY_POOR"), n.isValid = !1, r.failFast);
  }
  static async checkFaceMask(t, r, n, i) {
    if (r.maxFaceMaskProbability !== void 0 && (t.maskProbability === void 0 && await Kd(n, t), i.maskProbability = t.maskProbability, t.maskProbability > r.maxFaceMaskProbability && (i.feedback.push("FACE_MASK_FOUND"), i.isValid = !1, r.failFast)))
      return i;
  }
  static async checkFaceSharpness(t, r, n, i) {
    if (r.minFaceSharpness !== void 0 && (t.sharpness === void 0 && await wd(n, t), i.sharpness = t.sharpness, t.sharpness < r.minFaceSharpness && (i.feedback.push("FACE_SHARPNESS_POOR"), i.isValid = !1, r.failFast)))
      return i;
  }
  static checkFaceQuality(t, r, n) {
    if (r.minFaceQuality !== void 0) {
      if (t.quality === void 0) throw new ct("Cannot compute face-quality check due to invalid face quality metric.");
      if (t.quality < r.minFaceQuality && (n.feedback.push("FACE_QUALITY_POOR"), n.isValid = !1, r.failFast))
        return n;
    }
  }
  static checkFaceAcceptability(t, r, n) {
    if (r.minFaceAcceptability !== void 0) {
      if (t.acceptability === void 0) throw new ct("Cannot compute face-acceptability check due to invalid face acceptability metric.");
      if (t.acceptability < r.minFaceAcceptability && (n.feedback.push("FACE_ACCEPTABILITY_POOR"), n.isValid = !1, r.failFast))
        return n;
    }
  }
  static computeThresholdInterpolation(t, r, n, i, a) {
    let u = n - t;
    return u = u === 0 ? 1 : u, r + (a - t) * ((i - r) / u);
  }
  static checkIllumination(t, r, n) {
    if (r.imageIlluminationControl === void 0) return;
    const i = [0, 50, 100], a = [0, 30, 40], u = [255, 230, 220], s = [100, 100, 100], o = [100, 100, 100], l = -0.2, A = r.imageIlluminationControl <= 0 ? Cd : r.imageIlluminationControl;
    let d = t.boundingBox;
    d = It(d, t.sourceImage.width, t.sourceImage.height), d = Wa(d, l);
    const m = Xa(t.sourceImage, [d]), f = m[0];
    if (f.width === 0 || f.height === 0) throw new ct("Failed to compute image-illumination check due to invalid image data.");
    const p = A >= i[1] ? 1 : 0, c = A >= i[2] ? 2 : 1, h = i[p], v = i[c], Z = ce.computeThresholdInterpolation(h, a[p], v, a[c], A), b = ce.computeThresholdInterpolation(h, u[p], v, u[c], A), F = ce.computeThresholdInterpolation(h, o[p], v, o[c], A), y = ce.computeThresholdInterpolation(h, s[p], v, s[c], A);
    let V = 0;
    for (let q = 0; q < f.data.length; q += 4) {
      const I = 0.2126 * f.data[q] + 0.7152 * f.data[q + 1] + 0.0722 * f.data[q + 2];
      V += I;
    }
    const W = V / (f.width * f.height), { darkPct: X, brightPct: x } = ce.getIlluminationPercentages(f);
    n.imageAveragePixelValue = W, n.imageDarkPixelPct = X, n.imageBrightPixelPct = x, W <= Z ? (n.feedback.push("IMG_LIGHTING_DARK"), n.isValid = !1) : W >= b ? (n.feedback.push("IMG_LIGHTING_BRIGHT"), n.isValid = !1) : X >= F ? (n.feedback.push("IMG_LIGHTING_DARK"), n.isValid = !1) : x >= y && (n.feedback.push("IMG_LIGHTING_BRIGHT"), n.isValid = !1);
  }
  static getIlluminationPercentages(t) {
    let r = 0, n = 0;
    const i = 10, a = 250;
    for (let d = 0; d < t.height * t.width; d++) {
      let { v: m } = ce.rgb2hsv(t, d);
      m *= 255, m >= a ? r++ : m <= i && n++;
    }
    const u = t.height, s = t.width, o = n / (u * s) * 100, l = r / (u * s) * 100, A = {};
    return A.darkPct = o, A.brightPct = l, A;
  }
  static rgb2hsv(t, r) {
    const n = t.data[r * 4] / 255, i = t.data[r * 4 + 1] / 255, a = t.data[r * 4 + 2] / 255, u = Math.max(n, i, a), s = u - Math.min(n, i, a), o = s && (u == n ? (i - a) / s : u == i ? 2 + (a - n) / s : 4 + (n - i) / s), l = {};
    return l.h = 60 * (o < 0 ? o + 6 : o), l.s = u && s / u, l.v = u, l;
  }
};
Zt(ce, "version", Za), Zt(ce, "CACHED_LANDMARKS_DST_TEMPLATE", ce.getLandmarksDstTemplate());
let Ln = ce;
const Su = (e) => ({
  contextType: (e == null ? void 0 : e.contextType) || new URLSearchParams(window.location.search).get(Vr.CONTEXT_TYPE) || "",
  resourceType: (e == null ? void 0 : e.resourceType) || new URLSearchParams(window.location.search).get(Vr.RESOURCE_TYPE) || ""
}), wu = () => new URLSearchParams(window.location.search).get(Vr.APP_ID) || void 0, Id = { version: "1.0", osName: "", osVersion: "", computerName: "" }, Ed = {
  agentData: "",
  systemData: wn(Id),
  deviceData: ""
};
function Rd(e, t, r) {
  return {
    ...Ed,
    factorType: e,
    factorData: wn(t),
    ...r && { deviceData: wn(r ?? {}) }
  };
}
function fa(e) {
  return new Promise((t) => setTimeout(t, e));
}
const Fr = (e, t = "Unknown error") => {
  if (e instanceof Error)
    return e.message;
  if (e && typeof e == "object")
    try {
      return tr(e);
    } catch {
      return String(e);
    }
  return e ? String(e) : t;
}, kt = De(Tt.SERVICE, "authenticate"), z1 = ({
  store: e,
  commonHeaders: t,
  sessionService: r
}) => {
  const { startSession: n, enrollSession: i } = r;
  return ln(
    // Service span name
    kt,
    // Service return methods
    {
      authenticate: async (a, u, s, o) => {
        var l;
        o && e.set({ key: "traceContext", data: o });
        try {
          let A = u;
          if (!A) {
            const d = s ? i : n, { session: m } = await d();
            if (!m)
              throw Ie("Authenticate failed to create session"), new Yr({ code: et.SESSION_NOT_FOUND });
            A = m;
          }
          return await xo(a, A, s, {
            headers: t
          });
        } catch (A) {
          if (Ie("[AuthSvc::Error] authenticating", { error: A }), Ce(De(kt, "error"), { error: `${A}` }), pr(A)) {
            const d = A && "error" in A ? A.error : A;
            throw ((l = d == null ? void 0 : d.data) == null ? void 0 : l["session-terminated"]) === "true" ? new br(d, d.data) : rr(d, a.factorType);
          }
          throw A;
        }
      },
      /**
       * Enroll
       */
      enroll: async (a, u) => {
        if (!u)
          throw St({ message: "Cannot enroll before creating a session" });
        try {
          const s = await Wo(a, u);
          return Ce(De(kt, "response"), {
            response: tr(s)
          }), s;
        } catch (s) {
          if (Ce(De(kt, "error"), {
            error: Fr(s),
            is_in_catch: !0
          }), pr(s)) {
            const o = s && "error" in s ? s.error : s;
            throw rr(o, a.factorType);
          }
          throw s;
        }
      },
      authenticateByEnrollmentSession: async (a, u) => {
        var s;
        u && e.set({ key: "traceContext", data: u });
        try {
          let o = a;
          if (!o) {
            const { session: A } = await n() || {};
            if (!A)
              throw Ie("Authenticate failed to create session"), new Yr({ code: et.SESSION_NOT_FOUND });
            o = A;
          }
          const l = await Fo({ headers: t });
          if (ee("[AuthSvc] response received"), Ce(De(kt, "response"), {
            response: JSON.stringify(l)
          }), !l)
            throw Ie("[AuthSvc::Error] no response"), new ut({
              code: et.SYSTEM_ERROR,
              message: Xo.SYSTEM_ERROR
            });
          return { session: o, response: l };
        } catch (o) {
          if (Ce(De(kt, "error"), {
            error: `${o}`,
            is_in_catch: !0
          }), Ie("[AuthSvc::Error] authenticating (face enrollment session)", { error: o }), pr(o)) {
            const l = o && "error" in o ? o.error : o;
            throw ((s = l == null ? void 0 : l.data) == null ? void 0 : s["session-terminated"]) === "true" ? new br(l, l.data) : rr(l, wt.FACE_ID);
          }
          throw o;
        }
      }
    }
  );
}, Cn = De(Tt.SERVICE, "consent"), T1 = (e) => ln(Cn, {
  submitConsent: async (t) => Do(t).then(() => {
    Ce(De(Cn, fi.SUBMIT_CONSENT)), ee("[ConsentSvc] response");
  }).catch((r) => {
    if (Ie("[ConsentSvc::Error] api error: ", { error: r }), Ce(De(Cn, fi.SUBMIT_CONSENT), {
      error: Fr(r)
    }), yo(r)) {
      const n = r && "error" in r ? r.error : r;
      throw rr(n);
    }
    throw r;
  })
}), ma = [
  wt.FACE_ID,
  wt.PASSWORD,
  wt.IMPR_ID,
  wt.IMPR_PIN
], N1 = ({ store: e, ...t }) => {
  const { applicationId: r, contextResource: n, deviceFactors: i } = t, { username: a } = t.requestConfig || {}, u = Su(n), s = r || wu();
  let o = (i || []).filter(
    (A) => !ma.includes(A)
  );
  const l = () => [...o || [], ...ma];
  return ee("[FactorSvc] initializing: ", {
    initialDeviceFactors: i,
    deviceFactors: o,
    availableFactorTypes: l()
  }), ln(De(Tt.SERVICE, "factors"), {
    availableFactorTypes: l,
    fetchFactors: async (A, d, m) => {
      d && e.set({ key: "traceContext", data: d }), m && (o = A || []);
      const f = l();
      return Co({
        authnContext: u,
        applicationId: s,
        availableFactorTypes: f,
        username: a
      }).then((p) => (ee("[FactorSvc] fetched factors: ", p), p)).catch((p) => {
        if (Ie("[FactorSvc::Error] api error: ", { error: p }), pr(p)) {
          const c = p && "error" in p ? p.error : p;
          throw c.code === et.ACCOUNT_DISABLED ? new ga(c) : rr(c);
        }
        throw p;
      });
    }
  });
}, Pt = De(Tt.SERVICE, "session"), G1 = ({
  factorService: e,
  store: t,
  commonHeaders: r,
  ...n
}) => {
  const { contextResource: i, requestConfig: a, applicationId: u } = n, { username: s, oidcRequestData: o, userId: l } = a || {}, A = Su(i), d = u || wu();
  ee("[SessionSvc] creating session svc: ", { authnContext: A, requestConfig: a });
  const m = (f) => {
    if (pr(f)) {
      const p = f && "error" in f ? f.error : f;
      return rr(p);
    }
    return f;
  };
  return ln(Pt, {
    startSession: async () => {
      ee("[SessionSvc::startSession] called");
      let f = {};
      new URLSearchParams(window.location.search).has(Vr.CIPHER_V2) && (f = { ...f, cipherV2: !0 });
      try {
        const c = e.availableFactorTypes(), { session: h, response: v } = await mi(
          { authnContext: A, applicationId: d, availableFactorTypes: c, username: s, oidcRequestData: o, userId: l },
          !1,
          { ...f, headers: r }
        );
        return ee("[SessionSvc::startSession] response: ", { response: v }), Ce(De(Pt, "response"), {
          response: tr(v),
          availableFactorTypes: c
        }), h || console.debug("[SessionSvc::startSession] codingContext not found in response"), { session: h };
      } catch (c) {
        throw Ce(De(Pt, "error"), {
          error: Fr(c),
          is_in_catch: !0
        }), Ie("[SessionSvc::Error::startSession]: ", { error: c }), m(c);
      }
    },
    enrollSession: async () => {
      ee("[SessionSvc::enrollSession] called");
      try {
        const f = e.availableFactorTypes(), { session: p, response: c } = await mi(
          {
            authnContext: {
              contextType: Eo.ENROLL_LOGIN,
              resourceType: Io.AUTHN_WEB_UI
            },
            applicationId: d,
            availableFactorTypes: f,
            username: s,
            oidcRequestData: o,
            userId: l
          },
          !0,
          { headers: r }
        );
        return ee("[SessionSvc::enrollSession] response: ", { response: c }), Ce(De(Pt, "response"), {
          response: tr(c),
          availableFactorTypes: f
        }), p || ee("[SessionSvc::enrollSession] codingContext not found in response"), { session: p };
      } catch (f) {
        throw Ce(De(Pt, "error"), {
          error: Fr(f),
          is_in_catch: !0
        }), Ie("[SessionSvc::Error::enrollSession]:", { error: f }), m(f);
      }
    },
    terminateSession: async (f, p) => p ? qo(f, { headers: r }).then((c) => (Ce(De(Pt, "response"), {
      response: tr(c)
    }), c)).catch((c) => {
      throw Ce(De(Pt, "error"), { error: c, is_in_catch: !0 }), console.error("[SessionSvc::Error] terminating session: ", c), c;
    }) : {}
  });
}, zd = (e) => /* @__PURE__ */ C.createElement("svg", { width: 116, height: 250, viewBox: "0 0 213 461", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { d: "M184.284 69.3029C183.13 54.1161 173.224 51.395 173.224 51.395C172.88 36.9511 172.537 22.4998 172.186 8.05579C147.506 3.04747 106.578 3.73143 106.562 3.67995C106.516 3.67995 106.469 3.67995 106.422 3.67995C106.406 3.73143 65.4784 3.04747 40.7983 8.05579C40.455 22.4998 40.1118 36.9511 39.7608 51.395C39.7608 51.4024 29.8545 54.1235 28.7 69.3029C29.3396 69.3323 0.572207 422.216 0.814016 426.453C1.66425 430.718 5.26018 434.248 10.463 434.476C15.6658 434.756 50.2834 435.373 50.2834 435.322C50.2834 435.322 58.3021 434.954 60.0728 429.674C60.7436 418.025 61.4066 406.375 62.0618 394.726C62.0618 394.726 62.8419 388.46 70.1429 387.805C70.1507 387.805 87.5064 385.923 106.414 385.871C106.469 385.871 106.523 385.871 106.578 385.871C125.486 385.915 142.849 387.805 142.849 387.805C150.15 388.46 150.93 394.726 150.93 394.726C151.586 406.375 152.257 418.025 152.927 429.674C154.698 434.954 162.717 435.322 162.717 435.322C162.717 435.373 197.334 434.756 202.537 434.476C207.74 434.256 211.328 430.725 212.186 426.453C212.42 422.216 183.653 69.3323 184.284 69.3029ZM138.793 64.5888C138.793 64.5888 135.876 64.4343 134.261 61.8823C132.647 59.3304 131.422 55.8518 127.99 55.8812C124.55 55.9253 106.578 55.9694 106.578 55.9547C106.531 55.9547 106.484 55.9547 106.438 55.9547C106.438 55.9694 88.458 55.9253 85.0259 55.8812C81.5937 55.8591 80.3691 59.3304 78.7544 61.8823C77.1398 64.4343 74.2225 64.5888 74.2225 64.5888C71.0166 64.5593 67.8106 64.5152 64.6125 64.4784C64.7139 57.5506 64.8153 50.6228 64.9245 43.695C66.4378 43.7171 67.9511 43.7318 69.4643 43.7539C71.118 43.2832 71.0088 41.2019 71.0088 41.2019C71.0712 36.4951 71.1258 31.7883 71.1882 27.0815C72.6702 27.0962 74.1523 27.1109 75.6343 27.1256C75.6265 27.4934 75.6265 27.8611 75.6187 28.2288C78.7622 28.2582 81.898 28.2876 85.0415 28.3097C85.0415 27.942 85.0493 27.5743 85.0493 27.2065C87.0305 27.2213 89.0196 27.2286 91.0009 27.2433C91.0009 27.611 90.9931 27.9788 90.9931 28.3465C95.1818 28.3685 99.3706 28.3832 103.559 28.3832C103.559 28.0155 103.559 27.6478 103.559 27.2801C104.519 27.2801 105.478 27.2801 106.438 27.2801C106.484 27.2801 106.531 27.2801 106.578 27.2801C107.537 27.2801 108.497 27.2801 109.456 27.2801C109.456 27.6478 109.456 28.0155 109.456 28.3832C113.645 28.3759 117.834 28.3685 122.023 28.3465C122.023 27.9788 122.015 27.611 122.015 27.2433C123.996 27.236 125.985 27.2213 127.966 27.2065C127.966 27.5743 127.974 27.942 127.974 28.3097C131.118 28.2876 134.253 28.2582 137.397 28.2288C137.389 27.8611 137.389 27.4934 137.381 27.1256C138.863 27.1109 140.345 27.0962 141.828 27.0815C141.89 31.7883 141.945 36.4951 142.007 41.2019C142.007 41.2019 141.906 43.2832 143.551 43.7539C145.065 43.7391 146.578 43.7171 148.091 43.695C148.193 50.6228 148.294 57.5506 148.403 64.4784C145.197 64.5226 141.991 64.5593 138.793 64.5888Z", fill: "url(#paint0_linear_3236_1577)" }), /* @__PURE__ */ C.createElement("g", { filter: "url(#filter0_i_3236_1577)" }, /* @__PURE__ */ C.createElement("path", { d: "M182.679 71.7129C181.967 55.5234 172.267 52.3841 172.267 52.3841V6.24245C147.662 0.253587 106.53 0.84073 106.53 0.84073H106.389C106.389 0.84073 65.258 0.253587 40.6528 6.24245V52.3841C40.6528 52.3841 30.9453 55.5234 30.2408 71.7129C30.2408 71.7129 13.7068 448.025 14.5758 452.534C15.4447 457.044 18.6544 460.692 23.1637 460.778C27.673 460.864 57.7034 460.778 57.7034 460.778C57.7034 460.778 64.6474 460.253 66.1192 454.617L67.4187 417.392C67.4187 417.392 68.0293 410.706 74.4488 409.931C74.4488 409.931 89.7223 407.716 106.382 407.677H106.522C123.182 407.724 138.455 409.931 138.455 409.931C144.875 410.714 145.485 417.392 145.485 417.392L146.785 454.617C148.257 460.261 155.201 460.778 155.201 460.778C155.201 460.778 185.223 460.864 189.74 460.778C194.257 460.692 197.467 457.044 198.328 452.534C199.189 448.025 182.679 71.7129 182.679 71.7129ZM147.599 65.8571H138.166C138.166 65.8571 135.3 65.6614 133.742 62.9292C132.177 60.1971 131.01 56.4863 127.628 56.4863C124.246 56.4863 106.538 56.4863 106.538 56.4863H106.397C106.397 56.4863 88.6968 56.4863 85.307 56.4863C81.9172 56.4863 80.7508 60.1971 79.1929 62.9292C77.635 65.6614 74.7697 65.8571 74.7697 65.8571H65.3206V43.7335H69.8143C71.4426 43.209 71.3095 41.0014 71.3095 41.0014V25.9705H75.7327V27.1448H85.1035V25.9705H91.0297V27.1448H103.524V25.9705H106.389H106.53H109.396V27.1448H121.89V25.9705H127.816V27.1448H137.187V25.9705H141.61V41.0014C141.61 41.0014 141.477 43.2169 143.105 43.7335H147.599V65.8571Z", fill: "#F08421" })), /* @__PURE__ */ C.createElement("g", { filter: "url(#filter1_d_3236_1577)" }, /* @__PURE__ */ C.createElement("path", { d: "M106.389 391.362C83.1307 391.362 54.846 398.134 40.1752 402.384C25.5044 406.635 26.3812 396.482 26.3812 396.482C26.3812 396.482 39.134 96.9287 39.3141 88.9435C39.4863 80.9584 47.7298 80.1755 47.7298 80.1755H106.389H106.53H165.19C165.19 80.1755 173.433 80.9584 173.606 88.9435C173.778 96.9287 186.538 396.482 186.538 396.482C186.538 396.482 187.407 406.635 172.744 402.384C158.082 398.134 129.789 391.362 106.53 391.362H106.389Z", fill: "#E47925" })), /* @__PURE__ */ C.createElement("path", { d: "M39.3141 94.6271C39.4863 86.6419 47.7298 85.8591 47.7298 85.8591H106.389H106.53H165.19C165.19 85.8591 173.433 86.6419 173.606 94.6271C173.77 102.08 184.894 363.617 186.374 398.361C186.609 397.296 186.538 396.482 186.538 396.482C186.538 396.482 173.786 96.9287 173.606 88.9435C173.433 80.9584 165.19 80.1755 165.19 80.1755H106.53H106.389H47.7298C47.7298 80.1755 39.4863 80.9584 39.3141 88.9435C39.1418 96.9287 26.3812 396.482 26.3812 396.482C26.3812 396.482 26.3108 397.288 26.5456 398.361C28.0252 363.617 39.1497 102.08 39.3141 94.6271Z", fill: "url(#paint1_linear_3236_1577)" }), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M172.267 16.49H141.61V35.0281H172.267V16.49Z", fill: "url(#paint2_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M71.3017 16.4352H40.645V34.9733H71.3017V16.4352Z", fill: "url(#paint3_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("g", { filter: "url(#filter2_i_3236_1577)" }, /* @__PURE__ */ C.createElement("path", { d: "M101.113 173.696C104.056 167.95 108.871 167.95 111.815 173.696L132.819 214.741C135.762 220.487 140.577 229.897 143.52 235.651L164.524 276.697C167.468 282.443 164.587 287.148 158.129 287.148H118.203C111.744 287.148 101.176 287.148 94.717 287.148H54.7912C48.3326 287.148 45.4595 282.443 48.3952 276.697L69.3993 235.651C72.3429 229.905 77.1575 220.495 80.101 214.741L101.113 173.696Z", fill: "#F08421" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M141.555 16.49H138.862V25.9626H141.555V16.49Z", fill: "url(#paint4_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M73.9791 16.49H71.286V25.9626H73.9791V16.49Z", fill: "url(#paint5_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M169.926 8.83362C145.149 3.42407 106.538 3.97207 106.538 3.97207H106.397C106.397 3.97207 67.7632 3.42407 42.9857 8.84145V14.3919C67.7632 8.97453 106.397 9.52253 106.397 9.52253H106.538C106.538 9.52253 145.141 8.97453 169.926 14.3841V8.83362Z", fill: "url(#paint6_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("path", { d: "M43.1892 13.6091H42.7978V7.89422L42.9544 7.86291C67.4735 2.50033 106.021 2.9857 106.413 2.99353H106.554C106.937 2.99353 145.462 2.50816 169.981 7.85508L170.138 7.8864V13.6013H169.746V8.20737C145.266 2.89959 106.945 3.37713 106.562 3.38496H106.413C106.021 3.38496 67.677 2.89959 43.1971 8.2152V13.6091H43.1892Z", fill: "url(#paint7_linear_3236_1577)" }), /* @__PURE__ */ C.createElement("path", { d: "M174.741 16.49H172.267V35.0281H174.741V16.49Z", fill: "#C16B28" }), /* @__PURE__ */ C.createElement("path", { d: "M174.741 36.5547C175.528 36.5547 176.166 31.7178 176.166 25.7512C176.166 19.7847 175.528 14.9478 174.741 14.9478C173.954 14.9478 173.316 19.7847 173.316 25.7512C173.316 31.7178 173.954 36.5547 174.741 36.5547Z", fill: "url(#paint8_linear_3236_1577)" }), /* @__PURE__ */ C.createElement("path", { d: "M38.1732 35.0191H40.647V16.481H38.1732V35.0191Z", fill: "#C16B28" }), /* @__PURE__ */ C.createElement("path", { d: "M38.179 36.5547C38.9658 36.5547 39.6038 31.7178 39.6038 25.7512C39.6038 19.7847 38.9658 14.9478 38.179 14.9478C37.3921 14.9478 36.7542 19.7847 36.7542 25.7512C36.7542 31.7178 37.3921 36.5547 38.179 36.5547Z", fill: "url(#paint9_linear_3236_1577)" }), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M144.929 411.38C144.929 411.38 144.319 404.694 137.899 403.919C137.899 403.919 122.626 401.703 105.967 401.664H105.826C89.1665 401.711 73.8929 403.919 73.8929 403.919C67.4735 404.702 66.8628 411.38 66.8628 411.38L66.6201 418.277H66.8315L66.8628 417.392C66.8628 417.392 67.4735 410.706 73.8929 409.931C73.8929 409.931 89.1665 407.716 105.826 407.677H105.967C122.626 407.724 137.899 409.931 137.899 409.931C144.319 410.714 144.929 417.392 144.929 417.392L144.961 418.277H145.172L144.929 411.38Z", fill: "url(#paint10_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M66.3366 446.758C65.405 451.165 62.2344 454.688 57.7956 454.774C53.2863 454.86 23.2559 454.774 23.2559 454.774C23.2559 454.774 16.3119 454.25 14.8401 448.613L14.7462 445.967H14.5427L14.848 454.626C16.3198 460.27 23.2637 460.787 23.2637 460.787C23.2637 460.787 53.2863 460.873 57.8034 460.787C62.3205 460.701 65.5302 457.052 66.3914 452.543C66.4462 452.238 66.4305 450.226 66.3366 446.758Z", fill: "url(#paint11_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M198.275 446.758C197.343 451.165 194.172 454.688 189.734 454.774C185.224 454.86 155.194 454.774 155.194 454.774C155.194 454.774 148.25 454.25 146.778 448.613L146.684 445.967H146.481L146.786 454.626C148.258 460.27 155.202 460.787 155.202 460.787C155.202 460.787 185.224 460.873 189.741 460.787C194.258 460.701 197.468 457.052 198.329 452.543C198.384 452.238 198.368 450.226 198.275 446.758Z", fill: "url(#paint12_linear_3236_1577)" })), /* @__PURE__ */ C.createElement("path", { d: "M110.578 251.663L112.366 211.531H98.6904L100.567 251.663H110.578ZM105.573 272.042C109.505 272.042 112.813 268.734 112.813 264.891C112.813 260.958 109.505 257.651 105.573 257.651C101.64 257.651 98.4222 260.958 98.4222 264.891C98.4222 268.734 101.64 272.042 105.573 272.042Z", fill: "#FACE9B" }), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("filter", { id: "filter0_i_3236_1577", x: 14.5427, y: 0.824951, width: 183.818, height: 459.991, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ C.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ C.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ C.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ C.createElement("feOffset", null), /* @__PURE__ */ C.createElement("feGaussianBlur", { stdDeviation: 2.5 }), /* @__PURE__ */ C.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }), /* @__PURE__ */ C.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }), /* @__PURE__ */ C.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_3236_1577" })), /* @__PURE__ */ C.createElement("filter", { id: "filter1_d_3236_1577", x: 19.3712, y: 73.1755, width: 174.177, height: 337.249, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ C.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ C.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ C.createElement("feOffset", null), /* @__PURE__ */ C.createElement("feGaussianBlur", { stdDeviation: 3.5 }), /* @__PURE__ */ C.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ C.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }), /* @__PURE__ */ C.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_3236_1577" }), /* @__PURE__ */ C.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_3236_1577", result: "shape" })), /* @__PURE__ */ C.createElement("filter", { id: "filter2_i_3236_1577", x: 47.2437, y: 169.386, width: 118.436, height: 118.761, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ C.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ C.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ C.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ C.createElement("feOffset", { dy: 1 }), /* @__PURE__ */ C.createElement("feGaussianBlur", { stdDeviation: 3.5 }), /* @__PURE__ */ C.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }), /* @__PURE__ */ C.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }), /* @__PURE__ */ C.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_3236_1577" })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint0_linear_3236_1577", x1: 106.5, y1: 3.67371, x2: 106.5, y2: 435.325, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#A35A05" }), /* @__PURE__ */ C.createElement("stop", { offset: 0.34375, stopColor: "#C16B28" })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint1_linear_3236_1577", x1: 109.999, y1: 78.3758, x2: 109.999, y2: 87.1979, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#FACE9B" }), /* @__PURE__ */ C.createElement("stop", { offset: 0.9917, stopColor: "#FACE9B", stopOpacity: 0 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint2_linear_3236_1577", x1: 157.006, y1: 16.3811, x2: 156.875, y2: 35.1576, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { offset: 0.0127, stopColor: "#F08421", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5387, stopColor: "#FACE9B", stopOpacity: 0.6 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.9976, stopColor: "#C16B28", stopOpacity: 0.7 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint3_linear_3236_1577", x1: 56.0418, y1: 16.3307, x2: 55.9116, y2: 35.1073, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { offset: 0.0127, stopColor: "#F08421", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5387, stopColor: "#FACE9B", stopOpacity: 0.6 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.9976, stopColor: "#C16B28", stopOpacity: 0.7 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint4_linear_3236_1577", x1: 141.428, y1: 21.1965, x2: 139.258, y2: 21.247, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#C16B28", stopOpacity: 0.7 }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#FACE9B", stopOpacity: 0 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint5_linear_3236_1577", x1: 71.4186, y1: 21.2531, x2: 73.5881, y2: 21.2027, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#C16B28", stopOpacity: 0.7 }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#FACE9B", stopOpacity: 0 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint6_linear_3236_1577", x1: 106.461, y1: 3.95641, x2: 106.461, y2: 14.3918, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#C16B28" }), /* @__PURE__ */ C.createElement("stop", { offset: 0.625, stopColor: "#FACE9B", stopOpacity: 0 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint7_linear_3236_1577", x1: 42.6221, y1: 8.29466, x2: 170.832, y2: 8.29466, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#F08421", stopOpacity: 0.4 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5, stopColor: "#FACE9B" }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#F08421", stopOpacity: 0.4 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint8_linear_3236_1577", x1: 174.74, y1: 14.9508, x2: 174.74, y2: 36.5584, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { offset: 868056e-9, stopColor: "#C16B28" }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5, stopColor: "#F08421" }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#C16B28" })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint9_linear_3236_1577", x1: 38.1776, y1: 36.5584, x2: 38.1776, y2: 14.9508, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { offset: 868056e-9, stopColor: "#C16B28" }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5, stopColor: "#F08421" }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#C16B28" })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint10_linear_3236_1577", x1: 105.892, y1: 400.708, x2: 105.892, y2: 410.882, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#C16B28", stopOpacity: 0.5 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.1165, stopColor: "#C16B28", stopOpacity: 0.4417 }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#C16B28", stopOpacity: 0 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint11_linear_3236_1577", x1: 40.4828, y1: 452.206, x2: 40.4828, y2: 460.825, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#C16B28", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#C16B28", stopOpacity: 0.5 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint12_linear_3236_1577", x1: 172.421, y1: 452.206, x2: 172.421, y2: 460.825, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "#C16B28", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "#C16B28", stopOpacity: 0.5 })))), Td = (e) => /* @__PURE__ */ C.createElement("svg", { width: 275, height: 264, viewBox: "0 0 275 264", fill: "none", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ C.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ C.createElement("rect", { y: 166.92, width: 275, height: 97.052, fill: "url(#pattern0)" })), /* @__PURE__ */ C.createElement("path", { d: "M257.603 198.427V192.878H252.016V195.022L192.503 178.309L81.9683 179.001C81.9683 179.001 36.9283 191.695 22.9023 196.792V195.061H17.3198V201.153H17.3342C17.4785 202.447 18.9643 203.25 18.9643 203.25L130.6 239.125C130.6 239.125 135.74 240.745 142.842 240.673H143.025C150.127 240.745 155.267 239.125 155.267 239.125L254.435 202.009C254.435 202.009 257.642 201.086 257.632 198.638C257.632 198.561 257.613 198.499 257.603 198.427Z", fill: "#E95571" }), /* @__PURE__ */ C.createElement("path", { d: "M253.367 189.632L192.508 172.543L81.9731 173.236C81.9731 173.236 25.345 189.195 19.3105 192.512C18.1421 192.926 17.3198 193.917 17.3198 195.066C17.3198 195.085 17.3246 195.104 17.3246 195.128C17.3102 195.484 17.4064 195.811 17.5554 196.1C17.8103 196.648 18.2671 197.104 18.8441 197.417C18.9162 197.46 18.9643 197.489 18.9643 197.489L19.0076 197.504C19.2624 197.624 19.5413 197.71 19.8346 197.768L130.6 233.364C130.6 233.364 135.74 234.985 142.842 234.913H143.025C150.127 234.985 155.267 233.364 155.267 233.364L254.435 196.249C254.435 196.249 257.642 195.325 257.632 192.878C257.623 190.781 253.367 189.632 253.367 189.632Z", fill: "#BB435A" }), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M198.5 195.5L77.2271 199.004L86.8246 219.723L130.071 233.619C130.071 233.619 135.211 235.24 142.313 235.168H142.496C149.598 235.24 154.738 233.619 154.738 233.619L195.018 218.545L198.5 195.5Z", fill: "url(#paint0_linear_1182_498)" })), /* @__PURE__ */ C.createElement("path", { d: "M141.919 217.261C203.35 215.597 198.725 194.215 198.725 194.215L147.078 5.47673C147.078 5.47673 145.121 0.0673171 137.75 0H137.495C130.124 0.0721255 128.167 5.47673 128.167 5.47673L76.5202 194.215C76.5202 194.215 71.6878 216.554 137.495 217.343L141.919 217.261Z", fill: "#E95571" }), /* @__PURE__ */ C.createElement("path", { d: "M98.009 115.694L86.5459 157.58C119.276 170.918 155.974 170.918 188.704 157.58L177.241 115.694C152.175 127.59 123.07 127.59 98.009 115.694Z", fill: "#F7BBC5" }), /* @__PURE__ */ C.createElement("path", { d: "M118.43 41.0634L107.082 82.5355C126.974 88.5075 148.275 88.5075 168.167 82.5355L156.82 41.0634C144.352 45.0399 130.893 45.0399 118.43 41.0634Z", fill: "#F7BBC5" }), /* @__PURE__ */ C.createElement("path", { opacity: 0.25, d: "M116.069 216.131L134.144 6.74609L91.6763 210.698C97.4078 212.972 105.279 214.934 116.069 216.131Z", fill: "url(#paint1_linear_1182_498)" }), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "multiply"
} }, /* @__PURE__ */ C.createElement("path", { d: "M141.919 217.261C203.35 215.597 198.725 194.215 198.725 194.215L147.078 5.47673C147.078 5.47673 145.121 0.0673171 137.75 0H137.495C130.124 0.0721255 128.167 5.47673 128.167 5.47673L76.5202 194.215C76.5202 194.215 71.6878 216.554 137.495 217.343L141.919 217.261Z", fill: "url(#paint2_linear_1182_498)" })), /* @__PURE__ */ C.createElement("g", { style: {
  mixBlendMode: "overlay"
}, opacity: 0.6 }, /* @__PURE__ */ C.createElement("path", { d: "M137.625 6.00084C141.508 6.00084 144.655 4.65751 144.655 3.00042C144.655 1.34333 141.508 0 137.625 0C133.743 0 130.595 1.34333 130.595 3.00042C130.595 4.65751 133.743 6.00084 137.625 6.00084Z", fill: "url(#paint3_radial_1182_498)" })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("pattern", { id: "pattern0", patternContentUnits: "objectBoundingBox", width: 1, height: 1 }, /* @__PURE__ */ C.createElement("use", { xlinkHref: "#image0_1182_498", transform: "scale(0.00041876 0.00118203)" })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint0_linear_1182_498", x1: 137.681, y1: 223.895, x2: 137.681, y2: 194.781, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { offset: 132275e-8, stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.2433, stopColor: "#B5B5B5", stopOpacity: 0.2423 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5166, stopColor: "#686868", stopOpacity: 0.5159 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.7429, stopColor: "#303030", stopOpacity: 0.7425 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.9101, stopColor: "#0D0D0D", stopOpacity: 0.91 }), /* @__PURE__ */ C.createElement("stop", { offset: 1 })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint1_linear_1182_498", x1: 136.879, y1: 9.81465, x2: 101.516, y2: 227.958, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { offset: 132275e-8, stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.996, stopColor: "white" })), /* @__PURE__ */ C.createElement("linearGradient", { id: "paint2_linear_1182_498", x1: 142.889, y1: 109.761, x2: 185.069, y2: 99.5354, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "white", stopOpacity: 0 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.0848, stopColor: "#F6F6F6", stopOpacity: 0.0849 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.2224, stopColor: "#DEDEDE", stopOpacity: 0.2228 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.3958, stopColor: "#B7B7B7", stopOpacity: 0.3965 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.5982, stopColor: "#808080", stopOpacity: 0.5993 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.8221, stopColor: "#3B3B3B", stopOpacity: 0.8235 }), /* @__PURE__ */ C.createElement("stop", { offset: 0.9982 })), /* @__PURE__ */ C.createElement("radialGradient", { id: "paint3_radial_1182_498", cx: 0, cy: 0, r: 1, gradientUnits: "userSpaceOnUse", gradientTransform: "translate(137.623 3.00143) scale(6.73777 6.73777)" }, /* @__PURE__ */ C.createElement("stop", { stopColor: "white", stopOpacity: 0.9809 }), /* @__PURE__ */ C.createElement("stop", { offset: 1, stopColor: "white", stopOpacity: 0 })), /* @__PURE__ */ C.createElement("image", { id: "image0_1182_498", width: 2388, height: 846, xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACVQAAANOCAYAAAD0gxUkAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAABgfxJREFUeNrs3WuT8yystulO1fz/v+ypqZln3nv1SicGJBD4OL/EAeENYDadq6WfHwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYn5cqAAAAAAAAAABsgL9nY0cuVQAAAADYgAIAAAAAAAA4F39PBIB1EGcBAAAAk/AHEAAAAAAAgH3wtxwAANACERYAAADQgT/CAQAAAABgLw0AAAAQXwEAAAD/H/4IDAAAAMBeBgAAAABwB6IrAAAAPAI/QgAAAADW9gAAAAAAjEJsBQAAgGPwowsAAABgPQ4AAAAAQCbEVgAAANgKP+AAAAAA1tYAAAAAAKyC2AoAAADl8KMPAAAAYL0MAAAAAEA1CK0AAACwDD8QAQAAwFoYAAAAAADsAJEVAAAApuBHJAAAAFjrAgAAAACAXSGyAgAAQDh+ZAIAAIA1LQAAAAAAOAkiKwAAAAzhxycAAABYtwIAAAAAdtmzEcpA3wEAAMBRmxwAAADA+hQAAACwlgaeCDGPdgEAAIBNNgAAAGAtCgAArG0AAAiE+EcdAwAAYBL+0AMAAABrTgCAOQcAAOBMCITUHwAAADrwh0YAAABYXwIwDgAAAADPhnBIXQEAAOAf/KEbAAAA1pPQXwAAAAAAnyAiUjcAAACPwg8aAAAAsHbULgAAAAAAjEBUpC4AAACOwo8vAAAAsFZUvwAAAAAAZEBcpA4AAAC2xI84AAAAsC5UhwAAAID1MxALEY068twAAAA2rQAAALAOVFcAAADWOQCABC7P6nkBAAAwF380AQAAsO5TNwAAmIMAAMA5XJ7JcwIAAGAMf7gDAACwzlMXAIwRAAAAwDO53LtnBAAAwP/GH44BAACs6zw/tCcAAAAA4B2X+/V8AAAAT8QPFQAAANZxnlsdAQAAANa9wBiX53aPng0AAMCmEwAAANZtntfzAgAAa1QAQA6X+1e3ngsAAGAd/ugBAABgreY5PQ8AwJwDAAD253Kfx9fd058JAABgGv7wBgAAYG3mGbUPAGMDAAAAnsXlfra6H88DAAAwGX/4BQAAsBbzfNbG+hwAAACsC4F2Ls/mPrQvAACAjSUAAACsv3Z+rpc+BwAAYA0CABtwucfy9UNgBQAAcDj+sAEAAGC9ddJzvdQtAADmEwAAHsj18Hu51L9nAQAAiMQf1wAAAKyvdnwmHrEAGD8BAIC1A6K4POuR1770Kc8CAABggwYAAGBNdeLzEHNBuwEAAGsGACdzuadp1yOw8hwAAAC38QcCAAAAa6iX+3jE+tjaHwBgvgIA4Cyug697qUN9EAAAYCX+SAUAAPC8ddPThUvCBQKAMQgAAHMw/uXyjFtc5zq4LxBYAQAA2KABAABYJz3sWV4Pbz9rbug3AACYgwHgL64H3cvlnrfrE54DAAA8Fn8gAAAAOG9t9CTvTy99xbMCAMw7AAA8lOuQ610b1QuBlecAAAAPwR+pAACAtZDn2OHaL/3C2h2A8QYAAHMXinG517Tz7yKyIrB67jMAAAAbTQAAAOsfzzDtuq/D+4D1N/QVAIC5CwDwievAa18F7+8UgRXvVQAAAEn4QwcAALDe8Qyrrvs6pM5e3iEAgPEaAGAs3xbeftZd5yp0TwRW3kkAAAAbNAAAYI3jGaZf8+We9WvA/AMAMJYDwP/gpHBxlYRN1wPqqXIf8wwAAOAI/IEAAABY0zz3GXYSI73UOdQ3ABi7AQDG2QAuzzL1vJdzlOmPwgMCAADYPAEAAOsY9z/xmpXFUy990fofgLECAIyzAIqxu2eqCuKk64BnWN0veK8CAACweQcAANYtj3yG6gKq14Oe1Vod2h8AjLEAYAysARFJ7nmvhde/Nn72Cn3VuwEAAGDzBAAArFWOvP/KoqJX0Wd86cv2DACMLQBgDAQwmV3DvF0PKnsVbGPhAZ/3DAAAwOYdAADgmLXJa/NrVRI+vYq3ycs7AuMVABj/AMBYdQTXw+93pXem08tVbrOT35FTnwEAANiUAQAA6xH3P+laFYRPQgjq8wDM/wBgrALwRK5NrrGLh6ir+P1ltj3vVc97BgAA4I8CAADA+uPRz1AxxN1r4+tn1CtPVTCWAYBxCoAxB8/gOvReThVMEVg977148jMAAACbRAAAYM1x9P0TUMXd+6tw27+8DwC88wBgzAGAf7gKn/sk0dRV+Nmz+gNx1fOeAQAABOCPFAAAwBpj7TNUC+On7B793jremAoAxhsAxgWgNtdm13mqaGoHgRXvVc94lwEAgA0xAACwrnj8/VfyQrWi7C7lqraZdxswnwIwJgDwzmIO12H3MFvUU0XYRGBVp58TWAEAABs8AABgLeH+066zk4DqNfEeX4vb5+WdM74BMB4A8M4CQCNXsXNW8zi12vZpAiviquc9AwAA+AN/YAAAAE9aO+zqheq1oPwscVJ1kVbF9vROw/wDwPsKwDsN1Ocqfv4Zwp+dxFCVBFa8V3nvAQCADTEAALBeOOb+d/dCNaNMVbFVRPu9vIOeDfBuAfA+A95ZVXAc1yHXv4qVWWW3+toz2yKjDxNXPe8ZAACwwQMAADhoffBEL1QVBVTEVuv6pjW+sRSA9xnwzgJ40rtFeDF+ruwykeKk6qKtygIr3quMVQAA4JBNEAAAsCaodv87C6h6yr02s+2tm1eBPvEyDgD6J+B9BeDdAo7kKnjuq4D99YBztdYd71X1ruUZAACwEQcAANYA7n/Ctap7oXolnJfQyntrPwJ4twDvFQDvGU7nKn7+TAFVtO2ONhl2ve1OYGUMAQAANqkAAOBh8z4vVPFlVgqoVp9zpH1exfuyNb4xF/BeAfCeAd4LxLKbOCRTiLOrgKqiwKqCp7BZff468F31HAAA2AwCAADz/PH3X0FEtaOAqrrdrHqN6kOvB71zMDYD8I4B3g1AP6/EdcD1K3ihirK7DjpHxrl6+wzvVcYnAABgkwYAgLnd/U+7TmUvVJUFTzuJrF6b9zNjEKAfA94LQF8Hnt7Hr0PvJ1tUc5qHqavAPbS0QVWB1bXx+0lgBQAAbKAAADCfu/fEa1X1QrW7MGqFEGuW/Yw+/6S1vX0MzPeAfg7o58Dz+vbuIoLVHn4qCqlOz59tM6t/VOvbTx1TTnkGAABs4AEAgPl78v3v6oUqw76i6Gm2wCq6HqL72+uQ984YDOjjgD4O6NMA/jc8Ut3PXymCIrCK6bMEVvuPNQAAwIYbAABz9mH3/ipwngpeqKoJqGadI8NuRpuufnfsCYz5gD4O6M+A/gzkcYqYaqWQapVIahcPV9FtHdmHiav2H3sAALBJBgAA5ugN7/8JXqieKI6qKBob6SevjccE+wXzDKA/A/oyoJ8C/RBTrcmreM0Z9ZzR9tH9msBq//EIAAAbYAAAYF4ueu8VRFSZoprdBFSr82efZ1Y/2GW8sJ+AvgB9GdBPoQ8CeA8xVX9eJXHWKvHVbJtZ/S3jHYk+V6VreQYAAGx+AQAwD7v/KdfZ2QvVEwRUVbxfZbRf1X5tjIO+A+ij0A8B/Q/IYZWg6lQx1cmirRltkWkX1e8JrPYfrwAAsPkFAACPnHt5oYorMzOk3UoB1KvofUe31Yw+c+LYYi8C/Qf6IKAPQt8DTqa6oOoEMdWugq0Z+ZE2I326gveqjPOtvo7nAADABhgAAHPtQ+6fF6o4mx0FVJWFVxntnNX/iapgjgX0P+h/gD4H1OJacI5ZQpuqYqqVYq3e841cb4VNZt/MfJcyzlXpWp4BAACbYQAAzK+H3D8vVHNsqomgXsWeI7IdZvSrE8cfexLoO9D3AP0O+hP0pR52+ZH/mlw+Wyz1LX8XMdVKb1gjeRH5kTYj/fxp3qt2GrdOfwYAAGyeAQAwp5a6d16o4mxOEEntJMjK6gtZ7whRFcy7gD4H/Qn6EaD//B+uA+4hWtiSJdjZWUxFYDW/H0a9I7xXPXt8BQDAxgkAAHPolvfPC9WzBFSRZZ4oqnqqoMqeBPoK9CfoQ9CHAH1nFTuJJ65Au9mCqh3FVCtDB2aGBzzde1X0e01g9bxnAADA5gsAgIfNm7xQxdhH2a0K4zdLQJWdnpUX0TYz+uFJY5X9iHkV0Ieg/0D/gX6DilxFzx0lqqosqKoqpqoqsOK9at67TFz1vGcAANjEAQCAQ+dJXqhiylTwQnWSgOoEUVVlQdUO45Y9iLkS0H+g70Dfgf6CHbmKnK+CqGrHcHy7CawywgPO8F6WZRf1LhJYnTOGAgBgUwgAgLmx5L1X8KSz0gvVjmH8sgVUJ4mqdhVUVRu/7DXMHdB3AP0G+gz0BZzOtegcM0RV1QVV1cRU1cIdjrbx3X62c3jAq+B4UOk6ngEAYCOqCgAAIKKafB1eqObkrRBQ7SSqqiao2llMZU+h7qHfQH+B/gBtC32gIteG180IhVbVE9Vf6SenRdj2ttloX4jqby39nPeq2mOdZwAA2CgBAGD+e+z980I1bpMhsKoUqm8HUdUqQdWJYip7B3UJ/QX6ArQt9APoB0/gKnLOSK8+s0RVKwVVBFbz8u72T96rcseVCtfyDAAAGzQAAMx5j7h3XqjO8UK1WkC1QlRVSVA1S0z12mQ8MIdAX4C2hT4AfQHaHSexIszfTiH+VoXnI7rqO09E37nbR1cLrHiveu6YCwCAjSIAAAfNcbxQxdjP8DQ00wvVTgKqLFHVakFVBTHVq+g4YNyHNoQ+AP0A2l5bQZtW4troetEikpkei6qIj4iu1veFqD6a9V6semcrjVUEVgAA2CgBAMxr7n3CdXihmpM3U5hUTVRVTVC1Ukz1KjgG2IuYS6EfQLtDW0G7Qj84kdWhvq5Au1lejCqE6euxqSCwqhIeMMu7WURf7XmXeK+qdS3PAACwQQMAwFxW8t53FFFFC1NWeJn6lv8UAdVKkdaM9NY++yr6ztlXmN+g3aGttCmgL2h34B7X5PIRQpNIYdWI2CdTwBQhqKooAhtN60nPyovor5l2Ue85gdW+4zMAADaKAABz1+H3zgtVTS9UrWVOFktVDCXY23aRfXLG+2Of4Pm1E7Qp9ANoe2gr7fc0dgj9V9Ur1QxR1cpwfisFVsIDxvTpnveO96p646ZnAADYPAEA8MD5iogqxr6yF6oVYfx2F0tVCy3Ykx6VP+P92WlctT/RBtAPoN2hrbQftC8qci04R5Z46lNeVqi5GUKmGYKq1WKqa0LbjPSTO/22msCK96p61/IMAAAbPAAADp6fdhNRvSaWfaoXqllh/HYRS+0eLnC0//S8P9VD/9lXqFNod20FbQdtDO2lLSpSXXBwgmeqKHHQDoKp0z1a9aRn5UX0+553c6bA6iowBlUfVz0HAMAmCQCAH16oZl+HF6q2/J28UK0WUGXeYxUx1Swh1WvDMcKcBO0EbQftq82gHaA9T+OaXD5CIFJRQPUu7enfe+tppFzL+SLTR/pt5LvR8k7yXlXvWp4BAGBjBwAwD7n38OvwQhWXt0MYv5UCqtVerF6T2zKiH/a8a0L+QV1D+2ovaAdoU+0EbfGdyh5bZninahW37OCZquX7CQKrKh6tIvvZaN7oe9H77vJeVe9angEAYJMEADDvPOjed/RC1VKmsheqT3krRVTVwvO9Jpwz02ZWekRfnfVe2kuoH2gv7QDtqa2gHaAt8TczPVRV8U61s2eqqoKriHrpPU9GWmT6SL+OfHcy3teosYT3qn3nAACAzR0AAEfONbxQjdvzQhWTVsnj1GvBNaPKZLf5aF/teR8rjB/mFPM2tCe0k3aA9oS20QaV2d1L1YiQhIiqjsCqUnhA3qv29l4VPa4RWD3vGQAANk8AAPNL2XvnhWrcZmcvVKvLVf+edY6WtMj00f468921p1A/2gnaAdpS20A7QPvhb2Z5qsry1DMijtk9vN8MMdbMc2XbjKZFpt/J572qzjhX9VqeAQBg8wcAMJ8UvvcdRVS8UH1Pf6LHqRMEWa3tEJke/d5EjjG8VEH9aktoG20AbQj1q22eykpBwqiQY6aHqhnCqqiyGeVWhSLsuXZm+0X0rZ7zjObdtbmC33Xeq+pdyzMAAGzAAADmkMX3LpTfuM2uIqqVHqd+p60UOFUUV7WkRdhGvzO9Y0LmuGdPoW60DbSB9oP61T7QPuqyElfx61QP8/cuvXJIv0+2EZ6pVoQTXOW9KrJca1/s7dcjeVHvY+t4cBUbb04aX584FwEAbIoAAOaMLe79ZC9Ud2x5ocqxuVNulaipsrgqsr6j0yPfqajxZ4cx3t5FnUL7qV9oG22kHqGNsIJZnmJmiaj+Ss8KKbdCdFTBLuvZIr5ntnfrNSPTR9+ju+9spMCK96p61/IMAACbPgDA8fMEL1Tj9rxQfU5babNKyJSRN+N7r02UbcS7MDJWZI2H9hLqQd1qG2gf9QjtpF6hbU5glcAg01NVdSFVhnDqU96KMlnPPGKb3eajaT3pWXlR72jGuBA1hu3qvWr2tTwDANiAAQBwxNzw2uwar4nlZoqoZguo/srbyQtVq80sQRVxVX+fyn5XIsel1eO+PYl60z5Qj9oI6lX7QPuoy0iqhqSK8ljTKhAZEVedKqTKOlev3SzbzHbPSItMH3237r7DqwVWvFeZtwAANkUAAHPB1Hs/OZQfL1Sf06p6oVphO1tMVV1INVtclTkOnL5nsOdRf9oI6lXbQBupR2gjjJLtAWZUhBHtkepd2qzQfpkh+qqKrVryIm3vlM+0aUnrSc/Ki3hne8YW3qvqXcszAIBNHwDA+P/Ie18tROCF6n7eKzmtQti+399ne5laeY4Z33ttetNH8maNE/YWnl+dQttoH/UI7aTeoF2exrXgPFkeczKFVL/TThdSVQsdOMs222Y0LTL9Tj7vVfXG2mrX8gwAYJMGADDmH3vfvFCN2/BC1W4zWyT1yTZTJLVLeMCMtNF3p3VsGBnLVs0T9iTqTftAPWoj9QZto26hjmey2vNKhKgiQkiyMrzfLDHSiWKrlrwR26g+El0uwjYzL+odz7KLGgsJrM6ZwwAANlkAYIx376nXmSlgqCSi6hWB8EL1/vtsr1Of8l5J5XvtRmwz27unn8/2TCXsnz2P+tNGUG/aBepWPWsDPLXermLnriqkepfWatMr6jlBMDVbeBVV9yPnGbGJLBf1TmTmRb37reMO71W1ruUZAMBGCQBgXC9/7yd7obpjywvVGptsz1Kf8lYLqGaKwDK+j6aNvDNR7+zMsfbJewv7KvWmXaBu1TG0gzrTLupqHqt+QL6Sy0WLOaLELTO8VDmOqbuo9oj43tvfRs7datt6ntG8FTa9YxeB1Z4QWAGATSEA4JCxnBeqcfsnhPJ7kheqiFB9d+2yhFKnhgYcTRt5j1rHkFliT/sQ9aNuoY61gTqDtlE/0CZPYIaoYMS7DTFV33Gl60eeP6pNRq4x0t8iz936fvS+ayN5d8eJ1d6rRsbC1SFWq1/HcwCADR4AwNg9/d5Xi6heiWWyBVLf8it7oXqXtpMXqsqh+qoKqzLDBI70l570qPc7eiysNOfYu6grbaDOoF3UEbSJelL/mME1sTwx1fjxTmKr2d6rZuTd+T7bpuU9iEwffafvjh+8V8Wfq9K1PAMA2LgBAB40XgvlN2bPC9V42i5eqFaE8at2HF0m43tLWk965HtfbZw0j6onaBf1o02gnrSBuoN6rsw1+RzEVOPHM8rt7BFrRt432zvlM21a0nrSs/Lujie8V+Wdr8q1PAMA2JQBAA4ao4XyG7fnhaotbYWoimhqzXGEXVb/iE6PHjOyx+nT9xX2TepHm6gnqH91p66hPtXluVwLzkNMNX4caVtNxNVaruf8UXkjttk2o2mR6aPv/d0xZrXAiveqZ8+DAGDjBQAwJi+6d16oxm12EFGtFFVVFVS1CogqiaBWhiMcaYuRvhj5zmSMJbPH7yfvN+y11JP6V3dQz+pTfUI9q6/arPrxnphq/HjUdqYAK/K+R48j7CJt73zPtGlJ60nPyrs75uzsvWrlGL3TtTwDANhgAYBx+MH3zQvVmM2svKpeqO7YnOyF6rXpuUePo/Ki+/Douxc9vqyek+xD1IW6U8/qE+pSPaszqG/1sxJiKmKqlnNW9ZaVddySl3WebJvRtMj0kfe/ZRzivSr+XJWu5RkAwIYKAIy9D7jv1SKqTA8vEWKJU0P58UIVe1zlfERVse9p6xi1g7DKHkWdqE91CfWsvtS5+oG6VxezIaZ6n5YhktlVTJXh9Wr0/BG2EW2X1Vd6vvfajJSLsM3MixhvMu2ixmICqzPmUACwkQIACOU38RpC+d3PiyrDC9XnvChxVeVyVQVWUXkZfb/3HewZs2Z66DOnqhP1DPWlvtUP1L96UP/qoTpVxVTfbCp5p5opoPrreLaYaoVXq0qerFbn9fbr7HKt72bvez6SFzH+ZI15UeMzcdUZcyoA2EQBgPHVfQdf59RQfrxQjdmc7IWqgpgqOz/yOCpvpN/3vGMR40TkmLvDnGZfo07Ut/qBulcP2kAdQP2rh29cC8/3BO9UTxdTVRdVzfJYVdl7VW+5jHew59wR48ndsStSYMV7Vb1reQYAsIECAGNqsfveLZTfCV6oPuXxQhWXt8ILVaVzEVX1p428263jWsQYvNs8Z6+jPtS9eoD6VwfaQB1A/auDfyGoGv+eLa5aGdIvIm2WaGpFSMDK3qtW27Sk9aRn5d0dx3ivyjvf6ut4DgCwgQIAY+iiexfKLy+fF6r//f1JXqiyxVRRZXYRVY2I9SLSRt731nHuiaIq+x/Pr/7VAdS/OtAG6gDqXh38B0FV+/dV3qkyRUirxVQniqqqe6/KtBlNi0wfHWvujmurBVa8V5mDAcAGCgCMm1ve925eqFrKRIgaeKEas9nVC9VO4fZmpPXWTeRxS15kH+9Jjxp/IsdpoirPD/WvDtS/OoD6VwfqXR3sCEFV+/dK3qkqC6FWebJaGRKwSqjAiO+ZNi1pPelZeXfHON6r8s5X5VqeAYBNFADgyLGSF6ox+xmh/GblzRBWrRBV7eaFaoXnqJ5zPkVUNSqiivRcNfLO94yFRFX2QfaB6l8dqHt1AHWvDtS7Ongqq7yT7CKomuGtqoKwaoU4amYIwsj8rOOovBHbbJvRtMj00XHo7pjHe1X8uSpdyzMAsJECAGw9Pu4konpNLCuU3+f0KGFItheq39+f5IVqJ7FU1DNFlxuxi+rfvekRY0+1cdxc7/nVvTqAelcH6l4dQL2rg1VcC85zmqBqdri/lSKnCtfpSZuZf/c4wi7S9s73TJuI97t3/BjJuzv+7ey9KnKuiD5XpWt5BgA2UwBgPHTfP/uF8qvkhepb/iu5zOpQfpFeqD7l7eKFqoKYiveq/v5b2UsVQZW9kOdX7+oA6l0dqHt1AHWuDu5zTT4HQdXn46oiqh1FW9llso577XrPeed7ps1oWmT6yDjUMh7yXhV/rkrX8hwAbKoAwBj4mPsWyi8vv4oXqndps0RVKwVVu3mhGjnPClHVCiFVJS9VBFXmU88O9a4O1Ls6gHpXB+pYfezDTFEVQdX/Pr6bX0G4tPq6I/WSUSbCtre/RfXhiO+9NiPlWm1bzzOaFzHmZdpFzQEEVnvP3QBggwUAh417Twjl90osEyFEqCyiWu2F6o5NhGjqU96JXqiyBU67eLtqyR89bsnrfTd63vuocazKeG894NnVuzqAOlcH6ll9QJ2qmypUEVU9RVAV7alqhkDqBKHVSB1HtOvo8eq83ncru1zr+JAxDt0ZA08PDxgt8JklGOK9CgBsuACAgGrSdZ4Yyo8XqrjvmeH6WstU8UI1Szi1g9eriLaK6C8931vSRsaV1vE0YuwnpvLsUOfqQB2rD/UKdaP+1NcpzBJV9YoOCKpi8qJtdhNaRaVFtm1En5uR1/O99328a9Nyzcj0kbEscrxsGbt5r6p3Lc8BwAYMAIxtJe9bKL+8fF6oeKH6ll9VONV7D6u9WUXYjtj1vjc9Y0LE+BU5F5hnPTvUsfpQp+pGHaovqCP1eCLXhPKRYblOEVStElZl21YMSxiVFpk/erw6r4JNS1pPelZexLjZM37zXlXvWp4DgE0ZABjPlt03L1RjNpFCqb/yZgirMkRVJwiqdvRCtUpwNcvTVU/aiG2vXe97FTl2ZI2dp8y3T9/r2OupU3Wj/tSXOoK6VB/qFn1keiaJ9FJFUDVfAFVdaDXTe1VkftbxjLw73zNtRtMi0zPHwAyb3jGf96pnzu8AbNQAwBh20D0TUeXkVwnlt1JUlS2a+pQ32yNVZS9Uq4VTKz1lReb/DNhFvpuj40/0OLrrvEtABfWnvtSRelQfUL+eXV0jilWiqlFhw2mCqpXeqFaVHT1PZN63tNEyvbYR/TYqL+J7pk1LWk96Vt7dcXhn71WjZTPPVelangOADRwAHD5mCeU3Zh8hIhDKL64ML1RxaatFVS02q0RWPWmttr39sfd9iho7MsbT3eZgAiqoI/WoPtStZ4f69szq/FnPvuKHz6wwT1GiqlEB1bfvpwmqIsvOvo9Rm97y39Iyysw4jsobsc22GU2LTB8Z+1rGY96r5s+Xp4mSiKwA2NgBME4dct+8UPXb7OCF6l3aLFHVk7xQfcuvHr5vpXCqqsiq1fbueXq+t6T1pEePm5XnYuIpqA9169nVtWeGeve86twz/8VV8BoEVXuE98sUWFUSXGWUH23jlvxe297+3ZI3Ynvne6/NSLkI28y8iHE20y5qfiKwes4aA4ANEAAcPzYJ5Tdmf3oov9VeqO7YRHuQ6s17oheqFZ6mZpXptblrH5Hf2997372WtNG82WO+PYrn9+zq2jPjyXWuj6l3z6vOPW8driLnXSWqarUhqFp77lPCBI60c+85I4977XrPGfHuzijXOh71jm0jeXfHZ96rcufI1dfyTABskAAYjx54z68C53laKL/WMid6ofr9fXVYvyd4oYoSVUWUmVW2Na8n7U5+b1/tfTcjxpLIcbLCvPzUPQlBC9S551XnnhfqXR9T3557DtfC8/WKAFZ6qdpVULVS/LTiHmbYtOZFpbXk99q2vAcz8nq+977/d21Grjkyzo2MnS3jdKTAiveqetf68VwAbJ4AGH/OvG9eqHLyq4Ty28EL1ae8KmH9KgqnPuVVCM0XWTZb7BWVdie/t79nvrsReb3zwE7znLWD54U+BnXuWdW5Z4Z69vytXAvOs0JUlSGo+iuPoEqYwIy0yPzR49V5d9/73nK8V633XjUyP60UDe90rV3XGwBsrAAYc9z3DxFVVv7OofwihBkrBVUj4qpR2529UEWKnSLOUcl7VU/anfzefhz1HveMRxFj58z57il7DoIDqHPPqr49M9S151ef6mUvronniBQKRAgkskIAElSt/YyyzSjfkxaZf8e29Tyz8nre8Uib0bTI9DvjLu9VtebJitfafe0BwIYLgHHm+Ht+FThXhohqhs0OXqjepc0SVUWIpj7lVfdC9S5/dy9UMwRS1bxZRaW15LfmZb3DI+NT5vhun0HQAvXtmdWz54c6VS/qSf2dzIwfryNDYkUIJyJFJVkeiwiqcj5H6y8y71vaaJle27vHM/K+2UaNCb02LWk96Vl5d8dv3qvyzlflWruvQwDYiAEwrhxx37xQ5eTv7IXqjk1rmV0EVbPC+53uhaqi96qsUIY9aa19rtcucgzIGvdmzH+77y2ETYN69vzqU72oJ6hD9aBukf2jdZSoKjrsH0HV/c+neq1aGSYwo8yM46i8Edtsm9G0yPQ7Y/EJAqsneq9acb0T1iYAbNIAGEvK3/dTRVTZIqsoAUIFL1R3bGZ7ofqUV9UL1bu0Hb1QVRBbEVS120WOB73jX+aYf8oa4Kl7H3s+9ale1JP6UxdQt55dPaOdLGFVJS9VGSKqf4/v5u8iqBIucH75lvyZIQMj3qWWvBHbiLFixKYlrSc9K+/uPLCz96rRspnnqnStU9crAGzgABg/lt3ziSIqofzW20R7kIo4RxXh1Lu0Kl6oThZIZT57ZlrG+9PzPXL8ah3/TxZS+REU6kn9qQd169mhrj2z+j77uXfwiDFLVJXppeqOeCPTW9WIOKqnTHUh1UqvVZXCBI70qd78rOOWvKzzZNuMpkWmj4y/LfMB71Vr5muiIvUD2NwBMF4Uvm+h/HLydw7ll+2F6vf36l6o/j1eLaY60QsVQVV/38p4l3rHgKxxMXLOqrIWEEIN6kHdenb17JmhzvUx9e55/+UqeP5VoqpVYf8Iqs7ydhVtG5kXldaS32vb+15FvasR33ttRsq12raeZzQvYpzPtIuaH4UHfB7qDbDpA/CQMYKIqt9eKL/3aRVEVTsIqmZ7oXqXxgtV++fOgqqIMH8rvFX1jHcrxVQr1gNEU54d6tkzq2/PC3Wvn6lzz9vLVeS80T/kZ3ipygj7FxHq75M9IVXMtSKuM2rTWz4zLcK253h1Xu94kl2udUzMGHvvjP+nhwfc2XvViuudjvqETRIA44L7Tr2GUH5jeVW8UN2xaS2zKlzfHbtsYdVsMdUsL1S95zhJYBVdpict8jjje2965Di+ck0gJIpnhvr2vOrds0K962fq3HNnsfJH4BleqlaE/RPqb+65TvVelVE+Kq0lv9c2yi4qr+d77xh016blmpHpo+P33bkiUmDFe1X9az4NdQwbJwDGgQfct1B+OflVRVSzRFUVBVWVw/fdTdtBVLWbl6knCKqyPb+NjlO9Y+PoHJQ9x/ph1LNCvXtWde558fR619fUszpYw4ofgHt/dK8Q9u8vu0xB1bu02UKq/z4JqcY+R9us1yYqLTJ/9Hh1XgWblrSe9Ky8u/MF71V556t6Tah32FAB8O5ved9C+eWc47Ug/VXIZlW4vrt2GR6pdgnpt8IL1S7CqlMFVVXD/WV4p8qaU+w5nr2vsodU555XnXtmqGt1oF7Vye5ck88T+SN95bB/I+KqaO9HOwuqdgstmNFuozZRaZH5Wccz8u58z7QZTYtMvzP2nyCwquK9KuN8Va8JbQCbLADe9bL3LpRfn82pofyyvVD9/p4pqMryQvUtv5IXqjs2Vb1QEVa15/Xm976X32x7x5jRcTZrbnn6PoNoCurcM6tndQB1q07Uobo6i2vSOap7qcoIAZjpmarFdidB1RO8Wc2wac37ljZaptc24j2Nyov4nmnTktaTnpUXNYe0zmfCA+53bWgH2HQB8G5Pv//XwnMI5fc5PVpYVUFUleld6q5dhnDqXX5FL1R3bKLPUUVgxVNV7HFL3si41ZveM89EzrnWH54Z6lkdqFd1oh7VFdSVOtyRGT8Uz/ZSlRH2b7Wg6o7N0wRV1Z53tL1GbXrLf0vLKDPjOCpvxDbbZjQtMn10vL87p/BelXe+3a4P7QCbMAAPeZ95oeq3XxnKb1WIv1Vh+r7ZVArXN3Ic7aWqiheqOzYnep+qFkbwJ7DMaL8dPY74Hj3Gts43K8XF1kyeW72qE6hDdaW+1KH6gfqsRPYPxJFeqiJEVqPebqLEVZUFVf99ZpfdKZRgxmeUbUb5nj6dld/znvbaRdre+d5rM1IuwjYzb3TuyLabOX+uPN+u9wDtAJsyAD+8QMy8hlB+Y3kzQvnNElXtLqiaHd5vVEz1JC9UlYVVWcKyKNvIPp71nkek3R3jI70a7rwOefo+xz5PHaordaUO1Q/UqTpRv2jnSi7X88P6DmH/or1VVRFS/fe5u6BqZd1EXm/0OhF5I/26Nz/yuNeu95x3vvfaRJaLGoMz8+7ONcID5p5v9/uwzgNs0ADvq2fYSkS1eyi/1jLZofxWiKoyBVWtZbKFVRlh+z7lPdUL1ZMEVVH9oCct+j2MHJN6x93oeWWn9Yg9jTpQV+pQ/ahP9QL1qz7UM6LIFFXN9lI1S1D173GkoOpT3i7CqpXiqJ29WEXbRuZFpbXk99r2vttR40XE997x7q7NyDV7zz06J0TOOy3z3u7iqqxznnQ/1nyAjRrg/TzwGYTyiz9HVS9U79Jme6H6/X2WoKpK+L67aVkiqBbbaLHVbIFVtG1lQdVofxnt8z3HEd9b0kbzoubNKmsTexh1oH7UpzpRv+oD6lpdqGtk8VRB1e/vEce7e6b6/bmLoOqkcIArxVQzRFWzhFTRIQBXeq/qLcd7Fe9Vs875hHuzBoQNGwDvYvFnEcqvz+YpofwyvVB9ypsd1i9DWDVbTDVbVLWTFyqCqnbbiPcj4t2NHgfvzgFR80jFdYo9izpQJ+pXfahndQH1rS7UOWaySlQ1+qN9q6igqqDqU95uwqoTzpdRtuczukxG+ai0TNued3pGXsSYNmIzmhaZfmc+IbDKE7/sIKoh/FHHsGEDvHeeKe0ap4modg/lV0VUtUpQleWF6lt+tphqN+9Tvz8reaFaKahaJVTrtRl9L6LGhZGxLXJsjpoDV61b7FPUgfpQz+pCXasLqHd1ob6xCmH/7tlVFFT9lfcEQdVTwgFme62q4r2qJb/XdnQMiMz7ZnunfKZNS1pPelZe1NzUOjfOFldFlJ993orrGKhT2LQB3rHNnmuliEoov/b0nUP57SCoiso/NaRfNW9UBFW5wqqotIh3OmoM6x2no+aOCmsZexP1oC7UtbpQ5+oC6lx9qHOs5kouF/mDeaag6lNetLgqywNRtjjoKYKq1WETo/vBDJuotMj8rOOovBHbbJvRtMj0O/MNgVW++OUEcQ2BkLqDDRvgfdrw+U70QnXHTii/ezaZofyiBVWtZTLC990tM8ML1R2b2SKrXYRVBFUx/TbyOOJ7S9qMeWT12saeRD2oC3WuLtQ31Id6Vx/qHFWoKKga8Vp1mqDqjs0soc+Ogqqne7GaYdOaN/oeRebfPY6wi7S98z3TpiWtJz0r7+7cFTG/Rcy1lQVWs66xy5rIuhE2awAe8+4QUfXZC+W3TlRVUVC1wgvV3bRRMdUsUdWTvVCtEFRVa5eIvht53Dru3LWJHL9XzZHWVepBXahv9QF1rj7Uu3qBOt+ZlWKqT/k7CKr+Pd5RUPXf5wph1QmCqkperLLLzsobfb9a8rOOW/KyzpNtM5oWmX4n/xTvVSPlospXucaO6yZ1ARs0wDvieSddZ8YPxK9AuywR1UleqO7YZITymx3Wb7Zw6l1aVEi/HURVO3uhIqjKDfMXPQ70jnO9Y3nU/HPCmsA6TF1AnasPda5eoN7Vj7rGCDM8X8wO9/curaKg6l3abCHVf5/VPVXt5DErskzGZ3SZjPKj71NLfq9t79gRNR5FfO+1GSnXatt6ntG8FTYj83GEmGWmIOYp4punioyIq2zKAO+CZ192DaH8xvJWiKhWiKpWCqVaj2cIp96lZYmgWmx38Ub1JEHVjLodOW9rXm9+y5gQNQ72jN1Rc02FtZE9iXpQH+pcvUCdqx/1rc6gflcxy8NFBe9Uv9NWh/+rKKj675Ogai8h1Yz+ktmHZ6dF2PYcr86LGjujy0XNAZl5d+e7aHFV7zy9m8Bq5TV3XX95RtiAAfr89nUglF98/q6h/LK9UP3+XlFQtUo49S7tVFFVdWHV6YKqDJEUQVXMvDJzLrU+Ux/qRJ2rH6hrdaaOoR7V5Q5cC84T/QN3dLi/399bBVVZYQBXCar++6wW+m9HQdWOXqyibSPzotJa8ntto+yi8nq+9463d21arhmZfmcOI7DKO89u1/acnstmC9C31UWxaxFRfc/bLZRfpheqT3mjQqm/8iKFVXfLZIipZofray0zW2j1VEHVa1HbRPbX0fesd0yIGv9654KWua+6lyrrN/WhftS1OoP6VZfqEupanWVxLT7fCu9U79J6BVURx72Cqk95T/RUtYMXrB7bkTIrP0dtestHpUXmjx6vzqtg05LWk56Vd3dejPLoGDW/nyCyqngfnu257WQzBejD6iT5WjN+6BXKb20ov9YyFQRV2V6ovuXPCOk3W1S1yivVrl6oVgvBRmx7PnttetJ6jiO+R43n0XNbpbWW9Z06UWfqVz1CXaprdQb1r55GuIqcd/QH5sxwf7+/Z4urdhVU/fcZZUtQFS+kqui1aqcwgZH5Wccz8iLG0RGb0bTI9Dvz10neqzLWDhVFM6cJeS73DxslQF+tWj8neqG6Y7eDiOq0UH7RgqoocdXs8H4zQvqNCKZ6ygjdR1AVHd4vOsxfZMi/0bSoOWrm3GsdqF7Uo7qEulZf0AbqSHuop2yu4tdaKaZ6l5YZ7u+v4xGR1c7CqsqiqSphBbNtV37OsGnNi3ovI977u8cRdi15Ed8zbVrSetKz8lbYRK0VMtYZ1UU0O4t8LvcNm0Pol1hZP0L5xecL5ff++yxB1SqPVLPFVLNEVad5oyK2GrON+Oy16c2PGn+ix+WIvMj5vNIazXpRvahr9QX1r460ifqBNkEmV3K5KDHVu/RRgdWIiIGnqtqiqx0FVas8jd35zCqTUT7jPW3JzzqOyhuxzbYZTYtMH5nDWubJjPCAo/P7aNkV533qfe52rzver40eoA8+vo5eBc71SrBdKaJ6cii/3QVVM4RT79JWhPSbLaqq6oXqk81TxFYjbRTx2WvTmz8y5kSNrSPzSPRcuPv6zfpSvah/dQTtoX60C9STtkAr16Ty0T9SR3un+v1d6L91YqGTBVVZ4qedvVZVCBOYUaYl/+5xhF2k7Z3vvTYj5SJsR/Mi8iPn2JXzf9XzP+U+1SNs2qC/qacy1xXKbyxPKL85dq8g27tlMsRUJ3mf+v1ZObzfUzxb9dhmfGam9Y4lUeNo65gfNadVmfetS9ULtIf60SbqCdpDPUJ9r+SafI4Mbx8ZAqsMcdXdfJ6qCKoqhQOc4a1qtZgqWgDZmx953GvXe84733ttIsu1ziW989JIXrRN71w/e32ww3VOvE8CMNh8Qf9SR1OvLZTf9zyh/ObYzfRC9S1/hphqJ1HVCmEVQdV+nqki36XI45a80TG8d57JnFufvPaznlU/2kQ9QVuoR6hz9a8O9+UqcM7RH4Zniql+fx8RLPBUdaboavUzjdiOlMn4jLaNzItKa8nvtY0ax3rPGfG9d/y+azNyzd5z350DI7xXZdhlrSdmi2SIhvauJ6IqGyfoT+pn8+sTUX3PE8qvvVy2oGp2eL9e+9VCqb/yVgmsVomuqoqfTg71t4ugKmrc7ZkrIufGGeuUJ64PrYnVk7ZQj1Df2gDqUPuou3hW/aiU6d0i0sPHDqH/ThJWnRz671RBVdVwgCvFVDNEVbOEVNEhAFd6r+ott7v3qoj8LLvsdclOa5zT70mdwMYQ+s+D6uZkAdUdO6H8zgrl91eZmcKq2WKqnUP6VQvvt6OgSqi//vcsYoxozesdc7PmotH5e8Y6xjpSfahH9Q31rw6hjdSXNkIlronle38wzvRWlRUGcERkVVlYRVC15nmz6j+iTMRndJmM8lFpkWPG6Dg1K+/O90yb0bTI9Dv5q0L/VRFZZZxvt+uvvo9qQibCKps46C/qpeC9EFGN5WWLqITyqyGcepe2MqRflsgqu2wl0dSnvFPDB0a0c8Rna17L+/6Xbe94FTXmjsw/kXNoxbWOtac6Uv/qENpHfUE7qVNoi0hWepPICP03IrDKElDdOY70VLVKWFVFUNVbfrf7zbKJKLPyc/Sd6LWJSovMHz2ekffN9k75TJuIuaZnLrs7T64SWEWsHyqEID7p+k8OnUhUZZMFfURdLL6fmT+2CuXXlyaUX65w6l1+hphqZ+9Tvz9nCqt6y58iqBLqb32ov0wBVeZ8Fr1+2GF9aA2rrrSP+oI2Uq/QFtBmZ9Xpjj8cRvz4O+qV6l36LHHVCmHVLIFVdBlerOLK97TRqj6R1adn2ESlReZnHUfljdhm24ym9aSP5EXNsb1zfMSaJHNd8zSx1XXws1W/D5sb6Bfq4Ph7qiagumuX9aNztrgqS0R1Sii/LGHVSJlMMdUOoqoV3qgyyu8ognpaqL+I96/lve8dv6LG6Oi5qHd+jlxbnLx+tDZWX9oI6lRbQLupQ2inZzDLA0VGCKSIsH/fvmd5p/qWnx0WbZZo5imiqR08XI20585eqzLFVJmiqsgx5u5xhF2k7Z3vmTYR80/PeSLzW+f5FSKrjHOtOP/q614HPUv1e7CJg77guY+8tx1FVE8L5XfHRii/9vxZYqqTvE/9/oyynR3ebydB1dNC/UXmZR1nfO9Nj55fZ66L7DvUhzrVFtBm6hDaSp1CW6zkWny+jJB/f6VniKsqCqtmCKwqhQckqIorn20761xZZTLKR73/vflZxy15WefJthlNi5zfIvOz5vJq64+q1zjpeZ4cftEmC9rf8x5xb6/JZV9FbHYP5XfHpnIov5EyGR6pZoupdhRVzfRCdceGoGpO3ojtyGevTctYsUuov570nnl69nrAetW6F9pMHUI7qVdtAW2GkXrePaRKtreqEYFV5PdIkUOmmGPl54lhAXcXVD3Ni1WUbUb5nvEga7y5e9xr13vOiO+9NnfLtZyvJ31kvoyel6PWKhnrnFPEVpdzb7tutpGBNveMW9xfRQHVXbtXYv4OIqrs0H2/v1cP5ReVnxG271NehlDqru1sgVUl0dSnvKfZj/SLXYVUFb1UtaT1zmG9c3jUWuTEdaX9kfrTTlCn2gLaTZ1C2z2La/I5qnmqWhECcHbYvxbbyoKqOzY8XM2p58gyo+eMvN7odSLy7pZtOU+vbc/x6rzesT+7XOTcdnc+jRJYZdpmrUtWnDvz/M67x7Vt0KCtPVfZ+3stKF8llN+n/FNC+fWU2S2U3+zwflGCqTs2VUP6zRRW9ZYnqMqpi4w+MuM9aRkTem1b83rH8JH5K2runL1msedQJ+pUW0CbqVNoP2gjdZ5F9bA0ER4xMrxUvUurFgJwd4FVVhmCqnqCqh29V0XbRuZFpbXk99pG2UXl9XzvnSMy0nrnwzvzbWQIwFWh/3YUW13OefTa2EYI2tfzlLy/nQVUETYzwvxFiqhWlKkUyi9bWLWT96kW29lCmFWiqU95uwuqKommZvann+Ayo2PE6HHUmN06t0TOqaNrh9XrL/sV9abNoE61HbQT1Lm2xAyqeapq/dF4VQjAO3lRHquyw/71lIkSyswIC9h77qcJqk4XUmW8Fxnlo9Ii80ePV+dVsGmdr3rmw4h5NmNez1x/RJ5n1vmvB5xrVttUuabNG7Sr51hyb69F54gOGySU33iZp4fymyWmOsH71O/PKsKq3QVVO3uhyuhPI+fptWkZR+7Y9o6P0XPGyFyXOXc/dT9hf6Q+oe20EdS59oQ2w171f21wvYgfbUe9Ub1Lb/2BPCIvUjSRLbD6dg5hAfvzniSoWiXSi+jjo2UyyvekReZnHc/Ii5gHRmxG56w782W2wKpnHbBaaJW9XqooZqoqUiOsshGCtjz2GV6bXes1odzKUH6f8iqLqITyi8mfIabaSVRVzRvVToKqU7xQrQjjN0tANdtLVUveiE1veut8XS3sn72H+tJGUOfQltoM2gDasjLVPFR9sokO9fcuLdpL1b/H0WKrVQKrikKqO7ZCBgoHuNpr1YowgaNlem1Hx8vIvIjvvTZ3y7WcLzOvdV6fGQLwSeHuTjpHdn1Xup7NG7Thwff92vR6FQRUETa7hfK7YyOUX39+hphqtVDqr7yK3qgqhPAT1m+NB7LMvp71jkceZ43trXNQ9Pwbse7Ybc1pn6NuoS21GdQ/tKc2w9ltstN/+c/2UPVX+szwf1mhALPFUy22TwsLSFAVbxPRLzLP9ZNYJqN81PjSm591HJU3YjtiM1Ku1XYkL2q+nrFmmLk+quSBqkLd7BKiscK62aYH2m7z+31tfL3XpHJVQ/l9yhv5AbuKqEoov1wx1c4h/WZ6obpjQyBVSzQ1y8NZ5vs08s632rbk9c4HrfPSSF72fG+voY6gzdQ/tCW0mTaBtj2VVT+MjfyomyGuav2xu0dYNeoBZmX4v54yUeKWFSHoKoT3e4KgaocwgBnvSOY7/C0to0xL/t3jCLtI2555Irpcz/w3ktcyt0d7qMxar5wWnu9aeP+EVTZn0GZH3etr8+vtJKC6Y3NaKL+eMk8M5ZctptpdVLUidN8dG4KqfbxQZfbDkfOO2oyOPS1jYsT3lrTeObFnnh9Zm1h7Qj1rS2gzaA/tC+2KJzPjx7pK4f+ihFSf8mYIqyp6p+r9fKoXq10FVTuEA5zprWq1mCp6jOnNjzzutYsazzPnmIi0b/PqqIgqy0PVKd6XVp1jV2FW9HmqXcsmEtqq4D0+VTzVUzbK00UFL1R/pc/yOtVT5tRQfiNlogRTd2yqeZ/663O1aOqTDY9TeefosemxzfgctYlK6x0Lo+aAqHmsdd7mncoaH9pMe0DbQrtCG0E7/79cRa8xO/zfXdvWH8KjPalECx12FlhV92IlZGD9cICnea2KFFNVEVWdJqiaLaaKEBmPzrm964HZYqEK5UfPcRUuU6WOKl/L5gmPb6PXg679Kna+V1KZVV6oPuW9gm1XiKqE8nuu96m/PoXwy7cX1q++gGpnIVWmiCpaPMVDFdQ7tC20q/aBdoY+gc+s8DAw+iPtjNB/v9N6f6zPCgk4KrCKEE+NlN0xLCBBVV1BVdVwgCvFVDNEVbOEVNEhAGeGA8wWUwkFuGb9s+La1cVVOwmriKps1rTPgff12vxaTxVQfcoXyi/f7omh/CKFUt9sTvJG9WSPU9nPMpoX2d9eE96nUZvRcallvIz4PpoWMc9mrxXsN+wHoF21D7Qx9AtoZzyZWT82jvyA+8TQf+/yKwisqnqxaik7W3RFUDXWxjt5sYouk1E+Km10PIseW6PyRmyz56aeOTFiDm6Z72eGAlwltppZ7ipmv7ruq17HJhKPaJfXwdc8RTzVUm4XL1R/pWeJqLJFVSsFVU8L5VctpN9MYdXTQvjtENYvqt0iymR8jtqMjj/RY23vfNCSNjrP9qwVItY7J+4d7Ie0C7Qx9AloZ2gj7XwmO4f8u2OX4Z3qXdrI95Ef+KNCA0YJMlYLr2adI+p8FfKeIKjaORxgBTFVtZCAu3ivGrGNnI9G00bz7s7pWUKr0bXOiSH4rgOeYZf1rM0TtMei+3lteo3XwvJVBFTf8leF8rtjE32OWYIqofzqiKpO8UbF49T+XqgqCKeyw/yNHrfkjcw9kekZc361tag9iXqHPgHtDO2jnaFPYBXXwnNF/MhaUViVHQYwW2CVKZb6nVZNjHWSoKpi3gqbyL5WyXvVDJuotMj8rOOWvJHz3Dl3r01LWk96VH7meiFqfTPLK9P1gHNHrDWJqmzWULAtXodc51X0fK8J5WaE+sv2QvVX+govU7/TdhNUVQ7lN0tUVdUrlRB+OeeoGtYv2ibqHBF9vtemJy1iPG3Juzu3RM5/0fP5rDWYvYU6hHbWPtDG0C+gL+AkZv4ANiquyhBWjYT9+2Qb7aHqW7ksEVWLbfVwgDM9XRFUzfGCNas/rPicYdOa1zJ+ZYcMHB1/R8b3kfOM2IymfZuHK3uqmim2yr7WatvKwiqiKhtEbfCQ+3htdO5XgfO8EmyreKH6Kz0rlF9PmYhQfnftogRVu4by21FUJYTfft6ldhNURZTJ+By1vWufddySFz1XjcylI2sLof7sh7QLtDH0CegP0PZAHDN+hBz5YXaGsOpJ3qo+5VUJD1jRi1WvDUFV3DWybTPPMfrejNr0lo8am3rzI49n5PV8z0jrSb8zV0d7qqocom6Fh87seqzk4SqqbIXz26Riy/p/bXr+V8FzzQyxU1lA9VdetLBqtahqtqDq9FB+K0VVp3qjEsLvbC9UFQRTkWNE73jXOwa35LXYRKZnzPtV16X2JOod+gT0BWh7aHvoGyNcm1076ke6qFCAGSGZsoVUfx1HCKxWhwXkxapG3u6Cqsqiq4zPKNuM8j3jUW9+r23UmN6SF/F9NK3VdiSvdQ1QTWxVIeTeivqt5Fls1rqXqMpmWb3/7OUpKuO8qz01ZHqWyAzj9yl/Rii/OzbR56gYvu+v4xNC+VUP6SeE33kh/FZ7FosoM/Nz1OZb2ohtr13U3HJ3zomYcyPWI0L+2SdAX4C2h3aHvgF95mlUDZUS8UPdSmHVam9VUfnZ3qpGyu7kxSrqfMICrhdtZfSh3nNHXm/0OhF5d8u2nKfXtuc4Kq+17J3yLWkRtqN5PeuHamHpKgunKgu1RtenRFU2WOp8s2u/Cp+zQpibygKqb/lRIf6ivFDdsWk9x26Cqh29T7XYrhJV7SCsEsJv7jP3nnOkb0WWHfmMsh0du0aPW/J656CWtNE5eca6wr7Bc0O7a3dAv4B+A33oSVyFzh3xY15GuL93aVkiq9Uequ6mrRRN/U7b0YsVsdVegqoKYf9We63KEGNGpbXkt9r2jMUteaNle22ibL/NyxEhAVvXExXEUBnPNiu84k4exrLXsgRVNmePq2teo+adY7V46o7dDAHVX+kRAqmeMhGh/O7atZap5pGqQii/3nOe7o1KCL81IfxWCPJGzzXjfRvJixjvosby3nmnJW1k7s1cL5yyR7CfsWeCfgHoM9CPoA8hiqvAOUd/zMvyVjUqtNoxBOC7tAgRVU+Z6l6snhYOMDOvSvls20qfoza95aPSIvN7jnvtRuaNkbnrbtke25G8nnXDTrazBE07iq9G16FEVTZ26rnYdZ/sOWq0fJb9Kym/9cffTM9U0aKqWYKqmaH87pYRyu//fK4WTX2yEcLvXEFVZNnIzyjb0bEq8jjje0taz1zau26YGYrYXsR+BtBnoA9BP4K+hCdwLT5f1g+GVUMAjgiuRm138VoVea7rhxeriLyTBVUVxXir3qPR87Xm9aRF5kcet+SN2I7MYxFz47d5eZbIJ2vNkWFXQTxVSXw1uv4kqrIZVMeLr1lFRLWy/Cu5zCvQLsNDVbYXqjs2rWV2E1QJ5Tc/dF9LmQreqITwWyOo6ulbq/t01LvWa9Obf6dcz3ky5piM9Iw1wcq1qX2GvR70IUAfgv4E/QoncC08V5a3qqqiqk95lQVW1cME8mK1lxBr9Hozyo/0h6d4rVrhvWq0TK9t71g+Mj/0fG9Ji7AdzWtZN1QOxxdlM5JfQVhFVGXTiCJ1W1FI9XpI2ddC2x0EVO/STg/l99exUH51vVLNFk19yttNUFX5WlHt22ITUSbzM6pMT1pLfsSYHPG9Ja0nPXLOX7EutZ+wX4M+BH0J0Legz+FkdhZUfco/XVT173GG8GBWeMDVwqtV5xIW8DxBVdV+2fuezbCJGqdGy0QeR+VFfI+YC7/Nwz1loub/nrVHpXB414KyVTxajaxBiapsINXrhOvtKqKaWS4z1N8qAdWnvJ1C+f3+PltQtVJYJZRfbWHVEwVVK+phtH1XiaWqCqaqCqiyhFV3bSLTo+b+WetRewf1Bn0J+hWg30HfwxM50UvVX3mRaZVEVf8ez/Ra9Slvd29V3z6fHg5wVV6V8tn9YMVntG1k3ujY1ZL/l+3oGN2SF/F9NK13/q0SGnCmB6pV3qeqCqt2FFURVGHrOt09HF/1ctXFU99sVguo3qVFi6pWeptqPRbKr/0zu+xKj1Ot9pXPsVMIvwr9bsXnqG1U2si42TuuR81FrXPnnXk8Q0xVNfSz9T6gT0GfA/Q/6H/YkWvx+Z7iperb99Yf4zPC/r3LnxkesLrwqpL3qju2FcL7EVTV82IVcf1Rm4i8kXGq95yj43aLXcT3Xps7c+/s0ICRNiPriqhzzMxb4Qkruj1mrF+zzmkTqS63uN4u3qSqeZJqtX8F2s0QUP2VPiuU3++03QRVd/NH7ITyq+Gt6FQxVNZ5dxVNVfRCVdEbVeQ4GTUPRMxBkfNo1HyfvRZ98h7B/gj6GvQ9QB+EPgj8R4UfoyJ+bIvwUnXXdqdQgP8eRwsSRoVWM8RT32x4sdpTpDV6vRnlZ/WDGZ/RZSLzotIibHuOW/J6vvfa9M65u4eh28nL1Gnt07smJaqygXxsPe4qpHptfo2K4qlv+a15mV6o7thEhPK7azdSppJHKqH84myyvVHxLjVXUBVtE1Fm5meU7eiY1Tt29o7Z3/J656tPc+ppYipCKkB/g/4H6IeAfoq8H4syfwyr4qXqXVqGiOpT3u6hAD/l7R4usJIXK3nrBVUnhQNcKaaaLaqKGGN7ztOSd+d7r03UnJqZd3f9sFuovsgyu7VV71qSqMrG8HF1+Fp4jqd4iMq8jx0EVHdtZ4iqVguqMoRT7/JniKkqiaqqCqsIqmo+V0b7ZPbRyHNEvYe9NlFjXORxS17P94j5cnQun7FusTfw3NDnAH0Q+iqg7+J/cxU8f6TXgswfGiuE/rtrN0tgFSm+WhWSrIrIZYUXK4KqeoKqncRX0WUyyvekteT32kbZ3fnea9OS9m2OXiHeuWMzOwzeSqHULC9XEfm9a8rV4att7myOt7nOLCHVjqKoHb1PfcuPDuP3Lm2mF6pPednh+/49nuGR6ilep759nuaN6knh+iq0S49NRtkZn6O2d+17znfHNmJ87/l+16ZlnhzNm7X2si/w7NDvAP0U+i+gLz+da5NrZXun+pQX7blqdui/u3a7hAL8lLe716rfn9llo85XIbzfroKqp4QDrCCmWimqWh0GsIKgqpqYqlJYvqg1SMSaJTI9u41615dEVTZkR9fda0H5HUVUr+LXzhRYnRTar6KgakUov095szzWrA7hd8c2o/ypwqeZ19pBNHWaF6rRcaUnrTe/ZzxuyYucv3rm3tneqaLXpERVgL4J6LuA/gx9fGeug+5lhneqT3mVBFW/v2eGjVoVCvBdWrSgoqrwavY5nuLh6omCqure1n4SbEdtetIi80ePW/J6vmek9c7LWXmzr1lFLLXSw9Voe/WuNYmqbJaOq7fThFQvdmH5WZ6pZomqVguqVgqrosRUFUVVK0P5EVTtE8JvVUjHGf048zPKNjMt8rglL+L76PwZkTdz/WZ/oF6g3wL6MqCPA8jhWnCO2T+S3k2PFlllCqz+Kp8hupottDrFa9Xvz+qiKyED64YDPMFrVaaYqpKoakUYwNWCqkpCq5VCqpm2mfc7knd3TdiybiSosmE/qs5mi6l2CI93167iNUfPMdMzVVS53UL5/Xu8i5jqpBB+UTYrxEBPEFRFitIy2vHnZ55IqroXqshxqTe/5zgqL3Je65l/I9YDvevAjPWpfYJ6BPRl6N+A9wLAZ66F54rwXhD1g26vyGoHgVXV8IDZ3qt6yvBiJa+yoKpaf5zxjmbnRea3lrt7nozvo2mttpXyKni8zGqXFd6t7qzniKpsjtVX8DVO8zD12vR6s71P/ZVXSVS1Syi/b/mZgqlPeU8J4XfHhqDq/BB+lTyjzfyMsm3NGx0Xe44j7HrmopY5rtV2xdpm5jrVnsHeDdC/Ae8E4H3Bk7kKnTcqDIwwgPftqoUHjPZe1WIbLSDZ0YtV1Pmqh/7bQVD1NC9WUbaReaPjX4RtZN6d76NpEbYr8maH6quUFlG+t43vrv2Iqmw4H1FXTxBSnWizIrTf6A+/GWH8vn1fKaha7ZEq2ma2qCqrbFVvVBWFT6uvv0o0VU0ktYMXqswwfhUEVBW8U43kRa+rVq7v7SHsdwDvBADvC+B9OYFro+tF/lAW+SPrSpHVCoFVVnjASFHVJ/uTwwXOOsdugqrevFXPt8Imsg/1njvyehl5s0RVUSLXlryI71lzZE96Rt7qEHxRa4pZabPbLWOtWHk9bQP30HqqJqaqJqLaRRz1zSY675Wc1mqzQlBV3SNVtOeZE0P5EVTtee+jeS02PbYjZTI/o2xb83rS7ti2lo2aR+7OWxUFVdHrrIrrfPsL6E+AdwXwzgDoefdO+zHmWnCOiB/bZv6YWl1gVSE84Gyh1QzxVGuZU71YydtTdDWjX2a9T6PnGRlzIvPvHkfl9c5XWXPnnfl8x5B9s0VTFcVWI3mt60ZeqvwBYas6mhXWpZqQarW4aXX+K6jMbFHVKkFVpHeqymKqaqKq00P5PUFQtUsIvxPEUlW9UM0K45ctoIoQT0V4fhzNy1rD7bzmtx+BfSPgfQHgXQN2pcKPUSeFAHyXdkIYwH+PozxZrQ4TuIvXqt+fs8oSVNUWpc2yrfQ5+h5H5EXmR4zpLXl3vt+1aZkTZ6Svnucj63alTVR7j+S1riV5qbKxLl8/s7xSnSSSqiiAGi27Mqzfu7RdBVUrvE99yqscwu+/z2qh/AiqhPA7RWAVZRuZFzGO9hxH5UV8b50fM+b20bVg5Lr0SXsA+x3AuwF4zwB4l9HCtcG1on8sqxICsKLAKio8YIb3qndpGUKrSPFUxDl4sZob3u9kQVVFMd7s92zUJmIcih5De8f7jO+jabukzxRSZ7XLCq9WPel31nZEVTaER9TPTl6pMsPcZZateF8R3qdabCPC+q0SVFX1SDU7hN9dW6H8CKp2CuH3JG9UozateTPG1Ojxvse2Zz7rnaNneKLqWRdWW6NCfQPeMwDeZQCj7/KpP8JUDf13xy7qR77dPFZ9yqsWEvBuWqbQ6hTvVf998mKVL9Iavd6M8iP94QSvVZke70bHup7jXruI73dtWubG7PSqYqoKbUVU9cD1vD9IzK+bGWKq6t6mXg85b5b3qRbbUa9U2YKqnTxSnRDC7/dnRWHVLoKmive0S3i/iDIRZWe9y7PyevOzjqPy7nzPmkNH1xYZ67fVa3p7B+g3gPcYgHcXwP/kKnLOK9AuOgxNpteHlR6resrMCgl4N62C96qRslW8W62wFRawnqCqste16DKReT1pmWP2jO8taRG2WdfbQTAd1T6ZHq160u+s6SLXhivXxTbWD6uXbDFVZSHVTMHSyL3MfIZZPwhnhfH7ZBslrprhkeqUEH6/P4Xy412qgmjqCd6oRm1a87Lye44j7Hq+37WJmFcj1kY9a8DRtWjVNb69B+D9Aby3ALzLqM61ybUyPA9ck/Kifmy9Y9P7g2w1j1V/HVcXWp3iter3Z3ZZYqs9PFyN9Adeq9rGppb8iPF8xveMtNb0kfPOElNVElrt0KbZa8Vqa2kbwsPqJDucS7aYqoIHp4zzRd9HlleqkfKVBFXZofze5UeJqSqJqk4J5UdQlZeWmTfSDyt5o5p1rsi83vzZxyNzyZ3vs+bP6PxZa0Lrf/snAN5ZwLsMADVY+eNUdti/b/kzvF5EC6x2EltF5WeECTwxXGBFL1aVRFcEVXP70ui5st7N7DGmZYzLGN8zvs9Km3Gd1WKqSsKqp4uqCKr8gWbaOat4pVoZ7u60MjPC971LyxJUZYT4m+mR6sQQfr8/q4unCKry6ywzr8Umo+yMzyjb1rys/MjjqLw733ttemxH8nrWfjNCQdsrwJ4TgPcYgHECiOUqeO7oH8xGfqDLEFnNEFhVDQ+YLbqK9F71yb6SeOq/Y16s6ubtIKh6iherUZuscad1nIwYuzO+R85xo9fYZU6OaPNI2+g2XCWq4qXKZndJfVQXU1XwLJUtvFp5T6tEVTsIqmYIp96l7RzC7/fnamEVQVWdtMy8rP72M+mckfcxK683v9d2dDxvzev5npE2sg6KXqtFrkOrr+3tPQDvDwDjBABjSAbXw+73ZG9Vf6XPCP/3O23X8IBRIQMzwgSeHC5wNy9WQgauF7Vl9qWZn5F5I/aRxy15GfNPdLnotJUeI7PbM/K+o9uwJz16LXjq2twfWxbWxSvRPissTTUB0i7pK0VVFQRVK0L5vUubJabKFlVlla3mjYqgKr/OWvpUdh891fvUyV6oRsO89n7vnf+i1zd312a7hPqz/ld/AIwPAIwjAPK4Cp33dG9V79IyBFY7hwfMyJ8htJohnmotU02MFWVLUFVPULWT+GrUJss+8rglL+J75HyXfa5V8+uq9t05JGDW2nDl2thG/aB6yBJTrfBKVV2glHmOlnNn3FslQVXrj+wZwqooMdVKUdVTQ/mdLKia+byZeSN9dIVXtsjzj9q05mWNm6PHEXY933ttWufYnjVAxjotYv05cw1vvwD7WwDGEAAwVu3Mdfj98Vb1Pm224Kqyx6q/jkdEVe/SMvN29Vr112f1cIB3bGaF99tVUPWUcIBVxVS7Cm1656vV554RXjdrTuy1i+4Lo2kRa7fotTNBlU1o6DmjfqSL9kq1m+emCra7hfT7/T3DI1VVMVWV0H1/fa7ySvVUQZUQfjG2I2UyPqNsI/Ii82ccR+X1zm1Zc++39dJKj1RRa9Ld1/f2J4D9OQAYqwDszFXsvJEeCTI8Vf2Vt5vAaiexVVRIwLtpK8MErhZgVfZidYKHqycKqir1y6gyEfYRY1zE2J01/8y0WTU/VpwvK/SFiHVSz7qQqMofAFLroKKYakch1cpzrhRV7eCRaoWwKktMtVpUtdorVUUPUdHnPTVc34w+E1mmwueoTWteb36vbc9xhF3U3NVr05s+urbqWff1rjkz1+v2AtAvABinAMAYeDrXQ+4xKzTgqE1UOMAR28rhizI8aezmvarV/lSvVb8/q4uuhAysGw5wd29VWeLOzPG3JS9z7sq69koPjpFteAWdv9cusp170lvWiwRVNmBpz58hpqrglWqlkCk6XN5du1XPPFtQFeWdarWYqrKoKrpMb/ldwuvdtd89TODqvMgyEWVnvbPZeZH5s49b8iK+Z8zHPelR67GsdeCua3k/8gD20gBgDATwVK6C574SbDO8VZ0qsNo1VOBTvFeNlK3mzYqgak7ejPLZ56vw2ZoXldaSPzJuZ3yvMKeNzIFZwqUsL40Zc3hmO0es0TLWtNuLqp78B4DTxVSnCamqnD/7utmCqmzvVNHh/aLDdkWVnSW0WhnmT9o54f1G+u1TvE9FC6d29EK1QjBVMaRfBa9UWetzP/zZzwCA8Q8AcNqYex1Szyt/sJohoPqWX01gVTE8YNUfmO/mrxJanea16vdnVpmo81UI77e7oKqCN7OIz1HbzLTR45a8WXNO9H2sElRVCXlboV9ErH8y1n+PWK8TVK05XyUx1U6emKqUy3zGaEHVzPB+FcRUq0P4/fVZXTz1Lo/YiTeqGeeKfNdGbe7mReavPG7JmznHtc69PelR+T3rSV6pANhPAwCMt8B5XBtc50qwzxJZzRRYVfPsUdlj1b/Ho7aZYQJPDhdYyXvVHdvqeU8UVO3kperJ3qpmiKpmCaxmhKkdnYsijzP7yOiap2ddyEvVgzflO4upVnilquaRabVN5vVGy2SF9xsVVs0UU80WVc0M6TczzB8BFG9UO3mfygjp15MWYdtzHFEm4/vIPNtqm5WXtdabuS73I5w9DQDAWAsAqMlV5HyRP6qt9lT1V3pvmvCAfx+v8l7Veo6V4qm7tqd6sZK3XrRVqY9FvTtRaS35vePxiG3P96w5J+qZMwS6veUqhgbsbfOWdU7W+m/2mtcfhjZ75h3FVCM/Zs4SElUXZ616hl5xVZSnqpliqkqiqqyyVcRT79JOFDZVEUhl9puMPtx7jYzrjL7vUWkt+SuPR+aQmfNulO1oXsu6blUov8prdz84AzC+AADMBTiV64DrX0n2oyKr3QVWMz2E7BJS6d/jLO9VrfYRIqqRsk/1YiVvb0HVyeEAW/J7jrPG+pXzTuT8lJ2/qp9E9JWoNh9dg2Wsg7cVVRFUzTvXbmKqKkKqVT/uVhGFrRZQ/Xu8QkyVIao6IaRftHjqXRrx1D4h/FaJBSM+o8u05o2OcS35o8cRZVpts+a+KNuRtVPE2ixyjZm5JvfjE/QjAIB5AADWcxU9d7VQgJUFVqvDAz7Re9XdtCgx1R2bVQIsXqzWhPfbXVBVWUi1KhxgS36rbVRelfmkZx6IHONnlVkZirCnb7Skjay7otexBFUPfd5ILwY7hfKbGaYu4nvGPc+ol5Z6yhBQ/XU8W0w1O4TfX5+rvFLNEE+9SyOeWiu2GrEdKbPyc9SmNe9bWkv+yuPZc2rvHNuy7uhJH8nLWNdlrUF3W7v78RUAjKkAAHNTJNdD6vYqcK4r0LaywGrEdrbgKjLE0t3jv/JWe696l5bh7eoUr1W/P3mxyhdpjV5vRvmIfrHinRl5x3vHsVUh36qJdGcLqqqnzaq3ljVMVug/giqbvPRzjXhIWCmmqiScqu4danZ9zRRQ/XscKZz6lLdKVLU6pN8q8dS7tCeLpyp7oxopE1E2+30dtelJa8nvtb17HFFmxfw5mhaZHpUfvdarsib3YzzgHQIAmJMAxHFtfu2TwgB+ypsRCvBdWhXvI7t5r/pmu6P3qpGyVbxbrbAVFnC9F6zMPhX17kSlRdj2jrkteZFlV80PKwWz0efNOu753rMWil7fVV4723xPftadxVQrvDdF/dAb/aNwa/7K76sEVP8eZ3ihumMTLaqqEtKvknjqXRrxFG9UkZ9Rtq15o2NXleNq89NoWmT66FqrdW3Xu55c5SX1SagTAIB5BwCwE08KAXjH7jSB1Y7hAbN/WM/2ZJXhoepT3mleq35/ZpclttpTULVDOMCetOhxK2JMHRnnZ4zp0eP6qrxZfemvciPt2rJOGVlPRa5dCaoe8pwVxVQzvVLN9rDUkjfz/mdeu+cedxBTVQnl9/vzieKpd2lP9oi1Ki+yTNS5Mt6z7Lyecar3XD3HEWWy56tem9b1S0/6SF60TcZ6c/Xa3I/DAPw9AwAAVJ6LrwfW81XkfFewbZUwgH/lRYuueK9qP17tveqT/YnhAit6saokujpRULWjkGqml6qV3ohmeLaqOn7PtOk9Z28/qRz6j5eqYpue3Z8zyoPBajFVNW9KUXlZ91rluq12K8RUO4iqMkP67Sieepf2xHCCM/JGbCPLZnzOsGkZ31aE7DvJC9WoWKqKgCpDPDWyrsxcexMWwH4SAABzMIC5XAfdw5VYZieBFe9VOWUqe6+KtK8knvrvuJoIa6boamchVpXys9o6+v3pSYsYkyKPZ+dVCd06S7g6es3I/jbShi3rkZH1VOS6k6Dq8GeM8k41U0w1M3zfJ9uZgquo81QWUFUXU1UQVUWXyRJK3bUnqNpXPHVS6L4VgqmZwqkneaHK9njZmz6SF5EfsYaMWnuesk73Yx8AwN+aAAD4n1ybXOdKtL8S83cXWEX8cBrtseSuXRXvJ99sZ4QCvGOzW7jA3bxYCRk4NxxgZD+Jel+i0lYeR9jNGnszBFUZ42TU+Ufrprdte9cGI+unletLfwDa6BlnhPqbLaaa7YWqiherGYKq6OvPElPdzc8SVZ0U0i/6HLsKqnYRT+0Swq+iQCozpF9PWvS4GHkcOc9kfB9N60nPymtdv830UlVhHe5HYAD2+gAAAPW5Cp47S2S1s8AqO62696q7dhVCSn3LnyG0miGeai2zoxcrYqt6gqqKYf9a81ryVx7PKnMtGGOrCfBmhgTsbcsWm5E1U+T6dCtR1el/gNwp1N+ImCo7xF+keGqW6Cj6HjLqKKvOKob2u2NTSTT1yWZVSL+ni6dWtFOWTUSZFZ+ZNj1pEePeyDkiyozY9nzvtemx7VnzjORFrtUi15JC/OF09EMAAGDtgdO5HnR/M0RWlQVWO3qv6ilTKWxU9nFWKKqMvF29Vv3+nHWOiqIrgqpa/bE1r2XsyB6vIs8fPYbOGksr9ZdsUdXs0H+8VNmEpjzfyWKqiBB+f+Wt+HF6lueQFQKqO+fNEFNVFVXNEFitEk+9S3uSoGpFOMbRvhJhO/NcP4llWvN60qLmHV6o2tMi00fy7q7Pdgrxd+ra3I9eAACY2wHg6VwbXzdbZLVaYLXCe1WL7VX4+87eq77ZzhZazQpldUIYwJYyu3ix2l1QtaIPRNn2pK0esyqMp9WEVBXGybt5ke3e831k/VNljemPIAWfLeqHuBliqsgQf1FCoJUCqR29ZM06XiWqWu2dakWYv1MFVZXEU7P7w4jtSJnMzyjb1rzRMari8cj8GvG91ybKtnc9dGfNtTLEX9Tassra2w+hAOBvHQAAoCbXBte4EsvMEFjNCA+4wnvVHZvV4QGjhAK7ea9qtT/Na9Xvz1llhQWsL6iqEs6tJ23WWLTqOHNM+ynSbyp5RYuYL0fXGS1rMYKqQ9jZO9VsMVW2CGh1KLvR686ur+zjTOHUp7xKIf1meqp6uhepJ3mjGilT4TPTpmUs54WqrheqagKqTO9TlUP9PWEdD9hHAwAAAH9zFTzvlWRfVWC1Y3hA3qv+9/FTvFeNlK3ixarnXARVdQVVFcK3RaVljkGrrxktCp3x/lcWV/XOPy1z6ejaomX99Ziwf6f+IfjpYqqZYeyq/QC+UlzFG9W4bYaAZbVXqhPOwxvVWP+MKDvyGW3bmld93oiYI0Zse7732rSuSSLTR9ZL0euyqHVj1jqaUEMdAgAAwDoQ67jcf9j5rgTblQKrFeEBdxVcVRRbZYuuVgmtTvFa9ddn1XCAn2wIqnLK9Hz22vSkzRqTZt9TpXFpptgyux+OtGNLXmtay3rrMV6qCKpizhMV6q+KmCpLzLTLNXqOK9xDax3tGuJvt5B+TxJCrRZPCeGXF66vtfzdshXG9YgyK75npPWk95aJyO9Z91UQT1Vff/sRCgAAWEsAQAzXofdyTSgXKbCqEh5wZ+9V32wivFfdtavsvepdfoYI6wSvVX99VvJedcd2Vt4pgqqKodhWCKuqeZ2KHLtmjwu7eLTK6ksj83jP2iR6fUlQtfkzzRZTvUsfCeP3yTZKWJUteMr+kT77+AneqD7l7R7S76mCKt6oYspknGP03Ru1iUqrOmaPzKsZ33ttItYfveubkbyotdfomnD2OtLaHgBgLgAAAP9xbXzNK7nMzgKrLCHVXdsTvFfdtXuC96pP9itED99snuzFqroQa/R6PfVfORzbLGFVVfHn6rFkF5FhVv+7k98yZ/auB6LXVBXXvs0QVI2dIzPU3wwx1Z0yK0RVmT/eR9zf6vNF11Vlb1T/fWaLp+7aE1SNlVlpH2E7UibzM8q2NS9y3M8YM6PLr/iekRaZPpIXud7qXQOOrhlnraP9MA48c08KAAAA/Oba6FpPF1hFlangvaqnzJVgu5P3qm+2mWECqwqvTvVi9eS8rDqd+RnxXkaODdHniEiLHi8yBVU7iasi+9LI/N67llm5XpzOaX/ofWqov+xQfv8ez/ZUEiEO6r32bNsV9V9JVJUhrIr2VFVZULW7N6qMc7XYRJSp8Dn6DmeM7Zlj4ujxyPwa8b3XJmKdEbmOubt+2llAlbVmJrqw/wEAAACAKK7i578S7aMEVk/zXvUujfeqe8czvMJE2GeKpyLOMUvAsMKLFUHV3DbO6stRaRG2UWPMzPc6+j2rIrhqLTPSx3rnwzvfR9Y2q9aH0yGo6j/HU8RUFdNGBFXZIQcjbHvuYVa9tpap7JXqqV6ihPKrFbpvlvepiPFjtEzUWDl6rZa8Gd8z0iLTR/LurqsyBFSVxFM7r7eJjwAAAADr5VO5POvy864WWPFe9T1ttQBrF49Vfx2vEDz05u3uter350yBx4ht9TBnlQRVM/pua15PWkt+xtgyM8TfCkFVz7s0u3+P9LOWefLuvN67Zlm1HrTpK/AsqwVVI9939YDUap8pqJoVwjDj/iLb6TSvVARVuXXQer5I+wjbkTIzP0dtosbMHbxQteSN2N753mszup6IXq/cXSftJqCavX60vgcAALD2AXA218Pv9ZpYdieBVaRnqyyvVtW9V/3+vrP3qm+2s4VWEeKJkbJVvFutFopk5q26z4h2muGFaidh1Swx1bcy0W3ZI6haKbSK7qe9/SFibu1dv0StJwmqNnuWJ4qpqnpAGrXpSZt1nsz7yBBVzfBK1WszO6TfzuKoVeKp1d6oRspknOMnsWzWmNCbv/K4Zc6c8T0jLTK9t8zdtVMVAdXO4ik/FAIA/F0JAIBzuQ6+l5MFVqeEB+S9qv1cu3mvarU/1WvV78/qoquTwgLOqvPo/hv9/mWUmfHOzxBPRQqqIoVWq/vonfyWvJZ5P3LNtNNa+Og/fM0SVPX8sBgR6m+WmGq2l6mMMHM/CWmzvLhUb6dq3qg+5RFUrfXmNSOvxSajbMRntG1UWmR+5HGvXev3CK9TGR6ndvFCdYqAatY62Q/RAIwjAAAA+MZ1yLUrCqxOCg+4s/eqbzaneK/693i196pP9id4rfr9uZsXq6cLqrL7xKhNxPs2q0z2O9lr0+s1KlpItSLUZmTbt86XUWuIyLUiQdUmz1HZO1UlMVWUt6MW21WeWmaIoKrc+4rPimH+ThFHVRRPrQjlVz2EXwXPfLxQxX3PSItM7y1zd40U6amqZ21XXTxF7HA+2hgAAADAKq7Nr3lNKldJYLWL96q7ttXCBVYUW2WLrmYLrSqIp/473tGL1Uliq2ibGe3a2ncj83rSst71mR6o3uW1CKoyPFb1Cqyi3pnI/tGS17oOuLPuIajagAreqWaF+lsZ2q+St6Pse2zNm5FWzUNYpuglQmx1ivipqjeq7PaL7GOZ54h6rzLGs545INr203F0+QrfR9cDreUzykSsiXrWZ6cIqJ4gqiEcAgAAAIB9uDa81gyB1QnhAaPKVPBe1VMm2nvVXbsq3qu+2c4QX9yx2S1c4C7eq+7YEFTF983IvBlpVcRUEfl3xU+zRFUz+m7vnNA7D/euOSLWgQRVGzxDlneqnrQMMdW/x9Eimzs21cUKGeWzzlE1nN+3zxWeqgiq9hdP7RjCr4oANCt/9nHLvDjje0ZaZHpvmYj81jXZTAFVxnp3lzU08RMAAAAA4DfXZte5JpThvepz+tO9V921qxAS8Fv+TGFGi222MIsXq328WM1os9G+FZmX/V7O6O+jwqqeMH89oqhVXqtmeanKCL0bvf6psD5thqDq/jmqhvrrEVNVF1Wt9gIz27vV6nB+s9pphljniYKq1eKp3UVTM8SHGeNNVFrvPHL3ePS6Fb+Pzvut5TPKRKx9Wtdhuwqoqq2VCaQAAAAA2DN851IFJevtWniOygIr3qvabWYIqj7l7eTJarZA41Perl6rfn9mlz1RbNVTd6vbetQmMm/m+xgtplohqIoQVa0SU632UiXs36EbrFkhXzK8U42Kqf49jvRMVcW70cz7q2ITYb+6/WaF+XuK+Okp3qh6bCPLZo+NvTZRaRG2kcdReRnfR9MibHvWHXfWNDO9UO0ooFq9LvbDBwAAwBlY1wHP4/Jsy869W3jATAHWjt6r3qVV+v5U71Xv0laGCZwlwKoiwiKoqiGoiu7XO75rWaH8IrxLjYioIr1YjdRPRH/pnZ+i5vXItR1BVeH7n+Wdalaov2gxVQUvVCvvNatMa97MtpnRxlmekXYXVM0O7xdp3/K+CuU3RzhVLXxfJdHUylB+u3mhygrj17uG2937lB/XAAAw3wIA8P9wufeU81YSWFX1XvUp7+neq35/nyGc+itvN+9Vrfaneq/673Ol6Kqi2Cr6GVd8zrCZcf1sMVWmoCpTVNUjsuqpn6i+FzHfRMzvkWs5gqqi97+Dd6oKYqq755jpzSjzc1bZjLxZYqvZYf4IqtrKRNRlr310H/mZfK6sMq1539Ja8nttR49b8kZs73zvtfm0BuCFao4Xqh29T/kRFwCMhQAAABFcD7/PVQKrE8MDRgqvssRYvFfFHY/a7uhRZ6Tsaq9Wp3iviiofWbcZn1G2Udda0cczPU99shsVSUV6suqpn9a+3ZPWMie1zvMR65Qt1747/5FzZ+9Uo2GPMsP77eKxqPJnlG3UNSqG92vNI6ianxb9bu4Uym9VmM+7ZXvzZx+PzHcZ3zPSWm1bzzOad9emWhi/WWu8J6+j8Qz0UQAAAOBsrofd2w4Cq5niqm82K71X/ZWenbar96rR8ldyudVCq1O8Vv33ear3qqjyI/U08zPatmLfzxBTjeRFiawivVf9/OSIqa6AMfvO3NOSdmdtQlB14L1nCKpmeqeqKKbqtckWU5woqsryTlVFWFUxfN6pgqqo9/CkUH4rvU9liaUiPUxFCKparhcxv7amRdj2rCPurE+qeqE6WUBFmKKeAAAAAGAXrofc04of7U70XvUpL6rMDt6rvtlEeK+6a1fFk1WE0KpXhHVSuMCneK+KKh9Rb63niGjraNuK/TZaTNUjqOoVTGUIre7WT2taz7jaOw9FzNuR6zOCqmL3vruY6t/jk0RUK0UaVUVVVbxSzfZCVl1QtYN4KtI+y6bye5nhSe5bWmT+jOOWeW3G94y0VtvW84zmRaxpetdXpwqoThYFETwBAAAAwHO5Dr+X6gIr3qs+p4/Ynua9qqfMSd6rPtmf6rXqv88ne68aqYOMc/xMLDvz3maKqSLFVRECqijxVcvx3fzetm8d53vn0Og1yg5r1f+fXX9UOcU7Vau4qldM9TstW2STGcbt52cv7zlZtqcJqyoKqioKun5+zvBKlTEWZb2fvTY9aS35K49b8lZ8/zR/ZwiretYLd9YhJ4moKguonu6tFQAAAACA69B7WPGDXlWBFe9V8WWe7r3qm21mmMCThFe7eK+q4iErs2x2/6nUX1eIqaJC82Xa3klrqYee/JFx9K/8b3NPxPy8ev2VylMFVaM/MJ4Q6m8nEdVqMcgKjzi7eh3rzTsxPN+q8H2R7+4s2xWfUbbf0kbL9NqOHrfkjdj2fM9Ia7VtPc9o3t21CwHVOWtfYikAAAAAwEquA68/+we+a5FtpgBrR+9V79J28151165qSMB3aZlCqwriqf+Od/BeVUWQlf2cme28+hwZIf3epWWKqSJEUlHpd9K+1cNPh+1ov+mdUyLm3sg1XDlRFUFVn02PeOp32p0fn+/+uN4rvomyXeEJqPXamXl3Pn9+9vA+1fPcM0M9ElTli6dmiaaqh/JrHXPvlu3Nn3387TsvVONlIvJb1kTVRVQZa9LK61yCKQAAAADAblwHXVt4wJj8E71X3bGZIaj6lLeTJ6sM4VRvHu9V54X6qxq+ceU5I9szS0w1Gt5vVplvaX89Q0udtfblnrSeeat3jo9YZxFUFbnvkR8o76ZHeqeK8Ej112ekR6osEdVqEUpLXY18/vysF0f9/KwRqZ0oqJrRl3vto21mvytPDOUX6WEqQlAVWfavuXWWF6rI9JG8uzYEVPusa4mmAAAAAAAnQ2DVX/ZKsl8psLo6zxnxI+7M8ICrvFnt5r3qm+1sodVM0dRdW96r5nqxqvQ561ozQvv9e5zhiWp23t30n+DjqP70V37LPDIy369aV6Wy4w89J3unGhFWzRTLRApRsjxYrRBc7fq5SljFA1WdPntSKL8M71MZwileqOaIqCoIpXihyltzVlnHEk4BAAAAALDuBzDhAfvtRm2i81YKqd6lrRZgZQmn7tjt5r2q1Z7XKkKqp3yOiqn+TcsSU40IozLz79z/z886YdXImN07591dPxBUbX7PKwRVWd6p7goHIoUys4RTFUUwLfW5+rNKeL+ReueBai+vVNnvSbRta17PGF39OPp7xPzYkhZh25N+Zy0xI9Rf65qIgOq5a2cAAAAAAFZxHXDNFT8KCg/4dx7vVfePe8pUDwn4Lq2i96q7ttXEV5nej2bf34w6nt2vZnij+pY/W0w106bl/j49b+/x3T7bk9Yz5/TO3avWTmkQVLXZ9P7wG+mdqtdLVURovwxh1QqhVTVRVTWh1QqvZlHtlN0Pnh7SbwevU1nep0aFUyuFUqd7oWq1bT3PaN7o2mNkHbS7iGr1OpV4CgAAAMCJnLrXuTStdpp0Td6r7tmc7r3qXdpO3qt6ymR5tbqbv0poxWvVOg9X2banfkYLqP49jhZTRYqlWm1/OvK/pUUcj45Hf6W1zAm9c+/K9ZLNU9D9nuidalZovxnHlTxd9dZZhG1G+/bYrhZU9bTbk8L8RbXlir468jlqE5XWkj/7uCVvxfeWtAjbnrn9zpqBF6qzBFTEUwAAALD+BNACAde+9XgVOtdJAqsK3qv+St/Be9U3mwjvVXftKnuvepe/i/eqv/Kqiq9OFFvt/tlrOyKg+vc4Q0yVJZaKFFf93EzvqcPeNr6b1zsnjMzPEWskgqqF9xvtnepd+gzvVCOh/nrsZ4mmVoqwItJ6bDLKRt9jVh/bUVA1ox/tIp6qGsqvonAqUhAVEcqPF6q+dQIvVPFrRwIqAABgLQAAeBJEWPXqiPeqPtuneK+6a3uC96q7drxXxZfZMdxfS5nKnqhOFVdFCaj+Ol4lpppZ7uen33PVz0+/6Grks3XM7Z3PItcKW6yZ/y/r8//Ba9D+FXi+lh9mRwUF34Qd72wyBFTRIqqVoqqKopbskJAR9XiKYCrLg1eWTWSf7PmMss1Mi7CNPP72vaoXqhZbXqhi1iq9ZSLKzjhf1WsCAIzPAAAAveufSx1Nq4vo642cr6dsS5le26vzXJ/O8an83bw7Ze6kj9pef5R9NXxf+b5dC6515/inMf/1q26vP8rezfvrXJ9sW8rM+Pz5+S66ySzTavOadL+t51j12XLv7/K+9fNPx9/evd+2d97faK7Ovy19m4/u2L2bf1rq7c7YNjqWvz7MzQT+SQv4E+53dbi/aqH+RkL8ZeXNvmZU/XxK67HpsY26h9Vh/iqKsKLKZPadHURTQvnFHo9+jxBIzfJCFZk+khexluhd08wUURFQAfaDAAAAAOpyef5tr1fZe1WLfbb3qk/5O3qvepfGe9W944z8J3mvqujhqqKXrZX1HHmtDK9UI16o3qVFeprKPufPz1gIwJ+fdg9WrX3rbl7vWD8yJ69Y96Sxk4eqamFhXsH3+wp85khRQYvHqhFvVKPfe23fHffkt6b12ETbrhZPRdX9roKpGeKpFSH9ssq05t0d4+7kR5f7dByVl/F9VlpPem+ZGfk9c7owfvusEaGNAAAAAKDK/up62PNfm12vsveqlmfN9l71KX9H71Xv0lZ6q/rknSTSY0r0vY54r/r3OMpD1adzVvJe9fOz1ltVlgeqSI9TM+s54h4+lbl+2r3B3fWodOc9+ykyfvTMkd/OccfrYqtnqrv1+Kkv/AzWfWZbHeMN6/Wgex35QXRH71TZXqmiBU+jHqtmi6pmhQWs6JVqtzB/K8tk1H+PTUbZO59RtplpLfkzjlvyVnxvSYuw7Ukfybu73uCFau16kjhHPQIAAAAA7nN5zvLXW+HF4UqwzfRO9S3/6jxnhDeOKzCtqjcr3qti8mZ7sVp1jgreqiLrYMU1RrxRvUvr9aCU5Zkq20vVDC9Xd56/tc5H+1TLONj7PXJO32L9upOHqhFeG95fr4erWV6pPn3vETvdTYv83nI8avsp7U5elA2vVHt6pWqxiSgT+TlqEz2+3ckfOcfo+VvOl/E9I61nnosUV83I75m7eaE6Zx1nrQsAAAAA2G3PeD3gOa+J19vNe1Xr/Ud5r7pj8+15Rr1Xfcpr8Uj1V/rO3qu+9YEM71W9513pvWok75P3qp+fel6qIj1FZXmrGrn/lnO8FlzjU5loD1XfvCt9SxsZGyqNdb1z2OuPtF6vVRGeplq8Yf3f7J2LkqS6rm3N7fP/n7y4cR4du3btTNBjSrZhjIiOBFnmlWCLytmSd9uvD6SfeKyZbBO7Z6fqzkqlFFN17F+xHGm/snl8VhNPqa/FziKryraMb+dn1idi87RHfbPLnnljxnp2TvT2v5un1RmqrD5koZoXMyIO4loAAAAAAABAPyfnt+S+zgn9n5a96qpN1WeH7FV3PmSvurepMlRZfFb6rO7zhGxV1X0zGagsy5b1q8xN3+zqzFD/jHUyVFmvh/U6q+9TxbidmUOzMQwZqpy87cck74+4anFBJivVJ9sx6gRVq4iqPIKcq7anCKvISqVry/hm+tyNHZTyiy9n1xUCqR2zUGXarHOrstxfNH4hCxUxHwAAAAAAAMAK76jng8/v3OhaZrcVOe+nZa+6avNmr/pmj2av+mu/sykyuFRlwMpmr/Jm1Mkez8zsVceva2/9/Hn/qEVA2QxM2SxVCl/P+SivScVxXfnc3WfW5U/3/t361XOozGDkmXMqsR7HeWOPXGflmFzh/zr+i0sgf/i8P8Zafhy+EiOMi7Zoqb+r9axI6pPNa4/artbH0Iivsr6VbZ3+O4usqmyq71bZJ/Kp8lXZPO2Zfpa+kf5d6122iD3ap6M9EifsmoUKARXnCwAAAAAAAHD3Lns+9NwoD6jpY/W1+Hl9Tkf/rIjqZ1tWSGXxjQiu1CW01NvL/IAfFWDd+Vr734mirtoyJQGPMackoFpIVOXbcT6RbR2BPtb7RlnibwUxVQXqOfduzvGIpxQC0qqYBYHVD94gqFJnejgc2z8cx3EEjy0qOvi0fLWetUXEVApR1hgxUVVXtqrdhFJq2wyRVWY7yutqaVP2UXyqfBVjWKa9avlufdVSfpViqV2zUFX4VcYmK2xrpX3tGncCAAAAAAAA7Pbe+0SB1bnZNcwc+4rZq775KrNX/W5/Q/YqrwBrZvaqqEAks70rX4/QSpWhyuLT+TmGTpy0cpYqxbWpyEalEFB9un+/rd/ZhvOZriIiClbv4ypTVTYzlSLT1Gwh3CPEWWSoWuvl46ctkp3qm1+m1N8s0VRlRivP+hh6wZW13do36t8hrHpan6y/2mfGZ9RHZcuOc5XLd+tkoYoFtGShqo07OmOcN8RxAAAAAAAAAG/iiQIrslfZ+1Zkr7JcE7UA623Zq9Qotq/60V2dveqq3WvzZKiy+ChLA3aLrTx9qrdfIbby9DkT99SsEn/KZ9YzztzNBZFtZObYq+PyiKe8os2r+65qnN01Q5kEBFU9P1TeZapSZqfytP9dvlr/absTUn2yZ8RUSrHVGPUiK8Wy16bYxgrl/p4souoST1Vmm4pmnZohnOoQSu2YhcrjSxYqTbxAFiriRQAAAAAAAIC3gcBqrX3tkr3qyl9RHvDN2as+kc1WVZG9KtJHUSJLVQbwrk9FFit1Vqsx9snepNh+5LyqzqcjQ5W6xF/H/H415lr63M0VmeO52n5GqDaSY5qq/yrx1xLn8F+bXKxV9hst9+fdfjY71bc+2VJ/v+0WIdW3NouYqltUNbsk4NtsK5f7u7Jl2zw+ij53Y8msEn4rCqc6RFMKgVRXxilltimyUPXFOgioOC8AAAAAAACAVd+xnyawInuVrk+kPOAZ9PEIrCIiqp9ts7NXfbLtkL0qI5ZSlkT71u7pMwx9sxmqxli/9F91CcDZIqvqbFSK+9lS4u/qmesSuHwb+4ZhXon0Uc3VnnFgBMaf6njj8Zmmojw9Q9WxwfEofny1CA9UGaoybWoxlUJUpcxWhbAKEVWkLeOb+VT5qmye9u7lu3VK+en6eOZGslDNiXeeKDZCQAUAAAAAAAAw5x385Hym7Wtm9qq7fp3Zq+7OJyKiutqmWkj11/607FWrPN/VZQA/bS8iqvL4domtqkRJY4M+3u/Ik43KWtYvU+JvxtxszUYV8RvGPopjH8Yx45uPZTxS+IEDSv7VBbPeBzMjhsgu/123lPT71GbJRuX1UwmvxqgRWlnbvH6R9tVtO5Tze4uIamYJP6VwilJ+fluHPdNmnS+VQqto8LyCiAoBFecEAAAAAAAA8MR39CcJrM6Nrl139irvtdohe9VVm1d4pc5q9ZbsVRXLnv2PoC0quJqRoWq1kn8r9rn6riIZqjztCjGV5b5XjwNj5ERU1kxVXZmeRvL6HjdzmDd7mLLPK3m7oCrzo2v1j8bW/tnlK7HUN3skG5XFLyqmioiqosKqMWKiK8Wy1YaIKm5T+it8Kz+VbRGbwje77Gmr7Ntpi9ijfTraFfN5VR/FfF+1rZX2xbkAAAAAAAAAwLf3+JNzCe3vyeUB35696pud7FV1z1VGaKWwWcVY46b/aiKrXTJLRbKBZYRWw9H+6b6sEFOpsWSZ8oioMiIr1fx83Ow3cs0tgqdMSVQwQoYqW6BVtc1o9qqrvhEhVaSc36d2hYgqI6iKiKp2KQM4U+jUvb/KPorzq/Kx9h3jGSIqSvnlRVAzslNl2qzznlpEtWsWqqp4ZOZ+OBcAAAAAAAAAyLznI7Cas6+Z5QErsld9890he9U3O9mrfPdkVZYqRcaqTzaV8GpncVWmj9q3KkPVcLR/umciYirvM5N9rsewZaPyiqjOwJg/DMfjPbcReNY9Y8/sOGbm/TON1QVVu/woVl3u726bVkHAXZm/nzaPgGo4fK2iqDFqhFhjaEsDjtErsoq077Cd1UsYWto8PtG+Y/SJqTL+nnZ1v7sxMeNbsZ61eX0jcxZZqPpiFbJQvfc8AAAAAAAAAOCepwqsyF6l6RP1JXuV3zZufCqzV135RgVSd/dgZDt3Qopsyb+rth3FVV5RVcX2x+jNUDVGLhvV1f12OMbYyjnIko3qapyyjHeWMbu7BGC09J/yO+oSMj0+69WTM1Qdi+5X+YNtpIxVtsyfN1NVp5AqK6qqyFZlFUytVP4PYVWPiKpCGEVZP39bZd9OW8Su7uOZ51YQUZGFihgPAAAAAAAAAPamU5TUdR7V5/LW7FVX/mSvWjt71aqlAqNZqqLZqaJtnrJhMzNVrSLAqshQdWeL3FeeTFVj5EQvkWfQk41KMd5Z+1THEKrSf5TmWwhK/sUCTMWPtoeob0ZQYBFHDYNPRjyl3q6nZOAYzykD+IRyfN3bzrapfSyflT4qm6e9ajkyHlaue+eBJ5byIwtVzbZW2hfnAQAAAAAAAAAzIXvV/H2tnL3Kc65kr1ore5UHa19vOTVllqq79g5x1UoiqzHWEWCNEcv2ddcWEdll7iurv1q005GNyjJGnskxOzKPHTf+3tJ/me8dMZaYNwuqsmX61McRLff3234nIvCU+PvdbhVGWc+7499I+IyhF1pZ26LLFe2V23lyRqodRFQ7CKeOxHg3Jq5nbQrf7Hz3BBEVWaieFaMBAAAAAAAAAFh5isCK7FWx7FV3/aqyV33yIXvV9/U7MuKrjsxWHlFMJkvVJ5u37ZuPpc8IbqtCwDWC+8v6eDNSXX3vShFftNSfl9M5Xlm3kRmTftoj5f8iwt27c7N8R8pxR7kfhFhfIEOVPsC8sleV+/u9bvnh31q6z3JsO/wbY66wStHmWY60z+xTuZ2sv8cn4vvps8MnYvO0R30j41m1r2dMX6GU36wsVEqfzLxJFqrnxFIAAAAAAAAAACqeWB6wM3tVdn/d2au810qVvcri89bsVVGfCqr3ExVaRW2zSv9Fr0tmP50iqsh1vrNZ7hNvOb/hvL+yz8638cXr7xnDPOJQq4CqYz61ip8iIinP85gRTL4eBFW1wWWFn7LEn0U4dTzs3xjrlAGsLv33tvJ/Xlu2bYj6jtEntFLZFL7WZVVbxXrW5vX1bscy31DKrz8G2GU/nAcAAAAAAAAAPBWyV+X3t0r2Kmv/J2Sv+t2+W/Yqr5hKWSpQkckqU6JtGPtlxFWetogQo7Lk30geg/ccK0RU1u9LKVLpyk7l5U50pRpjfto9pf+8QlfV95MZByrndURTN6wsqFqlTE9225YfxlXl/n6vX2Wh+mZXlfSzXJcdhVVWu2fd2qZYrmhX9em0Wdo8Pta+ke1kfVQ2T7ty2TvOrS6i6sg2tUIWqgq/1WIEslC97xwAAAAAAAAA4Jk8MXtV9bmskr0q+v3tkL3qk0+ViOpnW0cZwE825d8PKzJQfdtmVCyzSgnAb75dQovKsoFZH2/bnc3y/SuzU3U+J5bMVZkxJiKiigirFDHB4ezbLWpCROXkrRmqOsr0VR6rV2xwJ6C623+VoKlzfx3CKovtat2yrBBFzRZbVW5H1ebxqfjM+qhsnnbvNq78PW0ZX8+4/+ZSfmSh6o8JEFABAAAAAAAAAMzhKdmrfp/LrtmrvNt7Uvaqu+saaavIXqUuDfjJpsxOpchWZfFTZiV6epYqRbYqi6/XRyGi6spOFb1XM6Iqj4gqOsZUia2u7MNwXtbrEv3eVP2eEJNNP29K/mmDuiu7IrNVVjRwdbzKzFQqodVThFWZ9crlGe2qPll/tU/mU+Wrsnnavb6qNsV4OAQ+ynmAUn6aQFXRt2I7q+2LcwAAAAAAAAAAsEF5wPn7UpUHfFL2qmhpwKs2b/aqzoxWKnHV+HCsHeKq399VVbmvqMjqt093lqq7/XeIpyw+ndmplPeF5R4ehvv4btzJjiU/7R7RVIewSnl/j8C9sVIs8TphF4KqugDxzq+63N/VtqwlndTZp7zbVh2PSlTVKawaoz9D1ZNK/2XbPD7e57o6S5XKpvDN+GV8PeOh1yc7TkftmbYxdKX8yEK13344BwAAAAAAAAAAHU8sD0j2Kk2fzuxV0dKAV21e4dWKpQGVmayGY79ev5/X1SuuUpQC9Ph8852RnUp9bh6fiM3TnvW/uv88969nPBwFY8ldhqqIsMr6XVUKq672WXlfUN5PAIKqXKCm9rf0V2WmUmel+rZN636sfZ5eBtDapl6e0a6wRf09Pp2fUR+VTeGr8suuU8qPLFSztrXCfjgHAAAAAAAAAIB6yF41f19kr7pvr8xe1VUa0LO9b8wUV1mWu571qICq+9iekJ2qOqvUUehv3ea4eA692ag+2SKiqWPEs1XdtWXubdgUBFW+wG7mfjOig782y4/rVZmpVIIp1bHuVAbQsrxChqpZ2ahWL+mnFk+9WUSlyEJVYeuwj9GXharCTzG3IqB6VywEAAAAAAAAALAbZK+au683Zq/KZreKZK+aURrQK7jKiq0UbV3PqjdT0t22PP07s1J5jrMyO1XFd2a5txRZ0rzPxXCMJdZxw/LcfrpOkfW7bQ7D95+dmxBTPYAnCqpm/0h6JI5JmanjLhNUxfXwiK2yZf6s+yVb1XszVFnalH3GiJX2m5GdSuGr8vO0Wce6qE0xrlPKTzu/IaJ6diwFAAAAAAAAAPBUyF41f19vyF6VFWBFMlspynl5fL2Cq3PkSgcq2jJCq4oMVllRh1IQZdluRtSV9YlcS8/xKgV6VyX+xrgXVo0LP8t4Y32ux9Bko6rIXvWtn6c9+txZji16zyHkEvLGDFWRH7uj21Ts2ypW+GTLlNhTZafKCKcsx1p1Pqtkq7K2qZcr2jttY6xd4i/rE7EpfFV+njbLetTHY1PaM22K9si811XKb0cBVfe+OH4AAAAAAAAAgP14osDq3Oiakb3qfhvRzFZZwZTHdxdx1Tc/dek/S/auu+2vLLzICKwqjqMbS5YqRUYqj3gqMjZ4M0d9Ekp5RVKR79MiUvLMAW/KbPVogRcl/+YGnIdoOxbb0XBO0cxU1m3MFlaNsV4JwKjgqUNgpeqjasv4ej7VfVQ2T/unsQQRVY3dOhd0i6jIQrXGfjgHAAAAAAAAAIBn8oTygN0isRXLA5K9SiOu+maP2qxiq6s+npJrFVmlhmFfu4wTneX+PNtRXfNMZilvab9z2LPH3T2LnuO1ji2ekn4Wn6vn9Mo3U+rPOp53loq03stkpipgVUEVP1TGxAt3+z5Ex2XNUOXNTGXtO1NYNUZfCcAxejNXzWi/smXbPD4dn1nfiM3T7hl7Zomo1IKplUVUO5Ty68jsuFK8QBYqAAAAAAAAAACogPKA8/cVFWutmL0q6jNTXPXNrspSZfGJrkeEVpnlu/0obE+n8pxnZSH7dq8PwViZzV7nFVZZBUKetkxJR+t18c4DyjkSIVUhZKiKDxYr7edwbqeitN8Y/uxUlrbVhFUj4TNGf6aqJ5f6i/hEfD2fKl+VrWpZ1RZZr7ApfLNtivYqP8VcSBaqZ8cuAAAAAAAAAACg4wnZq7rPg+xVvuNHXHXt41kfX9oqRDuV27ecV2Sfn7JTHcljrL62VpviXKL33JV4KpuRatyMIZYxIJuNyto2vvhZx95TsB14OAiq7AFT9Xbufsw/HL7qc/h2vN4sVVf9vfaZwqox1hRVWZYVJQIj/b22bJvHp/Iz6xOxKZcVfor1CpvCN9umaK/yU8wliKj2jV0AAAAAAAAAAGANyF41f1+zsletUhrQKqD63a4WV2UEVxGfO/HVXYnAcdGvKjuVIiuVRSRUKWzK7id7bpFrpvguLaIqzzN3Nzaoxhrvc2tdtwqnKrJUzZojT45jTRBUaYKxO3u0j/cYrrJCqc77GL7sV5b+uwmrxqgVVM3ITLVydipLm8cn4vvpU90nYrMsr1Dqz7Ie9fHYFL7ZMf3JpfwQUK0VkwAAAAAAAAAAwPMge9XcfWW25e27YmnAaGarqgxVP+2WjDhXNo+Y5a4E4DffTDm4rhKAv9siAitr32g/73FenXv2WnpFZd7MVNbn5K5tBHyj2euiIqpP+7IIp4Zxex7/SmHRLNGSZb+IqT6AoEobiHn8q8RXlkxRynJ/njJ/d/aMEMsrrBqjTkz1hNJ/FWUArX0t21D7KD+VbXe2juWon2U96uOxKXyzY3O3iIosVGvsh+MHAAAAAAAAAIBKyF41d1+q0oDWvpWlAZ8grlLYFOtXQitvdqSu7FQeUdIOZf+ufDIlGxVZqj61Xd1T32xXz4l1jMiOI8fF2FCRmWoE+uyUpaqa86X7TvM0QdUKPwh3ntMx8XyyZf6yvtFsVllxlcJ3jHdlqVKIqyxtHp+OT2/bnc3THllW+H0bf7pL/Cl8s+MspfzWmXvJQgUAAAAAAAAAAG+A7FVz9zUre9VO4ipvubBvdrXgylvu7249KrSKZrOqKvvn8YmKpqzbUR2vt5/3ml8tj8T61X1/92xZzyn7/KsyU40vft1ZqgD+h7dlqDoecHyHsc9RdHzeTFRjXAuY7rahEFZ9avNk1oqWDBzOtjHIUjVGj4Cqo9yfty3a3rHcsV5hi46RTxVRkYWKeAUAAAAAAAAAAN4B2avm7gtxla7NKqK687WUBFRlsaoqB1gprOrOTrValqpP/lVCqsj95Xl+MuOX5/nPZqb61vcIjptnoC26TXhGjGGCkn89Qdes/R2CY7GW/LP2s9jUwqqIIOrqfLoEVWSpyouhnlbWb2Z5P8V61Mdji9ijfRTt3jljNxFV53yIiAoAAAAAAAAAAOAzTxRY7ZK9SlUasEpcdSa3d7WdrLiqK2tVdznAT8KRamHVnW0Y2r75ZMVS1VmqouKqu+t3tzyMbd570jOuWDJVRceIQzA2ZoRTuwqlEGltBoKqNQPZ37bsD/JH4t/dNqP2K7FTtJ9HWJW9LmoxlSJrlbXNs1zR7rVZ2jw+ik9lW7S9avluvUo09bZyfoio9tkP5wAAAAAAAAAAAE/jCeUB35a9ynsM1v2o/DLt0ZKAqqxV1UKqv+sRkVVkWZmlKiOWUguvrMfjbbOKprzfxXC03d1/d89K5ThxJ5pcpdTfCOzn7l7rYqdjfR0IqnqDuertHk3npBBSWXy8/b71/W1XZqGKZMIaIy6y8qyrlyvaVW0en8ynsu3OpvAdwy6O2rGkn1osdSTGc0RUe8+rg+MHAAAAAAAAAICXQnnA3L52KA24qrhqRtYqVTlAVYaqT23K5Tux1elsGzc+1Z+WY7jysdjGsAvVFBmqomJB9bhXnZHKsv+O+edJ4qPzwee2zPkgqIoFYStvt/JYvdliLIILdYaqTzaP0GkYfaMlBceYXwLQI4LaJTNVxNfymfWJ2Dzt2eUZ61mb0p5ps463VSIqBFTEEAAAAAAAAAAAABU8IXtV53msJK5SlgX0+lWVBMzYo6X/PtmqMlR9assIriwCqt/t0XKAmUxTFiz7u/IZQZv12lq/u99t39aHwRYZK6L+loxU1nPrFmmdRb67QMYqIQiq7gcWRZ8rsYV1O0dgf6prcTjaPKKou/NTiK2u7L/bMuUOM4Irqz2zrl6OtF/Zsm0Z3+H0rRJSzSzrVyGS6ijzF7Erxk+lkAoR1bz9cPwAAAAAAAAAAADXkL0qvp/ZZQGzwgnvdquzVmXKAX6zRzIGdWeo+usXLfdnzVD1yXYlvurIWjWSPmP0Z6j61Ndzv0SeBc945xVfnkXj5Orl9M7Jx3ROPr7V9jsVBFV7BXhdff/294oOIgKKO+FURqBlET5dtWWzUVl8x4hnrBqjV1ylarf2HWNOWb8nlfvztCnWoz5XY1ZHqT9Fu2fcRUTVvw/OAQAAAAAAAAAAIA/Zq/r30SGuivhWZ61SlQO0+p5Jn90zVH2yRbNAdYqqxlgrQ9W379WyfmWzPnPWceJIjE3W4/7GWbxs3fcukG1qMgiqcoHLsdCxRNq/9TkC7dZMVVfXMiukypb++3au3n/WbYyhEVNFBVSdIqqnlflbvdyfp61ivcIWsWfarGMoIqp198HxAwAAAAAAAAAA1PHE7FW7iKt2KQkYzUoVbfMKq7wl16xCq2/rVpHVThmqqkRVn76rDjFV5Jp7v3fr/TfGvVDpaBi7LNteafzPlvvziLO+/as+7pnbfB0rCqr4kXLO9TxGTFygKN/XkcXqp80qnopeK3X5vzvbGL2l/yLtV7ZsW+ensi3afvfMqERW1mdzCHyuxip1NipEVPPmXkRUAAAAAAAAAAAAz+UJ2at2EVetWhIwKvyYJazy2NRlACPZqqoEVhZx0nD4qJ4T77HctVWJqb4d+zC2Hxf395l8Nq3XuZKZ80GVSOkU+ex0LV8LGarWDNIyPt/6ebIqZfbtFSsoslYNg8+diMpzzTzX1Zq16lvbMPhdrY9Rl50qI6JaNTuVJ0uVt+3OVrVsec7unuHuDFURe6ZN0R4dp6OZBLvmnZW3Pzh+AAAAAAAAAACAJXlC9qpOcdXTslbNEFZZ7SoR1TcfVbYqZdm/cXEMGeFUZak/lYhqGK+F5RmwCKgiZf4y+6smksHpNLZ1l/47k+cWyT6FAOoBIKh6XlDauY+sECtbokyZpcoiMIuIp676WvafEVdZ2zzLkfYrW7at8zPqc2dTLqvavj27KwqpyEa11pyBiAoAAAAAAAAAAAB+s7vAqlpc9bSsVVafSPYdT1aqO3u0DGA2W9WVyCqTuepqm9Y+M7NS3d0rVSIqbxYqa6Yqz7nN4izexqrndjaeR1TkdTZcl1W/u6VAULV+YHYsdCx39ohAw3LOnixWEVu2BKClr1fElRVXXfmrlxW2Kp/IZ9bnzuZp9zwbMzNUVdg8Y4anTdEeGZ8RUe3zxxwAAAAAAAAAAACoZefygEfxce+WtSojrMq0H2PfbFWeNu/3V5Gd6mpfndmphuPYIzbLdfX4VWSnUhLJNLVLdqrTedyZ69SxDcRNE0FQxQ+pqmuTKfXnEVrdCUEyJQDv2n62qzJVWdqyJf/G6BVTVWSg2jkrlac9u+xpU6xX2DxjQmYMyox5CKn2njuZ9wEAAAAAAAAAANZh1+xVO2WtigirlGIThbBql2xVVgGNJ1NVdHk426Mipurn7Bz+Eng7Z6eqvr6W0nWnY1vZbYyG8707rjN4nTLHMfMarPx9LQeCqvrAr2P7x4LnWJVZ5ptfRkjlyVTlvU7VWarGeHeWqojvp8+sz51ftP1qOeqnWK+wRceGLiEVIqo5883bjxsAAAAAAAAAAOBt7Ji9avWsVZH+6mxVf/2qygAqslVFshipRFTWfXgEPdnrPTtLlfe4KrJTZZ5ZlWjpU7+zqN83n092T7m6mdmp7q55p6jNsi+vmO2cPF9W3efLgKAKLAFr1lchrvJswyuk+mb3iLs8wqsjsG+LzbL+qS0qoBpDL6basdTfnc3Tnl2+W1cIpypEUwipesfslbbNMQMAAAAAAAAAAMA3dhNXdQiruksB7pStqkJUlf0OooKrzH6ekqWqOjvVKPgeVOOVNaOQVSB1JraVFQGtXOpvVoawjO/jBUyr8f+4BJAIXiM+6uxUUYGIx/67PVLaL1sC0GKzrN+JrKzLSoGVta269F9UcHUIr9OR/M68JTLv1isywVmf+7vnZgT6qX0ivlfP8piwDfV5zZ6fdjtmAAAAAAAAAAAAsLHT3/9W/7vtUbhPq29FsoZDdL53fSO/TWa/C+t/uq+4zp7vU5H8YBR8jx4y2Y6G0/9u+x5h1ad/1r7WtrtMVeeIZY6q/h6t62fwOkeu/Zh4bRTX8zWQoepfytYnBJJPOuaj6Ny8QiplgO4VWN0d4+oZqsaIi5Ii2aPemqHqbn12Virli01WkLlCRiqyUTH3AQAAAAAAAAAAQI7qTFA7HOdTslWd4nOsKPOnuNarZalSfXfqbFXH4s+1R2B1Crb5t/0Un4NKSBUt89edteo0nIv6+nuzft21P1GktcXxI6h6DkphWFe5v6xfJOOOdb+VJf8+9bMeQ1ZYtWqGqjHmiKqGYdtXPhGbcln9TCjFVR125TiEkGq/P5YAAAAAAAAAAADAu9mlJGCVsEqx3WwJO+W2K4+7ev8e0dQK5xLd5+qCp2+cRX0jIpfTYf/kE92nRUQVFVJFBVNncHkMXQnA0/ldqe6fU3iPRo7lLHpeHseKJf9Qy+0RmEZ81OKqqvOxnqei5J9lex5hlXU9m63q93ayGaru2jwpRxUpSMfNOVjOz3rtM8uVYirLPTaGpqxmVXk/VWrhzPikSr/89rJ+lPMDAAAAAAAAAACAK3b4++Gx6HaPiedxFOzL83tDthpH9TWL/Ef86L5nPj/nr88rn4jtW3ukPJ03S5VHQGUVTSlKz53O47NkdurKROUVWSm+G8X93d0XBPw/LsF2nBP3oU7ZmAkU7rZ3CPanDsitAqtjxIUr0bJ/3qAs0p4VK0UEU9HtHMnz8VwrRUB8J547bu6vFUv8HSMn0PQII6texhFSvec4AQAAAAAAAAAAYA1W/5ti1fEdk/t3b3eMvf92fCx4XqfIx7Ov6D4jtq4sVVYx0pX9Z1tXuT9Vliprm1pwlSn5N0aNkMp7z57B5+dc5Ll+JAiqnsH5wn1XBIaKTDfKoNmb4ce67slcZb1eXrGNt+3OVyG+8mTDuuunzlI1gt9n5FlQi6nISrXWC/8u/0sLIRUAAAAAAAAAAABkODjnbfbVmaWq8hqo9pkta3a1PWsf6zHeCTo8wo9h8J2ZpequzVpeLpKZypN9ypOtypOl6hz+8n4Vpf9GcJ/e7+TuWkYyg3lLDmbu6w5WO54SEFStyfnQYz+F53hOCGAqAy5vlp4jed5ZsYfnOO5skXJ+2WOvKPVXGbBXZWqLCo+qslVl79unZKV66x8QEFEBAAAAAAAAAACAkpX/5ni86JhW/7t3dBvR7DJe327OxDGeiWtRVe5PlQXpU5snc9Mw2H+2WcVn54iXCrS0rZahytrfew6R62+51opn/1xkTHglCKrWv3nOxc7tbDj+qMI6E8CskFrzmOhfVYP5CB5HRZaqEdimt83bri71l71fjoLvtOIeVZ2f+gWKrFTPPD4AAAAAAAAAAADYm4Nzfex1PRfZxgr7v/tN9cpmETNFhVZnYDvqLFXqcnJRwZFVxPStvStD1Tn2ylBlbRujv+Sft9SfIkFNZfnL14Ggap1J9VzseHYLVs5Fv1dV8HkE+5Ol6n47M7MlKV9OjuTxHZPv5aPounRtb6Xj3+kPBQipAAAAAAAAAAAA4K3w99E6zsnbi2avml3uL1OaLyO8sgioVhdSWcU7HgGV5bplRFZ3x2WxfVv/dA2qM1RFyjJGMnt5BG6R5/BJY+f2IKja60ZZpe5lph5mV9k/Zd+VB463Z6n61icjiKks8bdydqqK73Kll8qj+VrxMn5/bPyxAAAAAAAAAAAAALrg75HzWCUpwin0U5X7e3p2qrvtRAVUp9HmWfYIdSzrHRmqokKfK59MdqpseT5Vhqpolqox/GUUPdu1PreqZ/JsHF9XmjOkIKiqmzjfFuSc4m1kBpBoILP6d7hylipre0as9Mn3CPofhdf7t21GOTyyU/ESf7zwnAEAAAAAAAAAAACgj3Pydk7B9ip+PyQ7VW5bd213tujyp22qhDvfxEl3AquIqMe7rUphVUW2qlPwfQzD95Qd09RZqc6icRRuQFDVG1B41buKByOaeq7y2HbNUnU23iuZ4z2F18hKtShkNdHJGwUhZKfiXgAAAAAAAAAAAADYmTf8Pfec1Ldqm2Snym9TnZ3Key2z2ak8AqqRWK7MUGW1K7NVDed+MsKqaNk/6/egEL5Fy/15viPPs5d5fleYU14j8EJQtU+gcwq3NS4GlcwxeQcAz6TfmaXqTF6vXQLjRw1mC7xg7VLuT5mdC9Z8eSc7FQAAAAAAAAAAAMB/cnI8yx37btmpsuuW/UR/K/WIkL71VWap8vY5jce+Woaqb6Ki37YruzdbVbbsn1dYdQ67iMoisjoT348iQ5Wn3J9FN3AnZFOMPZlxrULI+RqeJqhaTQlXeTzqbVsGBGXgk31wIwKrMXyp/TLXayxy/T2B21n0Hez+MqGa/NSpWofonoA4iIMAAAAAAAAAAAAAYBXekp3qFGynIxOMNRGFajlqiwitop+RtsoMVR6xj1U49Xv9Tkg1btq9lac84qpvbZFsVcNxLa3fwXC2jREv9VdZ7s8jcoo8h6uM2Y+EDFUETJaHPBNcWDNGdWam8gQSVmFVtnat6vtQ3ScKkU9HWtHsuZ8vfMaZMLlOAAAAAAAAAAAAAG+D7FS6YzkbfFSVe05hX1VSA5XwLZKRaoaIypKFalaGKk/b1bo3w5MlW1U0a9VwbjubrerKZ4xY5qoRbIt8N9+es6y4zZvwonr82mFeXBIEVTU3i1oZXZll6G6gUAcUWRHPGdyPRYlqUadarlm0dq3lWDzfzYzsVAqVf0S0FVHAW7c5kufXkfa2IwvVinV7d3+BJVABAAAAAAAAAAAAAAVnU78Zv3lY2jLJFNRiqrsycsPQZhVG3bVnMkOpP71td8KbMXIl/hQioExWKqWIKpKJKpOtynsu6nKAdyKrO9swnLdlDPOW+zsT49kT5pvZ2w6BoOpZX2qniKJbhR0NPCIp/qyDasW1jgqpOlTy3dmpqtMWDsf2Vyz7l/k+TsG5RMaiSGCgKG/6qol98UALERkAAAAAAAAAAAB08/TsVCuJqaxJBbxtnt/IxsgljbD8tnjlf+X7qZ91+Wqb3rJ5XWKqc8TFVGPci2qs2ZHG8Gdp8oiWVFmphuB4MsIq1TXIrN+1eda7yvxZxwvPGHH3fI7AGNcloH3Ub4GrCqrOxY/hnHjeM5SKClWlVY2dDTqsx+WxWRWr0esaLfvnOY8RvK6Z78tjizwDynrNd/vIBuFkqeLF+hVBBQAAAAAAAAAAAMBCVP0H+VWOJ7O9s2A/FdVZxvBnpYoIp8bw/75Y+buoRUClEE7NFFGdCdsYcSHQGDphkFKYFO1XvY8x8qX/IqKq4ex79Vx7BFaKilSKRCincAxXzwmv4r+4BPIb7RD4KLcZufkPx37OX30+rR9ftnG1/HcbV9vzto0Px2Kx/b6Oqmt9GAetu2tutXm+q8x9+u0++WaztHmPJ/rsnoH7/3A+s9Zn4DA+30dwLLlbH8nr/q2v1+69pqqxVz32rzgfcWwAAAAAAAAAAADwVMhKpel3NvichfZIwgiLzyluqyz358lGZfGJCrEyWapUpf6y5f3u1u+yU80WVCkFV6Pg+L3flcd29b1kx2JLEpSqcn9n4bgNg5J/nYFOtORa9IHIqtIjKTWvAgJrUKDwU5b960oF6FHHjuD5RAK/6jSjw9jmCeIin8N5PE/NUhWdYCtfdqzHpgwOTvH3MitoofQfAAAAAAAAAAAAvA2yUl33Ve/niVmpvL87fttetsTf3e9sCtHSJx+P8MWznSufMXrERmO8NzuVOktVRSlAb+Yqj81SLSqakco6xnjL/VWN7zvsZxkQVM2/qSp+hK8Q+XgHhGgQYQ0wPG2W9TH8YqbIIOtNB6go92e9DhXpR711X6/azqZnNXqc0edeWf7ybt8RwVX2nJWiLkRV+//x4NVBFwAAAAAAAAAAAJRCVqrv/U6xr1Wg4D0Xz+9iY+R+w8yW5er+vU1Rxs8jihojLr6y+I5hL+uXFaRViJiG0Pef0Seo+mfMzVI1Rk5UddVnDF92qshvaNmSf54MeZGEIdb9rjifLvm74RNL/ilKQ61y3FdlvyJlsxQ3cKTk3xj+snxVpf6+rX+zjfG5jN63duXgcLVf6/FnvxfPd/LJ39L+zc9bDjD7ebWPuzavLbvsee69pf6+lY/MlDu0lAuNnk9kDLSOk2fgGc+WSRyFY/iqc98YlAAEAAAAAAAAAACAOAipNP1U/yH5FLedxTZVAomrtqokBqpSf8rPqE9Fib9vy9nSf5HSft/sK5X8uxJcRY9vBH0s38m3flf2T+OBIitVZtxQjtmR5BPqLIqP4s/Cx3YU9j2M9qt1z3Lk07p8GO2Ra3i1rbt9j5vjHwHfEWy7Wr+zHYZro7jXD8c+7+xH4DpYvofDeK8fzvbD8SwMke8Q+UZsVcuetnFxn2X7qHyzbdZ55HA8pyvNY2PRbT/52AAAAAAAAAAAAGAtEFJp+u4kpPpmrxZO3a1XiKyUoiq1yErl2ymi+rnsFVRlbdUlA1XZqbpKCo6hy4A1nPZIdipr31MwFgzDs7v6XPgoEFRd2yMCqwpB1U/bN+HUN9snu+Xfp2vjFe9EhFRjxARZaiHV1fnf3VuR6+vZ35E4n4yI7a5PVGB197x4np3I85b1ubN52iPLnjbFetamtGfG++h8452bsgKhKoHR6sIlhFUAAAAAAAAAAADwjfMFx9SRlapDSHXVPktIZfE5xW3dWalWzE7Vnakqm4Xqbr0iS1WVsOofgV9GjDUSPsPhN4Y2M5U1O9UQjR+K8da6n6fMveUgqLq3R0QMUeGGN1OV15b5Ny72M0Y8K1J3hqqI7U7MEclW5RFZWcRVFttw3MtPz1DVJaaqFFhF/SLrUR+Vb7bNOqesmq1K0b97u285PgAAAAAAAAAAAOjhfMlxrVLe7yzehkdI8Mbyfj+XqwRUHt+qrFSfbF4R1ewyf1ZbVCzl9e/OSKUUWY1hF1Vd+Y6hyUw1RiwzlWfsUI7hqnJ/ZLz6AYKqe3um7F80a44nO9Xv9QoxVUe5OZV46u67y2SpujpH1T1v3fcwnscIXnfvve55BqzPnKXtcIwXs8r+edqVyx3rWZvS7r0PFHMPwqp94gIAAAAAAAAAAADYE7JRafsipPKvd4isokKqq7bqLFVRn87Sfj+Xu7NUqYVV1j4REdU/wfYKwdYYeQHW1ZjiPZa77XyyW8YKy/hlKfu30hx5TupbysqCqv/mKOq3uqDq7+dddqrf63el/7LfhSc71Rj6DFXZrFTD4HMYzj9yrZQl/66ONZutqktUdWeLtHnFVh1iqi6BVdQvst5li4zXnrkDYVXvdt92jAAAAAAAAAAAABCHbFTavquW9vvWtoqQ6vf6CkKqT7Ynl/mrLvV31dZZ5s/iU/GvM4NV1bUcjusXGWeV2ak844FqLCbbVJK3CqqufBTik6yQ6u+nJ1PVN59PfsrMVJ6sVZ71q2uuyErluR8swguvgC0irrLex4qSf5bnJis4yQqohsEnK7q687W0edqVy2NQBhBh1XrbfetxAgAAAAAAAAAAwD0IqbR9EVJp1itK/VnbV8lS1ZGN6q49Wurvqk9UVFVZ6s/q1yWk+mfMyVo1AvZRcP3GxbaHcJzIzgenaE44BXPPo3iqoMrSN/ojv0WwkMlWFclUZRVcVZT9GyNe+m8MndDKum7NStVZ9s8jrMo8J1FhyJHwV2Qt8mSnUo05R+AYhvG597R7ru2bywBm2tQ+0ftxVWFV9bbfeJwAAAAAAAAAAADwL84XHdfZ1O9s8Im0rV7a7/d6l5BKKa6qylKlFlJ9ss3KUpXJTPXJZhFF3bVXCKz+GXOzV0W2l7m+ynHbU+IvOzZ4yv2tNM89VnCFoMpmz4gYotmqPNmp7tbVwh9LhiqvzZtBKVvyz3sPXG1beb9Xlqscjmts7VeZpWrcPE93+5mdrWoYx4OqZVWb9XtCWKWbx8ha9a5jBQAAAAAAAAAAeBvni47tLdmortoQUq2RpWqHsn4e3+rMVNlsVR3l/r71zYih/hn6rFWZ87+6tplrl81QdWWrzE51Nx7uWO5v6eNEUGWzRzLBqMr/3WWnultXlv77dr0y4iplOUDr93dlO4rux457V/1MrZSl6mp/R9H3kxFa3fXLjiGR7Xi3EX2+dhBWqZ6ztwqrOsfDtx0rAAAAAAAAAADAkyEblb7fbkKqjG+1sGqmkCqavcbis6qQ6q59RmaqTLYqRck/i8/MEoD/TDq+u+s6BNfuanyziKgi44T3Ga6eK15b1u8KBFU2e0SAkBVS/f6MZqr6bYtkrcqW/xsjlkVqhdJjinux696flaWq4hhnZ6nybHskjn9WGUBPm/JZy4qoKjJTqZ59slbtAeIqAAAAAAAAAACAXshGVdP3zWX9PtlUwqkr34h46q5dYdtBSPXJ5vWtElVVlPxTiKsqRVYV5f/+GbVCrDHioijrmOoRbI0P91lmzFCM+xVZDVefx8v5s8ExHoX9rD/kRzK8KLJVqcv+fTvXSGaqYdjHlf2Tn+o78Nru7pfjQc9FxT49mamU39m4ecYU5xrNTuVpuxsjssuqNuv3oxRbKe2K55ysVeuNS286XgAAAAAAAAAAgF04X3Zsu2WjuvPZpazfnU9ldqquLFVPF1LdtVdmo7pbV2Wn+mZXiKa+9VNlkvpn9GStGmOeuMxa4q+qzF82O9UpnpeeNuenebKgytI3mhnFW3ars+zf+NL+26b69+k6dYurKmyqe5CBqeYaRgRU3dmpVPfkDGHVne9Y6DmNiKQ6ygFG78/O5wpx1b7HCwAAAAAAAAAAsBrny45vtWxUFr9ou1dgtXJZv9/r6mW1uGrX0n5Wm1pU1SmsUmetWqH83z9j/TKBY/QJqCrK/J3F88AQjbPEDv8Hgiq73Sui+rZcWfbvU9tv2zG0PxxbBVYWe0RclbXd3SfHRoNHdf3Us/k5V4lFjmS/I7mPCmHfLGFVZH2MvoxyFc94t7hqhrCqeqxDXAUAAAAAAAAAAPBcyEZV049sVH4fZQYqy3JllqpqIVXUZxchlcfX41MhorprrxIU/TP2FV2px/TOMn/D8WzfjbOefT1xjm8BQZXdHhEkdJb9u2q7yxilzFA1PhyX1e79Djw2r6/qHlztBeAUbcubSjDyvx7OCWOGZbuzslMNh+8Kwiqlj+JZz/RRjhWrZ62qHvMQVwEAAAAAAAAAAOwPIqq6vrtlo/pmVwmpusr8VYunPrV3CKpWLve3e5m/TzZVhiqr34qZqyqyUnX8+z1OVAipTvE4TzzQwNsFVVc+GTFBd9m/n8veTFWH8HuqylTlsSl8lfdg16BTkZ0qomQ9G851p7GpOjuV6viVQitVH9Wz/ISsVdHvfeWSgN1j6xuPFwAAAAAAAAAAQMn5wuMjG1VeRPXJvntZv5/LVZmpvL6rZ6lSi6eu/CozVH2yRcVVK5cB/Kex30zx1e8xw1rq77y5/6+Wh+OZt46ZnrH9FIz/r+LPJse5YpaqbkHV309vCcDf7VeiphUzVWW+I+t9sIKo6hT5ePp3vQh4+mb+F8Oswb2q7F9XCcDO8n/RZ37mGNA1diCu2gvEVQAAAAAAAAAA8BbIRlXXd3Y2qqs2yvr953JnZqqVyvxdtalEVTtmqKoo/6cWTn3ajlrAtFM2qk/jjbrUX2V2qg49AfHFLxBU1ZT9U4urLMKqu7a7TFXK7yqSqcp6zdV2z/11TBwoTpHduv2IqjVap/UsuC67TRjW+666BKB1v7PKAVaPE9E+1vEBcdUa2+eYAQAAAAAAAAAArjlfeGxko6oRV62Sjcrqpyrx5xFNWXx2KfNHqT+/OOqufcVSgP+MfYRYv8eAKx9VqT+vuLIrO5V6Tn1FBisEVTpB1e/1K/HUp3Zl2b+fy9+EVJ/ObUamqjF82arGmCeGUNyP3sHFOwhWZ3hSDaoREVX2mM9Fx7LVSwCumrVqDEoCdvtXbWPm9jlmAAAAAAAAAACA/4WSfnV9u0RUV+2K35s8vt3Cqpkl/rrK+n37XKHM36zyfldt0dJ+lj4ZEdVVm0o8Fe3bIXLq2MfvccLj88k+DPenZQzIzBmV88OOMUEbCKqufXYs+/dz2SquUmepGhf7zVz7ij7Ze+woGGyUwbBa5Z8JVCPHbKkpa227C0Z3Hweryv5Fxj/LuqpPZgxXjB+Iq7TbmLl9jhkAAAAAAAAAAN4IJf3q+j6lpN83+9ngs1qJv6h46qptVnm/K9+ogMriqxBcdawrhVTf7DPLAe6W0SpTyi+SjUpR6m9mdipiDxFvEFRZ+j+l7N/P5U9tv9s/nYvy3901X03YoLjXKgeN6v8NMEPpX/ky4B2MvQHpMEx02XHqmHy/HsFnb7WsVQrfjjEIcdU62+eYAQAAAAAAAADgyVDSr64v2aienY3qU/vM8n5/P3cv7zdTWGX18YquFJmqLD4ria7+adzX7/HB6q8WUlmf88wcEpkvTvHYv1McIeXPRsdK2b+cmMoqour4HqsECSuV9esIlpUl/1Tqf8/5dGanqshKpc4+dhbcm8rsVMPYh5KA+bEq+l2s4D9jPEVcBQAAAAAAAAAAcA8l/er6Kn1nZ6Oq/O3pzme1bFR37Uqx1G9btciqSkBl8e0q7/d7PZOVymrLiqju2nfPVKUUUmX9x5f7YQx9qb/MeGAdE6EIBFX37Zkf/71Cqqs2a5aqO9HVJ9/xpU0htvJmrapsj95Hih++VcH0zCxVszJWeVMdeq55dfm/GWUFj4LtrFoSsMKmtEfmmMx3uoO4SrmdWdt/+/ECAAAAAAAAAMBeUNKvrm9XNipl2+rZqFbNTLV7eb8Vs1L9XJ5d7m+mkOqqLSOeivTZQUw1S0gVGS8sz/DdeNydnertccl/gKDq3melsn9/P7/ZvBmsftusZfpUZf/Gh2PMfv/HpPvpLB44Vi331xWoWs9PlZ1KFch69pGZUA7BvXwU9t8hSxXiqr45uWI7s7b/9uMFAAAAAAAAAIA1oaRfXd8dS/p9s3dVQvGuV/wO1SmoUvXZJSvVysKqmSX/vtnV2aqsfrsLsYbA1/vdK8YM6zzgyUhVOcdT7u8XbxFUWfpXl/37uRwRV3nL/l0t/1y/KwF4FH+ns4VSs368zgxGmWC4Kr1qJritmJA8YqWuLFKn4Lv3vMxYxiSvv+I5nCWuyozxanvkOq0+LlIakOMFAAAAAAAAAIC5UNKvtq9KSDW7pN83ezSjCdmoerNR/f2sykrVKbCanaWqKivVN1+ViMriM0sgNSZve1x8J2Pky/tVlfpTzk2UAhTzZ7PjfXLZv082a5aqyLK1BODv9kPwPXi30SWSqvrxurLcnzUYVgqpVgxqrZNPRmg1O1vVyuNxVxnAyjKBCt+IPTIHZcYvxFU923/78QIAAAAAAAAAQB+U9Kvru2M2qtVL+v1erxBY7ZiN6vdnV1aqt5b4+71enZXqm32VTFWZvucix/fte7J8f2PcC6s8Y8fd2OAdizPZqU7RfKOa17cTfCGosvlkyv79XLeKqzqEVZ/Wf9oqyv8dC37nqv5n0aDRkZp1doaqiiDXOlF1Z6kagf2dBd+5+lmJbCsqTLX2j/qofCN2S7tSOIW4qmf7HDMAAAAAAAAAAKihpF9d3xVEVFdtq5T0s/iskI3K2u4RQll8Vs1KtXqJv1VK/nWU/btqUwqtVIIpxTai27m7jp7vdAx7VirrM/jNdjVWk51qExBU2Xwqyv79XK7MUjVufH6uzyz/p/6+K7bTEexX1b1+aoaqyKSVEVqtkq3qLLw3D+ey9dnLZAHMjsdRH5VvxB69Fur5TzmuIq7imAEAAAAAAAAAIA4l/Wr7vq2k3yfbaiX9vrV1/ef8rmxUfz+zvlmBlUpstWqWqh3K/l21rVwSsHKfkWvy6V64u/csz4RyzLCOu13ZqeALbxJUWfpnf/A/BMvKLFW/bVf+48L2qX3XH7U7fnhWBunVwfBT07B6bNZJruo+iYitlPeE8plSCHwQV9XMYWqf7LiKuIpjBgAAAAAAAAAAG5T0q+tLSb/Ptqrfkq7aqv5jflRQNTsrVUeJv+psVauLqSw+HWX/vtlXKAkY6aMWfo2RF1PdZak6k+NLtoKSYv7KZqui3N8X/mx4zGSpiompjptjuMtO9e2aVGSwWj0TVmUwXyWY2TX4tUwqlf/LYBQGypb7YHa2KtVzFc2yFCmtOhp8VL4Ru6rdM/Ydwe+9c8xHXPWMYwYAAAAAAAAAgP+Fkn51fSnpZ7ft8NvRz+WObFTZvipx1erl/maKqSzCmzHml/0bQysk6hJajVGbXUr5HXjWrc+MZTy5GsOjGakUvxWTnSoAgiq7T7Wg6udyNkvVJ5tVZHVcnKtFNHVc/Kv+fnd8qagMpp8YDGcC48oAOnpvqEsCZlJGdk2sR0Pb08RVmbbs3JcZo58qrtpxrkJcBQAAAAAAAACwPpT0q+1LSb/e/5A/o8qJ6rcfi8/MbFRWf0W2qtXFVFHxVEfZv7eIrEZh+0h8z3f3XeSZyI4TnvH4LJynIv6vzE7137xNUGXprywv5RVYRbNVeTNXXfn8br8SV0Wu/d2/p7/gqFO+dqdmrQqCPQFxR/AcnfQqs1NFJ07EVX0+Kt+qa2OdQ6sEsB2lBCu3M2v7bz9eAAAAAAAAAICnQ0m/ur47lvT7Zqek378vKyqUKCqRZLNPWbZRkaHK61shplL8G0NX1m9FgVVWRJVtV4m1oscxRo2Y6k5YNYJjgNc3Mv9ES/uRnSoIgiqfz+pZqv5+WsVWn/btEVDtLIRaJbCvCqRn/S+DGQFyZFJaIdCuKgWoyFKlFFcpxDmIq/TXJjsfZudmxFXPiKkAAAAAAAAAACAGIqq6/k8q6ffNHvlNyNLvzSX9LD5VWaiufGaV+7sSsFj9lCKYquxVFf2q7SuIrCL7V/UZzvtzDJ+wyvPMWsYe65gcKfUXnTPUc+Gj+bPpca9c9u+3zSKw8toUYqpI6b/j5tqsJq46F9tPdXaqN/+vg0i7IkNVViylEFtFM1h1KZbPwNiNuApxVWUcoNzGzO2//XgBAAAAAAAAAHaDkn61fSnpt39Jv5/LSkHVrFJ+3z7VoipFu0JANUafuKoyq9JIbHuMOUKqMeaUCaw+t+G8d6xtlufE81zfzQmnY5z2zDG7CJ22FmS9UVBl7b9ylqrftiNo+2S3iKjuhFNVwqpzs4d9Rnm/igD6KaIqhdAqK6ZSlv7zlB603g+Rezb6P4NmiqsU43rUR+VbeW0QV60Xt+wWZwEAAAAAAAAAwL8gG1VdX0r6fbZ1/Wf7p5T08/hWZKG6alOW9rOKZq76Wrc7xrNL/a2Srcpr72xTHPMYutJ+mRKYmU/LWGqZQ07hnKGcGx8Pgiq/T1ZQ9Xv9Siz1qd2bpcpi+7TP1YRVq2WbUgXakbYZ/wthlfJ/3f97YWYwbrmfshmsTvE9vYu4yrsdxFWaORlxVc/2OWYAAAAAAAAAgPkgoqrr/8aSfp9sTyzp93NZlZVqVnaqKlFVRkzlXV4lG5V3fVapv5XLBHrtVYIoZTaqivtePWbc2azLO8cd2wuy/mx87LPK/n1r68pSddUWzVZ1V/rPcu5H0XelftC6gvpT3LZaKtcVgunohLSTqCqTlcqbiSoqvIr2+eaLuCp+LOpro547M/MC4qpnxF8AAAAAAAAAAE+Gkn61fSnp99nWkX3K6veEkn53PllR1cpiKkXZP282qkzfVUr9Wc9hjLnZnToyTVXbhrPN8hwpnvXoGF5d6o/sVALeKqiy9u/OUvVzOZul6u+np/Tf+OBjWb+z37WtEoxXBeerBdOeoHhmMK0IviPts1PLKjJZdYmrzoJnMfLcdoirIuO8Zx/dGa0i5xuZg5UirMz8j7iKYwYAAAAAAAAAqIJsVHV9Ken32fb0kn6fbNmKIDtlofpkqxBTqQRU6mxSHdmpqkv9KUVFq4iuqm2Z9ewzkx03hnE8i8wts0r9wf+BoCrmcwRt2SxVn2xV2aq+rY+Ldsu1rf7x9WzoN/t/L1Rkq9qh3J8nwFYF6BWBfFXgbp24leKqjN9q88ZRvF5hU8xT1rEZcVXvXIa4CgAAAAAAAABgbRBR1fWnpF/cZ8eSfp9sq/3m0imc+mTLiKmsIp8xNAIqpViqMzuVKhOV9ZzGmCe6UvdX9fOsR5ctz61iDLKOwx6f7njkXGQb0/mz+fGTpSovsPq2f2ubx+b93iqz2nQJqDzBcjbgVoqorIHvCkG3JxjPtiOu8k3sM8RVFSUDEVdp21XfkyIm2EFc1bWPNx8vAAAAAAAAAIAFSvrV9Z39m81dGyX9/MurlPSL9DlHX4Yqr1hKlXUq0me17FSzBVYqMdUYa2eOin63Y6yVkcrzbFvGq+j4djcWe8Z35TwHX0BQFffZJUvV309rm+WYMuev+u68D/4KwfjO5f1mBt2KIL0joM8G7NGg3jvpj4SP9V6LKLAz6uvsHJER7TxBXHV3DSrFV1XfU4d/9XZmbf/txwsAAAAAAAAA8BuyUdX1paTfZxsl/WyfHt8VS/tVZJ6K9I34qTJKKbNRDVGf0bTvVcRQVYIojyhqlYxUlt9OrWOSdwz2tFXHJ2Sn+gGCqpzP7CxVn2wZMZXlmCzZqtTfU0WArNyGN9iuTvvakfI1EkR3BeRR3xXKAb5FXBV9vjKTb1S0U5nJKurjHWsRVyGuekrcBgAAAAAAAADQBSKquv5PKumX+Q2Ikn7XbbuW9LtqU4mpvMsVpf46sxFVlv+blZ1JKXTqPCbluqJtjJyYSjnO3I3J0TlJNYetHtssy58HnMObslT9XK4qAfhNYOXJVpX98V8RdFeKpLoD7WpRFVmq4kF/NMiPTsBPEldlldQd4ipPv9XEVQpf7zl7rvFO4irFfKXaxsztv/14AQAAAAAAAOD5UNKvri8l/b7bKOl33Vb920mFqEpdxs+7XCGgGmNudqox1shopdrPSj6d62PMz0ilHoe8Y7F3vPbMoQoxFdmpfoGgao8sVT+XVeKqw7hdT7Yq73WpehA72xTZqVYTUVUG4F1Be5Uv4qp7n8pnwPKseSfpo6GtSoSKuCo/zyCuek48BwAAAAAAAAAQhWxUdX0p6ffZRkk/26fHd8UsVJ9sXt+scGgMjYBqtX9jzMloNUZvWbxZwqmqbY2hF1Rln2Pl+BRZ9s4XlXELGaw+gKDKvo0ZWap+rivFVaoSgJ425ffXIXyqtj9dRDUrgI9OXoirvu9jJHwqnoPKLFZVgiHrXKCaU1TzVsSevVaIq9aMk3aM7QAAAAAAAAAArkBEVdf/jSX9On7zoaTfWqIqpZgqIo7ybqdSQDVGvehohuCq47xW2Ib1vopuxyocvDsOa7ulrWLciizftSnmtu6Y53GirD8POY+3Zan6uewVVx2B/p+WI4IrxXelyAilCpqz25gdYCuC8RWCdkWQH3khyNgQV+Wf36qX+OyccQh9EVfp5n/EVT3b55gBAAAAAAAAYGUo6VfXl5J+cR9K+un6rFTST13G724/yuxUTyz3lxUhdWx/jDUyTo2CfYzgfsboEVFlx7PIsmI+VMYPZKf6AoIqX/+uLFVXberSf78/72xe4VdkXfWQn42+1v6IqGoCe8XkpWp/i7iqItiIPGPZF/azaF6o8D2KfFRz3N05VourrH6Iq3q2zzEDAAAAAAAAwCqQjaquLyX9Ptso6Wf79PjOEFVls1DdtauzTo1RI6B6Q7k/pUBqjJyYaow5wqox6sRYyucj8nxHPiM263JkPTq/k50qyZ8HncsOWao+2WaW/vv9aclaFVmufggrMuDMDqaVAXW0LRuwzwryoy8CFe1PFlcN47EOUZv1fra0e8eY6HimymRl8T8S++gWXUXON/J9IK5aZ/scMwAAAAAAAAB0g4iqrj8l/ew2SvrZfFYs6fepLZJpRy3mGUMvihpjn8xPK5Tq85xT5b5Uvt5llVgw61v5GbHdjemZuSIy56nn69eCoMrfP/sjc3Xpv0+2jJhKJaqqyEq1SgCsCpy7gm11kL5CYK9+KYhOirNS4WaDgNXFVafg5TrzR4HTOHap2tTrFTavvTI71azSgE8VV3Xt483HCwAAAAAAAAA1UNKvri8l/eI+lPTT9ekq6feprSLzlHdZIbRSl/vzbGvFcoKV4q0x1hJLqe/F7HMSaY+OA9mx6c4WHb875/Hq2OSxoiwEVf5tdGapumpTZqyyCq+sy6prF3kwOwVRM4LpimBbPfivFPxXbg9x1fdtZs7D+jydgWdaMbFb+yGuitmzc8UscVWHf/V2Zm3/7ccLAAAAAAAAAHnIRlXXl5J+n22U9LN9enxXEVV5BEtj1IumFGKjMeZkq6oQLK2UvWoMTaYq1T6zfurlSLvXVjUeecbIq+XIHJatwrVDbLQVfx52PrOzVH1r6yr996n9ri2Txcpybkfh91UR5Hb1qQquowP4TsIp9QuCot+M/91R9bKifJG5a4ue95OCikxGJMRV+WuLuGqt7b/9eAEAAAAAAADADiKquv6U9LPbKOln86Gkn768X7RtdQFVtSCqKnvWGLUZpHYUT2X6WNoin14fT3t2TvDYOufx3WOyNAiqYtuoFlT9XleX/vu77C0NGLFdLSsfzBkip+p9dKaBzQbgKwT/ipcFRb+ZqXPVLzWq4GQkfLxtHlukvXJu8pRGrRBTVQipEFc9tzQg4ioAAAAAAAAA6IaSfnV9KekX96Gkn64PJf0QUK0kzppVcm9FwVTk+cn4RcYBxXh2Z4uO6dG5UZm5sSpmeXwmrD8PPKcnZqm6alOU/PN8es5pVoYOdYCrDJCVfZ9Yts+6j1WEVruKq2a9BFl9hqit6iU/ExwcBf26MlUhrsp/n4irnhMvAgAAAAAAAEAfZKOq60tJv882SvrZPj2+lPTryU6lFFCN4vWVBFMqAdsYe2aY6s4y1ZGVStEWWVasR+dMKABBVXwbkR9zK0r//Vz2lgFUiKuyZQAV39eOYqhoQK32mymcmvGyULmNN4qrql+w7tqU1zMajGSEVlWCIescY52XMv0UvpXXCnHVmnHYjrEjAAAAAAAAAGhBRFXXl5J+dhsl/Ww+lPTTl/RTiYi6+nYInsaoE0yN0ZMtqkNYVdXPa4v6W32y49edLbIcWVfO32SnKgBBVW4bM0v//VzfJWPVjO+yQ9QUDZoVAbZ6YN9ROKV4iVD3m51qV/USlHnBUW13JK6B+gW6KkV2ZD6xziHR+SYzb10dB+Iq3XyHuIpjBgAAAAAAAHga5wuPjZJ+Ojsl/Xp+N6CkX02mqoq23cv/jaZtKdqs33nXPabs57Wpnl/VeGRtyy5H1j021TxPhisnfx56Xk8SVWVK//1cnpmxynO8lS8fq2SIqgykqyaBHYVT0RcORb9uwVVHBqsV/jfKuLkunrZssNKVxSozv2V9jyKfiH1FcZXVD3FVz/Y5ZgAAAAAAAIB9IRtVXV9K+n22UdLP9unxpaRfvLwfAqrebFfWtlF0v8wsx9eRfSriY/VVtt3ZPONyZN1ji86lb43dpCCoym+ju/TfVZtXSPXJVpGxyiOeqhJXVQa7Cr9ZAXfl+SKu0r70KAKBp4mrlEGTNXjpyGIVHQdVmaws/kdiH92iq+zcg7hqzThtx9gSAAAAAAAAAP4FIqq6vpT0s9ueUNKvMyvVDmIqa3u3yKdzv28UUCnEaxE/73K3aCrSPoYmM5Wij3LMu7NFx/zIusemjEso9Rfgz4PP7cml/36vzxJVDWO7x9bx8HYEvWo/lue8iKj7daTonf1C1fmyNW7OS9VW8ceEYRwHKjIwHcXrFTavvTI71azSgE8VV3Xt483HCwAAAAAAALAKlPSr60tJv7gPJf30fapLgq2Uhepu/5XZqp4soBrjGQKqYTgnT98x6kRVqmdW2WcE2qz+6vE9My9F5knv/E+pvyAIqjTb6chS9Xvd0lZZBtB63iuIq95SHg8h1PzrWr2t3coDdoqs7tpGsM2S7lMZ0ET7Ia6K2TNtihghMw92ZLuq3M6s7b/9eAEAAAAAAABmQDaqur6U9PtsqxJRXbWtUtJvxexUajHVlS0qVNmxpJ/H90kZp3YUUEWXK58FT5vHp/JTZYss37VZ5haPLTMvV8Y6rxNm/Xn4+T2t9N/v9btMUZbliKjK6jMcbervzfvAq4Pb2UH1zvtZbXmlbFWKlymF/6oZrEbyfCpf6FcJNjIZkRBX5a8t4qq1tv/24wUAAAAAAACoBBFVXV9K+tltlPSbX9ov6pMVkKxU0m+M+aIjBFR+vzHmiaYqnxPPsxnxVXwqxsI7m2pOqJjLdo+zHgWCKu12Kkr//bZlSv99W/YKpaKlAdXX1DuYPE1s9DRhFOKqmoBgh//ZMiPYigZk6kDodPhWz1mVmayiPlfHVSm6ys5hO4mrVPES4qq9jxcAAAAAAABAASX96vpS0i/uoyjpVyG22r2kX2WGKovYZKeSfm8RSalK9lVk9BqJ7VXeS5029bOr/PS2RWyKMT46L3ls2bbK+OeVIq4/LzjHp2ep+r1eKaq6ausUWSlfFjpENufm+0Zo1StiW0lwNSODlVJkNYzHP0RtHluX0Ooo6NeVqQpxVf77RFz1rHgUAAAAAAAAYFXIRlXXl5J+n22U9LP5dGWnoqTf/iX9hni9SmRmbRsFfRT3VafN0pbxjXxGfSK27LJi3TvXqWMXxFQCEFTpt7OzqOrncrYkoOUaeUsBVj7k1QGveoCvFvBU9tttn6t9dyuLq1YWWWV9RuAaZv9Q4RmrquYn73iMuCofSyCuWmv7HDMAAAAAAADAZxBR1fWlpJ/dtltJvwphFSX9KOnXnTGqM0vXEHw/ClFUVT/ls5J9Jis+oz4qW3QeuGuzzD/e+U0xb+8Sp23Fn5ecJ6Kq2HJUTJURXFVnsPIMfpWBb4fvrOxWlFms/Y67+6yawcq7DXVWK4XgKpvFKhMYqQRDykxW0bkwO7dG7dk5C3HVuvHejjEqAAAAAAAAQAeU9KvrS0m/uA8l/Wr6UtJv75J+s/a7QnavyvvB089rU24j49s1ztzZsn0UY75y7srMwbPjsFeLsxBU1Wwn8iOq6oflmaIqi082u1XFwx0RVlUKWVbcZofvStuu3Ods0dyTM1hVBH5D1BYNrLJ/UMkGOUej71HkE7GvKK6y+iGu6tk+xwwAAAAAAABvgmxUdX0p6ffZ9vSSfqq/tVf/PX2WmMraXimUGqNW9NNZJm9lAZXiO7B814r7R9WufHYiPsrPrO+dLdsnMz9Y1j226HwbiS8o9Sfkz4vO9SlZqj7ZqkVVP5cjYqpVvjvr4LaCSKWrz0riH/X+dtjnE8RVT3gpzO77ri0TaHVksYqOsapMVt55zbuPbtFV5HzVcUb0+0Vc9by4FQAAAAAAACAKIqq6vpT0s9so6ffckn7Z0m3VZfxWL+lXfZ26jm00f29j9ImpLM9QRVvHZ9b3zqbw9cwRkXWPLTofR+IMxFRi/rzsfBFVfV/+1mYVTK2cteoUtJ0vsHVOaLuKq54mqKp60csGWau+RI6b6xE5d2XApMhiVZGB6Sher7Ap5mlrzLBqacCniqu69vHm4wUAAAAAAIB9oaRfXV9K+sV9KOlX03e2mMra3pWdyuq3k7Bp53J/ke/Ncw94+mXu68q2GZ9ZH884qfD1tmXmsohdMefvEsdtC4Kq2u1EfyTtFFVZ/VRiqtW+y6tB2DJwVotQVrV1tndtY6dtP6UUYNUL5Oyg0Tu2eL7DigAr0g9xVcyeabPOfRXiqg7/rvm+e/tvP14AAAAAAADYA7JR1fXtykalbqOkHyX9LD5Z0Ym6JJsqy1G0jYxUNf2GeDnr67Vl2zK+qnEk6xMdUy2+1r6RdatPxG6Z+2eKqRBn/R9/XnjOiKru26yiqk+2qP/R8P1lBx2lMKJLaIW4ar3tKbZd8b9kOu6bp2WwGsbz8YwhKtsqQU8mIxLiqvy1RVy11vbffrwAAAAAAACwFoio6vpS0s9uo6Tf2iX9MmIqryBmZkm/FUVP3ce+akm/MeZlqfLaKtsUn1V9IzaFb3SOsKxnbdH5ORp7IKYqBEFVz7ZUpf8+2b0iK5Wo6udyVEx1dX5V5f+iA5CirJdaQDLD3zOpzRJXPanMX0fw0SG46n42ZryYVgWcqsDNEkB2z4WVmayiPt55GXHVc0sDIq4CAAAAAACAJ0JJv7q+lPSL+1DSr6YvJf00Waes20dAVVPSz9Pfc7+o7uXIs7VD2b5uIVWmn6ctOm95bNF5epV4DTHVL/689LxnZEpYSVT1e91bGvAosh2TBoSMwCqarapShLGK4CrbjqCq7tpWfDe7ZrBSiqwUY4WnzWPrElodBf26MlUhrsp/n4irnhfrAgAAAAAAwDMgG1VdX0r6fbZR0u+67Y0l/dTZhZ5W0u+J/0bRPRC9FzP3svrZ8viox5KsT8SmGH+HsC0750XsilhgtxjvEfx58bnvXPrvk71KVGXxU9ksbR0vbmqh1cxJbRdx1crZqp4k0HpjecBZIivFc+m9htbgKfq/5bxBWZVgKDrPZeZL7zyNuApx1RNjXgAAAAAAANgLRFR1fSnpZ7dR0o+SfupSfKrtUNLvWSX9qsr4rSaYmvm7csTWsaxYz9qybdXxyBNix2kgqOrdllJUFRVadZQDrBZYdQuuqrLUdKVc7Ba0eCbPanHVjiX6Kre3QzarjpTJ1cHo2TBejOTzNIztqqBKJRhSZrKy2hBX5WMoxFXPjH8BAAAAAABgPSjpV9eXkn5xH0r61fSlpN9eJf2ekEkqWtIv8h2OoRFLVQun1M+saoyobvO0K5c9bdE5TDnXeuIHxFSL8ufl54+o6j/XI20qgdXdtu+u2So/Es4SfKw0kc4UXKkn8TcJqrq+r64MVl0vusr/OTBEbdFgMPsHomzAdTT6HiKf7Bzt9c3GE8qYJTL3Iq56ZhwMAAAAAAAAcyEbVV3fHUv6dWSooqTfddtTSvqtkhmqS1z11oxUnec0gstj5IRXXlv2Oer47Gq7s3Use+cRS3/FHJqZvzMxDWKqRhBUzdlWdfm/T7ZZmas8YipVGcBOgZVHIOHp0/U/GFaacFcVVz21bOAO2aqi9/jqL7nVz2UmOOzIYhUdm1WZrCJzYoUtO68r4grP91GRvQpx1TNjYgAAAAAAAOgBEVVdX0r62W1PL+m3w3/arRRTWdtnZKe6auNfTUaqMfRCqZVL+qmetchn1sfbFrFVLXvaIuseW3SeVsUIHTEWYqob/nAJlhRVRdoU2TeiIquswOqu/Si81t7BxCKYsvSrDLir+s6emKsFQKv0W3F7q2azenoGq3FzPaLPnuKPOd4g69v9UFHe7iher7Bl53fPnLdqacCniqu69vHm4wUAAAAAAHgTlPSr60tJv7gPJf20fTsyVCkz/zyppJ/Hd6eMVBXXYIjO1XOPRNotz0pn2b4uYZXCv3vZ0xadvzy2iN0TU6wgpgIDCKr+l51K/121VZQ0UmauirZbbCv9+BfJWpUNxLuFWcoJvNKmCADelJWq6tquUgpQ/eysEjSPm3POPD/K4DDTD3FVzJ5ps86tFeKqDv+OmHDG9t9+vAAAAAAAAE/kfOHx7ZiNqkJE9a2Nkn62ZUr6aUr6ffJdqYQcZfj2Lumn8vXaIj4RX9X44W1T2aqWo37ROUwxn2bbOmKVp8WYS4Cg6n85Jm1vlqjqk62rBOC35azYKtuWGUiqs1bNEFPNElfNzI6kDiCeVCqw4n/9dAR9nS/MHSKrYTzm4WhTBpgrBGCZjEgKMRXiqpq4C3HVM+NlAAAAAAAAuIaSfnV9Kelnt1HSj5J+K5b0i7a9RZw1Rl4A1ZmdLOubfVY8Pt4+nu0p2yK2b+3KsVrV5vHxzIERuzJm6IwHEVMZQVD1L1Ys/XfXrhZV/bZ1iawO4zYt7dk29UCzYurHt9XtRVA1X1DV9R2u+tK8y3Oo+qOLNfitnmMPR7/VxFUK38p5cidxlWreR1y19/ECAAAAAADsAiX96vo+SUT1zU5JP0r6WW2dJf0UIqBo21syUlVcgyG6bsr7z2ur8lF8etsU/tF2xbjtaYusZ23RuVsZO+wSe70OBFX/ztNFVZ/s2exV2bYq4VXFd9o9EK0opkJcVeO7+jaUgdcu5QF3EFkN4/EPUZvH1iW0Ogr6dZUBRFyV/z4RVz0zhgYAAAAAAHgblPSr7UtJv882Svpdt1HSr0bsU70vygXuW9Iv0u55jlTPnHrcyNiqK/goxndPW2RdMY9G7OoYozM+REzlBEHVv3NM3N5MUdUn224lASPfX/T7ztZGjYglhnC7q4qrZotr1IHGWwVV2cBt1/KAs0VWWZ8RuIbqgPIusM6M6SrhLeKq/LyKuGqt7XPMAAAAAAAA86CkX11fSvrZbZT0o6TfrOxUY5CRaoeMVIplz71i7e9py/gqPr1tmW142iPLCr/IutXHMx9G53BlDNEdIyKmCoCg6j9ZWVR151NdAvBuPeqrFlMdDd9r1SB1PuyzK5CoFOFEg48nCaqenM2qIwV09TN0Dn1WK4XgKpvFKhPkqQRDykxW0XlWMb9H7Jk2RUyTmcMRVz03rgYAAAAAANgdSvrV9aWkX9yHkn7avpT0q/ObKaCq3HaXgCr7fT6hpF/EVzVOWNtUfS2+lWO8Yt3q45k3o/N4RbyxSzz2ahBUfeYtoqpP9tWyVymyW42ATTkIWdo8Poir5pUHVLZXbmNmViplMLdbecAd/rfTXVDZUQ5Q+cexbAB4NPoeIh/vXKYQXVnOX5EF7BB/D9E5HnEVxwwAAAAAAKCEkn61fVcu6TczQxUl/a7bKOnXX9JvjP2ETJT0W6Okn+p5yvgqxhSrf2Z7kWV1H8V61haxK2KFTBxUGS8ipkqAoOo7x8RtzRZVWW0VQqqf6yox1awf8KJ10d8gsqr0qbRFg5O3CqqU13NFcdUuL+2V55ANbjuyWEXnAFUmq8j8WWFTxAHR8418HxXZqxBXPTPOBgAAAAAAWBVK+tX1XSEblUpgRUm/f1+mpN91GyX9KOlHSb/cM1fxqRivsmNidlnhp1jP2tTzdkXc0R0zIqZKgqDqO8fk7VWJqr61VZUmqioDqFyu+s4zL0yWydbqS3nAmuDk6YKqmaKsVbNZPT2D1bi5HtFnUBWQKrJYVZS3O4rXK2xee2Xpv51KA6riBARWex8vAAAAAADAFZT0q+tLSb+4DyX9tH27S/p5skGNsY5o6o3ZnVYt6VeRgSxy/1mei1VFVVGfiC3bJzpmR/0U61lbdO7OxgSKeAgx1eIgqLpmd1HVVfvMbFV3652ZqVb9ES8rskJcpQ1oKvqs2E+9jej2dsxW1fGCv8ozOG7OOfPMqAPYaD/EVTF7pk09byOuWjvOecrxAgAAAAAA/DeU9KvtS0m/zzZK+l23Pamkn7V95ZJ+0TbK/83PTvWGkn6qsURl87RblxV+nraMj2IezbZ545XVSvztEJ9uA4Kqe3YQVd35dYmqPtkqygJGxFTREoCq71/xouQRWY3ilwRvsKLY3iqBzJMFVauUCqz4X0wd33/nHwA6RFbDeMyecUgZOK8QFGbmE4WYCnHV3NhLHS8grtr7eAEAAAAA4H1Q0q+uLyX97DZK+r2jpF9X6baOkn6rZol6Q0m/6H2UvT+zz0rGN/OpaIuMf572inHf0xadqzw2r2+mrSIOmRFDIqYSgqDKxrHA9rpLAH6zq37g7RJWKfpX3w+ZwV5VqmvW/8yIvuxUBDqVtmjw81ZBlfJ6dgiuVvsjQPeLQ+baqIJpS5BfPWcfjn6riasUvhVxiCoGyszhiKueGYsDAAAAAABEoaRfXV9K+sV9VirpV/W317eX9BtjPdHU00RSY4PjGMnjjdxzlPTzt2XHv+yyYnxXrGdtSruqXREfIabaDARVdp4gqrpqr/iB1ftjr7osYLTPyi+7ipJb2ZeOjkCmqo86EKoOjhBUvac84A4iq2E8ftXY5LF1Ca2Ogn5dZQARV+W/T8RVz43LAQAAAAAArqCkX21fSvp9tlHS77qNkn6U9HtqRipK+mmfT+VYErEp21VjfabNMv9kbUq7ql0RI3XEk4ipCkBQZedYZJuVJQCv2maVAbxbV4upVhBdVZUH7BJXzUituVMGq8rgaQVB1UxR1pvKA84WWSmeMe81rA58vYFmlWAoMz9G52HF/B+xZ68V4qo94t3BMQMAAAAAwKZQ0q+uLyX9PtuyQitK+lHSz7s8u6TfU/+NMUc0RUk/36e3LWLztEeWO9oyc5hnTlTP2ao4QhErIabaGARVPp4kqrpqr8hiVS20qhRTzbo3PAPiSuKqzpcZtW8moFopuNpdUPXkbFYdKa07nil1ViuF4CqbxSoTeKoEQ8pMVsr5WREHqK9VVWzUFQMgruKYAQAAAABgTSjpV9eXkn5xH0r6aftS0m+dkn4V+19932Pks4VR0m/Ob4MRm6c9Om6r2lRzVvVcm22rjGFmxJYIqYpBUOXnWGi7lSUAr9qUZQAtPtXCKtU2ZgyCq4qrFEHObJGVOrjqDLTeWiqw4n9KdQfXK4qslM+makyKBuvZQDkbmB6NvofIJzvvR7ZRFb9UxFFd8dys+LQz5uGYAQAAAABgFpT0q+1LSb/PtieV9Kv82ycl/SjpR0k/271z9z1n78/o8xDx8fpmxxKrf2R7Fl9rX1Xbna+lv8fm9c20KdpnxUtPjGEfAYKqGLuJqix+qkwSTyoNeNe22ovzauKqqhecqmNRBloqmyIQe5OgSnk9VxRX7fJHiMpzyAbwHVmsonOFKpNVZL6ssHntldmpZpUGRFz1/NgdAAAAAAD2hpJ+dX0p6ffZRkm/vA8l/Sjp96SMVKfo+1Tcf5T0u7dl+1iXO9qic1TWFp2fM/FANJ5BTAX/A4KqOG8SVV21ZX8srciqMbPtaLpfdhFXzXoBUh2TOtiqFFwpgrbdSwVWXa8VywM+IYNVdryx9qsMvu/usYrydkfxeoVNES8oYhnrfFwhrurw745Zu7b/9uMFAAAAAAAtlPSr60tJv7jPU0r6qf9DKCX9bMuU9Fu3bF9lSb+K+8/yXLy5pJ+yvastsm718cyV0bk7GxNUxjMz40zEVI0gqMpxLLbdo8GnqhxQVbmiajHVjPtDMZEoxFU7i6o6swJVBGUIquYLqiqD8or02as/u3dtqnHKG+Bng1NrP8RVMXumTRk3ReZ8xFXPjuUBAAAAAGAtKOlX25eSfp9tlPS7bqOk3z4l/fgXvz5j6LJTKe8/a3/18+T1jTz3mXFK2R5ZVs0FlvWoT/Wcq2z3xjTZeIysVA8FQVWOY8Ftz8xW9a1tRharDqHVne+KL99KcdVwBDRVL0OVn1mfblu378x+M49jJcHVjP8NVv3MjYRP1R+/VgpYM+XmFGKqCiEV4ipKA74hrgcAAAAAgDlQ0q+uLyX9PtuyP2BT0o+Sft7ljpJ+Vb5PKfEX+T6836fy/vPaLG0Z38ynt+3OpmyPju9K3+i85LEp7ar2yrhmZryJmGoSCKryrPhjlPIHv+oygN/sM4RVv9erRFmrvJRnxFWq8lyIq2ps0aDurYKq6iC6848UM/6osdMzl3lBiLRXzvue7ImIq3zXGHHVfvHy248XAAAAAAD07+e7HFtnNgVK+sV93lTSr+PvjJT0o6TfDhmpRkH/7P3ntVU/e6pxQWVTtCvGcaVvdn7zbC86H6vaI3HRDkKq1ePbx4OgSsOqP0J1ZKu6al9JWGXxOYp8rf1mDrQKwUG2rTuNb8fLneJFVPWyqwgQV+lXub23lAfcQWQ1jMevGouqAvtMoFsx/3eVAURclf8+EVe9J9YHAAAAAIAclPSr7UtJv8+2XUv6dWelqv7PmZT0o6TfzIxUY+iyUynvP2t/z3NU6ZsdQ6z+ynbrsqpNsZ61ReyZNrWPMjYjK9WLQFClY3dRlcVX/WNlxQ+rO2Wx6rx/si+uO4mrOlXvO2Sw6ggQVxZAVW7vTeUBZ/+xRPGMqZ+rSECbEVpVCYYy82F03q2KAaqvFeKq/eJnjhkAAAAA4NmQjaquLyX9Ptu8P1arM1OtXtJvVrWKt5b0m5FlSnFsu4mxxtCJpijppxtLIjZlu2dMV7VF5iGFTT1Xq+KHyvhmhdgTMdUiIKjSciy8j9llAK/aZgmrLP1mZ7GaPRhbXwijogX1C9YKpf+6MljNCCBX6bfKNnbIZhX1r85gVZXGeySuhfployJlvnoeVmayis6z3fGBai7uiqtUcQLiKo4ZAAAAAOApIKKq609Jv7gPJf18n3c+3WKqGSX9OoU+TxVFjQl9ld9nxf3ntVU9e8rxYAhtnvZvvtFxPDrmR+cdj83rG5mTlTFEJD7aSUi1erz7OhBU1fD2bFV37TuUCJyVxar7XopOcsqSWqqMVZ3/4yX64qhsU70kq4PJN5UKrPifX5UvC51/LBkTn8kZ5QAVLwnWsXbWvJ+dVz3zX7foqiquifghruqPf958zAAAAAAAu0BJv9q+lPT7bOsQUVn9KOn3vJJ+ke2P0S+Sqtru04RaY2iFdpF2r200+mbHEKu/sl0xjit91XOccu6tjhGy8RFZqSAFgqo6Vv6hCWGVz9YpptpFXGWdhCuyWa0u4FhRdY+gqn57O2SrUt6HO6T6VpyDdeyyvhBZ2r3jcoXI+nDuoyqblcemiBM6Yh/v91YlilPGFoirnnHMAAAAAAArQjaqur6U9PtsmyGqoqTf989OMVVnSb9uAdMYzxBQjaK+1rbMd+vZTqQ9+jwofDOf3rY7m7LdM6Z72ry+UZ/I/LtqWb9ojERWKpCAoKqWJ5QAtPp2Cqu+takFV9lsG+qsV9b9VA7g2RKB3iBo1Re5qmNSB4+VgqtM4PmUUoFV12vF8oBPyGA1guONt039x0XPuFxR3q46o2OFTRETKOIbVQwVne87sl3NiH93EyshrgIAAAAA8IGIqq4/Jf3iPpXCKW8fSvr521Yr6WftE23jX/z6jFGbeWyMuVmoKOm3Rkk/xbpifozYszFARUwyM7Z6euwLA0FVB8fi+9hBWHXVtkrWqt+2jh+gZ91vmQmzoxygIsBbQWSlbFO9cCsC05n91NtQBOc7lwJUP4+rPIPRscjyHSpfODL9EFfF7Jk2VRwVne8RV73nvQAAAAAAYEco6VfXV+lLSb/v65T0i39WZKh6e0m/Kt+dMlIptjtGXXayyL3qtY1G3+wYYvVXtivGcaWveo5T2xVxgicueYOQaocYGAaCqi6ODfbxJmHVN7tCSDVjfYc/KljLXqnKAapf6jo+sz7dtm7fmf1mHsdKgquO7Fadz/IQnE/li84KAXUmNlBnffTaFL4V8YoylorGBZQGfM/7AQAAAADA6pCNqq4vJf0+2yjpZ/v0+FLSb6+Sfm/MSGVtG4lr6rlHIu3R50Hhm/n0tt3ZlO2eMd3TducbmWs8to55WR1HZGMlRcxGVir4CoKqXt6WrcriF22fXQ7Qapsprpr1Q51nclWU1MqIJRBXrZNG9U2CquqXgs4/ulTex51/0MmOJZmxK/qipQq4o/N5ZSar6ByrmO+VsYcqFlLGXYpYAXEVxwsAAAAAkAERVV3/J5X0y/xwrBZWVYmovrXtUNJvhQxVlPR7nvhqLLoPz/2Q9fXaIj4R34rxJmLztH/zjY7RGd/oXKWYIyPzcjYOqIhLquI2slLBLQiq+nljtiqLX5ewymtHXKWbFDJZrKLZrFb8HzXR41EGpTPLA0Z9Z/ar3N5bygPuILKyjiVD1KZ8OVEJrY6CfoirtPGQMvZSfP+IqzhmAAAAAAALlPSr60tJv+82Svpdt1HS7x0l/chIRUk/SvrFx3Glb8ZHOc9WtVX6VcRsCKnADIKqORyb7GcnYdVVG2UC59x/6pfzCkHDDDFVV8plRUAbsXUEvCsLoCq396bygLP/+KN4xtTPVSTozgitqgRD2bkMcVVN/KWIFRBXccwAAAAAAJl32CccGyX9Yn0o6ffvy5T0u26jpN87M1INQZvqOt4tR9qjz4PCN/PpbbuzKds9Y7qn7c43Mtco5sPovJyJA6JxDEIq2AoEVfM4NtlX1Q9w2R8J1W1VP7QirvJNJIqX56r/mTMjOFX7Zq7TjIB4lX6rbGOHbFZR/+505KpneiSuhfqPhpUvLKo5NyvUPop8qmMBxXzcFV+pYgXEVRwzAAAAALwXRFR1/d9Y0q9DWLWCiOrnMiX9KOn31JJ+K4m0ovdD1tdri/hEfCvGm4jN0/7N19o3MzdE1rO2iD3TpoonsvHSzkKq1eNiMIKgaj5PzFbl8Vf88KcUUHn7WH1XLRM4417MTDIKgYI6Y1X3S6jKVx38zgqO31QqsOJ/slW+/HT+8WeFPxBFxxvlC1UkSFeVC8zGFUfS/0jso1t0VRXbVMRYilgBcRXHDAAAAADPh5J+dX0p6Rf3oaSfrk+l+IOSfu8RRamuwRg60ZRSLEVJv/s2ZbtiHFf6ZnxUvtk2a9xRnY1KGbshpII0CKrW4NhoX08TVl21dZUEtNqeJq7y/IhvzWLlFVx1lQZ7WgYrlS0aHL9VUNX5MjJDXLVr6nLlOVjHrsj4qHrR6cgeWTG/qW2KeEAR36hiqMj8j7jqne8SAAAAAACWd8enHhsl/WJ9KOn378uU9Ltuo6TfO0v6dQrfzlGbBc1r8zxPEd/Mp7ftzqZs94zpnrY7X0v/Cltmzla0e2OZmWX9ZsaoCKkeCIKqdTg2219lRgPEVfe2J2euyk7IFYKrXdInK1+sV7CpAumnlAqsul4rlgesyk7V/SyOhrbKFyTrC2TlPIy4Stvumders1ep4gsEVnsfLwAAAADsByKquv6U9LPbKOln86Gk3/3+divp98ZSfcrvUHF/UdIvbvO0f/O19s3MDZH1rC1iz7Sp445MzPQEIdXqMTIkQFC1Hk/OVuXts6Kw6qoNcVXt5BOZ+DvLAa7yAlvxAq4OpDsD7Zn91NtQvGzsXAqw6jmc/QxGxyLLd6h+caqIFzJxwRPEVVWxiiqOis7/iKve914BAAAAAM+Gkn51fSnpF/ehpJ+uDyX91iln95aMVEOwHe/94vGP3Kte22j0zY4hVn9lu2IcV/pmfFS+2TZP3LFTWb/ZsSpCqoeDoGpNnp6tyttP5TdbXNUhuOoUV638RxJr2St1OUDVy2rHZ9an29btO7PfzONYSXD1tAxWQ3Cuo8i2SvCfEfgqxFQVQirEVZQGfOv7BQAAAAA8A7JR1fWlpN9nGyX9bJ8e31VK+nnETKN4uVro8xYBVbdIa4iu3909Emn3Pg9j9GSfoqSf39fSP2tTz82ZWKDarzJ+mx2nIqR6CQiq1ubYcH+7Z626a1f9APoEcdUqP8x5ggRFSa0niaqeIK5CULVmtqqqPyLN+KPTjBfV6LXJvMx52jMvChUi7K5MVYir8t8n4qp3vmMAAAAAwF4goqrrT0k/u42SfjafnUr6WdtVJdwo6fe8jFQq0R0l/SjpF1nP2iL2TJs67sjGTQipYFsQVK3Psen+VhBWWfwqfpCstCOusk9imSxW0WxWK/4PoejxKIPsmeUBo74z+1Vu7y3lAXcoE2gdS4aoreJFK/vy0JE5EnFVPp5CXLV27P7WYwYAAAAALZT0q+tLSb+4DyX9dH2qs09dtXnFVN+WZ5f0IyOV7jzGqBHOefpG2r220eibHUOs/sp2xTiu9M34RHwjc7CqvTKWqYzhVohXEVO9EARV+/AmYZW339Hg01ES0GtfRVw1+16t+mNEhaBhhpiqK0OPIkCP2DoC+JUFUJXbe1p5wJVFVopnTP1cZV+svC8WVYKh7PyGuCp2vRFXrRsTPfGYAQAAACAO2ajq+lLS77ONkn62T48vJf16SvpF296akaprm9H7a5aYKtMn8ultu7Mp2z1juqftztfSP2tTz82ZWCATz6yQjWqVeBUh1YtBULUXx8b7XEVYZfGrymr1RHFV5nqsMOkpgqSq/2k0I9hW+2au04wAf5V+q2xjh2xWq2aw8m5DndVKXQ7QOn52vGxkslN5t3sU+ajm+YqYRB1TRWIBxFXvfvcAAAAAgHoQUdX1paSf3UZJP5vPm0r6VYl0xlhbJNV5XVYv6TeGVlAXuVe9Nkubsk90TFHZPO3ffK19M3NDZD1ri9gzbWqfGXHTDvEqQipAULUpbxRWefsirvLbFGKqY/H72DspKgQK6oxV3S/VlQH7zFKAlAqsv0a7lQfc7Q9e0fFG+YKYfSE7G+eHbLZF5ZzYLbqqjGe8foir1oyBnnrMAAAAABB7b3vKsVHST2enpF/8b1Ezs1PtVtJPtUxJv/1L+ikEV5F2ry3iE+2jGkPubMp2xTiu9M34RHyr2jyxB9monhk7QzMIqvbleMB+d8paZfF5k7gq0md2JitPZhVrFiuv4KqrNNjTMlipbNFg/62Cqs6Xq50zWK3+bEaeQesLYlUWq7NwblXMX6pSgR6bYv5XxDOqmKkyplPHF4irnnHMAAAAAG+FbFR1fSnp99lGST/bp8eXkn7zS/q95d9YZJuK+2tWSb/V/y58Z1O2e8Z0T9udr6V/1qaemzOxQCaeWSUb1UoxK0Iq+A8QVO3Pm4VV3r5d4qoK4VVnuaAOMdVKZQKzwUWF4GqXdNDKPxSsYFO9GDylVGDV9dq1PODqIqsRHG+8bdUvfNF+iKti9sqYpiL+6vSfFafsJlZCXAUAAACwHoio6vpS0s9ue0JJv86sVDuIqaztTyzpN8YzM1KprsFIfm/e5dVL+u0inqKkn88WsWfne3XskY2dniqiWj1+hskgqHoOx0P2ezT1Q1xl8+0QU60qrooEMZ3lAGe/kGePrfPFoPPFYWY/9TYUL087lwKseg5nP4PRscjyHapfAitiiYwQG3FVbczUEdep4wvEVXsfLwAAAMCToKRfXV9K+sV9KOmn71Nd0m+lLFR3+6ek3/oiLe936LkXIu1eW8Qn4juEvnc2ZbtiHFf6ZnwivlVtntiDbFTPjqFhERBUPYvjQfteLWuVxbeyXfWjaEZ0NVtctfKEai17pS4HmH3p7vysfhFYMVvVW0sFVvwBq+P7f1oGqyE411Fks74gd8culZmsoj7ZuVsdR6hiHs+c3yGWojQgxwsAAACwK2SjqutLSb/PtioR1VXbKiX9VsxOpRZTXdm8Waoyy5T02ycj1Rj6DGMj6auwjdGbfYqSfnZfS/+sTT03Z2KBrnimOo5bLWZFSAVmEFQ9k+NB+z8a+yKu8vkek9dXnWStgV40m9XOoqoniKsQVK2ZrUrxR7FV/og248U7em0yL6ddQquKzJddmaoQV/XGdsp4A3HV3scLAAAAsDqIqOr6UtLPbqOk3/y/z0Z9smIqSvo9U6iluJZjaAV1d74Km+d5iviqxhKVzdP+zdfaNzM3RNaztog9O9+rY48ZsdNOcSsiKgiBoOrZHA/bP+IqTZtaSPXJ9kZxVSaLVTSb1Ur/4yl7PFEf9UtGtk/Ud2a/yu29pTzgDmUCrWPJELVVvDR6x93q+dTii7jKfy0RV+0V77/lmAEAAABmQ0m/ur6U9Iv7KEr6VYitdi/pV5mhyiKcoqTfOzNSUdKPkn4VY7fSN+MT8a1q88QeiKieH0fDBiCoej7HA4/haO6v/GEPcdU7ygRmSwReBbaRtk4xVVeGnsxLxaopcVcQVM0UZT2tPODuf5S7a1M/V9mXm1niKmUmq+i8qpjPI/ZMmypuqo7t1PEG4qpnHDMAAABAJ2SjqutLSb/PNkr62Xy6/qMrJf3WK+nXtR9K+lHSL2JTtqvGeK+vpX/Wpp6bM7FAVzyzehz3tjgaNgJB1Xs4HnocR3NfxFU5W7V4anVxlSLoU4k8Vk9h253BasYLyyr9VtnGDtmsVs1gVTU+jMSLvfplt+t/42TmlazvUeSjmucrYo8Z8VVnPDgzZkFcBQAAALAviKjq+lLSz27braRfhbCKkn5rl/TrEkF1XhdK+lHSL2vztH/ztfbNzA2R9awtYs/O9+rYY0bstGPcipAKpCCoeh/Hg48DcZWubQdxlfd7W+1HOqt4oCKb1a7/I6NS1JJ9EenM1LRKv5nH8YTygN0iq8qSgUMwdkVfQhW+0flBlclKNQd2Z6mqElAhrnpu/P/0YwYAAADIQEm/ur6U9Iv7UNKvpi8l/dYRCFHSj5J+Cl/leHNnU7Yrxm6lb8Yn4lvV5ok9dhVRrRi7IqKCMhBUvZfjwceyaklAqy/iKs0Pycfk+1/5g380I8yMPwgoPzteVCpt0ZeXtwqqOl8Wd85gtfqzGXkGrS+8qhfVq+1WZGDqyNaotinm/464xjuvVwuxEVdxzAAAAABeyEZV15eSfp9tTy/pt8vfX2aJqaztlUKpMdYWSXXth5J+lPSL2JTtqjHe62vpn7Wp5+ZMLNAVz3TEcmSjgleCoAqOhx8L4ipt2wriqkifY6FnIKs4rxBc7ZAdpyODVbdN9aLzlFKBVddr1/KAq4usRnC8GcnvSP0CG+2HuCpmz87Js8RVHf6z4pTdxEqIqwAAAOAJIKKq60tJP7uNkn7PLemnFM5UlPFbraTfG7JVjaHLTjWGTlilsHmep4ivaixR2RTt1vE3MzdE1rO2iD0736tjjxmx066xK0IqaANBFfzleMHxPF1cdecT/ZGyMnPFDDHVquKqSFDWWQ5w1h8WVMfW+aJT/SK0Sj/1NqLbWzVbVdf9uMKze9fmGYuUL9ArvFxlYgHEVT2xU3WMp4wvEFftfbwAAADwbijpV9eXkn5xH0r61fSdLaaytndlp7L6kZFq/ZJ+WbEUJf3ubcp2xdit9M34RHyr2jyxByKq98TT8GAQVMFvEFbV9Edc5fftEFOt+kNcVlxVVQ4w84eHJ4isKm3dvjP7zTyOJ5UHXE1kNQrONfKynC2xWhkXZAS+FQLk7DytjBeq4hbF9zQ7LpwVsyOuAgAAANBANqq6vl3ZqNRtlPSjpJ/FJyumqsw6lMlOFW17S0Yq1TUYyWuluL8o6RezKdtVY7zX19I/a4vYM23quGNW7LRr3IqQCqaCoAq+cbzkmJ4grrL4VZQG7BRdzRBXrfIMZMUBUYHCE0RVTxBXIah6XnnAjv9ROfsPh3dtQ9TmsXUJrY6Cfl2ZqhBX5b9PxFW8xwAAAABk3yl2PDZK+sXslPSz/01hxb99VAimrtoyYqmZJf1WzNTUfexPLOk3Rn8WqqeU9OuozGDdT2ZuiKxnbRF7dr5Xxx4zYqddY1dEVLAMCKrgjuNFx7S6uMrqv5K46ltb9gfaY/L6CgFEJotVNJtV9x8hKv8oEvVR+Cv7RH1n9qvcHuUB56a0jxzbCLZ5BVeKl1vvS1yVYCg7fyGuil1vxFXrvhs88ZgBAABgPyjpV9eXkn5xH0r61fSlpJ9G6GPdPiX95gjfPPdF5p5WP1cRX+V4E7EpfKNjt9I34xPxrWrzxB5d2ajeIqJaPaaGl4KgCqwcLzsuxFX37UdxH8RVtX8sqsgWM0NM1ZWhR/2StFLN9JUFUJXbe1p5wBX/yKjyjYxdlv+pZWlXvdipBEPKTFbReVUxn6vjCEXM45njEVet/X7wtGMGAACAtSEbVV1fSvp9tlHSr+5vE7uW9FNlI6Kk37NL+kXvhzvfKtsYvdmnZv4uoPBVtt35WvpnbRF7pk0dd8yKnXaNXRFRwdIgqIIIiKvq+z9FXHXVtqO4aodnwRvo3tnUf8RYNSVvdwaripettwqqnpzNapc/MKqe4ZH4Q4XqRT3yEqcqF+idV7K+R5GPap6viD281+4Qfw9dceGMmAVxFQAAALwJRFR1fSnpZ7dR0o+Sfl0ZiSjpt48Qa4iXI+1em6Ut46saSzL+nnaLr3U7mbkhsp61RezZ+V4de8yInXaOXRFSwRYgqIIMxwuP65jUX/0DK+IqXSaPXZ4Pa2aWimxWu/4Pk0pRS/YlqzNT0yr9Zh7HE8oDdmWw6voDRnbssv4hwdLufSGsiAWygmCVuMo7fyq2URm3qOMrxb2AuIpjBgAAgHX+rvL0Y6Okn85OST9K+lltlPQjIxUl/Z5d0q9CuOppy/hmfCK+VW2e2IOSfu+KqQE+gqAKFBwvPTbEVfftTxFXRft0PiOeH/yt4gGv4GrGHziUnx0vXpW26IvZWwVVyuu5cinAznu+4plUn5/yxVqRxaoiA1NHtka1TTH/d8Q13nm9WoiNuIpjBgAAgN6/t7zh2Cjpd93WkaGKkn5r/L2iuqTfKpmhusRVb8lIpboGY9Rnp6KkX2wsitgUvsq2O19L/6wtYs+0qeOOWbHTzrErQirYFgRVoAZxVW9/xFV5W4WY6ljoGcn+L78KwdUO2XE6Mlh121Qvbk8pFVh1vXYtD7i6yGoEx5uR/I7UL+TRfoirYvbsnDxLXNXhPytO2U2shLgKAADgnSCiqutLST+77ekl/XbIpF0pprK2z8hOddXGP0r6eW2Wtoxv5FMxTkXbLb7W7WTmhsh61haxZ+d7dewxI3baOXZFRAWPAEEVVHG8+PgQV923zxBXfbJ3iKlWFVdFgszOcoCz/lCiOjZlW/aFDUFV7/HvVgpQ/RzOfga9Y5HyDwIrvChmYgHEVfWxU3T+R1zF+w0AAAD0/s3kLcdGST+dnZJ+e5T068hQ5RVLvaWkn8f3jRmpKOmX842OJSqbp109dit9Mz4R36o2T+yxczaqN8auAFNAUAUdIK7q77+TuOqqfaa4yuKjFFetHNzcBcFV5QAzf0h5gsiq6yWvw3dmv5nH8aTygKuJrEbBuUZe/rMlVivn+IzAt0KAnJ2nlfFCpk0VO0VjA0oD8n4DAAAAfX8PeeLx7ZiNqkJE5X3Ho6Rf/98f3lDS75PvCsKfp4meVhRbRe6DMXRiqTeV9Ov+W3uXcIqSfnVxx8zYaef4FREVPBYEVdDJ8fLjm/VjVre46s5nprjqm30FcdUqz0dWHBAVKDxBVPUEcRWCqueVB+z4H6JVz8mMjFWqPx50Ca0qhNddmaoQV+W/T8RVvOMAAABAzd8+nnZslPSL2SnpV/f3CEr69S7PyEj1VHHWKO6n/v4j7Qpb5tlTfCrGqWi7xde6nczcEFnP2iL27Hyvjj1mxE47x66IqOAVIKiCWSCumrON1cRVd+2qH0WzP9Aek9dXCIYyWayi2ay6/6hSKQSZ8aJXIeaJ+s7sp96G8gX7SeUBO1P0Z45tBNu8givFy7r3hbRKMJSdvxBXxa434qo93hmecswAAABvgJJ+dX2fJKLyvPdR0o+Sfp9snSX91JmSVinpt0uWKUr6xZ69TJ8h8I3YPO3qsVvpm/GJ+Fa1qWOPGbETsSvARiCoghVAXDVnG0eBb2VpwKO4D+IqXbAUzU4VbesUU3WlKu94EawWA63Sr/KFd7dsVYp77Ql/NI0+Y5nvbBjbVS+pKsGQMpNVdF5VzOfqOEIR8yjjq+64cOeYmfcc+P/snYuO47CuZeX//+gMBpgzt2+dOBbJTYqS1wIalZCUypVYD9u7SQAAeBeU9MttS0m/7zZK+uVc91t/vqGkX+XvqhRQVf8t2SX9lAIpz/mXZfPEZP6MzFNKv3cet/ieYmfaR20ee8Sn3Hes3DvtvH9FRAWvBUEVdOLiGLcQV83GrxBX/fLtKK7aYYxYN+5PNvVNmZUXe+rYzItCBFXrj797ecBdbphaj2GIfN4bD54LUlW5QOu6Eo29kmJU63zG3sP62V3i76FqX7jrnplrHQAAgHOhpF9eW0r6zdso6UdJv1XZqcaoEwG9OSNVllDK8trjV9jGWCuqUsxTXv9M7Gw/kbXB8z5q89ij671677Fi78TeFWBzEFRBVxBXIa6a9Z8qrrJ+F93GzGxmloxsVh0v8tSCE8UFZXYbRezKdiuP44TygLuJrCK+yA2JiixW3vVBlclKtQZWZ6nKElAhrnrndcMJxwwAANAdSvrltaWknz+Gkn7atpT0y4t7a0aqMfQZqYbob4uefwpb1thTzSUqm8WvnruVsZEYT2yWT733WLF3Yu8KcBAIqmAHEFchrpr1nyKu8rapHDOWB/6z4gFlua3dBRyZGaxWX2i+VVCl/DxXCa5Oz2A1nHNQRCyacSPh1/mQkYGpIluj2qZY/yv2NdZ1PVuIjbiKYwYAAOgGJf1y23Yu6bcyQxUl/Xpc31PSL34c2cdPJitK+il/RuYppd87j1t8T7Ez7aM2jz3iU+47Vu6ddt6/IqICuAFBFezExXHK+r8K2iGu+m7LEFNdjcZN9H84Zgiudig9VpHBqtqmvijdvVRg5YV9ZRr/6Pncdaw++YbTN5MSXHmDwdsOcZXPHl2TV4mrKuJ33jdzvQMAANAPSvrlte2QjUolsKKkX89re0r6zb1eXdLPEnuqEMrzfahfW84V63k+M1YisZGfVt+TzeK3xlp8kdiZ91Gbem1W+T17GkRUZxwbQAsQVMGuXByrrG/EVXH7bGyFmKqruMqzaa4sB7jqxo/q2DpdgCKoqj3+TuUBK/+Ha8XYHZPHbJmLlDc4Olz0RvYCiKvy907e9R9xFdc7AAAAHaGkX15bSvr5Yyjpp21bXdLPkg1qjD6iqTdmd+pa0i8jA5nn/LOe+9ljTzUvqGwWv3ruVsZGYjyxWT713mPF3om9K8CLQFAFJ4C4Stf3G8RVv/wrxVUzMUpxVefN2tOmPqscoOJCcGeRVdVFa0XsynbVx1GdrUpxrmXfsN1pzA2BbfaGTPbeICLwzRAgR9dp5X4h4lPtnbx7A0oDcr0DAADQ+f7BicdHST+dnZJ+udfrJ5T0m/V3Lunn9VH+b312KlWWKuu5HxlzmT8j85TSP/s6Mv8/xc60j9o89ohPue9YuXfaef+KiArACYIqOA3EVbq+dxFXPcWsFFfd2TuIq7qMlag4wCtQOEFUdYK4CkFV7We0ujzg7iKrMXn8Q+Sz2KqEVhl7g6pMVYir4t8n4iqudwAAALrcKzjt2Cjp52tDSb/86/c3lPSrKt1WUdKva5aoN5T0855H0fPTeu5Hxpzyp9X3ZLP4rbEWXyR25n3Upl6bVX7PngYR1RnHBrAFCKrgZBBXafvOfoh2FcUoy//d+aIPaK/F7zts7CJZrLzZrKpvEmUKQbwx1RezpwuqqkVZXbNVKW+gdBFZKW4ORecu9c0H68V1lmAoun4hrvJ93oir9rt+2PmYAQAAovvYU46Nkn46+xtK+mUJqt5e0m+MfqKp00RSY4PjGMHj9Zxz0fNT5YvEZtw789gsfvXcrYyNxHhis3zqvceKvRN7VwD4/yCogreAuErbfwdx1UxcB3HVnR1xlW7z581O5fVViqmqhCYVF7ar0jHvLqhafaNV/f1X3OCtGFvqrFYKwVU0i1XkolslGFJmsvKuq4r1XL2PUOx5lPur6n3hzntmrnkAAAC0+84Tjo+Sfjo7Jf3817cZ18nWn5T0o6TfSrHWGLrsVE/fc/T89I4H770sSvrF5/+nWM/aY137PPaIT7nvWLl32nn/iogKIAkEVfBGEFdp+694iJadmerJrxRedRZX7TBWrBciTzb1TaaVF6/q2MyLXARV64+/U7aqjHO1YznPpznI4vPeSPFcYKvKBVrXlWjslRSjWucz9h7Wz+4Sfw9V+8Jd98xc8wAAAOj2lbsdGyX9fG0yRVQzMZT0y/9JSb/3CJ8o6ec7P6NjJRIbvQe2qqRf5+xTlPTruXdi7woAP0FQBW8HcZW2f8RVcfsqcZX1u+g2dmYzs2Rks+p40aoWWVVfBCsvjHcUYlUfxwnlATv9L9vs8Ra5wVKRxcq7PqgyWanWwOosVVkCKsRV775+2PmYAQDgPCjpl9eWkn7+GEr6adtS0q9PSb+M39/9d48RzxZGST9K+kXWBtXapFgjM33qvceKvRN7VwCYBkEVwP+AuErbP+KquL1KXOVtUzl2LA/8Z8UDynJbuws4Vl4QI6ha38eO5QF3KWHw9Ds9c1BELJpxY+TX+ZCRgakiW6Paplj/K/Y11nU9W4iNuIpjBgCA/aGkX25bSvp9t51U0i/zPyRR0o+SfpT0mzt3nr7n6PnpHQ+emOz7XJT086891rXPY4/4lPuOlXunnfeviKgAFoGgCuA7iKu0/V8F7RBXfbdliKmuRmMn+j82MwRXO5Qeq8hgVW1TX2QjqHpvecAVY/XJN5y+p+9QfcPE2w5xlc8eXZNXiasq4nfeN3PNAwAAJ0BJv7y2lPT7bqOkX5/rW0r6/Y6b7eMNoqeq3xv5PhXnHyX95u5RUdIvtgZT0o+9KwAkgaAK4BnEVdr+EVfF7bOxFWKqruIqz0VAZTnAVTeyVMfW6YIaQVXt8XcSXFVmsKoYu2PymC1zkfKGTYeL+MheAHFV/t7Ju/4jruKaBwAAzoCSfnltKennjzmlpF/WNS4l/Sjpt5M4a9Y3hj7bWPT8mxkXlPSLzbHeuVsZG4nxxGb51HuPFXsn9q4AIANBFYANxFXa/t8grvrlXymumolRiqs6bz6fLlKyygEqLmx3FllVXYRXxK5sV30cHbJZdftfuzuNuSGwjYnzqWJvEBH4ZgiQo+u0cr8Q8an2Tt69AaUBueYBAIC9oKRfbltK+n23UdJv/TUrJf3enZHqLSX9POffbHv1eJqNVd+rmo1X+mdfR+b/mXtelPTruXfaef+KiAqgKQiqAPwgrtL2v4u46ilmpbjqzt5BXNVlvETFAV6BwgmiqhPEVZQKzP+MOpUH3F1kNSaPf4h8FluV0Cpjb1CVqQpxVfz7RFzFNQ8AAPSFkn55bSnp990WzQhCST9K+llfV5T0y4o9pcSf5/uwfp/K889qm/FFYqP3pCjpR0m/yJ4GEdUZxwYAA0EVgAoejOj7zn6IdhXFKMv/3fmiD2ivxe87bFQjWay82ayqb3plCkG8MdUX5wiqakVnJ4qrVomsojGKuUt9M8V6syBLMBRdvxBX+T5vxFV7XkPseswAAKC/hn7DsX0K21PSzx/zppJ+FdejlPSjpN8OGalGQvvo+We1ZY+9zHtNHpvFr567lbGRGE9slk+991DsnxBRAUBbEFQB6EFcpe+/g7hqJq6DuOrOjrhKt5n1Zqfy+irFVFVCk4oL9VXppXcs81dx/LuVB6z6n8DqMTwCn0XkOxuTftVNBJVgSJnJyruuKtZz9T5CsedR7q+q94U775m57gEAgOrr4xOPj5J+OvvbSvpVZ6XK/g97lPSjpN/KjFRj6LJTKc+/2fbW+znqWNUcMhuv9M++jsz/1ntcM++ta5/HHvEp9x0r9047718RUQFsCoIqgFwQV+n7r3iIlp2Z6smvFF51FlftMF6sF1ZPtqybZitSQatjMy/aTxZUdRFlvaE84A7lFixzkMXnsXlvGKjKBVrXlWjslRSjWucz9h7Wz+4Sfw9V+8Jd98xc9wAAgOpa+A3HRkk/X5uVJf3Umam6l/Rbda351pJ+K7JMKY5tNzHWGDrRFCX9dHOJx6b0W+Z0ZaxnLfLcK6OkH9moAGAzEFQB1IG4St8/4qq4fZW4yvpddBs/szf2MrJZdbwIV98ErL6o75S16dQ+diwPuPuNb9V4GwFbRRYr7/qgymSlWgOrs1RlCagQV3ENsesxAwAAIqrM9pT088dQ0k973VktplpR0q9S6HOqKGosaKv8PjPOP6sta+yp70OpbBb/r/tPlPTT+NR7D8XeCREVAGwLgiqANSCu0vePuCpurxJXedtUjh/LA/9Z8YCy3NbuAo6VF/gIqtb3sWN5wBMyWA3nHBQRi2bc6Pl1PmRkYKrI1qi2Kdb/in2NdV3PFmLvIK7iOgIAADKvfd9yfJT009m7lfTLzlJFSb89Svp5+h+jXiSV1e9pQq0xtEI7j99qG4Wx0TlkNl7p987jyljP2mNd+zz2iE+571i5d9p5/4qICuBQEFQBrIeHIvr+r4J2iKu+2zLEVFej8RP9HxsZgqsdSo9VZLCqtlXHZtyY2ElQteo7z8xutXKsPvmG0/f0Hc7Opd4bELPtEFf57NE1eZW4qiJ+530z1z0AAO+EbFR5bSnp9922QlRFSb/7n5ViqsqSftUCpjHOEFCNpLazvsh3a+nH4/eOB0Vs5n0fSvrlrH3qtVl9H41sVO/bVwOAAARVAP24OFZp/4ir4vbZ2AoxVVdxleeiprIcYMWFenX66beVB1S0U/dR8Xd3ElxVZLeqHLtj8pgtc5HK1uWmRGQvgLgqf+/kXf8RV3HNAwDwVhBR5bWnpJ8/JlM4pb5WpaRf/5J+s228Pv75P58xcjOPjbE2CxUl/WIl/VRrg2ptUqyRmT713kOxd0JEBQDHgqAKoDeIq7T9v0Fc9cu/Ulw1E6MUV3XeTD9ddGWVA1RcqO8ssup+U4FSgX2zWXW7kb7TmBsC25g4nyr2BhGBb4YAObpOK/cLEZ9q7+TdG5xaGhBxFQAAqPdMOx1f1cNAZSwl/eb2/ZT0qxFM/Yp5e0m/rNidMlIp+h0jLzuZ51y12kZhbHQOmY1X+hXzeGSt8K5VnvtVlPSjpB8AvAAEVQD7gLhK2/8u4qqnmJXiqjt7B3FVl/ESFQd4BQoniKreIK5CULVvtirl+djlxvuYPP4h8llsVUKrjL1BVaYqxFXx7xNxFdc8AAAnQTaqvLaU9Ptuo6Rfr/sylPTrLTw6JSPVrG8EPlPLOeLxe8eDIjZ6D+fEkn7Za0vUpl6bVX7PngYR1RnHBgAFIKgC2BMejOj7zn6IdhXFKMv/3fmiD2ivxe87bLwjWay82ayqbt5VCEG8MdU3GzqUzFO0y+xvdTar7uKqVSKraIxi7lLcxIgIrbIEQ9H1C3GV7/NGXLXnNcSuxwwA0OGa8w3HRkk/nz3y0FgtrMoSUWVcM1aV9OuQoYqSfueJr0bT32E5H6KxVpsnxhObMd94bIp7dd45OhLrXasUa2emT733UOydEFEBwGtBUAWwP4ir9P13EFfNxHUQV93ZEVfpNufe7FReX6WYqkpoUnHjofJ/d+2elari796tPGDVzXn1WB6BzyLynY1Jv+qmiEowpMxk5V1XFeu5eh+h2PMo91fV+8Kd98xc9wAA9L+ePPH4KOmns1PSj5J+v2yU9CMjFSX9KOm3qqSfQjRFSb/6vdPu+1dEVADwFQRVAGeBuErff8VDtOzMVE9+pfCqs7hqh/FiEQ/M2LJuAq5Iaa2OzbwJgaBqfR8nZLDa7X9AP81BFp/H5r0BoioXaF1XorFXUoxqnc/Ye1g/u0v8PVTtC3fdM3PdAwCw7trxDcdGST9fG0r61V23UdLvfSX9Mo5nxd81BD7V5/j02uP3jgdFbPQey9tL+nlFU5T0q987sXcFgKNBUAVwLoir9P0jrorbV4mrrN9Ft/Ezm5klI5tVp5sJWTc1q29SrPqfYm8XVGV8b8qb9LveyFePtxGwVWSx8q4PqkxWqjWwOktVloAKcRXXELseMwCA6rrw5GOjpJ/P3klY1UFElXHNtfJai5J+lPTrLtLyng/RWKvNE+OJzZhvPDbvfTlK+lHSj70rALweBFUA7wBxlb5/xFVxe5W4ytumcvxYHvjPigeU5bZ2yY7T8YbFCYKqlWX+FH3sWB7whAxWwzkHRcSiSv/MvJuRgakiW6Paplj/K/Y11nU9W4i9g7iK6wgAgPVQ0i+vLSX9/DGU9Mu97sqMoaTfu8VOlSX9lGIpSvpp7xtS0s+/Nkd8lr0HJf3eua8GgKYgqAJ4HzwU0fd/FbRDXPXdliGmuhqNn+gN3gzBVff/oam8abE6c5H6JsjuWamy/u5dSgFWnvPVGauG0/f0Hc7Opd4bKrPtEFf57NE1eZW4qiJ+530z1z0AAPprwROOjZJ+vjaU9Mu7/qKkX85rSvrtky1rBH+f5/zy+L3jQRGbeZ+Ekn45a596bVbfdyIb1fv21QCwAQiqAODiWKX9I66K22djK8RUXcVVnou0inKAFTccVqXT3rU8YOSGyVsEVVXfW3UGq6zxkZGxyjsXqWxdbrJE9gKIq/L3Tt71H3EV1zwAAJ5rvjccGyX9fHZK+uVdX1HS790l/d5Yqk/5HSrOL0r6rb1XONs2sjZ43lvv7yjEVZE1PWPvodg7IaICAHCCoAoA/gVxlbb/N4irfvlXiqtmYpTiqs4XB08XkepygIobDieIrLrfJNlRUFXRR4dsVt0eDOw05obANibOp4q9QUTgmyFAjq7Tyv1CxKfaO3n3BqeWBkRcBQCQdz134vFR0k9np6QfJf1+2XYq6VdRzu4tGamGoB/r+WKJ95yrVtsojI3OIbPxWfcKvfO4MjYS473nQ0m/M/eviKgAIAUEVQBwB+Iqbf+7iKueYlaKq+7sHcRVXcZLVBzgFSgoSgYirvLZlP4u7TL7e0t5wB1EVtG5RDF3WeZHb2z13qAqUxXiqvj3ibiK6x4AeC+IqHLbUtLvu42SfnXXOtUl/SxippH8Olvo8xYBVbVIa4g+v6dzxOO3jocxarJPUdLPHjvTPmpTr80qv2dPg4jqnL01AGwOgioAmIH/da7vO/sh2lUUoyz/d+eLPqC9Fr/vcCERyWLlzWZVdTOyQgjijVHEZ7fp2C6zv9Xiq+7iqlUiq2iMYu5S3JSJCK2yBEPR9Qtxle/zRly15zXErscMAPtASb+89pT0m7dR0i//PoXifoZFTDXrV5Vwo6TfeRmpVKI7SvpR0s/zPmrz2BX3gxBRsa8GgJeAoAoArCCu0vffQVw1E9dBXHVnR1ylu9jwZqfy+irFVFVCE6sv01Ydq2in7mPVZ9S5PGDVwwb1WB6BzyLynY1Jv3feVayN1jUIcVV874S46uxriF2PGQD2u/468dgo6aezU9LvnSX9ssRUd69Xl/QjI5Xu7xgjRzhnaevxW22jMDY6h8zGK/2KeVwZG4nxxGb5LHsPSvq9b18NAAeDoAoAIiCu0vdf8RAtOzPVk18pvOosrtphvFjTMD/Zsm5qrkjRrY6NfE6R/rx+b6yiXZc+dhBUZYw/9fjIHKND5PPYvDd0VOUCretKNPZKilGt8xl7D+tnd4m/h6p94a57Zq57AKAzlPTLbUtJv+82Svr1upahpF++760Zqar69J5fq8RUVfcLKekXW5sU92LU2agU+4Xo/aHd93Jv31sDwOEgqAIAFYir9P0jrorbV4mrrN9Ft/Ezm5klI5tVp5sjWTdprT6PLdrGG7uyXWZ/J5YH3PXBhHq8jYCtIouVd31QZbJSrYHVWaqyBFSIq7iG2PWYAWDdddTJx/Y2EdUvHyX9KOnXuaRflkhnjN4iqcrPpXtJvzG0gjrPuWq1Re4BdhdPUdLPZvPYo+u9eu+xYu/E3hUAQASCKgDIAHGVvn/EVXF7lbjK26Zy/Fge+M+KB5TltnbJjrMig5XKpvR3aZfZX7b4qkvpi8zzuWvGqohYVOmfmXczMjBVZGtU2xTrf8W+xrquZwuxdxBXcR0BADtCSb+8tpT088e8oaTfyv8EsltJP9VrSvrtX9JPIbjy+K02T4y3jWoO6XAfzjKPK2MjMZ7YLJ9l70FJv/ftqwHgxSCoAoBseCii7/8qaIe46rstQ0x1NRo/0RvWGYKr7v/j1HtMVt9sfKQ/b5+KWEU7dR9Zf/cupQArz/nq/z06nL6n73B2LvXeIJpth7jKZ4+uyavEVRXxO++bue4BgNXXTaccHyX9fG0o6Zd3vUJJv5zX1SX93vJvNOlTcX6tKunXPRN29n2hp3sRlPTL3S949jSIqM7ZWwPAy0FQBQDVXByrtH/EVXH7bGyFmKqruMpzE7qiHOBMzA4iK6XPY1P6vbGKdl36yHigkPn9V2a3qhzDY/KYLXORymbxd9mHIK7S7nssnz/iqv2uIXY+ZgDouWavOj5K+vnslPTTX9N2uxegFlPN+k8s6TfGmRmpVJ/BCH5v1tfdS/rtIp6ipJ/9Hgkl/RBRAQC0BUEVAKwEcZW2/zeIq375V4qrZmKU4qrOFztPF8vqcoAzMW8QWWXaLH5v7Mp2mf3tUB4w83+JZ42PLmNuCGxj4nyq2BtEBL4ZAuToOq3cL0R8qr2Td29wamlAxFUA0On658Rjo6Sfzk5JvzXiqeg1REZJv05ZqJ5+PyX9+ou0rN+h5Vzw+K02T4wndghjs+/1eF5bfJHYSIz3Hgkl/c7cvyKiAoAtQVAFAF1AXKXtfxdx1VPMSnHVnb2DuKrLeImKA7wCBUXJQOXN1Uh/0ZhIvKc/pb9Lu8z+3lIecAeRVXQuUcxdlvnRG1u9N6jKVIW4Kv59Iq7iugcAdNc5Jx4fJf18bbqW9FuVmapCPLXquj8qpvpls2apirympN8+GanG0GcYG8FYhW2M2uxTlPSz3V84saTfKrH3Tnu5t++tAQB+gqAKADpycbzyvrMfol1FMcryf3e+6APaa/H7DhdGkSxW3mxWVTdXK4Qg3hhFfHabju3UfXj7e1N5wNUiq2iMYu6yzI+KeVexnkb3BoircvZOnr0A4iquewAgtgafcnyU9PPZKemnvw7tlpHaGxMVU1HS70yhluKzHEMrqHuKVdg899Eo6UdJP+X9E0r6sbcGAJCAoAoAuoO4St9/B3HVTFwHcdWdHXGV7uLJm53K66sUU1UJTay+TFt1rKJdlz52yGbV/X+cq8fyCHwWkTE0Jv3eeVexNlrXIMRV8b0T4qqzryF2PWaA3fm89Pgo6aezdy7plyG22r2kX2aGqhnhFCX93pmRipJ+lPTLmLuVsZEYT2yWz7L3oKTfO/fWAAAuEFQBwE4grtL3X/EQLTsz1ZNfKbzqLK7aYbxY00o/2dRZclamHlfHRj6nSH9evzd2ZbuVx3FCecCOZT2ejmGIfB6bxW+Zd7PW/2jslRSjWucz9h7Wz+4Sfw9V+8Jd98xc+wCcw+elx0hJP18bSvpprgs6ZqeipF+/kn5Vv4eSfpT0y77HRUk/3dqsvEeCiOrd+2sAADcIqgBgVxBX6ftHXBW3rxJXWb+LbuNnNjNLRjarjjd9Kv6XXbV4CkHVedmqvOdsxTnf7cas6gZlRRYr7/qgymSlWgOrs1RlCagQV3EdsfMxA3SDkn65bSnpN2/braRfxjUBJf16l/SrEkFVfi6U9KOkX/Z9r9l7mZT006z36r3Hir3T7vtXRFQA8BoQVAHACSCu0vePuCpurxJXedtUjh/LA/9Z8YCy3NYO2XEqMv5k2pT+Lu3UfXj765rN6vQMVsM5B0XEokr/zLybkYGpIluj2qZY/yv2NdZ1PVuIjbiKYwboACX9cttS0s8fQ0m/nLaU9OsjEKKkHyX9FLHK+abDfSvL3K2MjcR4YrN8lr0H2ajeubcGAEgBQRUAnAbiKn3/V0E7xFXfbRliqqvR+InegM8QXO0gqqrIYDUbH+nP6+/STt2Ht78ds1V5z+euY/bJN5y+p+9wdi713vCabYe4ymePrsmrxFUV8Tvvm7n+AVgPIqr8tpT0+247vaTfLhlnV4mpZv2ZQqkxeoukqn4PJf0o6Zd9X4qSfrq1WXlPAxHVe/fXAACpIKgCgNO5OFZp/4ir4vbZ2AoxVVdxledCuqIc4EzM7hmsrD6PTen3xiradekj43+cZ37/Kx7WVIzhMXnMlrlIZbP4u+xDEFdp9z2Wzx9x1X7XECccN4DyWuJNx0hJP5+dkn55e/vTS/ophTMZZfy6lfR7Q7aqMXTZqcbQCasUNst48sSq5pJO96pm59/I2uB5r7inQEk/RFQAAK8FQRUAvAnEVdr+3yCu+uVfKa6aiVGKqzpfvD1d/KvLAc7EvEFklWmz+L2xK9tl9rdDecAM4VU3kVXWmBsC25g4nyr2BhGBb4YAObpOK/cLEZ9q7+TdG5xaGnBnkRICKzgZRFT57Snp54+hpF9O29Viqll/VXaq2TgyUvUv6RcVS1HSL//eiHruVsZGYrz3FMhGdeY+FhEVAMAXEFQBwFtBXKXtfxdx1VPMSnHVnb2DuKrLeImKA7wCBUXJwIz/VevpNxpj9Vn8CKry+zilPOAOIqvoXKKYuyzzoze2em9QlakKcVX8+0RcxfUPQPW1wOnHeWI2KrWPkn6U9JuJiYqpMrMORbJTeX1vyUil+gxG8LNSnF+U9Mu5JxW5P6PyWe5tZq19HnvEp953rNo77b6XRUgFAPADBFUAAPs9XLg26Dv7IdpVFKMs/3fniz6gvRa/73ChF8li5c1m1eEmsep4ojGZNqW/Szt1H97+3lQecLXISjHGonOXZX5UzLuK9TS6N0BclbN38uwFThVX7Xgdccqxw3v4vPxYKenns1PSL28/vkNJv4iYKiPbUFZJv46ZmqqP/cSSfmPUZ6E6paRfxX9Gm/09kbXB8z5q89gV9xso6cc+GwBgCxBUAQD8bxBX6fvvIK6aiesgrrqzI67SXQx6s1N5fZViKuXNbqUv01Ydq2jXpY8dsllVlB+pGFPqrFYKwVU0i9VwxnrXRusahLgqvndCXHX+dcRpxw/ngIiqrj0l/fwxlPTLaUtJP43QZ7Z/SvqtEb5ZzovIOa0eV9F7Vhn3oqrvA1nmbmVsJMYTm+Wz7D3IRsU+GwCgDQiqAADuQVyl77/iIVp2Zqonv1J41VlctcN4sabJfrKps+SsTKGujlV8Tp7+vH5v7Mp2K4/jhPKAVQ+NlGN0iHwem8VvmXez1v9o7JUUo1rnM/Ye1s/uEn8PVfvCVXuWE8RJCKxgxZ79zcdLSb9nHyX9KOk3E6Ms6afKRkRJv7NL+nnPh6fYLNvq+1GV/1lPdR9F5fPcq6SkX4+90857WkRUAABBEFQBAMyBuErfP+KquH2VuMr6XXQbP7OZWTKyWXUWcqhirT6VzeL3xq5sl9nfDtmqvOdsxTnf7Uaz6oZrRRYr7/qgymSlWgOrs1RlCajUWamy9worS1WffB1x+t8BfffjbzxeSvr57JT0y99DU9KvJiMRJf32EWIN8WuP32qb8UViM69pZ+PV94Fm+4msDZ73UZvHHl3v1XuPFXun3fe0CKkAAEQgqAIAsIO4St8/4qq4vUpc5W1TOX4sD/xnxQPKcls7ZMepyPiTaVP6u7RT9+Htr2s2q9MzWA3nHBQRiyr9M/NuRgamimyNapti/a/Y11jXdcRVe15HvOVvgdr9+duPuWNJvx1EVJY9DCX9KOn3zUZJPzJSUdLv7JJ+GcJViy8SG4nxxGb51HsP1f6JbFQAABACQRUAQAzEVfr+r4J2iKu+2zLEVFej8RN9+JAhuNpBVFWZFchjy2jTsZ26D29/O2aryjiPV47ZJ99w+mb+t+7MXOq9gTfbDnGVzx5dk1eJqyriV+5TEFjBqXw4bmm/n0WxGSIq6/6Ckn7511unlfTrkhmqSlz1loxUqs9gjPzsVJT0y7n3Q0m/2NqpXrc9ew9EVOy7AQC2BEEVAICWi2OV9o+4Km6fja0QU3UVV3luDFSUA5yJ2UFctboU4CphUZd2K4+jk+Cq8uFTxRgek8dsmYtUNou/yz4EcZV232P5/CvEUiv3pKdeR7zx74G+833n46ekn89OSb/8fe/JJf1m/SuyU/3y8Y+SflbbjC8Sq7oGjsSr79fM9hNZGzzvFdfglPSjpB8AACSBoAoAIA/EVdr+3yCu+uVfKa6aiVGKqzpfjD7dzFCXA5yJeUMGq0ybxe+NXdkus78dygN2ewC105gbAtuYOJ8q9gYRgW+GADm6Tiv3CxGfau/k3RsgruL6CHrul9/+dyCi0top6bdHSb+KDFVWsdRbSvpZYt+YkYqSfrFY71yy+n6NYu5WxkZivNfgZKM6c7+LiAoAYAEIqgAAakBcpe1/F3HVU8xKcdWdvYO4qst4iYoDvAIFRcnAjNILkf69MYp4ZRtv7Mp2mf29pTzgDiKr6FyimLss86M3tnpvUJWpCnFV/Ps8WVy127UEf9t5fPhb0vulpJ/GRkm/+j1o15J+32I7CH9OEz11FFt5zoMxdGKpN5X06/wf4FRzvDV2pn3U5rFHfJa9ByIq9uIAAEeCoAoAoJ6L45X3nf0Q7SqKUZb/u/NFH9Bei993uHiNZLHyZrPqcNNbdTzRmEyb0t+lnboPb39vKg+4WmSlGGPRucsyPyrmXcV6Gt0bIK7K2Tt59gKrxFVV+5Y3CJAQWfXY8/I35fZLSb88GyX9KOnXsaSf1/cWcdZIbqf+/j1+hS3r3g4l/Sjpl733UOyfKOkHAABLQFAFALAWxFX6/juIq2biOoir7uyIq3QXt97sVF5fpxtu6tgONou/S7sufeyQzaqinErFmFJntVIIrqJZrIYz1rs2WtcgxFXxvRPiqvdcT/C37rGH5W/L6ZuSfj4bJf322V+eUtJPnSmpS0m/XbJMUdIvdr+Gkn7z152U9Mvde6j2UGSjAgCApSCoAgDoA+Iqff8VD9GyM1M9+ZXCq87iqh3Gi0c84BUoqP7HcYdU8B3KA2a0UcSubLfyOE4oD7hD5gDLHGTxeWwWv2XezVr/o7GXKMayTitis/ct6v3Vin3h6n3LmwVHiK3icyp/Z07/mQ8cV5T0W5mhipJ++msvSvrlCnO6ZY2q/luyS/opBVKe8y/Ltvq+jfI6Oeu+imqOt8bOtFdcG1PSDxEVAAA0AkEVAEBPEFfp+0dcFbevEldZv4tu42f2ZkxGNqvOQg5VrNWnsln83tiV7TL72yFblfecrTjnV47NJ98I2CqyWHnXB1UmK+UaGLEp1v/sfUtmXOXecPVeBZHR+Z/Fmx/AfJr3/1kY631wqhJYUdJPs7/svGc8uaTf6oxUp/4bo074pnjt8StsY6wVVanvuajvm8z2E1kbPO+jNvXarPJn72kq9naU9AMAgDAIqgAA+oO4St8/4qq4vUpc5W1TOX6UD/wzym3tkB1nVQarTJsidmU7dR9Zn1fH8oAnZLAazjnIOndZ5schmGs/iWuoYs17s7hKtXfK3Ldl7TEq9/oIrPp/VjxYWfv5UNJPb6ekHyX9Zm1dSvqp496akWoMfUaqIfrbouefwpY19lRzScZ9EUr6adbmiE+991DtochGBQAArUFQBQCwF4ir9P1fBe0QV323ZYiprkbjxyK0imSnUmSsssTuJrKy+p5sGW06tlP34e1vx2xVGefxyjH75BtO32dyrlSKqzztEFf57NE1GXEV1xUAkTm+8ncgotLZKOnXYz9ISb/4cWQfP5msKOmXfb03G19xL0Tp81x/UtIvZw+FiAoAALYBQRUAwN5cHKu0f8RVcftsbIWY6mo6dtTiqm82j7hqJmYHcdXqUoCrhEVd2q08jk6Cq8qHaRVjeEwes2UuUtks/i77kIrsjVGb0h5dk98qrqreryCwgi68WUSlWuso6Vf7mpJ+v32U9HuH2CrjM8g8FyznivU8nxkrkdiseyoZ19aRWIsvEjvzXnHNSkk/SvoBAMCmIKgCADgHxFXa/t8grvrlXymumolRiqs6X1w/3ZxRlwOciXlDBqtMm8XvjV3ZLrO/HcoDdnugttOYGwLbmDifKvYGEYHvanGVItb6Nyv3NZHvqcPesNNeH4EVdNkPd/k9K0VU3uuGJx8l/TT7UUr6+bIAdS/p95bsTl1L+mVkIPOcf9ZzP3vsZV6vVd7fUMzdythIjPealWxUe+wfTzkuAAAIgKAKAOBMEFdp+99FXPUUs1JcdWfvIK7qMl4saceVGWFWiaoyBSHeGEW8so03dmW7zP7eUh5wB5HV7FwyRL4RnB+9sdV7g6oygIir4t/nanHViv0LAivI2PN2/12IqCjpt2J/d0JJv1l/55J+Xh/l/9Znp1JlqbKe+9F7H28u6ZcllKKkX92+pmK/h4gKAACWgKAKAOB8Lo5X3nd2+ZerKEZZ/u/OF31Aey1+v8OFuTc71XD6KsVUVQ8irD6VTenv0k7dh7e/N5UHXC2yUoyx6NzlnT/HxDkVXbdV5WcRV2n2WZQGfPd1BvTcy3b8XZ+FsRkiql++6vJ9MzGU9Mv/WSGmqirdVlHSr2uWqDeU9POeR9Hz03ruZ98DoaQfJf0iexBK+u2/xwUAgIUgqAIAeBeIq/T9dxBXzcR1EFfd2buIq3YYL9ESgX9tK8RVK0v/VWWwivTn9Xdp16WPHbJZVZSHqRhT6qxWCsFVNIvVcMZ610brGtVVXKXqI+JT7p28+4E3Zq/a9VoD1uxXu/6+ldmookIrSvrV7xsp6acVtlhfVwuaMvo86bjGiGcLs/RtOUc856fKl3UvRHk/o+KehHfuVsZGYjyxWT7L/oNsVGfscwEAoAEIqgAA3gviKn3/FdkJsjNTPfmVwqtO4qrI393hIn5WPOAVKKj+B3WH1Pbq7EAeW0YbRezKdiuP44TygDtkQrDMQRafx2bxW+bdrPU/GnuJYqzrp6KP7H2N9TNGXHX+NQf496M7/l5K+lHST70ny7pWoaQfJf12EWuNoctO9fQ9R89P73hYfZ+Dkn7atclzLUlJP0RUAADwIhBUAQDA/wVxlb5/xFVxe5W4ajZml/Eze3MpI5tVZyGHKtbqU9ksfm/synaZ/e2Qrcp7zlac893KUqge/FZkscoQ00SzLaqyWVlsivW/Yl9j/d52FFd12bcgstqXtwmoVOuBJYaSfvWvKen320dJv3f8G2ONaGp1Sb9u2ac6l/TrnH2Kkn41eypK+gEAwCtBUAUAAH9BXKXvH3FV3J4lrvK0WZ3JSvnAP6Pc1g7ZcSoy/lTbFLEr26n7yPq8OpYHPCGD1XDOQda5yzI/DsFc+0lcQxXr1w7iqqzPTrV3qtzrZe01uuz9EVn143PI70dEZV8fKelHST9K+vUUZo2Gv3cEj89zzlHSL+c+AiX98tdn5bXnztmoEFEBAMBWIKgCAIBfIK7S91/x8Axx1XdbVenAVePHIrSKZKdSZKyyxO4msrL6nmwZbTq2U/fh7W/HbFUZ5/HKMfvkG07fZ3KuVIqrPO0QV/ns0TVZKa7y7AEie4ZTBVa7Xo/syOfA49hBRPUUQ0m/3H1hZlYqSvpR0o+SfnPnztP3HD0/vePBE1N9fTQbX3HvQDn/e67XKOmXs7eipB8AAMD/A0EVAABYuDhWaf+Iq+L22di3iassNwYUD1k84qqZmB3EVatLAa4SFnVpt/I4OgmuKrJbVY7hMXnMlrlIZbP4u+xDqkrjRoVUO4mrMuIUe4Zr8bnGtUlfPi84JkRUOWtfNCMIJf0o6Wd9TUm/3hmpPqLvU3H+UdIvfi0auYa2+CKx3rXIeo1HST9K+gEAAHwFQRUAAHhBXKXt/w3iql/+leKqmRiluKrzzQLPjTpL/I6iqooMVpk2i98bu7JdZn87lAfs9oBwpzE3BLYxcT5V7A0iAl/EVTnfgXK/101gxXXAnnu8E4/xU9BO9aCzU0m/FdmpOpf0yxKeU9KPkn47ibNmfWPos41Fz7+ZcUFJv5xrbqsvEhuJ8V7jkY3qzH0pIioAADCDoAoAABTwUEXb/y7iqqeYleKqO3sHcVWX8aIqEejNZlUtqsoUhHhjFPHKNt7Yle0y+3tLecAdRFazc8kQ+Sy2KqFVxt6gqgzgLuIqhT9jP6bcQyCw2uvv2P2BT6csB6eKqCLrWaWIKmOvp95TU9Lv/vWOJf345/98xtBlp1Kef7Pt1eNpNjZ6rUNJP//aY10PPfaIT7m3UO61KOkHAAAwCYIqAABQc3G88r6zsxlcRTHK8n93vugD2mvx+w6oxFUqsUOlmKrqwYrVp7Ip/V3aqfvw9vem8oCrRVaKMRadu7zz55g4p6Lrtqr8LOKq/uIqxT5ih30w7MOuAipLfFZpn84l/bIzU1HSj5J+GQKqrNhTSvx5vg/r96k8/6w2z30ASvrZ5nRl7Mz7qM1jz1z3VdeRO+/Vdt2bAgDAC0FQBQAAmSCu0vffQVw1E9dBXHVn7yKu2mG8WP/n4JMtKnZYIaZaKbKajY/05/V3adeljx2yWXnjqx46qsf0CHwWkTE0O3/OzLvR9TiSnSq6vlWIqxTrf8W+JjOuwz7z5GsD0M1VFX2vElE9xage4FLST7//qRSJU9KPkn47ZKQaCe2j55/Vlj32qq//K67hvXO3MjYS44nN8qn3Fyv2R6v3gScfGwAAbAqCKgAAqAJxlb7/iodt2ZmpnvxK4VUncVXk7+7ArHhgdTnA6v9Nroq1+p5sGW0UsSvbrTyOE8oD7pDZYXa+GYK568lm8Y+Jcyl7zxCNvUQx1vWzKntVtbiqas+3aj+CyKo/n8b97yai+uVTZ95YJaKq2p9VlPTL2stQ0o+SfiszUo2hy06lPP9m23uu9ZWxqjlkNj7rut0yjytjPWuPYk3MWrsz9her9kgd9oSnHRcAABwCgioAAFgB4ip9/4ir4vYqcdVsTJfxY7lx1K0coKfN6eIqBFX5/e2Qrcp7zlac893KbKjEVRVZrLzrgyqTlWpNjNqU9ohPHZP5PXfcgyC0quezye85XUSlXHuy359Q0m/V3uStJf1WZJlSHNtuYqwxdKIpSvrlXmtUXkda5nRl7Mz7qM1jt97vyt5jKPZJZKMCAABIAEEVAACsBnGVvn/EVXF7lrjK06ZTJqvoTSBFtpidRFWVGX+qbYrYle3UfWR9Xh3LA56Qwco7B0Uy8Sn9Y+IcyxAIVZTC3VlcpfB71ve3CKx2vn7oxmez3/VJbPMWEdVMjDLjVOV+qEtp4mox1YqSfpVCn1NFUWNBW+X3mXH+WW1ZY6/iuj7jOm/2GoWSfhqfeo+h2C8hogIAAEgGQRUAAHQCcZW+/4qHbIirvtuqSgeuGj+WzCoRcZUiY5UldjeRldX3ZMto07Gdug9vfztmq8o4j1eO2SffcPo+k3OlUlzlaXequEoRG113V4irqvZ+3ffzbxdcfQ743ZklcU4VUX2zUdJvzb7j1JJ+nv7HqBdJZfV7mlBrDK3QzuO32kZhbHQOmY2vuNaOzP/WWM/a47lWoqQfJf0AAADKQFAFAACduThWaf9vEFf98meJq77ZK8RUV9OxoxZXfbN5xFUzMTuIq1aXAlwlLOrSbuVxdBJcVWS3qhzDY/KYLXORymbxd9mHVJXG7SSuUqzLnbJXqfcSnff0O11vfA4+ntVZqJ7ilL7IA+NKEVXGfqlyH7LqWqBSTFVZ0q9awDTGGQKqkdR21hf5bi39ePze8aCIzbpmz7h2i1xzWnyRWO96FV0To2u08vqLbFTv2PsCAMBLQVAFAAC7gLhK2z/iqrh9F3HVSiw3p6LZqb7ZdhRVVWSwyrRZ/N7Yle0y+9uhPGC3Mjw7jbkRsHn8mWt8ROCblalqRQnADtmrMmMr9reU7tuHT5P+ThJRRdaJ6IPsCuGUaj+y417/xJJ+s228Pv75P58xcjOPjbE2CxUl/WIl/bJEtt71SrEmZvoy9hrRfRQiKgAAgMUgqAIAgB1BXKXtfxdx1UxMdvk/q32FmKqr2EpVItCbzarj/073Ho83RhGvbOONXdkus7+3lAfcQWQ1O5cMkW8E50fvXFu9N1gprrL0p7RH9y7W76OqPGDm/gKRVa892+o+K0v5PflXi6i+2TJK+mWIrd5U0s/b/u0l/bJid8pIpeh3jLzsZJ5z1WobhbHROWQ2XulXzN2RtcK7NqnWSvU67dlvUNJvn70nAACADARVAACwOxfHK+/7Sm6zo7jqzoe4Ko5KXKUSO1SKqarKl1h9KpvS36Wdug9vf28qD7j6QapijKnH1ez8OSbOqei6rSo/myWuitqUdpXf8tlWCqwq9hmIrer2X6v6znhQWSmisszXq0VUGXuZyr0DJf3eU9LvjRmpZn0j8JlazhGP3zsesq6x317S75O4tihsHnt0jbfsO8hGtd9+FAAAQAaCKgAAOAnEVfr+O4irZuI6iKvu7F3EVTuMF494IFoO8JdvhZhqpchqNj7Sn9ffpV2XPnbIZuWNryrtox7TI/BZDLEt84a/SlwV3SusEFyp9wyqtTq75F93kdXO1wKV+6quvycr0wMiqrk1ooOgipJ+9/4x1oimxsjPSHWK+Go0/R2W8yEaa7VFrp8p6fe8768UVVls1tgsn3IvsWov1GkPeNqxAQAAfAVBFQAAnAriKn3/FQ/hsjNTPfmzSwauEldF/u4OzIoHIoKrO1/H/zWrFllZfU+2jDaK2JXtVh7HCeUBd3vY6p1vLPPeL5vFPybOpeo90BWMrxJSVYm1M2Iq93Yd9x27C68+G//ezFI5p4uoZmIo6bc2+9SvGEr6kZFK8VmOkZedzHOuWm2jMDY6h8zGZ13neuduZawlxnqtQkk/SvoBAABsA4IqAAB4A4ir9P0jrorbq8RVszErx4/lIf5sFqtIOcAKgdMpGaxUNovfG7uyXWZ/O2SrUp6HncsAKf+G2bnLMz/OzLVjIjYjK1OFoLhLCcCK0oBVa/7KstM77tV3eKj0WdSPOhvEKhHVbKw6O9Wq8n6U9Pvto6TfOzNSDYFP9Tk+vfb4veNBEVu5N6+87rLM3Raf9TrBe/3hWRcja7XCn7X/qNwDko0KAAAgGQRVAADwNhBX6ftHXBW3Z4mrPG06ZbKK3tTKEFztUopkCGM72BSxK9up+8j6vDqWBzwhg9VwzjdWn3cuzc5i1VlcZVkHO5cGtKzROwmsdt7D78JncV+VAqonf5WI6ptNJaLK2GdE9wKU9Lv3j7FGNDVGfkaqUwRUnURa3vMhGmu1eWI8sRnzTcZ10ey9B0r6aXyWvQUiqv57SwAAgBYgqAIAgDeDuErff8WDN8RV321VpQNXjR9vFiuvLSKussR2FFkpfU+2jDYd26n78Pa3Y7aqjPN45Zh98g2n7zM5VyrFVer1PrIXqC4DqBBXeduo9kLe9fxK+v7ftKdftX/q0G/Gw8s3iqg8+wb1XoOSfpT0e4MoSvUZjKETTSnFUpT0y79WUs/XylhLTPQ+S6ZPuWdQ7qMo6QcAAHAICKoAAAD+h4tjlfb/BnHVL3+WuOqbvUJMdTUdO1FxVVY5QEvsiSKrTFt17Mp2K4+jk+CqIrtV5Rgegr9nJNks/sp9SGYmqwyb0q7Yq1jW6kqBVfUe4jTh1WeD39NNQPXL30FE9RSzqrwfJf1++yjp986SfpXCt8/IzYJmtVnGkyc269o241onco2m8j3Fetcfxdr4tC5T0q/Pfu+0YwMAAJCBoAoAAOA7iKu0/SOuitt3EVetxHKzTVFS6yRR1QniKgRVPbNVRb7rbmWFqsfcCHw2I2Cz+CM30VfsDVQZH6Nr9czfkpm9KiMuY5/Qab+RdSydHkR9itsrH4KqslBZ7aqH1orST6tFVDvtjSnpR+m9bPGV8jtUnF+U9Ft7vemd1yOx3vVIsQ5a780o23r3JYiozjg2AACAFBBUAQAAPIO4Stv/LuKqmZjs8n9W+woxVVexlapEoDebVcf/be89Hm+MIl7Zxhu7sl1mf28pD7iDyGp2Lhki3wjOj4pYxXqqWINUYiqFQNqzF4juVTL3Wdl7VMr8xfZGK/pSzifKLFRWe7WISrmPyFzHO2SnoqTfmnJ2b8lINQT9WM8XS7znXLXaRmFsdA6ZjVf6PXOxcn1QrlHe6wdK+vXZq73huAAAAEpAUAUAAGDj4njlfWc/lNtRXHXnQ1wVJ1oi8K8t6qsUU1U98LL6VDalv0s7dR/e/t5UHnC1yEoxxtTjanb+HBPnVHTdVman2rU0YPQz6iKw2mmvugufZv2qBZnqh7TdRFSeNV29D+iWGXJ1ST+LmGkkv84W+rxFQFUt0hqiz+/pHPH4reMh+5qUkn6+9SGyJln3/JT0IxsVAADAK0FQBQAA4Adxlb7/DuKqmbgO4qo7exdx1Q7jxSMe8IoWsh4mrSz9V5XBKtKf19+lXZc+dshmVZFJo2JsqbNaqcsBzs6f3nk3aw/RTVxljc3yZe2jFOv+in1Dt73KZ6Pfl/EgM6Nc0K4iKtU+IGvt7VbaTyWmmvWrSrhR0u+8jFQq0R0l/Sjp53kftXns0fVbuU9Yscfpusc75dgAAACWgKAKAABAA+Iqff8V5WSyM1M9+bNLBq4SV1m/ix0eYCoECuqMVdUPqFSxVt+TLaONInZlu5XHcUJ5wI4ZN56OYYh8HpvFP9Puk7iGzsR61rgsIdWKEoC7lP6j5J9uj5Pdx0oBlXUuWy2iylj7s9bK7L1kdvapXz6rmOru9eqSfmSk0v0dY+QI5yxtPX6rbRTGRueO2fis60LvXK6MjcR49/uU9Fu/DxsvOi4AAIAWIKgCAADQg7hK3z/iqri9SlzlbVM5fiwZUmazWFkFV1WlwU7LYKWyWfze2JXtMvvbIVuV8jzcLTOH0jcm5z+v3zpfq9ZXdeaknbNXqfY/is83Y/2n5N+a/pQPRbOzUM3OeZ1FVBXrZKc1kJJ++b63ZqSq6tN7fq0SU0XaVOxlK69TVHO7Nda7LllsHnvEl7FnUOyHyEYFAAAA/wWCKgAAgFwQV+n7R1wVt2eJqzxtrkbjJ3qTLkNwtUN2nIoMVtU2RezKduo+sj6vjuUBs7JTVY/FUeDzzqWdbtxXlL+tzl4VXVtV5ZGV6/m16HxYzWeD36N+wKl+aNtJRDW7hmau1yvWv5NL+mWJdMboLZKq/Fy6l/QbQyuo85yrVtuMT9lm9TWh4jrGO39HYr3rknX/Tkk/RFQAAADwAIIqAACAOhBX6fuvyIKAuOq7rap04Krx481i5bVFxFWW2I4iK6XvyZbRpmM7dR/e/nbMVpVxHq8cu0++4fR9JufKj3CuVazbmaUAdy0DqMpQtar8H6X/7PuaivaKrBQrSvy9TUSVtUZ52+5W0k/1mpJ++5f0UwiuPH6rzRPjbaPcr1LST7fOqddXxZqevd/I2htV9XnycQEAAGwBgioAAIB1XByrtP83iKt++bPEVd/sFWKqruMjKq7KKgdoiT1RZJVpq45d2W7lcXQSXJ2WwWoI/tYhtlUJra6i2FVlAD32iC/7c83cB5wqvOpQ5k/1kLQiO5XX1qW838qsVJT0i72uLun3ln+jSZ+K82tVSb/u5amj1waRaxqVb2ZvS0m/mr0P2agAAADADIIqAACAHiCu0vaPuCpu7yyu6jJeooIAr2jhBFHVCeIqBFU9s1VFvutuD6Krx9wIfDbDaLP4LfOqas1XrztV2as8ewDFfsTzGV1J392u+/TKB15dSvx5/Rnl/b7ZVoqoqvc6XfaUajHVrP/Ekn5jnJmRSvUZjOD3Zn3dvaTfLuIpSvrZ99uU9ENEBQAAAEEQVAEAAPQDcZW2/13EVTMx2eX/rPYOYqqO4qpIFitvNqvqB2CZghBvjCJe2cYbu7JdZn9vKQ+4Q5nA2blkOH2zgiuP+CoyB+9WCpAygO/ZT2ftRyr7ySzxl1Xe75utWkS1Yv1bsRapYu9sXbJQPf1+Svr1F2lZv0PLueDxW21ZYy86D0Su05R+xdysjI3EePfTlPTrsc96y3EBAAAcAYIqAACA3lwcr7zv7Id7O4qr7nyIq+JESwT+tUV9lWKqqgw9Vp/KpvR3aafuw9vfaeUBu4qssrJaDcP3M2vLFFpl7gG86303gZXCr1ivd9hnrthLVPZLeb8aEdXKtSpLpJ8lpvpls2apirympN8+GanG0GcYG8FYhS3r2o2SfvG1YaZ91OaxR3zWfQTZqPbaIwIAAMA/IKgCAADYB8RV+v47iKtm4jqIq+7sXcRVO4yXqKDgr0394KxrOYjqDFaR/rz+Lu269LFDNquuGawyH6wP57hTzHuWubRybxAtc6fMXqW0K9faCqHVzvvlij1HdvtodiqVgCoyz2SIqKrXwR1K+3ljomIqSvqdKdRSfJZjaAV1T7EKm+e6jJJ+lPTz7rUjewREVD33eAAAAGAEQRUAAMCeIK7S919RliY7M9WTP7tk4CpxlfW76DZ+ZjOzZGSz2vV/N2eKWp5sGW0UsSvbrTyOE8oDdn74bZ1ThmDuGhPf/+xcWrnfyMiqeGopwKp912n76U+D/jJL+/3yZQiruomostafigyIK8VUlPR7b0YqSvpR0s/72uKLxEZiPLFZPsuegZJ+e+wBAQAAwACCKgAAgP1BXKXvH3FV3F4lrvK2qRw/XkGANzuVNX5V6Zes3+2NybRZ/N7Yle0y+9shW5X3fKw857tkJvgE5rMhmEut2a0q91jKbFWdSgFaP8dL/Dm+laoHlFlZLlZkpsou9ZcpEF5RNvbvT0r69S3pV/V7KOlHSb/s6yRK+tnXWkRUa/p8w7EBAAC8BgRVAAAAZ4G4St8/4qq4PUtc5WlzNRo/0QeWGYKrHbLjVP+v6WrBlTd2ZTt1H1mf167lAbuLrIZzvonMZ2PivPDOx7P9ZWar8qx31jU3Y29gXU9XZ6l6c4aqrIefOwmorO+j5aPU603H7IZZYiqlcGZlSb8qEVTl50JJP0r6Ze+7Z69tKekXX4vVa75qD4OICgAAAJaCoAoAAOBcEFfp+78K2iGu+m6rKh24avxEy1pVlgO0xHYUWSl9T7aMNh3bqfvw9tc1W5XivOqUhSQyhqyfm3WOs/h33sNERVPKtV65f1F9pm/PUlXx0DJa+m/H0n6za1L1utNlf5ZZ0m/W372k3xjni6Ao6bdPSb/M66fqa5+suX3mvTfGu8clG9W6PVLXvRsAAAAkg6AKAADgPVwcq7T/N4irfvmzxFXf7BViqq7jIyquyioHaIk9UWSVaauOXdlu5XGcVB6w2xgegXGlHkuW82jVHkexPmWW/cveZ3jX4Ldlqvos6ucjiMkWVkUfdleLqKrXBtW8v7qkX2bWIUr6UdIvev4pbGPUZp+ipN98rHetsdg89ojPsidARNV/fwcAAACJIKgCAAB4J4irtP3vIq56ilkprrqzdxBXdRkvlhuiGeW2dhZVnSCuQlDVM1tV5LuuyFKlHh+VGatGks06h3oe7mWuIasFVpH9QuYeaPf9bsU+QdEuq4zQjqX9lGt099J+2WIqVbahrDJ+3Ur6vSFb1Ri67FSWc+opVmGzjCtPrHKf1kVQZdmDUdKPkn5Zfb7h2AAAAOALCKoAAAAAcZW2/1PEVU/+DuKqb7Y3iqsiWay82WKqRVWZghBvjCJe2cYbu7JdZn9vKQ9Y9aA9u61nPI2AreuDDEV2qhXlACv3JhX7ww5r/WdhX5+CmGwB1UxMZxFV9rxMSb8csZO33VszUlWU9IuKpSjpV7u/nn1t8UViIzGe2CyfZS9ANqr++zoAAAAoBkEVAAAA/MvF8cr7zn4weIniKsVV1jaIq+aJlgj8a4v6KsVUVRl6rD6VTenv0k7dh7e/08oDdhNZKUoFDsdn9/T9z/o77WNUe4o3Zqvada/rXe+V7clKpVuHMud865xdLaZSl18bQyeaGiM3i9LJGalUn8EIflZDcH5R0q/fNYrKZ90PRtYi1boX9VnWekRUffdrAAAA0AAEVQAAAHAH4ip9/4ir4m26iKt2GC/Wm8ZPtqoHfqvLW1RnsIr05/V3adeljx2yWVVksOpUztMz3ma/l1+2ITgPZ3531t7kEvaVsa5n7Fmq12RV35nnxSexTeThbbWA6immSkSl3D9kzdsVJf1m/atL+nXM1FR97CeW9Iucn1ab5zqms3iqYk9t2UdR0o+Sftn7qJOPDQAAABwgqAIAAIAZEFfp+694QJhd9u/Jn10ycJW4yvpddBs/sxlaMrJZ7fq/tTNFLU+2jDaK2JXtVh7HCeUBO5eUUswzlvnu6XvffS9ziW2Rdd/yN61YYzvvdT/FfShK/u2Qlapq7elQtrVKTLUiC9XT71EKfWb7p6TfGuHbGP2yUJ1Q0m/F3t7ii8RGYjyxWT7LOk82qr57NQAAAGgKgioAAACwgrhK3z/iqri9SlzlbVM5fizCgNkMLorMMNXZFqp+tzcm02bxe2NXtsvsb4dsVd7zsfKcX51hITp+LOdO1hz9Ea491rVbLaZanbFqx/2r53zKaJeRkWpmvN3ZVgqqVOLbFRk/n36qxFSzflU2Ikr6nV3Sz3s+eM5PhW2M/v9JJONaI7IXV/mse7rIOvRrfaOkHyIqAAAAOBAEVQAAABABcZW+f8RVcXuWuMrT5mo0fqLZKTIEVzuUHqvIYFVtU8SubKfuI+vz2rU8YFeR1XDOM5G5bWbuXF32z7LGVJYEVOwlKvdG1f12KvmXmZHKMu6+2dUiq8zX0TJ+yr1JppgqMwsVJf3eJ8Qa4tcev9WmHmdZ1yeRePXe2LJHoqQfJf1W7Z1PODYAAABIAEEVAAAAqEBcpe+/IgvDG8VV3+wVYqqu4irPDdvKcoCW2I4iK6XvyZbRpmM7dR/e/rpmq6o6H1eO3epx5Zk7o3OzxafcZ+yWsarDvqtqva5o3y0j1TfbakFVVYm/6FwajfXYrFmqIq93Lun3hoxUlPSLxWZfb1RcHzztmyjpp1t/M9f9zD1KVZ8nHxcAAAAUgKAKAAAAsrg4Vmn/bxBX/fKvFFfNxCjFVSuJiquyygFaYk8UWWXaqmNXtlt5HCeVB+wgslJns/LMc0N8Hu6218nIWJWxb9l5fxpZr6NtVmWk+mbrIKiqElGp9yWrxFRdMyB1KelX+TlR0o+SfquuD5Q+615Mue+L2CM+y7qNiKrPXgsAAAAOBEEVAAAAVIC4Stv/LuKqp5iV4qo7ewdxVZfx4i1z9dfmzWa1s6jqBHEVgqrzygNWlKPKHi8dSnBa5sHMeXhlxqqMPUhW+b8u+7rsh3JZD1M952A0y4f1oXhlib9Zf1bmvw5iqsxybV6x1i8f/yjpZ7VZxpAnVrVHisSr97Oz/VjaKd5HbR679To6a41W7kMo6QcAAACvBkEVAAAAVENpQH3f2RkarqIYZfm/O180o9W1+P0qVCUCvdmsqkVVmdl2vDGKeGUbb+zKdpn9UR6wVmTl6Sc6H1nmxKyMVUqBVWR9UQmbLcdxFf1tK9fgz4J+PsEYRYkkpYBqxRrRSURlmSsVwqnKMn7VJf08x/WmjFSU9IvvTVR7qozrAMX+hZJ+tvWWbFR97ncAAAAA/C8QVAEAAMBKEFfp++8grpqJ6yCuurMjrponWiLwry3qqxRTVQlNrD6VTenv0k7dh7e/08oD7lbG0zPnrMxY9RG1+4j67bz3ugp/V5d1VtXW+6C3IkuV6kF8tbBVOTdmiqk8IpUskVB2/7uInjqKrTzfzRg6sdSbSvp1zkqrmoOtsbP7GEr61e4dVvZ58nEBAABAMxBUAQAAQBcQV+n7f7O46pdvR3HVDuPFehP8ybYi08PK0n9VGawi/Xn9Xdp16WOHbFYni6wqsz8MwflmnWtX7UXU2akqhFS77T0/ye0qRFWeh+RZAqqM+TSzRGo01iucWlXGrzoj1anirJHcTn0uePwK26prBEr6xd5HbR57ZL1Ur8uKPULWfpKSfgAAAHAMCKoAAACgI4ir9P1fBW2yy/49+U8VV1m/i27jZ1ZckJHNqvP/PlfFWn1Ptow2itiV7VYexwnlAbNLZFaW3RwBW1YZwOGIi8zfndaYq6hNRz5JbVTl/Sz2DoKqyLyaPQ8qSpR5S/79+1pZrk0l4OlS0m+XLFOU9Ivt+ynp55uLI7GRGE9sli9zL4eQau/jAgAAgA1AUAUAAADdQVyl7x9xVdxeJa7ytqkcP5aH/rNZXJSluXYtQVaRwUpls/i9sSvbZfa3Q7Yq7/mYPe68bbOEjNZzo2LeVWR+GI6YrHU6e1+i3l9VPLxTP3jNzlJlfVDufUhflZGqcn/x5IsIp7IzTFnbWvvdNQtU15J+SoGU5zzLsnn3Ax2zUmXtzSNzMiX9/Gs0IqoeeyQAAACAryCoAgAAgJ1AXKXvH3FV3J4lrvK0uRqNn2iJggzBVWdRVWUGq2qbInZlO3UfWZ9XheCqQliQOX4+i8fWEJ0/qrmXveO6PiuyiXnjVFmq1OX9nsbEivm0Q0liS3k/jyhqjHzB1RhkpOok5hqJrz1+hU21L6CkHyX9FH7V9fKqPUf3/SZ7YQAAAJCCoAoAAAB2BXGVvv+roN0bxVXf7BViqq7iKs8N6MpygJbYjiIrpe/JltGmY7sufXTNVpVxPnYZl8rSgJmldzKzVGU8wKvOTtV9H/cp7iPyIHiloCojO9WsXz2nZYuprDZlWbcugqYxzsxINYY+I5Xqu7f0qT6Hreu3UlQVjV21n/bOscrYSIwnNstnWYfJRtV3LwUAAADwFQRVAAAAcAoXxyrt/w3iql/+leKqmRiluGolUXFVVjlAS+yJIqtMW3XsynYrj2OV4Koyq8tu42sYv3frHGp5mJkxd1dlWdhlP5SxJqraqwVVq7NTrSj1VyGi+jh9v2yVGYlWZ6TiHyX9KOln3yNQ0k+3XkbWd0RUex8XAAAAHAaCKgAAADgRxFXa/ncRVz3FrBRX3dk7iKu6jBfLDWtvdqpf8TuLqk4QVyGo2rs8YKYYIWssqB7GenyWOW0m1jqndshSpYo/aT/ZXVB1QnaqXcRUFp+3vN+32BUCnjH2zxq1Q0aqLiX9IoJAy9rsic3ag3fbI1t8kdjZ/QQl/er3Wrvtx3Y6NgAAADgQBFUAAABwOpQG1Pd9Jbe5imKU5f/ufNGMVtfi96tQlQj0ZrOqFlVlikS8MYp4ZRtv7Mp26j6in3HGd6QUJ2SLrKx9ZD1E/QjHwtN8Gcl+9TTX7pKlarf9Y8UDVWWmjpNK/Z2ekWoUvlaJnbztdi7xN0SxY+SK1qLnm/Vc9q7RSlGVck+t3LNl7BEo6Zezxq5a91f3efJxAQAAwAtAUAUAAABvAnGVvv8O4qqZuA7iqjs74qp5oiUC/9qivkoxVVWJNKtPZVP6u7RT9+Htb8fygKtEVhXZZGY/I1UpnzEZ58lKterhYsVDtRUP7ioyVK3ITvURnouniqksPm9GKq9YplIwNAYZqSozgllfq7JUjaHJQkVJP/uegJJ+OfsNRFTn7MUAAAAA/gsEVQAAAPBWEFfp+78K2mRnpnryK4VXncVVO4wX6039J9uKh6krS/9VZbCK9Of1d2nXpY8ds1VVnt/VZX46PUzNKP3XKUvVbg/iyE4VP5d3EVN1zEilyEqE2Gmfkn7ec8XS98x+l5J+lPR7WoMo6UdJPwAAAIClIKgCAAAAQFyV0T/iqrh9lbjK+l10Gz+zmTAysll1fACkFqFYfU+2jDaK2JXtVh5HJ8FVldghcwxHHyJnnE9P8571IeOKB6UzfmvcXduqbFi7ZafqXupv1l8ppvqM9RmpxtCIrFRZp8bomZGq8netKuk3RkyI9RTrXQc9+2RK+sXm00hsdG9gjc3yZe4rEFLtfVwAAAAACKoAAAAA/oC4St8/4qq4vUpc5W1TOX5mRQIzsbMPPyzxnTLndMtgpbJZ/N7Yle1WHkcHwVVlmcDdMlp8hOeX5SFsZkYKj33Wb4371T5DXPURHlv0M6go9Zcppvo4xs7sXFEhoqrKSBUR3UT62VnU1OXvGkOXnSp6Lnn8nnFFST/b68i8arlusuwFKvYDiKjW9HnycQEAAAD8LxBUAQAAANyDuErf/1XQDnHVd1uGmOpqNH6iJRcyBFc7CD4qMlhV2xSxK9up+7D017U84G6lAL0xnqxVsw+3v81bXcr8PNmfHpbOCooUD+4i4qrP0ImzLH14P7/PZPxn5ImpPiMuLszMjjebRehX7IzvjRmpKOm3d0m/btmnOpf065x9ipJ+OdeiyraVfb7h2AAAAAD+i4uPAAAAAODIfRPiqvnY08RV3+wVYqpf72d9V3J7j99qm/FFYit/RmOsvidbRpuO7br0UfUdZJxLlnNY1XaI2nhsytcWn3c9Uduz9gcdUT7czchK9c0WEVN5XivL/XmzXmWUAPUIX1SvV/uy36/qe9bniYueMx6/yheJjY51lc3i97y2+CKxkRhPbJbPsn7unI0KERUAAABAAmSoAgAAAPBxcazS/t8grvrlXymumolRZq5aiedGe0U5QEvsDpmsrL5MW3XsynbVx7EqW5VqLK0aR9lZq6Kvv/ks7+/665St6t/YHR7wfZx/m8f/McQ/fc+e9xnz3Uc4D8xmoBrDlq3KaiMjFSX9KOlHST9lrLX9MPbltUd8M35rnDde1bayz5OPCwAAAMAEGaoAAAAA3rWnQlw1HxuNWSmuurN3EFdFs0152kQzVz3FRrNZdc9UdfczI4NVps2btckS2yWzVfVxqL4Dq011LkZi1WPbY7POXYq5V7WmeO3Ktbzjnu6T0MbzULo6K9Uvn0oQmy2uzCr5WZmdakXWKUts5wxVCl/kO7L04/HPnOeU9PPPWVZfJHbmfdTmsUfXM8saSkm/PnsYAAAAgLYgqAIAAAB49/7q2qDvK7nNVRSjLP9354tmtLoava8UVN29VpcIVJcKzBZ3VIqsupUHpFSgNrbSFj0XV/y0+izzVPR1xnvPuhcVVlXsJyJ8EtuphFTf7FZx1Ypyf5miqmissqzfnb+LuAoBVfzzVpwPEb/KF4mNjmOVzeL3vLb4IrGRGE9sls+yjlLSr9c+BgAAAKA9CKoAAAAA2GtVHe+q7FVXQmxmacAruc3u4qpfPsRV+VmwTslglZXNCkFV7vditWWfv9lj0WOLxHrjZt5bbOq1UL0nie5nPkXtM4VU32yZWanuXisyVHUo7fnNl52dCkFVftvoZ+99HY2NnseWmKfYyFi09qecZzyvI/PmU6xnzrb05bVHfKr1UL1OU9IPAAAA4DAQVAEAAACw71pxvDuIq2bjV4irfvl2FFf9tanLBFYLraoEV9ViqrufnTJYrS4P+NZSgdHYLFvUpzqv1ePVMqdEX0fm5+ja47F71vvuezRlSaLVQqq/72fEAt1L/P3np1pE9eTvXu6PjFQ534OlH48/ej5HYiM/rT7LHENJP936EV2rrOsiJf3W70sAAAAAtgdBFQAAAAB7sNXHi7hqzn+quMraZjdx1Tf/CnFVpO1KkVW3UoBPfjJb1X3uVlvWOar4GY1RzE8jEKea+z3rmWp97rJX+yS0UWWqioqrMsr9RbNSzcRkZOepyk6FoKpHRqpoG8+54PGrzu9IbHS8qmwWv+e1xReJjcR4YrN8lvWxKhsVIioAAACAl4CgCgAAAID9WKfjRVw15z9FXBXto0JcdefLzGLlje8mqvrPz1UZrFZnq7LEvl1QtTqDledc9bZVjV2PTTkHWn0KW2RtVO01lPug7Ie4XYRUf99XZKjapdTfquxUGeKqNwqqonHe19FYq20UxHrGnLUfS1vvHDQ7r6ljPfOydd732CM+1XqnXH+jbSv7PPm4AAAAAEpBUAUAAADA3qzr8V4L+1CXCkJclZ/tKktcNRNXXSIwq4zYKRmsVgquEFTl+CNtvPFj7JWtSjEnKeZF7/yvWrM8a/lbSv6tLvenylBlFVVliauqs1NR4q+XgIqSfpT0o6Sff92ipB/ZqAAAAAC2AUEVAAAAAHu1HY4VcdWcf4W46pu9Wkz1971SXBVp31VcZYntJrI6tTzgW4VYmd9F9JyxxMy2iYwRq88yF3nnQIvPEmNdgxRra5d9mDrLhvWB9+yD8+wMVVVZqe58K7NTqQRXCKoo6UdJP9scYo39FW/xRWIjMZ7YLJ9l/UNE1WP/AQAAAPAaEFQBAAAAsG/b7VgRV8X9K8VVMzFVYqtsQdW/r1V+VTlAS+xpIqvu2aossScKqlaX/+uQrSoaY5lb1POidx2IrjWetXpV6b/sB7w7lPr75VMIJ7JL/il8lPh7V0Yq72uP32obhbFjUNLPE+uZf63zu8ce8VnWQ0r65YCICgAAACD5BhAAAAAAsIdbfaxvElc9xawUV93ZTxBXedpUlQiMiqtmYhBX1WerssS+UVC1W7YqxU9vjMemmh+V64LXnrVeV6F60HxyqT9lVqr//FQJrLqW+3u7oErhi3zOln48/pnzmJJ+Nn9kjovEzryP2jz2yLqjXt+8scq2lX2+4dgAAAAA2oGgCgAAAID93CnHey3sp5u46smvyvgRzWh1NXpfKai6e60uEaguFZgpBlGXVlMLa7LLA1YLo7y/o9txZtmyz0nVmLT6vH6rz/Nesc6o19nsPcwnsV2GiOqbrbrUX9esVL9iFCKqO38nQZUldoeMVNHP2fudRs6l6LmqiI2OTZXN4r+LnW0bmQtn3ntjPLFZPsuah4gqB0RUAAAAAE4QVAEAAACwtzv1eFdlr8rIhJFZGvBKbrO7uOqXD3FVfhasUzJYZWWzQlB1ftaqaKzH5p0TPe+jNsUa2Xkf9RHEqEVU32zKDFWZ2ame2mSW/avMVIWgipJ+lPTLL+mXKaqajbHM2x57xDe7hlnivPGqtpV9nnxcAAAAAFuBoAoAAACAfd4bjncHcdVs/Apx1S/fjuKqvzZ1mcBqoVWV4KpaTHX3s1MGq9XlARFU+b8TZXz0PFSPL5XNMlcqhFTR9US5llbtVT4JbawPv2cfsFeW/Ytmovrl65CV6putSlD1K66roEoV6/mMrG3GoKSfYrw+2ZR+1fyV8T5q89ij64xlbSMbVQ4IqQAAAACEIKgCAAAAYM/3tuNFXDXnP1VcZW2zm7jqm3+FuCrSdqXIqlspwCd/57KCHf4mqy3q85yPqnEUGfsWv9Wnmqe9duv622nPpHggnVH6r1N2quwyf39/rij3Vymo+uU7TVDlibO8jsZabZ4YT2x0HKpsFv9d7GzbyDzneW+xWWOzfKo1KxKrbFvZ5xuODQAAAGBrEFQBAAAAsP978/EirprznyKuivZRIa6682VmsfLGdxNV/efnqgxWq7NVZcXu0i7LFvUpf0ZjlHOKdS7zztGedUa1bmbuHT5JbVTiqmg5KquoKqPM30xMhhAlM3PRyvJ/lYIqVWz0s1O89vittjEo6TcEry2+SKwlZrat1x7xWdYySvrlgIgKAAAAoAAEVQAAAADsBTleXf8VD2cRV323ZYup/r7PElfNxFWXCMwqS3ZKBquVgqu3C6o8fqst6ntqEzm3vTHe+cQ7j6nmbK89a63NQvWAOvrAPZqtSvG6Q5aqzKxUT/7qLFS/fLsLqlRtlLFW24wvEhv5afU92ZR+y1xl8T3FeudVi81jj6wf6nXKG6tsW9nnG44NAAAA4DgQVAEAAADAjntDxFXzsaeJq77Zq8VUf98rxVWR9l3FVZbYbiIrygP2yDSVLbiyfgeWc8gTmzHWPDb1HGaZ63fIVDXbR/TBZ/TBdTTriarkn7csV1amHKUwpUpE9e/rkwRVqthonOV1NNZqyzp3FePIM46fbBb/XexsW0s7xXuLzRqb5VOsRer1EREVAAAAAJSAoAoAAAAAdt8nIq6aj70W+VeKq2ZiqsRW2YKqf1+r/KpygJbY00RWu5cH3Pl3ePwqnyUmayx5bNZY79xmmevVmao863LmXkNdCsn6wFyRVcWT7cUqpuhS7q+LoOrf1ycLqhQ+62doaevxW21jUNJvCF5bfJFYS0xkXs72WdYnSvr12B8AAAAAQAIIqgAAAADgpD0j4qr52GjMSnHVnf0EcZWnTVWJwKi4aiYGcVWNuOrJj6DKH2+JUfz0xnjnCMW85p2vvXbrOtph37Oi7F9UIJBV7u+bbYdyf9kiqn9f7yaoUsWOkSu0yvB7zy1FbOSn1fdkU/otc5PF9xTrnTctNo89sjao1yBvrLJtZZ9vODYAAACA14GgCgAAAABO3j9eG/R9Jbe5imKU5f/ufNGMVlej95WCqrvX6hKB6lKBmZl7vIIXb8zO5QE7lO5TxkbaRH0VP60+r987j828V6wB6jUw0sfqkn93voySf0rx1Dd/RED1n9dVgqpvNgRVfTJSPb2OxlptnhhPbHRcqWwW/13sbFtLO8V7i00RG1kH1GuNcv1DRAUAAAAALUBQBQAAAABv2Uuemr3qSojNLA14JbfZXVz1y4e4Kr+vUzJYdSgVuCo2w6/yeduoxoTHFn1t8Snme9U6VrWHyCiTpMhyohBR3fmyslR5xVZZZf6+2d4qqMroJ/IZWdp6/FbbGJT0G4LXFl8kNhLjic3yWdYgSvr12AMAAAAAwAIQVAEAAADAG/eViKvm41eIq375dhRX/bWpywRWC62qBFfVYqq7n50yWK0QXL1BUDXbJuqLxHrPeZVt9rU3zjJne+zWNXLVvkaZ+SP6IF9RQkslnvpmU5f7U/jeJKhSxc76PHHR78jjj55PkdjIT6vvyab0q+Yja+xM+6jNY4/M/9a1hmxU69d6AAAAAFgMgioAAAAAePseE3HVfDziKo0goHu2qrvXs/5KcZWnTSeRVYdSgE/9vFVQpbApzp/oOIiMUeXrrPk0ur503r9klfq7s0fKXKmzVFUKqf7+3KXM37+vTxFUeeIUrz1+q80T44mNjhmVzeK/i/XOM5HYmfdRm8c+syYgokJEBQAAAAAJIKgCAAAAAPabdceLuGrOf4q4KtpHhbjqzpeZxcob301U9Z+fqzJYvak8YLQvVZuZ73GFoEo53rzzQCTOO5967Yp12dvuk9jO+iBeWervl09d4u+XD0FVv9J8maIpxffg8VttY1DSTzFPWHyR2EiMJzbLZ1lzKOmXAyIqAAAAgANAUAUAAAAA7D3XHO+1sA912SPEVfnZrrLEVTNx1SUCVWXNThBZ7Sa46pR1qqOgquoctPq8410xz3jnz8ja4Vk/s/YEGQ+xlVmp/toyRFT/vvYKPRBUrfWpRVNVmafUwin1+ab8afU92ZR+y9xi8T3FeuZAq81jj/isawvZqHqs7QAAAADQGARVAAAAAMBedP2xIq6a868QV32zV4up/r5Xiqsi7buJq2ZiuousVguvumazWuG32lTfs+Kn1WcZ1+o5xzvHWufxrDVPifLB9opSf798ERFGtFyZMiMQgqq1Gam8rz1+q81zjkXaeMeBymbx38XOto3MQ573UZvHHpnXrWsIIqr1azgAAAAAbASCKgAAAABgX9rrWBFXxf0rxVUzMVViq2xB1b+vVf5oOcCZmNNFVieWB8zwR9p44y0xip+RMWbxe+cY7xxqnbeta1yHPYniwbiqzN9fW3Wpv2+2aPYqBFX7lfHbqaRfpqhqjBphldI/+9rii8RGYjyxWT7VWqGIV7Wt7PPk4wIAAAAAIQiqAAAAAIA9at9jfZO46ilmpbjqzn6CuMrTpqpEIOIqW0wkvnt5wAx/pc0To/ipGFfR1xafd1712nfYf0RLO6lEVV1L/f3yIaiqEUZVl/HbpaRfVSk/SvrF5raozWOP+CwxljhrrLJtZZ9vODYAAAAAEIOgCgAAAADYr+5xvNfCfrqJq578l6hNNKPV1eh9paDq7rW6RKCqVGCGWEUlovHGdCgP+NTmVEFV9LurOkc9tuhrxXvFfJ2xvv7qQ/HgNbPE3zdbZtm/iLgqKqT6z88sQdUqcVW24KljGb8dSvrtIp6ipJ/N5rFH5nHrWoKIKgdEVAAAAAAvBUEVAAAAALB33fN4V2WvuhJiM0sDXsltdhdX/fIhrsrvi/KACKrGOLf0n8U3894zp6vKAKraZj68rhRVqTJWIajaX1A1kttn+K02T4wndghjn2xK/+xriy8SG4nxxGb5LGsGJf1yQEQFAAAAAAiqAAAAAIB97AHHu4O4ajZ+hbjql29HcdVfm7pMYLXQqkpwVS2muvvZPYPVKYIrhc0b7/mus87VJ5vFb5lfFHObd/6uXPfu+CS06ZKlCkFVL0HVbNzK0n1dhFOU9KOk3xDYIz7r+kA2qhwQUgEAAACA/EYQAAAAAAB72h7Hi7hqzn+quMraZjdx1Td/pbjK06aTyIoMVlqbNz4Sqz5fPWPO8zprfvPM2Vlrlgd1VpGIqGqFoOrf1xax1ExMRvahkwVVnrhIX5Z+PH6rzXKOeGItP60+j83iv4udbWtpp3gftXnskfnZuh4gouqxHgMAAADAS0BQBQAAAADsb889XsRVc/5TxFXRPirEVXe+zCxW3vhuoqq/P6szWJ0muFLYoj5LjPpcnfV5x2lkvonOpYo1o3pvoXqQvqrs30zcaYKqTuKqTKHU6sxTK7JQUdLP99rii8RGYjyxWT7l3B+NV7Wt7PPk4wIAAACARiCoAgAAAAD2uu843mthH+oH14ir8rNdZYmrZuKqSwR6hFKWWDJY5YifqgVVynhFbPT8nPV5x6ZlHvDOcZ55OWNNUqDKOLJKUPXLZxV1ZAirogKZ7tmqOgqlKOln+2n1ecaW16+aC6yxM+2jNo894rPM94ioeqy5AAAAAPByEFQBAAAAAHvf9x0r4qo5/wpx1Td7tZjq73uluCrSvpu4aiaGDFZ5thMFVZE2QxDrsSnGvnee88zFGeuQig5ZqtQZqiJZqb7ZEFSdmYXK47faVOeC4qfV57FZ/HexnjEfjZ15H7V57JG5Vz3He2OVbSv7fMOxAQAAAEBjEFQBAAAAAPvgdx8r4qq4f6W4aiamSmyVLaj697XKHy0HOBNzkshqVVarqjbevynqi7YZI68MoNdvGfveuc46n1rXnuq9QocsVQpBlVe8oSjr95/X6nKApwuqql6r/NbvxRMTOZeGIObJpvTPvrb4IrGRGE9sls8yr5ONav26CgAAAADwFQRVAAAAAMCemGNV9r+LuOopZqW46s5+grjK06aqROAO4qq/tpVlArtntTpBUHXXh/Ic8o4r5Xj3zm+eudWy3qzYHygevp8iqIoIq94sqPr3dSexlOoztPY3BiX9KOmnm0dn5mlEVOtBSAUAAAAAMhBUAQAAAADsuz++Nuj7Sm5zFcUoy//d+aIZra5G7ysFVXev1SUCVaUCK8q5ZWZE2kV41U1QFfless8jjy36+sk3M+co598Oe4LMDFVem0dUoRJ/IKja83WGX+WLxFp+Wn0em8I/O3Yjc4PnfdTmsc/MwZT0Q0QFAAAAAC8EQRUAAAAAwBl75VOzV10JsZmlAa/kNruLq375EFfVCbUqRFbdM1gpjz36WVX8tPos48fzWvFePeeu3gvslJ3q7/vMMn/fbCuFVL98pwuqlLFW24zPEuOJtZ6XVl+Wf/a1xReJjcR4YrN8qnlbEa9qW9nnyccFAAAAAAeBoAoAAAAA4Lx9M+Kq+fgV4qpfvh3FVX9t6jKB1UKrKsHVKjHV35/qNtnZrRBU6c+fJ5vFb5kPKPv3P2Rmp7qzqwRUv3wRQUiVsOptgqqKPjz+6PcRiVX8tPqi48PiV41na+xM+6jNY4/4LPM1IqoeayYAAAAAQAgEVQAAAAAAZ++hEVfNxyOu0ggcumeruns9668UV3na7JLB6pevoxgr6ovERn4qzmHLOPGOee9845lDrWtIxbpfXe7vm12Rkerf96qsVdnCqpMEVdX9efxW24xP2SZ6DkbiLf3M+D3jNho78z5q89hn5llK+iGiAgAAAAD4LxBUAQAAAAC8Zz+NuGo+HnGVXkz1932FuOrOl5nFyhvfTVT19+fOZQKz+8j6jCI/vTGWcaIWUXnmGM+8aV07stfODtmpvtmiIg116T+1oCpDbLUyK1R1+T5VG9X3oWwzBDEemyLWO3aVsZEYT2yWzzI/k41q/foIAAAAAJACgioAAAAAgHfurU8VV1nbIa76bssWU/19nyWumomrLhHoEUpZYncUWe2Q3SrqU7bJPK+8Y0MxPr1zj2e+9KwxGeum8iF8Vbm/v++rBVVRYVVm9qos8VJVHx5/lk3x/Sl/Wn0emyJW6XuKnWkftXnsEZ9lXkZElQMiKgAAAABoBYIqAAAAAAD22oir5mNPE1d9s1eLqf6+V4qrIu27iatmYt4ssuogmtpFUKWyqcekd/7xzJHetUW1Xn7EbaJCBFWmmozSZWph1UmCKktsd+FUR1FVxKYUSVHSLzYPqvye+RsR1RnHBgAAAAAvBkEVAAAAAAD77spjRVwV968UV83EVImtsgVV/75W+aPlAGdiEFnl9BX1jZErrIrGKs9375j0zjlP86kyS1W03SepXWa5v7/vreKO7ExVs23U2ayUgqqoP1s4pf5sFN9RZsapigxUqjJ+lPQjG9WqPk8+LgAAAACA/w+CKgAAAAAA9uCrjvVN4qqnmJXiqjv7CeIqT5uqEoGdxVWzsW8SWanaq9uqYpXneGSMeucez7ynWoue2iseGCvFBB3K/f37Wi2oUv7MFFR52lQKtqw2b3wkVvnT6vPYFLFK31PsTPuozWOP+CxzMiKqHBBRAQAAAMBWIKgCAAAAAGA/3uF4r4X9dBNXPfkvUZtoRqur0ftKQdXda3WJQFWpwEyBzsrydx2zT1V+Xqrv1mNTvva8t85p0TnXs6YoHxh3zU71y6cq/bdaWKUQDlWKrFS/02rzxo+xR0m/7AxUlPSbm+8o6bemzzccGwAAAADALQiqAAAAAADYm3c83lXZq66E2MzSgFdym93FVb98iKvqSwpmt10tlqr4bNTfq8cWfW3xWWK8c1/ndTgiEFBlm6kSVHXMVKUWVM3aVpbtU34eMz5lG+85o7JZ/J7XFl8kNhLjic3yzfitcd54VdvKPk8+LgAAAACAaRBUAQAAAACwT+9+vDuIq2bjV4irfvl2FFf9tanLBFYLraoEV6vFVE8/u4ms1DGqPtTf7ZPN4reMzawsVR571/VXLab6Zs8o9/fve5XIapWwapWg6ptt1TFEfZaY2TaR7zXT5j33LWPN4nuKnWkftXnsEd+M3xrnjVe1rezz5OMCAAAAAHCBoAoAAAAAgD37TseLuGrOf6q4ytpmN3HVN3+luMrTZkexVaVoS/V71N+nxzYT6xkTqrEfnRu7rL1RMUAkY4xCUHVS6b/VYiu1EGp19qnqLGPWc8hzbkZiZ/uxtFO8j9o89pm5j5J+lPQDAAAAACgHQRUAAAAAAPv3XY8XcdWc/xRxVbSPCnHVnS8zi5U3fjdR1d+f2W3enpnqKh4rqjkhOieuXnMVggBvdqqnmAxxVfdMVd6YjtmkMjJLrSjl5zkXVDaL3/Pa4ovERmI8sVk+1ZypiFe1rezz5OMCAAAAAJCBoAoAAAAAgL38Ccd7LezjEscirsrPdpUlrpqJqy4R6BHkWGJPEV1li7mifXn6t/oU56x3fHjnBcu8453rK9ZbVcaUFdmpfvlUQpXdBFW/fF1K8lX8/ao20djZeKXfO2YsvqfYmfZRm8ce8VnmS0RU69crAAAAAIDtQVAFAAAAAMDe/rRjRVw1518hrvpmrxZT/X2vFFdF2ncTV83EVGe/2kl0pe5L9XnPxlv8ivHhnQs885V3js9Yu9QP/JViCUVpst0FVf/5qcxUZY1fVaavcyk/Rfk+Svr5bR67d/7yzJeU9MsBIRUAAAAAvBIEVQAAAAAA7PNPPlbEVXH/SnHVTEyV2CpbUPXva5U/Wg5wJqZr1qsufaj6VLVR2RRjQvHea6+a2+/4JLRTZqf6a8so93f3+iRBlde3SkTliY20mfnpjfHYLH7Pa4svEhuJ8cRm+SxzJdmockBEBQAAAACvB0EVAAAAAAB7/rcc65vEVU8xK8VVd/YTxFWeNlUlAitKBe5eQrBzn6o2Hpv1fPTGeecBzxykWhcs7aMPplViqm92Vfk/pYjqm3+VoOo/P6uFVVGfJcYTq2objZ2NV/p/vVb5nmJn2kdtHnvEZ5krEVHlgIgKAAAAAOAfEFQBAAAAALD/f+PxXgv76SauevKrMr9EM1pdjd5XCqruXqtLBGaJqzxt3iq+Un+eKps1VuWzxHjnquz1QPVg2itAyC7398t3oqDqPz87i68sMRltlT+tPs85pYq1+CKxM++jNo89Mk9Z50tK+uWAkAoAAAAA4AsIqgAAAAAAuBbgeNdlr7oSYjNLA17JbXYXV/3y7SSu+mbrJqpS97mLmCsa67EpXyveW2yqeXElSjHVN7tVYIWg6r9/rhZYRWIz+7D8tPo8Novf89rii8RGYjyxWb4ZvzXOG69qW9nnyccFAAAAANAGBFUAAAAAAIC4St//VdAmOzPVk18pvOosrvprU5cJ7CC0qhBXWWLfmvVK/RmobMrXGWMyYu++FkbECBnZqZ7e7yCouvNVi5CyRE3VQjHFZx/53rP8s68tY8IaO9M+avPYI74ZvzXOG69qW9nnyccFAAAAANASBFUAAAAAALDzNQLiqvl4xFUa4Ub3bFUzr5UCql/xGUIoRR87ZJc6SVBl8annAPU8WcknEBPJSrOi/F+moMoS26GEXrdsUp/Ez9vq85wzqliLLxI78z5q89hn5iRK+lHSDwAAAADgOBBUAQAAAADAKdcLiKvm4xFX6cVUf99XiKvufJniqm+2qMjnat62s9DK6vPYss7TyNjzzCeq+bGCTzBGKcDYVVA1E9Mli9NOpfko6acfK96x+GseoKRfTtvKPk8+LgAAAACAbUBQBQAAAAAAJ147nCqusrZDXPXdli2m+vs+S1xlbdNFXPXLt5uYanWfVp/HlnmeesefZw6xzJ8r17wMMdWd/URB1S9fh5+dS/KtEk9R0m/+vXU8e+wR3+wcZonzxqvaVvZ58nEBAAAAAGwJgioAAAAAADj9WgJx1XzsaeKqb/ZqMdXf90pxVaS9yp+ZzeqkrFbZbSPfjcWvPk+9Y9Brt8ybK9Y5hRABQVVembpThVmZn9kQ2pT+yLkdiZ15H7V57DPzDyX9KOkHAAAAAPA6EFQBAAAAAMCbrisQV83HXov8K8VVMzFVYqtsQdW/r1UlAruVCsyKXdXWG+OxKV9bfArb0/yjnitVqMQIJwuqvtlUAp+dfu4mnuqcgYqSfmSjqu7vLccGAAAAAHAECKoAAAAAAOCt1xiIq+ZjozErxVV39hPEVZ42O5YIzBZIZcWu+BtVNuVri09hi8w5q9Y1VcYWq6+LoOrf1wrbCgGVtU2039XHPxy+J5vSP/s6co4/xVrbe8arxx7xWeYrSvqtXy8AAAAAACAIgioAAAAAAOB6I/94r4X9dBNXPflVGWeiGa2uRu9XCar+fV0hrvpm2014Vdmf1ef1R19bfApbdA6qXh+U5a9OFVR980dFVjtlrbrzVf6NSp/yPJh9bfFFYmfeR20ee3T+sMxVlPRbv1YAAAAAAIAIBFUAAAAAAMC1R/3xrspelZGVJbM04JXcpou46q/tEvh2FVpVZrOaiVEdT0bZvs5ZqU4TVGWtC+oMLm8SVM3aqkRFXURVmb/L47N8t4pY7zmqjI3EeGKzfJY5ipJ+OSCiAgAAAABYDIIqAAAAAADgOmTt8e4grpqNXyGu+uXbQVz1FKMuE7hSaNWpROBM+9XCL6vPY/N+l5Z+rOd01KaYiyrWg09CmxMEVf++VmSrivo6iK1W951pU8RazktlrLW9Zzx67BGfZW6ipF8OiKgAAAAAABqBoAoAAAAAALgm6XO8iKvm/KeIq6J9VIir7nwZWayqSgTOtMsUUymP22Pzfo/e88/iU9gU80/FGoCgKi6w8War+uWril3RZzTGY7P4vbFWXyR25n3U5rFH5wfLnERJvxwQUgEAAAAANARBFQAAAAAAcH3S83gRV835dxVXedqsEFdZ21RnsVIKtFaLqTJt3u9Icc5YY6M2xZxTMe+/SVD1y1dR9u+bLUswZemvoi9vjMpm8c/EqnyR2EiMJzbLZ5mHqrJRIaICAAAAAIBWIKgCAAAAAACuVfof77Wwj0sci7hqLqaLuCrSvnuJQGt8tbDLY1N+/t5zweJTjzXVPFMx158gqPr7fkUJQKW4SiXAmonJ6CPjb/PYFLGzryPn5FOsZzxYx5vHHvFZ5h5K+uWAiAoAAAAAYCMQVAEAAAAAANcuex0r4qo5/wpx1Tf77uIqT5uMcoAR28pMWJXiMa8/+tri846J6DhcMQc+caKg6u97q9iqKotVpk8hqlLHWn3Rz1kRazm3lLEz76M2jz06/i1zDiX9ckBIBQAAAACwIQiqAAAAAACA65h9jxVxVdy/Ulw1E1MltlolqLp73dG2QsjlsSk+a+85YfFFYrz2yLyXMZ9nZICJZsypKgOozFL15K8WXHXLMtWljN9Mu9l+lOel97xXjLdMn2WOQUSVAyIqAAAAAIDNQVAFAAAAAABc05xxrG8SVz3FrBRX3dl3FVfNxu2exUptOy0L1U7ZqSJzwIr5Wy2qUmTEycpS9cuXnQmps6gqGmP1eWyKWM9ri8/a1tOfpS+vPeKzzCmU9OsxpwMAAAAAQGMQVAEAAAAAANc35x3vtbCfbuKqJ/8lahPNaHU1ep8lqJqJy8hi5WnT3eb9zDK/T2usNyYydj3zWsXaslJUtWOWqrvXaqHVasGV0hf9TBSx3vPE4lO8j9o89si4ts4jZKPqMY8DAAAAAMAGIKgCAAAAAACudc4/3lXZq66E2MzSgFdymy7iqr82dZlAlTgru1ygp80OfWe9jpw3ivM0OlY981jlWtJdVJWVtWpnUZU1vrOIyuJXtbP4IrHec1wxjjJ9lnkDEVWPeRsAAAAAADYDQRUAAAAAAHDd867j3UFcNRu/Qlz1y7eDuMraRimuiravKg24c5us1xZf1nnqtWfOQWoQVZ0hqrL2kXU8Fr83dqadyheJtcRYxojHHvFZ5glK+vWYpwEAAAAAYGMQVAEAAAAAANdA7z1exFVz/lPEVdE+ouIoT5udhFad/MrXFl/Weeq1Z845WSCq6imqitgq+7D41e1mX1vOC2vsTPuozWOPjFXr3EA2qh5zMwAAAAAAHACCKgAAAAAA4HqI41X1j7gqbs8SV3naqMVVs3HW9pVCK+/vrexL+driU7xXjSPvHNNpXVCKIhBVxURNnjaVoiuLv6oPqy8SO/PeYrPGZvks8wAiqvXzMAAAAAAAHAiCKgAAAAAAAMRVGf1fBe0QV323VZQO7CSosr5eJW7KOt6s1xaf4r1q3Hjmk85rgEpQgahqL4FV9BiqPrPId62MtcREzvtsn3LMR+NVbSv7PPm4AAAAAABgAQiqAAAAAAAA9r5WQlw1H3st8meJq77ZV4up/r7vKKi6e10tclollHqDmGqFkOpvX+qH8h9BzFtFVf++3jnDlffvyPiMLD5l7Ez7qM1jj4w/65xBNqocEFIBAAAAAMB/gaAKAAAAAADgnOsmxFXzsYir1r+vEFT9+36lAKvy9yiPoeK9cryoxn9m++hD+6iwClHV/euOYivv8ak+h9m2ke9a8d5iU8RGx5t1PkBElQMiKgAAAAAA+AmCKgAAAAAAgDOvoRBXzcdmC7CuBfYVYqq/NrW4Sh13YmapzM/xKVZxznjHgHKsV8+ln6R2nURVf20Kwc6KcnYrhFGdBGdWn7qtN8YTm+WzjHlK+vWacwEAAAAA4IUgqAIAAAAAAHjH9dS1Qd/ZYocdxVV3vm7iKmubTKHUbNypr7PjMs6HDLt3Xukwtyuz0WQJq9TZq7KFVBmvTxZOVWWboqRf7vjPalvZ5xuODQAAAAAAmoKgCgAAAAAA4H3XVqdmr7oSYjNLA17JbarEVYo+OgiFEE/FvqvI+eIZD9eC+WAFKnGF1afKVvXXdorI6hSx1Cfhu8p4H7V57DPjDxEVIioAAAAAADgYBFUAAAAAAADvvs5CXDUfv0Jc9cvXQVzlabNzJitPm65CKosv69xQnd/qsZw9p32S23UUVnnFOApfF2FVx9cWX2bbSIwnNsunGqfKeSPatrLPk48LAAAAAAA2BEEVAAAAAAAA11xVx4u4as6/i7hqJqZKbFUpNuoivFL5IrHKc8drV43ZDvN3hsBCIaCajVVmp7K03bFE4MrjUX4v0b5mYxTnq2c8qMaad5wjojrj2AAAAAAAYFMQVAEAAAAAAHD9teJ4EVfN+d8srvprq8xkpeh/dZYs6/sq4VT0/FSNu13m51Ul/+7s6uxU1vcnCKuqjlXli35HM+2jNo99ZnxR0g8RFQAAAAAAvBgEVQAAAAAAAFyLrT7ea2EfatHFaeKqb/YVYqqn910EVbO/e+dSfsqMVLuV+1PNVxWCCZWA6s6+Wlj19/1qgVKXflW+ivcWmzU2y6cag6vmhdV9nnxcAAAAAABwIAiqAAAAAAAAuDbrdKyIq+L+3cVVij7UoiRvP10ybGW898aozkWVv9uc/EloU5md6pvtI26TKazytIn2lfl7lLFZ3631/PLYIz7r2CQbVZ+5EQAAAAAAIASCKgAAAAAAAK7Tuh4r4qq4v1p01U1M9fd9taDql2/1caq+n0g7pd06dne7J3ZC6b+ZmB3KAa6KyxJGrcw8RUm/vHlgZZ9vODYAAAAAAHgBCKoAAAAAAAC4ZtvhWN8krpqJyS7/Z7UrhFGeNtY+VgiVqn0V7zNsHrvKv3oe/iS28wpGskUyarGVWkyliFv5u5Sfn/I7VZxzmT7LeKSkX6/5EAAAAAAAQA6CKgAAAAAAAK7fdjvea2E/p4urrG0yMxhVC7KqMj8hoso7R7PG6UrUoo3V5f++2aLinQzh1Q7iLfX7LiIqjz3is44zslH1mOsAAAAAAADSQVAFAAAAAADAtdzux7sqe1WGaCMzE09XcdU3W4aY6q+tSnyl7OsEEdUqAVXHLFUVYgtlhqo7+8rMVdVZrFT9VJbgixx/5Huz9OexR85v9TiqHter+3zDsQEAAAAAACCoAgAAAAAA4LruqOPdQVw1G79CXPXLFxVXfbNXlQr09LtK2LQ6E1WGMKoyO1XWeFxFhwxVd76IWEYhrlpRIlDV70rRlOd9hk19PirGQObYy2pb2efJxwUAAAAAAPBfIKgCAAAAAADgGu/U40VcNefvIq76ZlslpnqK6SZ6orxf7nyQOVedkqXqzt4xU5WyraWvt4morLFZPuVYWTF+V/f5hmMDAAAAAAD4CoIqAAAAAAAArvfecLyIq+b82eKqO3uWUEoVc4IgaofMVBFf5phbTYbIwyNOySrrphZTPfkrS+ZFYquPXWFT2mfOZUr6IaICAAAAAABIA0EVAAAAAAAA135vO95rYR+XOPZa5F8trvpmO1lwtaoPxXfnsSvOXcV4r5o7P/+HvbvdcR5FwgDaaO7/mlnNjLR6e7c7cewCquCcn+bD2MGRjB7hCe1HfApwRMAqQ6goy25Xs8b/9DeLmiNP5+Onz5PdqHL+nwEAAKQhUAUAAOBd8OSxClc9L4/a1Wr0scqBq1Ft7taJPv6kbNTzlFX0Tjqjg1SfHI8IE91pU/HTexVDVKPKPnkuhKhy/DcBAACUIFAFAADgvdBY4/qvEq66Uify83+ftnlSd8fA1cg6T9pFz4Wn8/Lps5jp/7APbLN6t6qfjveFdSoEokb1EfWbrgpK+aRfvf8pAACAMgSqAAAAqPiOKFx1ve6qcNWrspWfBvzpWLag1sjxRPcVPQei5/bq5/mVPrGP2btVfdLmbvAnqt2MsNOs88wMUUXPi6jyu8+XIFXtcQEAAIQTqAIAAGCH98VWoO/RO+ZEhUtOD1f9dKzqpwdnHRsxL6LndeX/tz+N2Gln5ifaRgal7vZfabes6Ps14/jTuRQ1lyPqR7Wd2ecJYwMAABhCoAoAAIDd3h133b3qhHDVq7I2oG6G4FKWcY1qP2OuzX6+ZumD24wKwDz9VNzqQNXdOlF9VwpRjSr7dD77pF+e/yAAAIBtCFQBAACw83ukcNX1+m1R+ehdrXY9NnOXqSyhqlFzf+X/SF/Qx8hPrj0NU31Sd2bIafb5ou9B5PEnZRHlo+b96Od0Rp87jwsAAGA6gSoAAABOeacUrrpevy0sbwuOOzbneMTcmfmsZDZq96pZYapPj88OOK04pxBV/LwXotpjbAAAAEv85RYAAAAQQLgqvv9dwlXv6kSGq34ry/YZwafHshsZvPiz3p1wxZ12me7rk+v+enjvZ3wC8LfjOxybcc7I4yPnxNfXuM/0CVHtMTYAAIDl7FAFAADA6e+au4arPm3XJtVpE8tmf9ou405SI3eoGlU2Yu5W/c+aFQ7J8hnA345n+mRgtmN3jt9tc7fPO/NyVogqov2sPnceFwAAQDp2qAIAAGC0Zqyh/Z8SrnpVnm1Xq0/6WBF6ymjV7jW/tc+0c1XEeLKEqV6VPw1ERfRRIRiVPUQV+Tz7pN+a/1sAAAB+YIcqAAAAvIeuGetO4aor9UaWr9q96tPjs8NUo48/Kbs6t9riZ3bGf1Zf2N/oTwG+Kl9xvEowatZn+/qC3/3p/Bei2mNsAAAA6QlUAQAA4J10/Vjbwn4yhqve1an22cDfjlcIU40qi5xP1Z7VkSGHEeGU2YGqO21Whqoi6kYeH1UWUT6j7qxnzm5UAAAAmxOoAgAAwPtpvvGu2r2qDajfFvcxI0QV1Ve1MNXItqPn5azndWa4oQ9qMzJkkz1UFVF3xvFRZVFz5O4ctRtV7XEBAACUJlAFAACAd9Xc4z0pXHWlzuxw1auyKp8ajL6GWeUz5+8OVgWq3tUZEbgaFaqKqBt5fEVZ5Ly4My+FqPYYGwAAQHl/uQUAAAAkJlwV3/9O4ap3dUaEr3bZDWvkvav47O6gD2zTF5avCFVF1b9z/G6bu31+MhdOCVGN7HfXcQEAAGxHoAoAAIAqhKvi+28T2kXtQpTx04AjyjK3mflbVX3uV+qD2+waqpp17ug2o9uOmCNP52tk+1l97jwuAACArVmUAgAAwPts/fGeFq66UqfSpwPvls0eR0R59DzY4f8hklBV/TZPyiLKo+dExByNaDuzzxPGBgAAsD2BKgAAALzb7jXeKuGqq/Vn1WkL2mYLRAlT7eHEUNXdsp5kHE/KIsqj50DEnIxoO7PPE8YGAABwFItMAAAAeNfdd6xtYT9tUP1ZoZ6MoaWsQarIOk/mbUv4HK8KR2QPVT3tY/eyGeXRv3n03PdJPwAAAJYSqAIAAMB77xljPTFcFVVn1ecDs587+rd6Mk9bsWd0RoBidagqqk5f0LYnHG9E+YjfOHJe240KAACANASqAAAA8A585nirfBpwdrjqSr3M5TMCZNG/y5P51Db5v+jJ+q4WrHpXXrHtzD5mzpcZc1+ICgAAgMcEqgAAAPA+bLxVwlWf1G+J6owun9VHZJ2nc6cd8J/QE/SXMVh1pc7uu0gJUc3td9dxAQAA8IJAFQAAAN6NjTe6/4rhqqv1soSbqn+ub3WIquKaWF/Y14hwToVw1Yzy2XWezCef9NtnbAAAALwhUAUAAAB135Nbkf5bsjYtYV9Vd5hqg+dSO/C5vqov7KcP6DvLzk3VAlJCVHs+lwAAACwmUAUAAAB7vDPvHK660y46FFTxU4PR1zaybtQ8s9Y1PwBTefeqK3UyhqNODFGN7HfXcQEAAPCARSYAAADY7/1ZuOp+/ayfEVzR16h7FzGP2kbP/qwwRp/UbveA1Ypxj7qvkfPwtBBV9rEBAADwkEAVAAAA7P0u3YqcY2a4JnvA6mq9SuGpJ79x8xz/I8un0zJ8IjBjECu6r5F1o+aUEBUAAADbEqgCAACAc96tW6FzZNy96pP62euNrDvz99vhuYzSF/ZTZRerq/UyB8Bm/1Yj59roPk8YGwAAAIMIVAEAAMC579k+Dfi8zcqgU4bw1MrgVCv27KwMZazaiWj1bkwVglEnh6hWPxeVxwYAAMBgAlUAAADgnXvGeDPsPLR7wGpk3Vn3b9a89Mm/mH5Hh3t2C2TNqh81X4SoAAAAOJZAFQAAAHj/XjHeirtX3WlXMQxVPTh18npXT9KXoNXc+pG/vxAVAAAAfAlUAQAAgHfx9eM9ZfeqT9uM3kFqZnBqt8BUtU/+RY9hZuAnw+fzMu8oJUS17/gAAABYSKAKAAAAvJdnGm+W4E1L2mb30FTzzL3Vk/c/Kxg0sv6sQNSOIaoZc3TXsQEAAJCIQBUAAAB4R8863ky7GmUOJlUJTbXDn5mVKn8K8E67rDtK9cW/nxAVAAAAXGThCQAAALyvVxlz5d2rnrQ9LTDVPGvf9GLnmh242q1N9O9+aoiqwvgAAABITKAKAAAAvL9XHG+m3Y5WtK3SbvS8sLb1Xk/Y38ydmnqBMUb/VkJUAAAA8JBFJwAAAPAuv8N4q38esHLbbPd/l+eqFz9nhU8DVj3n7PkiRAUAAMBxBKoAAADAe/1u420J+6sadmrJf3drW+/1xP32w9pG/h696Lw5ZXwAAAAUZ9EJAAAAvOPvPubdAlYZ2o+4t82z803f5Nw9QR87BKhmzIkKISVBKgAAAKYQqAIAAADv+yeNuSXtc6c+Zvym1rQ+1wv0Wz18NeI+C1EJUQEAALCAxScAAADw7n/ymFviPk8JSDXPx0t9s3NnCmD1hPeobz6ndhojAAAAGxOoAgAAgHM0415yrmyhplb0N7KOFaMXPE9P1E8v+pt08xMAAACusxAFAAAA57J71brzZdw5qm06z3Zd/+qbnr9v2s+K306ICgAAAG4SqAIAAAD+Zveqtedrh/W30xzcUS/Wf09+7X2j3+60cQIAAHAoC1UAAADA/xKuynHOKqGoZo6W0Dc4Xy90T4So6o4TAAAALD4BAAAALzVjT3XOZszHzut+2Hiq7RQlQFV/rAAAAPBfAlUAAADAVcJVOc/bNrlv1qny6Bucp29yj1ad77TxAgAAwDcWqgAAAIA7mvGnPm/bfA5Y0/pc3/i8fcP7180xAAAAWMfiEwAAABBBwCr/uZs5UXq+duOadr7uN956zAAAAPCWQBUAAAAQrbmGUue20xS/6YecW4DqjHEDAADAZRatAAAAgJGa6yh9/uY32FI/eCzdvT9q3AAAAHCLhSgAAABgJgGrfcbQ/FbLdeNMf4+6+QUAAAD1CFQBAAAAqzTXYhxsoRtHuntx6vgBAAAghMUtAAAAIIPmeo67v9al6ujGU+benHoNAAAAEMrCFQAAAJCRgJX7vOtcyKIb47b37aTrAAAAgCEsSAEAAADZNddlbObNSz4z576eeD0AAAAwjEAVAAAAUI2AlXFSjx2xXA8AAACUYQEMAAAAqKy5PuMljW6srgsAAAB2YJELAAAA2ElzjcbPMN3YXRsAAACcwAIWAAAAsKvmWl0Tb3XX5PoAAACA7yxMAQAAAKdortn1HqC7VtcKAAAAPGORCQAAADhVc+0svF8CMu6X6wUAAICkLJ4BAAAA/Ms6iXvAWt31AwAAABlYJAMAAAD4mXUT94MxBIfcBwAAAEjNQhgAAADANdZR3BuuERRyXwAAAKA0i10AAAAA91hXcb9OJRjkPgEAAMDWLGQBAAAAxLDO4j5WJwDk/gEAAABfFqgAAAAARrL24h6vJODj/gIAAAA3WHACAAAAmMdajN/oFQGdvPw2AAAAcBCLeAAAAABrWZ+BfASoAAAA4GAW7AAAAADysWYD8whPAQAAAN9YnAMAAACowToOPCc8BQAAALxlIQ4AAACgLms78DvhKQAAAOAWi24AAAAA+7Hmw0kEpwAAAIBQFtcAAAAAzmEtiOqEpwAAAIDhLKIBAAAAYI2ITISmAAAAgKUslgEAAADwivUjRhCaAgAAANKyIAYAAADAE9aX+InAFAAAAFCWBS8AAAAARrMGtR+BKQAAAGBbFrMAAAAAyMR61TpCUgAAAABfFqgAAAAAqM8a1/8TjgIAAAC4yWITAAAAAFwTsZYm6AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwHD/EWAAozHh25quvqEAAAAASUVORK5CYII=" }))), qn = {
  LINK_URL: "https://imprivata.status.io",
  LINK_TEXT: "imprivata.status.io"
}, pa = ({ children: e, testid: t }) => /* @__PURE__ */ _("div", { "data-testid": t, className: "authn error-view", children: /* @__PURE__ */ $e("div", { className: "error-view-container flex flex-column flex-align-center", children: [
  /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(zd, {}) }),
  e
] }) }), Nd = ({
  error: e,
  onClick: t,
  online: r
}) => {
  const { t: n } = ya();
  return (e == null ? void 0 : e.code) === et.INVALID_TENANT_ID ? /* @__PURE__ */ $e(pa, { testid: "error-container-invalid-tenant-id", children: [
    /* @__PURE__ */ _("div", { className: "error-view-container_heading", children: n("errors.something-not-right") }),
    /* @__PURE__ */ _("div", { className: "error-view-container_text", children: e.code })
  ] }) : (e == null ? void 0 : e.code) === et.NOT_FOUND ? /* @__PURE__ */ $e(pa, { testid: "error-container-not-found", children: [
    /* @__PURE__ */ _("div", { className: "error-view-container_heading", children: n("errors.epcs-username-not-found.title") }),
    /* @__PURE__ */ $e("div", { className: "error-message-container", children: [
      /* @__PURE__ */ _("p", { children: n("errors.epcs-username-not-found.1") }),
      /* @__PURE__ */ _("p", { children: n("errors.epcs-username-not-found.2") }),
      /* @__PURE__ */ _("p", { children: n("errors.epcs-username-not-found.3") })
    ] })
  ] }) : /* @__PURE__ */ _("div", { "data-testid": "error-container", className: "authn error-view", children: /* @__PURE__ */ $e("div", { className: "error-view-container flex flex-column flex-align-center", children: [
    /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(Td, {}) }),
    /* @__PURE__ */ _("div", { children: n("errors.something-unexpected") }),
    /* @__PURE__ */ _("a", { style: { visibility: "hidden" }, href: qn.LINK_URL, title: qn.LINK_TEXT, children: qn.LINK_TEXT }),
    ((e == null ? void 0 : e.code) === et.NETWORK_ERROR || (e == null ? void 0 : e.code) === et.ERR_NETWORK) && /* @__PURE__ */ _(
      Br,
      {
        type: "primary",
        label: n("actions.again") || void 0,
        "data-testid": "submit-button",
        htmlType: "submit",
        disabled: !r,
        onClick: t,
        block: !0
      }
    )
  ] }) });
}, Ku = Bn(null), Iu = () => {
  const e = Yn(Ku);
  if (!e)
    throw new Error("useEvents must be used within a EventProvider");
  return e;
}, P1 = ({
  onEvent: e,
  apiService: t,
  appError: r,
  children: n
}) => {
  const i = ba(), [a, u] = ht({
    loading: !1,
    error: r,
    online: navigator.onLine
  }), s = Xe(
    (f) => u(
      (p) => typeof f == "function" ? f(p) : { ...p, ...f }
    ),
    []
  ), o = Xe(
    (f) => {
      i.current || u((p) => !!f == !!p.loading ? p : { ...p, loading: f });
    },
    [i]
  ), l = Xe(
    (f) => {
      if (!i.current)
        if (f instanceof ga)
          u((c) => ({ ...c, error: f }));
        else {
          const h = {
            loading: !1,
            error: f instanceof Yr ? f : void 0,
            // This restarts the UI by updating the react key
            key: Date.now().toString(),
            online: navigator.onLine
          };
          u(h);
        }
    },
    [i]
  ), A = Xe(
    (f) => {
      switch (ee("[NotifCtx::emitEvent] event: ", f), f.event) {
        case ae.NOT_ENROLLED:
          break;
        case ae.INTERNAL_RESTART: {
          l(f.data);
          break;
        }
        case ae.ENROLLED:
          break;
        case ae.TERMINATE_SESSION: {
          const p = f.data;
          p !== di.CANCEL ? l(new br({ code: et.SESSION_EXPIRED })) : di.CANCEL;
          break;
        }
        case ae.IMPR_ID_ERROR:
        case ae.FAILURE:
        case ae.ERROR:
        case ae.INTERNAL_ERROR:
          f.data && (typeof f.data == "string" ? s({
            error: new ut({ message: f.data, code: et.UNKNOWN })
          }) : s({ error: f.data })), l(f.data instanceof ut ? f.data : void 0);
          break;
        case ae.RESTART_STATE:
          s({ error: void 0 });
          break;
        case ae.OFFLINE:
          s({ online: !1 });
          break;
        case ae.ONLINE:
          s({ online: !0 });
          break;
        case ae.CAMERA_IN_USE:
          s({
            error: typeof f.data == "string" ? new ut({ message: f.data, code: et.CAMERA_IN_USE }) : f.data
          });
          break;
      }
      e(f);
    },
    [e, l, s]
  );
  Ht(() => {
    const f = () => {
      A({ event: ae.OFFLINE });
    }, p = () => {
      A({ event: ae.ONLINE });
    }, c = (h) => {
      const { message: v } = h.detail;
      A({
        event: ae.CAMERA_IN_USE,
        data: v ?? "Camera is currently being used by another application"
      });
    };
    return window.addEventListener("offline", f), window.addEventListener("online", p), window.addEventListener(ae.CAMERA_IN_USE, c), () => {
      window.removeEventListener("offline", f), window.removeEventListener("online", p), window.removeEventListener(ae.CAMERA_IN_USE, c);
    };
  }, [A]), ee("[NotifCtx] store: ", { storeUid: t == null ? void 0 : t.store.get("uid"), error: a == null ? void 0 : a.error });
  const d = ir(
    () => ({ ...a, setLoading: o, emitEvent: A }),
    [a, A, o]
  ), m = a == null ? void 0 : a.error;
  return m && m instanceof Yr ? /* @__PURE__ */ _(
    Nd,
    {
      error: a.error,
      online: a.online,
      onClick: () => {
        A({ event: ae.RESTART_STATE });
      }
    }
  ) : /* @__PURE__ */ _(Ku.Provider, { value: d, children: /* @__PURE__ */ _(Zo, { children: n }, a.key || "initial-notif-render") });
}, Eu = Bn(null), L1 = () => {
  const e = Yn(Eu);
  if (!e)
    throw new Error("useAuthentication must be used within an AuthenticationProvider");
  return e;
}, Gd = ({
  apiService: e,
  requestConfig: t,
  children: r,
  ...n
}) => {
  const i = ba(), { emitEvent: a, setLoading: u, error: s } = Iu(), [o, l] = ht({
    username: t == null ? void 0 : t.username,
    userKnown: !!(t != null && t.username),
    nextFactors: n.factors || []
  }), A = Xe(
    (E) => void l(
      (L) => typeof E == "function" ? E(L) : { ...L, ...E }
    ),
    []
  ), { hideFactorSwitch: d } = n, [m, f] = ht(
    n.factors || s && !(s instanceof br)
  ), [p, c] = ht(d), h = Xe(
    (E) => {
      d !== !0 && c(!!E);
    },
    [d]
  ), v = Xe(
    (E) => {
      A((L) => ({
        ...L,
        nextFactors: L.nextFactors[0] === E ? L.nextFactors : [E, ...L.nextFactors.filter((z) => z !== E) || []]
      }));
    },
    [A]
  ), { factors: Z } = n, b = Xe(
    async (E, L, z) => (u(!0), Z ? Promise.resolve({ nextFactors: Z }) : e.fetchFactors(E, L, z).then((G) => {
      if (a({ event: ae.FACTORS, data: G == null ? void 0 : G.nextFactors }), !i.current) {
        const { nextFactors: w = [] } = G || {};
        A((U) => ({
          ...U,
          nextFactors: U.nextFactors.length === w.length && U.nextFactors.join("") === w.join("") ? U.nextFactors : w
        }));
      }
      return G;
    }).catch((G) => (console.error("[AuthnCtx::Error] api error: ", G), Mn(G) && a({ event: ae.ERROR, data: G }), G instanceof ut ? G : St())).finally(() => void u(!1))),
    [e, i, a, u, Z, A]
  ), { username: F, session: y, enrollSession: V } = o, W = Xe(
    async (E) => e.terminateSession(E, y || V).then((L) => (L && a({ event: ae.TERMINATE_SESSION, data: E }), L)).catch((L) => (a({ event: ae.TERMINATE_SESSION, data: E }), L instanceof ut ? L : St())),
    [e, a, y, V]
  ), X = Xe(
    async (E, L, z, G) => {
      var w;
      ee("[AuthCtx::authenticate] Calling authentication", { enrolling: L }), u(!0);
      try {
        const { session: U, response: O } = await e.authenticateFactor(
          E,
          L ? V : y,
          L,
          G
        ), { nextFactors: j, userKnown: te, pushInitiated: oe, oidcAuthorizationCode: ue } = O;
        !i.current && !L && !z && A({
          nextFactors: j || [],
          modelData: O.modelData,
          userKnown: te,
          pushInitiated: oe
        }), a({
          event: ae.SUCCESS,
          data: {
            factorType: E.factorType,
            nextFactor: (w = j == null ? void 0 : j[0]) == null ? void 0 : w.factorType,
            enrolling: L
          }
        }), !(j != null && j.length) && !L && !z && a({
          event: ae.AUTHENTICATED,
          data: {
            oidcAuthorizationCode: ue,
            // TODO: Remove - pass "Session"
            codingContext: U.encode,
            enrolling: L,
            username: F
          }
        });
        const se = L ? "enrollSession" : "session";
        return l((qe) => ({ ...qe, [se]: U })), { session: U, response: O };
      } catch (U) {
        return console.error("[AuthCtx::Error] Error authenticating", { error: U }), a(pi(U)), U instanceof ut ? U : St();
      } finally {
        u(!1);
      }
    },
    [
      e,
      i,
      F,
      u,
      a,
      y,
      V,
      A
    ]
  ), x = Xe(
    async (E, L) => {
      var z;
      ee("[AuthCtx::authenticateByEnrollSession]"), u(!0);
      try {
        const { session: G, response: w } = await e.authenticateByEnrollmentSession(E, L), { nextFactors: U, oidcAuthorizationCode: O } = w;
        return a({
          event: ae.SUCCESS,
          data: {
            factorType: wt.FACE_ID,
            nextFactor: (z = U == null ? void 0 : U[0]) == null ? void 0 : z.factorType,
            enrolling: !0
          }
        }), a({
          event: ae.AUTHENTICATED,
          data: {
            oidcAuthorizationCode: O,
            codingContext: G.encode,
            enrolling: !0,
            username: F
          }
        }), { session: G, response: w };
      } catch (G) {
        return console.error("[AuthCtx::Error] Error authenticating (post face enroll)", { error: G }), a(pi(G)), G instanceof ut ? G : St();
      } finally {
        u(!1);
      }
    },
    [e, F, u, a]
  ), q = Xe(
    async (E, L) => e.enroll(E, L).then(() => {
      Ce("enroll-success"), Ce("enroll-success", { factorType: E.factorType }), a({ event: ae.ENROLLED });
    }).catch((z) => (Ce("enroll-failed", { error: z }), z instanceof So ? a({ event: ae.NO_SESSION, data: z }) : E.factorType !== wt.FACE_ID && a({ event: ae.ERROR, data: z }), z instanceof ut ? z : St())),
    [e, a]
  );
  Ht(() => {
    m || (console.debug("[AuthnCtx] initial fetchFactors"), f(!0), b().then((E) => {
      var L;
      E instanceof ut ? a({ event: ae.ERROR, data: E }) : (L = E == null ? void 0 : E.nextFactors) != null && L.length && a({ event: ae.READY });
    }));
  }, [m, b, a]), Ht(() => {
    m && a({ event: ae.INITIALIZED });
  }, [a, m]);
  const I = ir(
    () => ({
      state: o,
      factorSwitchHidden: p,
      switchFactor: v,
      toggleFactorSwitch: h,
      updateAuthState: A,
      authenticate: X,
      authenticateByEnrollSession: x,
      enroll: q,
      terminateSession: W
    }),
    [
      o,
      p,
      h,
      A,
      X,
      x,
      q,
      v,
      W
    ]
  );
  return ee("[AuthCtx] state & nextFactors: ", {
    state: o,
    storeUid: e == null ? void 0 : e.store.get("uid"),
    session: y,
    enrollSession: V
  }), I.state.nextFactors.length ? /* @__PURE__ */ _(Eu.Provider, { value: I, children: r }) : (console.debug("[AuthnCtx] First factors empty, returning"), /* @__PURE__ */ _(
    "div",
    {
      style: {
        position: "absolute",
        background: "#fff",
        zIndex: 1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    }
  ));
};
Gd.whyDidYouRender = !0;
function Mn(e) {
  return e instanceof ut;
}
const Pd = {
  width: 1280,
  height: 720,
  frameRate: { ideal: 15 },
  facingMode: "face"
}, ha = (e) => !!(e != null && e.srcObject && e.readyState >= 2 && !e.paused && e.videoWidth > 0 && e.videoHeight > 0), Ld = async (e, t = Pd) => {
  try {
    const r = { video: t, audio: !1 };
    return r.video.deviceId = { exact: e }, await navigator.mediaDevices.getUserMedia(r);
  } catch (r) {
    throw r instanceof DOMException && si(r) && Ai(r), r;
  }
}, Md = (e) => new Promise((t) => {
  e.requestVideoFrameCallback(async (r) => {
    t(r);
  });
});
async function* Hd(e, t) {
  let r = 0;
  try {
    for (; !t(); ) {
      const n = e();
      if (!n || !ha(n)) {
        await fa(10);
        continue;
      }
      if (r += 1, ee(`VideoGenerator entering loop : ${r}`), await Md(n), !ha(n))
        continue;
      const i = await createImageBitmap(n).catch((a) => {
        const u = { error: a, video: n, src: n.srcObject };
        Ie("VideoGenerator: Error creating image bitmap", { ...u });
      });
      i || (ee("VideoGenerator: no source"), await fa(10)), yield i;
    }
    ee(`VideoGenerator: cancelled - iterations=${r}`);
  } catch (n) {
    Ie("VideoGenerator: Error processing video frame", { error: n });
  } finally {
    ee("VideoGenerator: EXITING GENERATOR", { iters: r });
  }
}
const Ru = async (e) => {
  if (e) {
    const t = e.getTracks();
    if (!t.length) return;
    t.forEach((r) => r.stop()), ee("All tracks have been stopped");
  }
}, si = (e) => {
  if (!(e instanceof DOMException))
    return !1;
  if ([
    "NotReadableError",
    // Standard: Hardware already in use
    "AbortError",
    // Standard: Operation aborted (often due to device in use)
    "NotAllowedError",
    // Sometimes used when device is busy
    "InvalidStateError",
    // Windows: Device in invalid state due to being in use
    "OverconstrainedError"
    // Sometimes thrown when device is busy
  ].includes(e.name))
    return !0;
  const r = [
    "camera",
    "in use",
    "busy",
    "being used",
    "already in use",
    "device is busy",
    "resource unavailable",
    "hardware error",
    "device not available",
    "source is busy",
    "device already in use",
    "camera busy",
    "mf_e_video_recording_device_invalidated",
    "another application is using the camera"
  ], n = e.message.toLowerCase();
  return r.some((i) => n.includes(i));
}, Ai = (e) => {
  const t = "Camera is currently being used by another application", r = new CustomEvent(ae.CAMERA_IN_USE, {
    detail: { error: e, message: t }
  });
  window.dispatchEvent(r), ee("Camera in use detected, dispatching event", { error: e, message: t }), Ce("camera-in-use-error", {
    error: e.message,
    errorName: e.name,
    msg: t
  });
}, Ud = De(Tt.UI, "face"), Bd = /iPhone|iPad|Android/i, Yd = /front|back/i;
var zu = /* @__PURE__ */ ((e) => (e.WEBCAM = "webcam", e.MOBILE = "mobile", e))(zu || {});
const Od = Hn(
  De(Ud, "device-data"),
  (e) => {
    const t = Bd.test(navigator.userAgent), r = Yd.test(e.label.toLowerCase());
    return Sn({
      device: e,
      userAgent: navigator.userAgent,
      isMobileUserAgent: t,
      isMobileCameraLabel: r
    }), t || r ? "mobile" : "webcam";
  }
), Jd = (e) => {
  var t;
  return typeof ((t = navigator.mediaDevices) == null ? void 0 : t.enumerateDevices) != "function" ? (Ie("enumerateDevices() not supported."), Promise.reject(new Error("Cannot enumerate devices"))) : navigator.mediaDevices.getUserMedia({ video: !0 }).then(() => navigator.mediaDevices.enumerateDevices().then((r) => r.filter((n) => !!n.deviceId)).then((r) => e ? r.filter(e) : r).catch((r) => {
    throw Ie(`${r.name}: ${r.message}`), r;
  })).catch((r) => {
    throw Ie(`Startup:: getUserMedia failed: ${r.name}: ${r.message}`), r;
  });
}, jd = async () => {
  try {
    const e = await Jd(
      (n) => n.kind === "videoinput"
      /* VIDEO_INPUT */
    ) || [];
    if (e.length === 0) {
      ee("Startup: No devices detected");
      return;
    }
    ee("Startup: devices enumerated", e);
    const t = e.find((n) => n.label.toLowerCase().includes("front"));
    let r = e;
    return t ? (ee('Startup: using "front" camera', t), r = [t]) : ee('Startup: using "primary" camera', e[0]), r;
  } catch (e) {
    throw si(e) && (Ie("Camera in use detected during device initialization", {
      error: e.name
    }), Ai(e)), e;
  }
}, at = "Center your face in the frame and look at the camera", va = {
  FACE_QUALITY_POOR: at,
  FACE_ACCEPTABILITY_POOR: at,
  FACE_SIZE_SMALL: at,
  FACE_SIZE_LARGE: at,
  FACE_POS_RIGHT: at,
  FACE_POS_LEFT: at,
  FACE_POS_HIGH: at,
  FACE_POS_LOW: at,
  FACE_MASK_FOUND: "Remove any face coverings and look at the camera",
  FACE_FRONTALITY_POOR: at,
  FACE_SHARPNESS_POOR: "Remain still and look at the camera",
  FACE_RES_LOW: at,
  FACE_ROLL_ANGLE_EXCEEDED: at,
  TOO_MANY_FACES: "Multiple faces detected",
  IMG_LIGHTING_DARK: "Adjust the lighting so your face is better lit",
  IMG_LIGHTING_BRIGHT: "Adjust the lighting so your face is better lit",
  UNKNOWN: ""
}, Lt = (e) => Number((e || 0).toFixed(2)), Va = De(Tt.UI, "face", "validness"), kd = Hn(Va, (e, t) => {
  var n;
  const r = {
    iters: e,
    Type: "Results",
    Valid: t.isValid,
    Feedback: (n = t.feedback) != null && n.length ? t.feedback[0] : "No feedback",
    "Face Quality": Lt(t.quality),
    "Face Frontality": Lt(t.frontality),
    "Face Mask": Lt(t.maskProbability),
    "Face Height Pct": Lt(t.faceHeightPct),
    "Face Height": Lt(t.faceHeight),
    "Face Width": Lt(t.faceWidth),
    "Face Sharpness": Lt(t.sharpness)
  };
  Ce(De(Va, "metrics"), r), ee(r);
}), Qd = (e, t, r) => {
  if (e.length) {
    const n = e[0];
    kd(r, n);
    const i = n.feedback, a = t(i);
    if (n.isValid || a.length === 0)
      return n;
  }
}, _d = (e) => new Promise((t) => {
  const r = document.createElement("canvas");
  r.width = e.width, r.height = e.height, r.style.visibility = "hidden";
  const n = r.getContext("2d");
  n && (n.drawImage(e, 0, 0), r.toBlob((i) => {
    t(i ? URL.createObjectURL(i) : null);
  }));
}), $d = {
  ...qu,
  minFaceQuality: 0.65,
  minFaceFrontality: 15,
  minFaceSize: 50,
  minFaceHeightPct: 0.01,
  maxFaceSizePct: 0.95,
  imageBoundaryHeightPct: 0.9
};
async function* e1(e, t) {
  ee("FaceVideoGenerator: creating", t);
  let r = 0;
  const n = await Kn.create(), i = await Ln.create();
  try {
    for await (const a of e)
      if (a) {
        r += 1;
        const u = performance.now(), s = await n.getFaces({
          source: a,
          options: { qualities: !0, landmarks: !0 }
        }), o = performance.now();
        ee(`Detection took ${o - u}ms`);
        const l = performance.now(), A = await i.checkValidness({ faces: s.faces, settings: t }), d = performance.now();
        ee(`Validness took ${d - l}ms`);
        const m = {
          faceDetectionTime: o - u,
          faceValidnessTime: d - l,
          totalFaceProcessingTime: d - u
        };
        yield { image: s.image, validness: A, timings: m };
      }
  } catch (a) {
    Ie("VideoGenerator: Error processing video frame", { error: a });
  } finally {
    ee("VideoGenerator: EXITING GENERATOR", { iters: r });
  }
}
const t1 = ({
  onValid: e,
  onFailure: t,
  onFeedback: r,
  overrideSettings: n,
  ignoredFeedbacks: i = [],
  children: a
}) => {
  const { refs: u, videoStream: s } = Sr(), o = Un(null), l = Xe(
    (d) => {
      if (Array.isArray(d)) {
        ee("Received feedback", { feedback: d });
        const m = d.filter((h) => !i.includes(h)), f = m.length ? m[0] : "UNKNOWN", p = De(Tt.UI, "feedback", "image");
        Ce(p, { feedback: f });
        const c = f in va ? va[f] : at;
        return r(c), m;
      }
      return r(d), [];
    },
    [r, i]
  ), A = Xe(
    async (d, m, f) => {
      ee("StartCapturing");
      const p = () => u.status === xt.UNMOUNTED;
      try {
        let c = 0;
        for await (const { image: h, validness: v, timings: Z } of d) {
          if (p())
            break;
          if (c += 1, ee("StartCapturing: result", { iters: c, validness: v }), !Qd(v, l, c)) continue;
          if (u.status = xt.FINISHED, l(""), u.image) {
            const F = await _d(h);
            F && (u.image.src = F);
          }
          setTimeout(() => Ru(m), 200);
          const b = f ? Od(f) : zu.WEBCAM;
          if (await e({ image: h, deviceType: b })) {
            go("ui:model:timings", Z), ee("StartCapturing: onValid accepted, breaking device");
            break;
          }
          if (p()) break;
        }
      } catch (c) {
        Ie({ error: c }), Ce("capture-error", { error: `${c}` }), t(new br({ code: et.SYSTEM_ERROR }));
      } finally {
        ee("StartCapturing: EXITING ON FINALLY", { streaming: s == null ? void 0 : s.stream });
      }
    },
    [e, t, s, u, l]
  );
  return Ht(() => {
    const d = !!(s != null && s.video && (!o.current || o.current !== s.device.deviceId) && u.status === xt.STREAMING && u.frameGenerator);
    if (console.debug("Detection: debugging start invariants:", {
      refs: u,
      isReady: d,
      frameGenerator: u.frameGenerator,
      videoStreamExists: s == null ? void 0 : s.video,
      notCapturing: !o.current,
      differentDevice: o.current !== (s == null ? void 0 : s.device.deviceId),
      refsStatus: u.status,
      isStreaming: u.status === xt.STREAMING,
      isStreamingAndFrameGenerator: u.status === xt.STREAMING && u.frameGenerator
    }), d && u.frameGenerator) {
      const m = { ...$d, ...n };
      ee("Detection: starting capture generator", { deviceId: s.device.deviceId });
      const f = e1(u.frameGenerator, m);
      A(f, s.stream, s.device), o.current = s.device.deviceId;
    }
  }, [u, s, A, n]), a;
}, r1 = ({ feedback: e, ...t }) => /* @__PURE__ */ _("div", { ...t, className: `hint ${t.className || ""}`, children: e && /* @__PURE__ */ _("h5", { className: "feedback", children: e }) }), n1 = ({
  disableBlur: e,
  ...t
}) => {
  const { registerRef: r } = Sr(), n = r("image");
  return /* @__PURE__ */ _(
    "img",
    {
      ref: n,
      alt: "",
      ...t,
      className: `${e ? "" : "blurred"} ${t.className || ""}`
    }
  );
}, i1 = ({ children: e, ...t }) => {
  const { refs: r } = Sr(), n = r.status === xt.FINISHED;
  return /* @__PURE__ */ _(
    "div",
    {
      ...t,
      className: `oval-container ${n ? "finished" : ""} ${t.className || ""}`,
      children: e
    }
  );
}, a1 = (e) => {
  const t = Un(!1), { emitEvent: r } = Iu(), { refs: n, startVideoStream: i, setLoading: a } = Sr(), u = Xe(
    (s) => {
      !t.current && s && (n.video = s, jd().then((o) => {
        if (!o || !o.length) return;
        t.current = !0;
        const l = i(s, o[0]);
        n.devices = o, l || r({
          event: ae.INTERNAL_ERROR,
          data: new ut({ code: et.SYSTEM_ERROR })
        });
      }).finally(() => a == null ? void 0 : a(!1)));
    },
    [a, i, r, n]
  );
  return /* @__PURE__ */ _("video", { ref: u, muted: !0, autoPlay: !0, playsInline: !0, ...e });
};
var xt = /* @__PURE__ */ ((e) => (e.UNMOUNTED = "unmounted", e.INITIALIZIING = "initializing", e.STREAMING = "streaming", e.SWITCHING = "switching", e.FINISHED = "finished", e.ERROR = "error", e))(xt || {});
const u1 = {
  video: null,
  devices: [],
  status: "unmounted",
  frameGenerator: null,
  image: null
}, Tu = Bn({
  refs: u1,
  registerRef: (e, t) => ({}),
  startVideoStream: async (e, t) => {
  },
  unmountVideo: async () => {
  },
  setLoading: (e) => {
  }
}), li = ({ onEvent: e, children: t }) => {
  const [r, n] = ht(), [i, a] = ht(), { proxy: u, register: s } = Ro(), o = Xe(
    (c) => {
      ee("[VideoCapture::emitEvent] event: ", { event: c }), c.event === "error" && Ie("Error occurred during image capture", { error: c.data }), e == null || e(c);
    },
    [e]
  ), l = Xe(async () => {
    if (!i) {
      ee("Unmount: no action taken, no video el found");
      return;
    }
    const { stream: c, video: h } = i;
    ee("Unmount: stopping generator"), await Ru(c), ee("Unmount: stopped tracks"), h.srcObject = null, a(void 0), ee("Unmount: finished unmount");
  }, [i]), A = Xe(
    () => {
      var c;
      return u.status !== "switching" && ((c = u.video) != null && c.srcObject) ? u.video : null;
    },
    [u]
  ), d = Xe(
    (c) => new Promise((h, v) => {
      c.onloadedmetadata = () => {
        ee("Video metadata loaded successfully"), h();
      }, c.onerror = (Z) => {
        const b = St(Z);
        Ie("Video stream error", { error: b }), o({ event: "error", data: b }), u.status = "error", v(b);
      };
    }),
    [o, u]
  ), m = Xe(() => {
    if (!u.frameGenerator) {
      const h = Hd(A, () => u.status === "unmounted");
      u.frameGenerator = h, ee("Frame generator initialized");
    }
  }, [A, u]), f = Xe(
    async (c, h) => {
      try {
        u.video ?? (u.video = c);
        let v;
        try {
          v = await Ld(h.deviceId), ee("startVideoStream: got video stream", { mediaDevice: h, stream: v });
        } catch (b) {
          if (si(b)) {
            Ai(b), u.status = "error";
            return;
          }
          throw b;
        }
        if (!v) {
          ee("No video stream available");
          return;
        }
        c.srcObject = v, ee("startVideoStream: video stream assigned to element"), await d(c), m(), u.status = "streaming";
        const Z = { device: h, stream: v, video: c };
        return a(Z), ee("Video stream started successfully"), Z;
      } catch (v) {
        if (Ie("startVideoStream: error starting video stream", { error: v }), u.status = "error", v instanceof Error || v instanceof DOMException) {
          const Z = St(v);
          o({ event: "error", data: Z });
        }
        return;
      }
    },
    [u, d, m, o]
  ), p = ir(
    () => ({
      videoStream: i,
      refs: u,
      registerRef: s,
      loading: r,
      setLoading: n,
      startVideoStream: f,
      unmountVideo: l,
      emitEvent: o
    }),
    [i, r, u, s, f, l, o]
  );
  return Ht(() => () => {
    u.status = "unmounted", e == null || e({
      event: "unmounting"
      /* UNMOUNTING */
    });
  }, [e, u]), /* @__PURE__ */ _(Tu.Provider, { value: p, children: t });
}, Sr = () => {
  const e = Yn(Tu);
  if (e === null)
    throw new Error("useVideoFrameCapture must be used within VideoCaptureContext");
  return e;
}, o1 = { FaceDetection: t1, Feedback: r1, Overlay: i1, PauseImage: n1, Video: a1 };
li.Plugins = o1;
const s1 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 18, height: 24, viewBox: "0 0 18 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.9647 0L17.308 8.38243L8.86244 6.21649L11.0689 3.96872C10.408 3.79969 9.71492 3.70972 9 3.70972C5.59483 3.70972 2.66654 5.75463 1.384 8.68417L0 8.08068C1.51422 4.62193 4.97315 2.2024 9 2.2024C10.1416 2.2024 11.2389 2.39716 12.2597 2.75565L14.9647 0ZM9 20.2903C12.4052 20.2903 15.3335 18.2454 16.616 15.3158L18 15.9193C16.4858 19.3781 13.0269 21.7976 9 21.7976C7.85845 21.7976 6.76106 21.6028 5.7403 21.2444L3.03527 24L0.692002 15.6176L9.13756 17.7835L6.93108 20.0313C7.59198 20.2003 8.28508 20.2903 9 20.2903Z", fill: "white" })), A1 = (e, t) => e.find((r) => r.deviceId === t.deviceId) || t, l1 = (e, t) => e.length <= 1 ? t : e[(e.findIndex((r) => r.deviceId === t.deviceId) + 1) % e.length], c1 = ({ disabled: e, children: t }) => {
  const { refs: r, videoStream: n, unmountVideo: i, startVideoStream: a, loading: u, setLoading: s } = Sr(), o = r.status, l = r.devices, A = ir(
    () => ((l == null ? void 0 : l.length) || 0) > 1 && o === xt.STREAMING ? l || [] : [],
    [o, l]
  ), d = Xe(
    async (m) => {
      const { device: f, stream: p, video: c } = n || {};
      if (ee(`SwitchDevice: provided=${m}, `, { readyDevices: A, device: f, stream: p }), f && p && c) {
        const h = m ? A1(A, f) || f : l1(A, f);
        if (f.deviceId !== h.deviceId && (r.status = xt.SWITCHING, await i(), ee("SwitchDevice: updating device state", { previous: f, next: h }), c))
          try {
            s == null || s(!0), await a(c, h);
          } catch (v) {
            Ie("SwitchDevice: failed to start new video", { error: v });
          } finally {
            s == null || s(!1);
          }
      }
    },
    [r, i, n, s, a, A]
  );
  return Ht(() => {
    console.debug(">> -- Switch: ", { status: o, disabled: e, devices: l, readyDevices: A });
  }, [o, e, l, A]), /* @__PURE__ */ $e(vr, { children: [
    !e && A.length > 0 && /* @__PURE__ */ _("div", { className: "capture-grid-controls", children: /* @__PURE__ */ _(
      Br,
      {
        shape: "circle",
        disabled: u,
        className: "capture-grid-controls-switch",
        onClick: d.bind(null, void 0),
        icon: /* @__PURE__ */ _(s1, {})
      }
    ) }),
    t
  ] });
}, { FaceDetection: d1, Feedback: f1, Overlay: m1, PauseImage: p1, Video: h1 } = li.Plugins, v1 = ({
  visualOptions: e,
  onValid: t,
  onFailure: r,
  overrideSettings: n,
  ignoredFeedbacks: i
}) => {
  const [a, u] = ht(), { hideVideo: s, disableBlur: o } = e || {};
  return Ht(() => console.debug(">> Feedback: ", a), [a]), /* @__PURE__ */ _("div", { className: `capture-grid ${s ? "video-hidden" : ""}`, children: /* @__PURE__ */ $e(li, { children: [
    /* @__PURE__ */ _(
      d1,
      {
        onValid: t,
        onFailure: r,
        onFeedback: u,
        overrideSettings: n,
        ignoredFeedbacks: i
      }
    ),
    /* @__PURE__ */ _(f1, { feedback: a }),
    /* @__PURE__ */ _(c1, {}),
    /* @__PURE__ */ $e(m1, { children: [
      /* @__PURE__ */ _(p1, { disableBlur: o }),
      /* @__PURE__ */ _(h1, {})
    ] })
  ] }) });
}, V1 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { id: "Union" }, /* @__PURE__ */ C.createElement("path", { d: "M22.5 17.5C23.3284 17.5 24 16.8284 24 16C24 15.1716 23.3284 14.5 22.5 14.5L9.49992 14.5C8.6715 14.5 7.99992 15.1716 7.99992 16C7.99992 16.8284 8.6715 17.5 9.49992 17.5L22.5 17.5Z", fill: "#D7324A" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 11.8387C0 10.7778 0.421428 9.76039 1.17157 9.01024L9.01025 1.17157C9.76039 0.421427 10.7778 0 11.8387 0H20.1613C21.2222 0 22.2396 0.421428 22.9898 1.17157L30.8284 9.01025C31.5786 9.76039 32 10.7778 32 11.8387V20.1613C32 21.2222 31.5786 22.2396 30.8284 22.9898L22.9898 30.8284C22.2396 31.5786 21.2222 32 20.1613 32H11.8387C10.7778 32 9.76039 31.5786 9.01024 30.8284L1.17157 22.9898C0.421427 22.2396 0 21.2222 0 20.1613V11.8387ZM11.8387 2H20.1613C20.6918 2 21.2005 2.21071 21.5755 2.58579L29.4142 10.4245C29.7893 10.7995 30 11.3082 30 11.8387V20.1613C30 20.6918 29.7893 21.2005 29.4142 21.5755L21.5755 29.4142C21.2005 29.7893 20.6918 30 20.1613 30H11.8387C11.3082 30 10.7995 29.7893 10.4245 29.4142L2.58579 21.5755C2.21071 21.2005 2 20.6918 2 20.1613V11.8387C2 11.3082 2.21071 10.7995 2.58579 10.4245L10.4245 2.58579C10.7995 2.21071 11.3082 2 11.8387 2Z", fill: "#D7324A" }))), b1 = (e) => /* @__PURE__ */ C.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ C.createElement("g", { clipPath: "url(#clip0_3887_517)" }, /* @__PURE__ */ C.createElement("path", { d: "M23.2289 12.8602C23.704 12.1815 23.5389 11.2462 22.8602 10.7712C22.1816 10.2961 21.2463 10.4611 20.7712 11.1398L14.6883 19.8297L10.9371 16.8287C10.2902 16.3112 9.34627 16.4161 8.82875 17.063C8.31124 17.7099 8.41612 18.6538 9.06301 19.1713L14.063 23.1713C14.3867 23.4302 14.803 23.5437 15.2133 23.4848C15.6236 23.4258 15.9912 23.1998 16.2289 22.8602L23.2289 12.8602Z", fill: "#30961F" }), /* @__PURE__ */ C.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z", fill: "#30961F" })), /* @__PURE__ */ C.createElement("defs", null, /* @__PURE__ */ C.createElement("clipPath", { id: "clip0_3887_517" }, /* @__PURE__ */ C.createElement("rect", { width: 32, height: 32, fill: "white" })))), y1 = "data:image/svg+xml;base64,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", g1 = ({
  status: e,
  loading: t,
  username: r,
  flow: n,
  children: i,
  actions: a
}) => {
  const u = {
    success: {
      title: "Success",
      text: "You can now use your face as an authenticator.",
      icon: /* @__PURE__ */ _(b1, { height: 32, width: 32 })
    },
    failed: {
      title: "Try Again",
      text: "Make sure your face is centered and look right at the camera.",
      icon: /* @__PURE__ */ _(V1, { height: 32, width: 32 })
    }
  }, s = n === _t.Authenticating && e === mt.SUCCESS;
  return /* @__PURE__ */ $e("div", { className: `float-container ${e || ""}`, children: [
    e && !s && /* @__PURE__ */ $e("div", { className: `face-processing ${e == null ? void 0 : e.toLowerCase()} ${n || ""}`, children: [
      /* @__PURE__ */ _("div", { children: u[e].icon }),
      /* @__PURE__ */ $e("div", { style: { width: "inherit" }, children: [
        /* @__PURE__ */ _("p", { className: "primary-body-bold", children: u[e].title }),
        /* @__PURE__ */ _("p", { children: u[e].text }),
        e === mt.FAILED && /* @__PURE__ */ $e(vr, { children: [
          /* @__PURE__ */ _("br", {}),
          /* @__PURE__ */ _("p", { className: "username-message", children: r })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ _("div", { className: `face-processing-animation ${t ? "loading" : ""}`, children: t && /* @__PURE__ */ $e(vr, { children: [
      /* @__PURE__ */ _(
        "iframe",
        {
          src: y1,
          style: { width: "95px", height: "90px", border: "none" },
          title: "Signing in"
        }
      ),
      /* @__PURE__ */ _("div", { className: "face-processing-animation-message", children: /* @__PURE__ */ _("p", { children: `${n} ${r}` }) })
    ] }) }),
    i,
    /* @__PURE__ */ _("div", { className: "face-actions", children: a })
  ] });
};
var Nu = /* @__PURE__ */ ((e) => (e.Enrolling = "image/png", e.Authenticating = "image/jpeg", e))(Nu || {}), Gu = /* @__PURE__ */ ((e) => (e[e.Enrolling = 1] = "Enrolling", e[e.Authenticating = 0.9] = "Authenticating", e))(Gu || {});
const Z1 = (e) => {
  const t = new URLSearchParams(window.location.search).get(Vr.MAX_ENROLL_WIDTH), r = e === _t.Authenticating ? wo : Ko;
  return t ? Number(t) : r;
}, F1 = (e) => new TextEncoder().encode(e).length, X1 = Hn(
  "compress-and-encode-image",
  async (e, t, r) => {
    const n = r && e.width > r ? r / e.width : 1, i = e.width * n, a = e.height * n;
    Sn({
      "image.bitmapWidth": e.width,
      "image.bitmapHeight": e.height,
      "image.scalingFactor": n,
      "image.scaledWidth": i,
      "image.scaledHeight": a
    });
    const u = typeof OffscreenCanvas < "u" ? new OffscreenCanvas(i, a) : document.createElement("canvas");
    u instanceof HTMLCanvasElement && (u.width = i, u.height = a);
    const s = u.getContext("2d");
    if (!s) {
      console.error("Failed to get canvas context");
      return;
    }
    s.drawImage(e, 0, 0, i, a);
    let o;
    if (typeof OffscreenCanvas < "u" && u instanceof OffscreenCanvas) {
      const A = await u.convertToBlob(t);
      o = await new Promise((d, m) => {
        const f = new FileReader();
        f.onloadend = () => {
          d(f.result);
        }, f.onerror = () => m(new Error("Error reading the image blob")), f.readAsDataURL(A);
      });
    } else
      o = u.toDataURL(t.type, t.quality);
    o = o.replace(/^data:image\/(jpeg|png);base64,/, ""), u instanceof HTMLCanvasElement && typeof u.remove == "function" && u.remove(), e.close();
    const l = F1(o) / 1024;
    return Sn({
      "image.base64EncodedLength": o.length,
      "image.base64SizeInKB": l
    }), Ce(De(Tt.UI, "image", "captured-data"), {
      capturedImageDims: tr({ width: i, height: a })
    }), { imageData: o, width: i, height: a };
  }
), M1 = ({
  username: e,
  reset: t,
  enroll: r,
  onSuccessfulEnrollment: n,
  onError: i
}) => {
  const [a, u] = ht(), [s, o] = ht(!1), [l, A] = ht(!1), { t: d } = ya(), m = () => {
    t(), u(void 0);
  }, f = Xe(
    (h) => {
      i(h), Ie("[FaceEnrollCapture]: ", { error: `${h}` });
    },
    [i]
  ), p = Xe(
    async (h) => {
      const v = setTimeout(() => {
        o(!0);
      }, 1e3), { image: Z, deviceType: b } = h ?? {};
      try {
        const F = Z1(_t.Enrolling), y = Nu[_t.Enrolling], V = Gu[_t.Enrolling], W = { type: y, quality: V }, { imageData: X } = await X1(Z, W, F) ?? {};
        if (!X)
          return Ce("authn-enroll-no-image", { msg: "No image data" }), !1;
        const x = await r(
          Rd(wt.FACE_ID, { imageData: X }, { deviceType: b })
        );
        return Mn(x) ? (u(mt.FAILED), !1) : (ee("FaceEnroll successful"), u(mt.SUCCESS), !0);
      } catch (F) {
        Ce("error", { error: Fr(F), is_in_catch: !0 }), u(mt.FAILED), i(F);
      } finally {
        o(!1), clearTimeout(v);
      }
      return !1;
    },
    [r, i]
  ), c = Xe(async () => {
    try {
      o(!0);
      const h = await n();
      Mn(h) ? u(mt.FAILED) : (A(!0), u(mt.SUCCESS));
    } catch (h) {
      console.log(h), u(mt.FAILED);
    } finally {
      o(!1);
    }
  }, [n]);
  return /* @__PURE__ */ _(
    g1,
    {
      flow: _t.Enrolling,
      status: a,
      loading: s,
      username: e,
      actions: /* @__PURE__ */ _(vr, { children: a === mt.FAILED ? /* @__PURE__ */ _(Br, { type: "primary", disabled: s, label: d("actions.again"), onClick: m }) : a === mt.SUCCESS ? /* @__PURE__ */ _(
        Br,
        {
          type: "primary",
          label: d("actions.continue"),
          onClick: c,
          disabled: s || l
        }
      ) : /* @__PURE__ */ _(vr, {}) }),
      children: /* @__PURE__ */ _(
        v1,
        {
          onValid: p,
          onFailure: f,
          visualOptions: { disableBlur: !1 }
        }
      )
    }
  );
};
export {
  Gd as A,
  Nd as E,
  M1 as F,
  Nu as I,
  g1 as O,
  z1 as a,
  Fr as b,
  T1 as c,
  L1 as d,
  Su as e,
  N1 as f,
  wu as g,
  Z1 as h,
  Mn as i,
  Gu as j,
  X1 as k,
  v1 as l,
  P1 as m,
  Rd as p,
  G1 as s,
  Iu as u
};
//# sourceMappingURL=face-Dml70xnv.js.map
